var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550 450",
    style: {
      enableBackground: "new 0 0 550 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.3112,
    y1: -289.8189,
    x2: 257.4923,
    y2: 503.9528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#804EA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D005A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 550,
    height: 450
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025413187668956953980000011773818664076672667_",
    gradientUnits: "userSpaceOnUse",
    x1: -131.6559,
    y1: 368.479,
    x2: 514.0896,
    y2: 314.6121,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 -46.5308 127.6964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00017593,
    style: {
      stopColor: "#4422A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1164,
    style: {
      stopColor: "#4A239F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2667,
    style: {
      stopColor: "#5A2699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4357,
    style: {
      stopColor: "#742B90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6185,
    style: {
      stopColor: "#9A3283"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#C93A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF445F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000025413187668956953980000011773818664076672667_)"
    },
    cx: 278.854,
    cy: 294.669,
    rx: 240.405,
    ry: 138.802
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080202590580978063220000005527153282133920183_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.3282,
    y1: 361.1513,
    x2: 521.4174,
    y2: 307.2844,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 -46.5308 127.6964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00017593,
    style: {
      stopColor: "#4422A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1164,
    style: {
      stopColor: "#4A239F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2667,
    style: {
      stopColor: "#5A2699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4357,
    style: {
      stopColor: "#742B90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6185,
    style: {
      stopColor: "#9A3283"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#C93A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF445F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000080202590580978063220000005527153282133920183_)"
    },
    cx: 278.854,
    cy: 284.306,
    rx: 240.405,
    ry: 138.802
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "107.179,193.203 63.77,190.97 63.929,187.887 105.401,190.021 141.941,123.124  166.162,153.785 197.809,126.799 220.545,68.762 262.198,36.183 264.099,38.615 223.112,70.674 200.402,128.645  165.727,158.214 142.413,128.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M225.653,68.109c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.251-4.166-2.406 c0-2.657,1.865-5.888,4.166-7.216C223.788,64.375,225.653,65.452,225.653,68.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.5,124.466c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.251-4.166-2.406 c0-2.657,1.865-5.888,4.166-7.216C201.634,120.732,203.5,121.809,203.5,124.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M166.975,160.478c0,2.657-1.866,5.888-4.166,7.216c-2.301,1.329-4.166,0.251-4.166-2.406 c0-2.657,1.865-5.888,4.166-7.216C165.109,156.744,166.974,157.821,166.975,160.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.559,124.466c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.251-4.166-2.406 c0-2.657,1.865-5.888,4.166-7.216C143.693,120.732,145.559,121.809,145.559,124.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M113.428,204.792c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.328-4.166,0.251-4.167-2.406 c0-2.657,1.866-5.888,4.166-7.216C111.563,201.058,113.428,202.135,113.428,204.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M68.016,186.848c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.328-4.166,0.251-4.166-2.406 s1.866-5.888,4.166-7.216C66.151,183.113,68.016,184.191,68.016,186.848z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#13B7FD"
    },
    points: "67.042,210.086 64.603,208.195 104.261,157.058 136.688,171.041 176.593,111.054  213.034,107.388 241.751,79.934 242.005,79.824 287.655,60.104 288.879,62.937 243.484,82.548 214.4,110.353 178.355,113.979  137.832,174.896 105.235,160.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M181.211,110.818c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.251-4.166-2.405 c0-2.657,1.865-5.888,4.166-7.216C179.346,107.084,181.211,108.161,181.211,110.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M142.311,169.389c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.252-4.166-2.405 c0-2.657,1.865-5.888,4.166-7.216C140.446,165.655,142.311,166.732,142.311,169.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M109.262,156.599c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.252-4.166-2.406 c0-2.657,1.865-5.888,4.166-7.216C107.397,152.865,109.262,153.942,109.262,156.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M70.722,205.813c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.328-4.166,0.252-4.166-2.406 c0-2.657,1.866-5.888,4.166-7.216C68.856,202.079,70.722,203.156,70.722,205.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M218.269,105.438c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.329-4.166,0.251-4.166-2.405 s1.865-5.888,4.166-7.216C216.403,101.705,218.269,102.781,218.269,105.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M245.533,79.858c0,2.657-1.865,5.888-4.166,7.216c-2.301,1.328-4.166,0.252-4.166-2.405 c0-2.657,1.865-5.888,4.166-7.216C243.667,76.124,245.533,77.201,245.533,79.858z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "467.18,206.13 438.086,223.128 417.713,211.366 417.713,207.348 446.807,194.368  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "443.234,192.286 414.14,209.283 393.767,197.521 393.767,193.503 422.862,180.524  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "419.332,178.442 390.238,195.44 369.866,183.678 369.866,179.66 398.96,166.68  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "395.501,164.848 366.406,181.847 346.034,170.084 346.034,166.066 375.128,153.086  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C5243C"
    },
    points: "383.913,69.103 383.638,165.963 364.897,176.855 365.171,79.995  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5354F"
    },
    points: "365.171,79.995 364.897,176.855 346.034,165.964 346.309,69.105  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F75061"
    },
    points: "383.913,69.103 365.171,79.995 346.309,69.105 365.05,58.213  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#078AA5"
    },
    points: "407.808,129.183 407.533,179.759 388.792,190.65 389.066,140.075  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#18B6D6"
    },
    points: "389.066,140.075 388.792,190.65 369.927,179.759 370.201,129.183  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15D9FD"
    },
    points: "407.808,129.183 389.066,140.075 370.201,129.183 388.943,118.292  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB700"
    },
    points: "431.701,118.292 431.426,193.553 412.684,204.445 412.959,129.183  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC400"
    },
    points: "412.959,129.183 412.684,204.445 393.82,193.553 394.094,118.292  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDE23"
    },
    points: "431.701,118.292 412.959,129.183 394.094,118.292 412.836,107.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "455.594,176.802 455.319,207.348 436.577,218.239 436.852,187.693  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DDE3F4"
    },
    points: "436.852,187.693 436.577,218.239 417.713,207.348 417.988,176.802  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9ECF5"
    },
    points: "455.594,176.802 436.852,187.693 417.988,176.802 436.729,165.911  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "signature_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "495.107,307.617 411.736,356.307 333.938,294.306 396.612,251.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4DBEF"
    },
    points: "494.047,317.599 430.873,354.074 323.252,304.25 397.089,261.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2E5F2"
    },
    points: "494.047,310.654 420.21,353.285 323.252,297.305 397.089,254.674  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M355.482,311.525l-0.038-0.023l-26.591-15.352l0.116-0.067l63.589-36.714l0.039,0.022 l26.59,15.352l-0.116,0.067L355.482,311.525z M329.162,296.15l26.32,15.196l63.396-36.603l-26.32-15.196L329.162,296.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "333.459,298.764 333.382,298.63 396.931,261.939 397.008,262.073  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "337.871,301.312 337.794,301.178 401.344,264.487 401.421,264.621  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "342.283,303.86 342.206,303.726 405.756,267.034 405.833,267.168  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "346.696,306.407 346.619,306.273 410.169,269.582 410.246,269.716  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 346.154,
    y: 290.465,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -93.9719 230.2871)",
    style: {
      fill: "#CDDCFB"
    },
    width: 73.382,
    height: 0.155
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399.363,
    y: 255.485,
    transform: "matrix(0.5 -0.866 0.866 0.5 -34.7773 481.3035)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393.008,
    y: 259.154,
    transform: "matrix(0.5 -0.866 0.866 0.5 -41.1326 477.6336)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.155,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.653,
    y: 262.823,
    transform: "matrix(0.5 -0.866 0.866 0.5 -47.487 473.9662)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 380.297,
    y: 266.493,
    transform: "matrix(0.5 -0.866 0.866 0.5 -53.8398 470.3021)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.155,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "387.218,293.157 360.744,277.871 360.821,277.737 387.296,293.023  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "380.864,296.826 354.389,281.54 354.466,281.406 380.941,296.692  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "374.509,300.495 348.034,285.209 348.111,285.076 374.586,300.361  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "368.153,304.164 341.679,288.878 341.756,288.745 368.231,304.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 284.839,
    transform: "matrix(0.5 -0.866 0.866 0.5 -85.6179 451.9493)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.155,
    height: 30.57
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "361.837,307.766 355.482,311.435 343.288,304.395 349.643,300.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "371.37,302.263 365.015,305.932 361.219,303.74 367.574,300.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "409.5,280.248 403.145,283.917 383.356,272.491 389.711,268.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "390.435,291.255 384.08,294.924 375.078,289.727 381.433,286.058  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "419.032,274.744 412.677,278.413 405.189,274.09 411.544,270.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "380.902,296.759 374.547,300.428 351.169,286.93 357.524,283.261  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "399.967,285.751 393.612,289.421 378.637,280.774 384.991,277.105  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M419.797,346.451l-0.039-0.022l-26.59-15.353l0.116-0.067l63.589-36.714l0.039,0.022 l26.59,15.353l-0.116,0.067L419.797,346.451z M393.477,331.076l26.32,15.196l63.396-36.602l-26.32-15.196L393.477,331.076z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.819,
    y: 315.201,
    transform: "matrix(0.8666 -0.4991 0.4991 0.8666 -100.0326 256.4241)",
    style: {
      fill: "#CDDCFB"
    },
    width: 73.382,
    height: 0.154
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "402.186,336.239 402.109,336.104 465.659,299.413 465.736,299.547  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "406.598,338.786 406.521,338.652 470.071,301.961 470.148,302.094  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "411.01,341.334 410.933,341.2 474.483,304.508 474.56,304.642  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "415.423,343.881 415.346,343.747 478.896,307.056 478.973,307.189  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 463.677,
    y: 290.411,
    transform: "matrix(0.5 -0.866 0.866 0.5 -32.8688 554.4615)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 457.322,
    y: 294.081,
    transform: "matrix(0.5 -0.866 0.866 0.5 -39.2216 550.7971)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "464.243,320.745 437.768,305.459 437.846,305.325 464.32,320.611  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "457.888,324.414 431.413,309.128 431.491,308.995 457.965,324.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "451.533,328.083 425.059,312.798 425.136,312.664 451.61,327.949  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.902,
    y: 308.757,
    transform: "matrix(0.5 -0.866 0.866 0.5 -64.6446 536.114)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.571
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 425.547,
    y: 312.427,
    transform: "matrix(0.5 -0.866 0.866 0.5 -70.9943 532.4576)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.155,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 419.192,
    y: 316.096,
    transform: "matrix(0.5 -0.866 0.866 0.5 -77.3532 528.7792)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.155,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.837,
    y: 319.765,
    transform: "matrix(0.5 -0.866 0.866 0.5 -83.705 525.1182)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "426.152,342.693 419.797,346.362 407.603,339.321 413.957,335.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "435.684,337.189 429.329,340.858 425.534,338.667 431.889,334.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "473.814,315.174 467.459,318.843 447.671,307.418 454.026,303.749  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "454.749,326.181 448.394,329.851 439.393,324.654 445.748,320.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "483.347,309.67 476.992,313.34 469.504,309.016 475.859,305.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "445.217,331.685 438.862,335.354 415.484,321.857 421.839,318.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "464.282,320.678 457.927,324.347 442.951,315.701 449.306,312.031  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M387.983,330.057l-0.039-0.022l-26.59-15.353l0.115-0.067l63.589-36.714l0.039,0.022 l26.59,15.353l-0.116,0.067L387.983,330.057z M361.663,314.682l26.32,15.196l63.396-36.602l-26.32-15.196L361.663,314.682z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "365.959,317.297 365.882,317.163 429.432,280.472 429.509,280.605  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "370.372,319.845 370.295,319.711 433.845,283.019 433.922,283.153  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "374.784,322.392 374.707,322.259 438.257,285.567 438.335,285.701  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "379.197,324.94 379.12,324.806 442.67,288.114 442.747,288.248  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "383.609,327.487 383.532,327.354 447.082,290.662 447.159,290.796  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 431.864,
    y: 274.018,
    transform: "matrix(0.5 -0.866 0.866 0.5 -34.5779 518.7137)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 425.509,
    y: 277.687,
    transform: "matrix(0.5 -0.866 0.866 0.5 -40.9308 515.0491)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "432.429,304.351 405.955,289.065 406.032,288.932 432.507,304.217  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "426.074,308.02 399.6,292.734 399.677,292.601 426.152,307.886  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDDCFB"
    },
    points: "419.719,311.689 393.245,296.404 393.322,296.27 419.797,311.556  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.089,
    y: 292.363,
    transform: "matrix(0.5 -0.866 0.866 0.5 -66.3536 500.3664)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.571
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393.733,
    y: 296.033,
    transform: "matrix(0.5 -0.866 0.866 0.5 -72.7043 496.7079)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.378,
    y: 299.702,
    transform: "matrix(0.5 -0.866 0.866 0.5 -79.0626 493.0307)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.155,
    height: 30.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 381.024,
    y: 303.371,
    transform: "matrix(0.5 -0.866 0.866 0.5 -85.4147 489.3692)",
    style: {
      fill: "#CDDCFB"
    },
    width: 0.154,
    height: 30.57
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "394.338,326.299 387.983,329.968 375.789,322.928 382.144,319.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "403.871,320.795 397.516,324.464 393.72,322.273 400.075,318.604  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "442.001,298.78 435.646,302.449 415.857,291.024 422.212,287.355  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "422.936,309.788 416.581,313.457 407.579,308.26 413.934,304.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "451.533,293.277 445.178,296.946 437.69,292.623 444.046,288.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "413.403,315.292 407.048,318.961 383.67,305.463 390.025,301.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#98A4E0"
    },
    points: "432.468,304.284 426.113,307.953 411.138,299.307 417.493,295.638  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_x5F_man_x5F_smart_x5F_watch_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_24_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M72.098,247.748c-2.094-2.391-2.844-5.352-1.704-6.201c1.077-0.802,2.969,0.395,5.687,4.634 c0.661,1.031,3.553,4.281,4.107,6.437c0,0-0.98,2.005-1.518,2.003C76.882,254.619,76.218,252.452,72.098,247.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4CB3"
    },
    d: "M70.474,241.547c1.068-0.795,2.416,0.376,3.228,1.017c1.036,0.816,1.948,1.789,2.698,2.874 c0.376,0.544,0.939,1.215,0.893,1.896c-0.052,0.778-0.418,1.425-0.941,1.988c-0.393,0.423-0.844,0.792-1.337,1.093 c-0.858,0.525-1.187-0.007-1.717-0.634c-0.597-0.706-1.199-1.409-1.808-2.105C69.396,245.284,69.335,242.396,70.474,241.547z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C232A"
    },
    d: "M64.886,298.093c0.014,0.19,0.258,0.474,0.348,0.635c0.18,0.319,0.4,0.635,0.56,0.959 c0.206,0.417,0.304,0.932,0.448,1.375c0.294,0.906,0.589,1.812,0.883,2.719c0.117,0.361,0.235,0.725,0.276,1.102 c0.041,0.377,0,0.774-0.185,1.105c-0.336,0.603-1.053,0.864-1.715,1.061c-0.388,0.116-0.814,0.224-1.187,0.066 c-0.294-0.124-0.499-0.393-0.677-0.658c-0.812-1.208-1.237-2.542-1.698-3.902c-0.244-0.721-0.455-1.47-0.423-2.23 c0.018-0.422,0.119-0.847,0.314-1.223c0.102-0.196,0.23-0.379,0.385-0.538c0.153-0.156,0.305-0.227,0.401-0.427 c0.181-0.378,0.305-0.833,0.603-1.146c0.254-0.267,0.749-0.263,1.07-0.123c0.358,0.156,0.625,0.48,0.774,0.841 c0,0.119-0.171,0.235-0.179,0.354C64.885,298.073,64.885,298.083,64.886,298.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M69.481,295.035c0.34,0.244,0.644,0.533,0.979,0.785c0.33,0.249,0.677,0.446,1.002,0.703 c0.715,0.565,1.458,1.095,2.225,1.589c0.58,0.374,1.176,0.727,1.714,1.16c0.419,0.337,0.805,0.726,1.093,1.183 c0.159,0.253,0.22,0.395,0.142,0.688c-0.07,0.261-0.213,0.498-0.359,0.722c-0.276,0.426-0.598,0.858-1.067,1.055 c-0.451,0.189-0.973,0.126-1.433-0.042c-0.689-0.253-1.43-0.75-1.903-1.312c-0.507-0.602-1.088-1.084-1.834-1.361 c-0.593-0.22-1.247-0.308-1.769-0.666c-0.462-0.317-0.762-0.843-0.837-1.394c-0.088-0.644,0.166-1.295,0.117-1.947 c-0.031-0.418-0.152-0.874-0.05-1.294c0.087-0.359,0.518-0.602,0.866-0.641c0.388-0.043,0.781,0.104,1.09,0.342 L69.481,295.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98A4E0"
    },
    d: "M68.064,279.659c-0.099-1.238-0.048-3.002-0.125-4.241c-0.16-2.564-2.722-10.795,2.492-12.423 c0.784-0.245,1.983-1.807,2.655-1.263c0.138,0.112,0.575,0.65,0.911,1.823c0.192,0.669,0.3,1.691,0.43,2.59 c0.223,1.54,0.248,3.339,0.007,5.25c-0.243,1.931-0.186,5.928-0.676,8.931c-0.015,0.225-0.03,0.45-0.045,0.675 c-0.083,1.261-0.18,2.522-0.28,3.781c-0.561,7.069-0.574,10.678-1.163,12.152c-0.487,1.217-2.1,1.116-3.144,0.767 c-0.457-0.153-0.89-0.423-1.154-0.826c-0.257-0.393-0.334-0.873-0.398-1.337c-0.586-4.264-0.302-10.569,0.65-14.975 C68.145,280.27,68.089,279.969,68.064,279.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E2FC"
    },
    d: "M61.202,277.637c-0.952-4.417-1.32-9.26,0.61-14.686c0-0.001,0.31-0.418,0.318-0.414 c1.142,0.587,2.553,0.448,3.906,0.615c2.92,0.36,3.143,0.878,5.074-0.4c0.375,2.018-0.125,3.908-0.11,4.356 c0.077,2.309-2.066,2.49-2.156,3.706c-0.208,2.82-0.596,8.39-1.035,11.183c-0.123,0.78-0.263,1.574-0.549,2.304 c-0.067,0.947-0.138,1.894-0.214,2.841c-0.561,7.069-0.574,10.678-1.163,12.151c-0.487,1.217-2.1,1.116-3.144,0.767 c-0.457-0.153-0.89-0.423-1.154-0.826c-0.257-0.392-0.334-0.872-0.398-1.337c-0.588-4.274-0.957-8.001-0.011-12.195 C61.573,283.686,61.673,279.821,61.202,277.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M61.912,258.72l0.009,0.01c0.094,0.734,0.156,1.472,0.183,2.21 C62.069,260.198,62.005,259.457,61.912,258.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M62.104,260.94c0.021,0.451,0.032,0.902,0.032,1.353c-0.009-0.004-0.017-0.008-0.026-0.012 C62.123,261.835,62.12,261.387,62.104,260.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8763CD"
    },
    d: "M61.212,260.907c0.077-0.361,0.126-0.722,0.126-1.079c0-0.421-0.15-0.816-0.181-1.238 c-0.047-0.641-0.064-1.275-0.165-1.912c-0.25-1.589-0.815-3.107-1.248-4.656c-0.39-1.394-0.898-3.265-0.444-4.699 c0.398-1.254,1.571-2.169,2.611-2.874c1.308-0.886,3.921-2.051,6.476-2.851c0.972-0.304,2.221-0.661,3.196-0.17 c0.823,0.415,1.208,1.356,1.528,2.164c0.622,1.573,0.641,3.242,0.691,4.929c0.056,1.91,0.021,3.821,0.022,5.732 c0.002,2.245,0.134,4.489,0.393,6.719c0.12,1.038,0.187,2.131,0.55,3.108c0.313,0.842,0.039,1.638-0.578,2.305 c-0.55,0.595-1.288,0.981-2.035,1.293c-2.843,1.189-5.987,1.463-9.069,1.44c-0.613-0.005-1.243-0.024-1.805-0.268 c-1.944-0.843-1.112-3.916-0.75-5.479C60.714,262.575,61.035,261.74,61.212,260.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4CB3"
    },
    d: "M60.993,256.678c-0.25-1.589-0.815-3.107-1.248-4.656c-0.39-1.394-0.898-3.265-0.444-4.699 c0.234-0.737,0.736-1.356,1.321-1.885c2.344,1.31,4.093,3.34,4.093,6.091c0.132,5.89,0.041,11.743-0.336,17.579 c-0.432,0.01-0.863,0.013-1.293,0.01c-0.613-0.005-1.243-0.024-1.805-0.268c-1.944-0.843-1.112-3.916-0.75-5.479 c0.184-0.795,0.505-1.63,0.682-2.464c0.077-0.361,0.126-0.722,0.126-1.079c0-0.421-0.15-0.816-0.181-1.238 C61.11,257.949,61.093,257.315,60.993,256.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5A783"
    },
    d: "M64.432,243.074c-0.092,2.889,5.329,2.938,5.251,0.221c-0.109-3.787-0.339-4.221-2.123-4.809 c-0.489-0.161-1-0.285-1.517-0.294c-1.883-0.035-1.154,0.922-1.083,1.589C65.169,241.76,64.465,242.034,64.432,243.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9C76"
    },
    d: "M64.432,243.074c0.033-1.04,0.738-1.314,0.528-3.293c-0.071-0.667-0.8-1.623,1.083-1.589 c0.517,0.009,1.028,0.133,1.517,0.294c1.76,0.579,2.008,1.012,2.119,4.655c-1.5-0.144-2.825-1.799-4.353-0.816 c-0.407,0.305-0.681,0.699-0.872,1.132C64.435,243.335,64.428,243.208,64.432,243.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5A783"
    },
    d: "M65.325,242.325c1.528-0.982,2.853,0.672,4.353,0.816c0.002,0.052,0.003,0.101,0.005,0.154 c0.074,2.591-4.852,2.667-5.229,0.162C64.644,243.023,64.918,242.63,65.325,242.325z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M71.981,234.023c0.393,0.627,0.622,1.351,0.614,2.119c-0.004,0.331-0.058,0.661-0.168,0.973 c-0.104,0.296-0.291,0.575-0.294,0.898c-0.004,0.378,0.269,0.801,0.392,1.158c0.111,0.322,0.174,0.684,0.047,1 c-0.073,0.182-0.203,0.333-0.308,0.499c-0.5,0.786-0.028,1.946-0.9,2.512c-0.218,0.141-0.475,0.168-0.732,0.182 c-0.323,0.017-1.776-0.39-2.339-0.639c-0.621-0.275-1.228-0.981-1.676-1.492c-0.351-0.399-0.941-0.913-1.165-1.392 c-0.069-0.147,0.097-0.174-0.053-0.247c-0.091-0.044-0.201-0.623-0.302-0.634c-0.12-0.013-0.282-0.145-0.383-0.213 c-0.195-0.13-0.288,0.343-0.352,0.118c-0.273-0.957-0.619-1.934-0.578-2.944c0.037-0.924,0.017-1.718,0.612-2.504 c0.447-0.591,1.086-1.021,1.778-1.284c1.058-0.402,2.256-0.424,3.327-0.059C70.514,232.419,71.416,233.12,71.981,234.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M63.782,235.921c0.037-0.924,0.017-1.718,0.612-2.504c0.447-0.591,1.086-1.021,1.778-1.284 c0.632-0.24,1.313-0.342,1.988-0.31c1.009,2.017-0.452,4.6,0.648,6.691c0.368,0.491,1.105,0.86,1.105,1.474 c0.245,1.103-0.855,2.084-0.249,3.187c-0.505-0.135-1.069-0.315-1.373-0.45c-0.621-0.275-1.228-0.981-1.676-1.492 c-0.351-0.399-0.941-0.913-1.165-1.392c-0.069-0.147,0.097-0.174-0.053-0.247c-0.091-0.044-0.201-0.623-0.302-0.634 c-0.12-0.013-0.282-0.145-0.383-0.213c-0.195-0.13-0.288,0.343-0.352,0.118C64.088,237.908,63.741,236.931,63.782,235.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C99C83"
    },
    d: "M68.474,234.874c-0.261-0.042-0.524-0.034-0.763,0.073c-0.406,0.183-0.648,0.623-0.713,1.063 c-0.143,0.97,0.192,1.939,0.219,2.901c0.004,0.145-0.005,0.296-0.076,0.422c-0.194,0.343-0.556,0.156-0.762-0.061 c-0.132-0.139-0.235-0.303-0.361-0.447c-0.126-0.144-0.285-0.272-0.473-0.306c-0.301-0.055-0.533,0.182-0.58,0.461 c-0.043,0.254,0.004,0.51,0.071,0.755c0.016,0.059,0.143,0.502-0.039,0.504c-0.183,0.002-1.789-1.652-1.861-4.462 c-0.069-2.695,1.801-3.198,1.801-3.198s0.824-1.396,2.995-1.293c1.142,0.055,2.259,0.426,3.224,1.029 c0.039,0.024,0.077,0.049,0.116,0.074c0.468,0.304,0.911,0.667,1.215,1.136c0.833,1.289-0.289,2.321-1.64,2.105 c-0.636-0.102-1.223-0.396-1.831-0.61C68.841,234.957,68.658,234.903,68.474,234.874L68.474,234.874z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B98C74"
    },
    d: "M68.474,234.874c-0.261-0.042-0.524-0.034-0.763,0.073c-0.406,0.183-0.648,0.623-0.713,1.063 c-0.143,0.97,0.192,1.939,0.219,2.901c0.004,0.145-0.005,0.296-0.076,0.422c-0.194,0.343-0.556,0.156-0.762-0.061 c-0.132-0.139-0.235-0.303-0.361-0.447c-0.126-0.144-0.285-0.272-0.473-0.306c-0.301-0.055-0.533,0.182-0.58,0.461 c-0.043,0.254,0.004,0.51,0.071,0.755c0.016,0.059,0.143,0.502-0.039,0.504c-0.183,0.002-1.789-1.652-1.861-4.462 c-0.069-2.695,1.801-3.198,1.801-3.198s1.118,0.423,1.89,0.913C67.597,233.979,68.474,234.874,68.474,234.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M65.26,237.781c-0.801-0.054-1.004,0.94-0.454,1.708c0.16,0.224,0.444,0.423,0.654,0.602 c1.435,1.221,1.795-0.1,1.339-0.516C65.74,238.608,66.267,237.849,65.26,237.781z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M65.582,239.401c-0.088-0.081-0.961-0.596-0.366-0.947c0.164-0.097,0.348,0.047,0.373,0.221 c0.013,0.09-0.015,0.183-0.002,0.273c0.008,0.053,0.03,0.104,0.059,0.15c0.077,0.126,0.342,0.247,0.29,0.432 C65.891,239.695,65.633,239.447,65.582,239.401z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170244533028202902740000016927912248419456136_",
    style: {
      enableBackground: "new"
    },
    d: " M72.122,260.93l0.577-0.481c0.096,0.57,0.617,1.198,1.161,1.4l-0.577,0.481C72.739,262.128,72.218,261.5,72.122,260.93z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170244533028202902740000016927912248419456136_",
    style: {
      overflow: "visible",
      fill: "#0F1317"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131337594114894821070000007598214883765378210_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170244533028202902740000016927912248419456136_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131337594114894821070000007598214883765378210_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M72.122,260.93l0.577-0.481c0.016,0.097,0.045,0.196,0.084,0.294l-0.577,0.481 C72.167,261.125,72.139,261.027,72.122,260.93L72.122,260.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M72.206,261.223l0.577-0.481c0.137,0.344,0.401,0.68,0.707,0.903l-0.577,0.481 C72.607,261.903,72.343,261.568,72.206,261.223L72.206,261.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M72.914,262.126l0.577-0.481c0.093,0.068,0.189,0.125,0.287,0.169l-0.577,0.481 C73.103,262.251,73.007,262.194,72.914,262.126L72.914,262.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M73.201,262.296l0.577-0.481c0.027,0.013,0.055,0.024,0.083,0.034l-0.577,0.481 C73.256,262.319,73.229,262.308,73.201,262.296L73.201,262.296z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0F1317"
    },
    points: "73.284,262.33 73.861,261.848 74.263,261.997 73.686,262.478  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C6FF7"
    },
    d: "M74.92,261.953l-0.577,0.481c-0.147,0.123-0.376,0.148-0.65,0.047l0.555-0.488 C74.508,262.089,74.772,262.075,74.92,261.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M73.693,262.481l0.025,0.148c0.22,0.082,0.413,0.088,0.567,0.038l-0.031-0.181 C74.11,262.558,73.918,262.564,73.693,262.481z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0F1317"
    },
    points: "72.052,260.509 72.629,260.028 72.699,260.448 72.122,260.93  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098218337381446444190000017397325981842160802_",
    style: {
      enableBackground: "new"
    },
    d: " M72.216,259.888l0.577-0.481c-0.146,0.122-0.212,0.338-0.164,0.621l-0.577,0.481 C72.004,260.226,72.071,260.009,72.216,259.888z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098218337381446444190000017397325981842160802_",
    style: {
      overflow: "visible",
      fill: "#13B7FD"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036251056362632966260000015782583593656030124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098218337381446444190000017397325981842160802_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036251056362632966260000015782583593656030124_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M72.216,259.888l0.577-0.481c-0.092,0.077-0.153,0.193-0.173,0.339l-0.577,0.481 C72.063,260.08,72.124,259.965,72.216,259.888L72.216,259.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M72.044,260.227l0.577-0.481c-0.011,0.08-0.009,0.169,0.006,0.266l-0.577,0.481 C72.034,260.396,72.033,260.307,72.044,260.227L72.044,260.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M72.049,260.493l0.577-0.481c0.001,0.005,0.002,0.011,0.003,0.016l-0.577,0.481 C72.051,260.504,72.05,260.498,72.049,260.493L72.049,260.493z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008151058821350577240000001280557368467766718_",
    d: "M72.098,259.746l0.577-0.481 c0.169-0.141,0.43-0.17,0.744-0.054l-0.577,0.481C72.528,259.577,72.267,259.606,72.098,259.746z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008151058821350577240000001280557368467766718_",
    style: {
      overflow: "visible",
      fill: "#13B7FD"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183935169630210730330000010415536206978482618_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008151058821350577240000001280557368467766718_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183935169630210730330000010415536206978482618_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M72.098,259.746l0.577-0.481c0.128-0.107,0.311-0.15,0.529-0.113l-0.577,0.481 C72.409,259.597,72.227,259.639,72.098,259.746L72.098,259.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M72.627,259.634l0.577-0.481c0.068,0.012,0.14,0.031,0.215,0.059l-0.577,0.481 C72.767,259.665,72.695,259.646,72.627,259.634L72.627,259.634z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M73.244,259.841l0.025,0.148l-0.402-0.149c-0.545-0.202-0.91,0.098-0.815,0.668l0.071,0.421 c0.096,0.57,0.617,1.198,1.162,1.4l0.402,0.149l0.025,0.148l-0.402-0.149c-0.623-0.231-1.219-0.949-1.328-1.601l-0.071-0.42 c-0.109-0.652,0.309-0.995,0.931-0.764L73.244,259.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#13B7FD"
    },
    points: "73.244,259.841 73.82,259.36 73.845,259.508 73.269,259.99  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#13B7FD"
    },
    points: "72.842,259.693 73.419,259.211 73.82,259.36 73.244,259.841  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M72.639,263.422c0.738-0.03,1.182-0.486,1.5-1.104c1.093-2.123,8.587-8.97,5.222-10.737 c-0.512-0.269-1.494-0.393-2.006-0.044c-0.637,0.434-3.161,5.952-5.313,8.947c-0.228,0.318-0.025,0.504,0.075,0.877 C72.278,261.959,72.068,263.445,72.639,263.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M69.475,265.101c-0.318-0.04-0.636-0.456-0.342-0.552c-0.156-0.066-0.275-0.236-0.232-0.399 c0.056-0.212,0.316-0.279,0.519-0.362c0.279-0.115,0.508-0.321,0.731-0.523c0.471-0.427,0.75-1.108,0.641-1.124 c-0.273-0.042-0.585,0.01-0.759,0.225c-0.101,0.125-0.145,0.291-0.257,0.406c-0.092,0.095-0.221,0.145-0.346,0.19 c-0.043,0.016-0.089,0.031-0.134,0.022c-0.095-0.019-0.134-0.134-0.133-0.231c0.002-0.151,0.062-0.296,0.12-0.435 c0.143-0.342,0.303-0.704,0.611-0.911c0.102-0.068,0.216-0.116,0.324-0.176c0.118-0.065,0.228-0.144,0.352-0.196 c0.16-0.068,1.133-0.419,1.536-0.464c1.585-0.749,2.279,0.016,2.228,1.117c-0.024,0.529-0.651,1.637-1.045,2.213 c-0.012,0.018-0.019,0.036-0.032,0.053c-0.023,0.031-0.05,0.066-0.076,0.1c-0.001,0.002-0.003,0.004-0.004,0.006 c-0.001,0.002-0.002,0.003-0.004,0.005c-0.591,0.776-1.904,2.299-2.551,1.73c0.015-0.06,0.03-0.121,0.045-0.181 C69.628,265.714,70.09,265.179,69.475,265.101z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smartphone_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124147125495049892070000007167417799426843043_",
    d: "M72.251,260.055l-0.032-0.193 c0.009,0.052,0.051,0.097,0.126,0.125l0.032,0.193C72.302,260.152,72.259,260.106,72.251,260.055z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124147125495049892070000007167417799426843043_",
    style: {
      overflow: "visible",
      fill: "#ECF5FE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080910987956537001970000012464382735827540908_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124147125495049892070000007167417799426843043_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080910987956537001970000012464382735827540908_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M72.344,259.987l0.032,0.193c-0.075-0.028-0.117-0.073-0.126-0.125l-0.032-0.193 C72.227,259.914,72.27,259.96,72.344,259.987L72.344,259.987z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000120552335282035982770000008024478771694449807_",
    d: "M74.675,259.695l0.032,0.193 c0.009,0.051-0.016,0.107-0.076,0.157l-0.032-0.193C74.659,259.802,74.684,259.746,74.675,259.695z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120552335282035982770000008024478771694449807_",
    style: {
      overflow: "visible",
      fill: "#ECF5FE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114783001806133896860000001137279360009277075_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120552335282035982770000008024478771694449807_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114783001806133896860000001137279360009277075_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M74.675,259.695l0.032,0.193c0.003,0.018,0.002,0.036-0.003,0.055l-0.032-0.193 C74.677,259.731,74.678,259.713,74.675,259.695L74.675,259.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M74.672,259.75l0.032,0.193c-0.009,0.032-0.03,0.065-0.065,0.096l-0.032-0.193 C74.642,259.815,74.663,259.782,74.672,259.75L74.672,259.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF5FE"
    },
    points: "74.607,259.845 74.64,260.038 74.632,260.045 74.6,259.852 74.607,259.845  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF5FE"
    },
    points: "74.6,259.852 74.632,260.045 74.046,260.534 74.014,260.341  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF5FE"
    },
    points: "73.525,260.424 73.558,260.617 72.377,260.18 72.344,259.987  "
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150785107169153839020000005315872086607475130_",
    d: "M74.014,260.341l0.032,0.193 c-0.121,0.101-0.34,0.138-0.488,0.083l-0.032-0.193C73.674,260.479,73.893,260.442,74.014,260.341z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150785107169153839020000005315872086607475130_",
    style: {
      overflow: "visible",
      fill: "#ECF5FE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095330631889516586280000014664691542354182835_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150785107169153839020000005315872086607475130_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095330631889516586280000014664691542354182835_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M74.014,260.341l0.032,0.193c-0.054,0.045-0.129,0.078-0.208,0.095l-0.032-0.193 C73.885,260.419,73.959,260.387,74.014,260.341L74.014,260.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M73.806,260.436l0.032,0.193c-0.055,0.012-0.111,0.016-0.165,0.012l-0.032-0.193 C73.694,260.452,73.751,260.448,73.806,260.436L73.806,260.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M73.641,260.448l0.032,0.193c-0.041-0.003-0.08-0.011-0.115-0.024l-0.032-0.193 C73.561,260.437,73.6,260.445,73.641,260.448L73.641,260.448z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M74.549,259.57c0.148,0.055,0.171,0.182,0.05,0.283l-0.586,0.489 c-0.12,0.101-0.34,0.138-0.488,0.083l-1.181-0.437c-0.148-0.055-0.17-0.182-0.05-0.283l0.586-0.489 c0.12-0.101,0.34-0.138,0.488-0.083L74.549,259.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C232A"
    },
    d: "M74.621,259.704c0.006,0.033-0.015,0.071-0.057,0.106l-0.586,0.489 c-0.05,0.042-0.126,0.074-0.208,0.088c-0.082,0.014-0.164,0.009-0.226-0.014l-0.259-0.096l-0.922-0.341 c-0.002-0.001-0.004-0.001-0.006-0.002c-0.048-0.019-0.079-0.048-0.085-0.08c-0.006-0.033,0.015-0.071,0.057-0.106 l0.041-0.034l0.545-0.455c0.008-0.007,0.018-0.014,0.028-0.02c0.049-0.032,0.112-0.056,0.18-0.067 c0.054-0.009,0.109-0.01,0.157-0.003c0.025,0.004,0.048,0.009,0.069,0.017l0.072,0.027l1.109,0.41 C74.582,259.641,74.615,259.671,74.621,259.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#F1F1F1"
    },
    d: "M74.621,259.704c0.006,0.033-0.015,0.071-0.057,0.106l-0.586,0.489 c-0.05,0.042-0.126,0.074-0.208,0.088c-0.082,0.014-0.164,0.009-0.226-0.014l0.986-0.751 C74.53,259.621,74.615,259.671,74.621,259.704z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147909565308350777250000014378764687881600928_",
    d: "M75.038,262.094l-0.577,0.481 c0.166-0.139,0.242-0.386,0.188-0.71l0.577-0.481C75.28,261.707,75.204,261.955,75.038,262.094z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147909565308350777250000014378764687881600928_",
    style: {
      overflow: "visible",
      fill: "#13B7FD"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126306721771739584680000001259146890450269588_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147909565308350777250000014378764687881600928_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000126306721771739584680000001259146890450269588_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M74.649,261.865l0.577-0.481c0.001,0.006,0.002,0.012,0.003,0.018l-0.577,0.481 C74.651,261.877,74.65,261.871,74.649,261.865L74.649,261.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M74.652,261.883l0.577-0.481c0.017,0.111,0.019,0.213,0.006,0.304l-0.577,0.481 C74.671,262.096,74.669,261.995,74.652,261.883L74.652,261.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M74.659,262.188l0.577-0.481c-0.022,0.168-0.092,0.299-0.197,0.388l-0.577,0.481 C74.567,262.487,74.636,262.355,74.659,262.188L74.659,262.188z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#13B7FD"
    },
    points: "74.579,261.444 75.155,260.963 75.226,261.384 74.649,261.865  "
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011725367352439901760000001988723785716470711_",
    d: "M74.028,260.396l0.577-0.481 c0.292,0.32,0.493,0.702,0.551,1.049l-0.577,0.481C74.521,261.098,74.32,260.716,74.028,260.396z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011725367352439901760000001988723785716470711_",
    style: {
      overflow: "visible",
      fill: "#13B7FD"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036968100645230316940000008402020866994972829_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011725367352439901760000001988723785716470711_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036968100645230316940000008402020866994972829_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M74.028,260.396l0.577-0.481c0.201,0.22,0.358,0.469,0.456,0.716l-0.577,0.481 C74.386,260.865,74.228,260.616,74.028,260.396L74.028,260.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M74.484,261.111l0.577-0.481c0.045,0.112,0.077,0.225,0.095,0.333l-0.577,0.481 C74.56,261.336,74.528,261.224,74.484,261.111L74.484,261.111z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M74.028,260.396l-0.073,0.079c0.256,0.28,0.431,0.615,0.482,0.917l0.071,0.421 c0.056,0.334-0.049,0.572-0.254,0.673l0.031,0.181c0.283-0.092,0.435-0.381,0.364-0.802l-0.071-0.421 C74.521,261.098,74.32,260.716,74.028,260.396z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "73.052,259.392 72.667,259.711 72.552,259.669 72.937,259.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "74.129,259.815 73.743,260.134 73.629,260.092 74.014,259.772  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M72.891,259.777c-0.073-0.027-0.18-0.009-0.239,0.041c-0.059,0.049-0.049,0.111,0.024,0.138 c0.073,0.027,0.18,0.009,0.239-0.041S72.963,259.804,72.891,259.777z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "73.098,259.878 72.924,260.023 72.874,260.004 73.048,259.86  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M73.176,259.54c-0.073-0.027-0.179-0.009-0.239,0.041c-0.06,0.049-0.049,0.111,0.024,0.138 c0.073,0.027,0.18,0.008,0.239-0.041C73.259,259.628,73.249,259.566,73.176,259.54z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "73.383,259.641 73.209,259.785 73.16,259.767 73.334,259.623  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M73.462,259.302c-0.073-0.027-0.18-0.009-0.239,0.041c-0.059,0.049-0.049,0.111,0.024,0.138 c0.072,0.027,0.179,0.009,0.239-0.041C73.545,259.391,73.535,259.329,73.462,259.302z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "73.669,259.404 73.495,259.548 73.445,259.53 73.619,259.385  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M73.338,259.943c-0.073-0.027-0.18-0.009-0.239,0.041c-0.059,0.049-0.049,0.111,0.024,0.138 c0.072,0.027,0.179,0.009,0.239-0.041C73.421,260.031,73.411,259.969,73.338,259.943z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "73.545,260.044 73.371,260.189 73.321,260.17 73.495,260.026  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M73.624,259.705c-0.073-0.027-0.179-0.009-0.239,0.041c-0.06,0.049-0.049,0.111,0.024,0.138 c0.073,0.027,0.179,0.009,0.239-0.041C73.707,259.794,73.697,259.732,73.624,259.705z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "73.831,259.807 73.657,259.951 73.607,259.933 73.781,259.788  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F1F1"
    },
    d: "M73.91,259.468c-0.073-0.027-0.18-0.009-0.239,0.041c-0.059,0.049-0.049,0.111,0.024,0.138 c0.072,0.027,0.179,0.009,0.239-0.041C73.993,259.557,73.983,259.495,73.91,259.468z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1F1F1"
    },
    points: "74.117,259.57 73.943,259.714 73.893,259.695 74.067,259.551  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#F6F0ED"
    },
    d: "M73.421,259.211l-0.136,1.066l-0.922-0.341c-0.002-0.001-0.004-0.001-0.006-0.002 c-0.048-0.019-0.079-0.048-0.085-0.08c-0.006-0.033,0.015-0.071,0.057-0.106l0.041-0.034l0.545-0.455 c0.008-0.007,0.14-0.076,0.208-0.088c0.054-0.009,0.109-0.01,0.157-0.003c0.025,0.004,0.048,0.009,0.069,0.017L73.421,259.211 z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M58.106,251.096c0.047-3.373,1.682-5.592,3.097-5.445c1.337,0.14,1.754,2.429,0.933,7.698 c-0.2,1.282-0.135,4.858-1.167,6.947c-0.67,1.355-1.209-1.32-1.607-1.705c-0.405-0.391-1.464,1.407-1.613,0.729 C57.409,257.778,58.042,255.707,58.106,251.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8763CD"
    },
    d: "M57.874,250.965c-0.014-0.964,0.222-1.968,0.599-2.854c0.433-1.017,1.415-2.597,2.73-2.46 c1.055,0.11,1.43,1.431,1.582,2.293c0.15,0.846,0.066,1.646,0.083,2.483c0.022,1.065-0.048,2.124-0.248,3.172 c-0.078,0.409-0.195,0.85-0.529,1.1c-0.361,0.27-0.858,0.231-1.305,0.181C56.899,254.44,57.895,252.456,57.874,250.965z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M71.339,259.793c-0.382-0.632-2.473-0.549-3.167-0.53c-2.386,0.065-10.53-4.221-10.457-0.421 c0.011,0.578,0.099,1.446,0.929,1.779c0.715,0.288,6.748,0.669,10.409,1.111c0.388,0.047,0.454-0.221,0.732-0.489 C70.232,260.815,71.635,260.282,71.339,259.793z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M71.486,259.433c0.11,0.044,0.186,0.073,0.304,0.189c0.121,0.119,0.207,0.274,0.236,0.441 c0.042,0.238-0.034,0.491-0.189,0.675c-0.03,0.035-0.118,0.087-0.134,0.126c-0.022,0.054,0.046,0.063,0.091,0.104 c0.283,0.259,0.154,0.817-0.52,0.968c0.067,0.97-2.593,0.616-3.518,0.077c-0.285-0.166-0.623-0.398-0.746-0.72 c-0.271-0.707,0.355-1.699,1.045-1.922c0.531-0.171,1.074-0.318,1.627-0.395c0.383-0.053,0.795-0.084,1.172,0.02 c0.214,0.059,0.408,0.165,0.526,0.356C71.407,259.396,71.445,259.416,71.486,259.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M71.435,258.61c0.061,0.089,0.049,0.216-0.006,0.311c-0.049,0.086-0.143,0.189-0.237,0.226 c-0.1,0.04-0.198,0.053-0.284,0.13c-0.366,0.332-0.866,0.528-1.349,0.616c-0.146,0.027-0.296,0.043-0.442,0.016 c-0.146-0.027-0.288-0.102-0.368-0.227c-0.055-0.085-0.076-0.203-0.016-0.285c0.032-0.043,0.081-0.07,0.128-0.094 c0.391-0.204,0.793-0.388,1.203-0.553c0.077-0.031,0.156-0.041,0.231-0.074c0.101-0.044,0.2-0.09,0.304-0.125 c0.202-0.068,0.42-0.105,0.631-0.058c0.07,0.016,0.141,0.042,0.189,0.096C71.424,258.596,71.43,258.603,71.435,258.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M70.728,259.183c0.451-0.024,0.887,0.014,1.336,0.034c0.465,0.021,0.93,0.063,1.388,0.153 c0.146,0.029,0.293,0.063,0.429,0.126c0.151,0.069,0.476,0.267,0.356,0.464c-0.032,0.053-0.082,0.093-0.134,0.126 c-0.152,0.094-0.333,0.132-0.511,0.138c-0.452,0.014-0.926-0.097-1.371-0.167c-0.48-0.075-0.959-0.16-1.435-0.255 L70.728,259.183z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "virtual_20_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028319634947841350400000002868819453140494772_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.3336,
    y1: 232.8186,
    x2: 429.3336,
    y2: 261.4919,
    gradientTransform: "matrix(-1 0 0 1 506.9012 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F0159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#1A2B79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#0F8AC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8646,
    style: {
      stopColor: "#08C5EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05DCFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000028319634947841350400000002868819453140494772_)"
    },
    points: "90.934,250.471  64.202,265.905 64.201,245.465 90.934,230.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "89.15,236.059 65.985,249.433 65.985,245.963 89.149,232.589  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M75.577,257.679l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777v-2.533 c0-0.855,0.605-1.904,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777v2.533 C76.923,256.203,76.317,257.252,75.577,257.679z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M76.346,254.46c0,1.15-0.808,2.549-1.804,3.124c-0.598,0.345-1.128,0.315-1.456-0.012 c0.16-0.039,0.329-0.107,0.505-0.208c0.996-0.575,1.804-1.974,1.804-3.124c0-0.461-0.129-0.812-0.348-1.03 C75.797,253.028,76.346,253.511,76.346,254.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "74.379,253.832 74.525,254.089 74.852,253.955 74.616,254.357 74.671,254.7  74.38,254.691 74.088,255.037 74.143,254.63 73.907,254.5 74.233,254.257  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "73.589,256.093 73.696,256.282 73.936,256.184 73.762,256.479 73.803,256.731  73.589,256.725 73.374,256.979 73.415,256.68 73.241,256.584 73.481,256.406  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "73.022,254.804 73.153,255.035 73.447,254.915 73.235,255.277 73.285,255.586  73.022,255.578 72.759,255.89 72.809,255.523 72.597,255.406 72.891,255.187  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M81.526,254.245l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777l0-2.533 c0-0.855,0.606-1.904,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777v2.533 C82.871,252.768,82.266,253.817,81.526,254.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M81.913,250.853l-0.366,0.211c-0.021-0.06-0.049-0.115-0.081-0.162l0.267-0.462 c0.046-0.079,0.046-0.166,0-0.192l-0.267-0.154c-0.046-0.027-0.12,0.016-0.166,0.096l-0.278,0.482 c-0.053,0-0.109,0.005-0.166,0.018v-0.461c0-0.075-0.053-0.105-0.118-0.068l-0.377,0.218c-0.065,0.038-0.118,0.129-0.118,0.204 v0.461c-0.057,0.053-0.111,0.11-0.163,0.17l-0.284-0.164c-0.046-0.027-0.121,0.016-0.166,0.096l-0.267,0.462 c-0.046,0.08-0.046,0.166,0,0.192l0.271,0.156c-0.031,0.081-0.058,0.164-0.079,0.246l-0.381,0.22 c-0.065,0.038-0.118,0.129-0.118,0.204v0.436c0,0.075,0.053,0.105,0.118,0.068l0.353-0.204c0.018,0.071,0.043,0.134,0.074,0.19 l-0.246,0.427c-0.046,0.079-0.046,0.165,0,0.192l0.267,0.154c0.046,0.026,0.12-0.017,0.166-0.096l0.23-0.399 c0.067,0.007,0.139,0.003,0.214-0.013v0.373c0,0.075,0.053,0.105,0.118,0.068l0.378-0.218c0.065-0.038,0.118-0.129,0.118-0.204 v-0.367c0.077-0.07,0.15-0.148,0.219-0.233l0.228,0.132c0.046,0.027,0.12-0.016,0.166-0.096l0.267-0.462 c0.046-0.08,0.046-0.166,0-0.192l-0.237-0.137c0.034-0.095,0.06-0.191,0.079-0.286l0.346-0.2 c0.065-0.038,0.118-0.129,0.118-0.204v-0.436C82.03,250.846,81.978,250.816,81.913,250.853z M80.547,252.721 c-0.328,0.189-0.594,0.036-0.594-0.343c0-0.379,0.266-0.84,0.594-1.029c0.328-0.189,0.594-0.036,0.594,0.343 C81.142,252.071,80.876,252.531,80.547,252.721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M87.475,250.81l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777v-2.533 c0-0.855,0.606-1.904,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777l0,2.533 C88.82,249.334,88.215,250.383,87.475,250.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M86.491,250.25c-0.742,0.428-1.345,0.08-1.345-0.777c0-0.415,0.14-0.886,0.394-1.326 c0.084-0.145,0.219-0.223,0.303-0.175c0.084,0.048,0.084,0.205,0,0.349c-0.173,0.3-0.269,0.621-0.269,0.904 c0,0.584,0.411,0.821,0.917,0.529s0.917-1.005,0.917-1.589c0-0.283-0.095-0.494-0.269-0.594 c-0.084-0.048-0.084-0.205,0-0.349c0.083-0.145,0.219-0.223,0.303-0.175c0.254,0.147,0.394,0.456,0.394,0.871 C87.836,248.777,87.233,249.822,86.491,250.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M86.491,248.855c-0.118,0.068-0.214,0.013-0.214-0.124v-1.495 c0-0.136,0.096-0.302,0.214-0.371c0.118-0.068,0.214-0.013,0.214,0.124v1.495C86.705,248.621,86.609,248.787,86.491,248.855z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M81.526,247.65l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777l0-2.533 c0-0.855,0.606-1.903,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777l0,2.533 C82.871,246.174,82.266,247.223,81.526,247.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M82.127,244.481l-1.585-1.016l-1.585,2.846l0.466-0.269v1.935l2.238-1.292v-1.935 L82.127,244.481z M80.912,246.515l-0.74,0.428v-1.088l0.74-0.428V246.515z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M75.798,247.564v-0.35c0-0.693-0.489-0.975-1.089-0.629c-0.6,0.347-1.089,1.193-1.089,1.886 v0.35c-0.128,0.162-0.214,0.373-0.214,0.557l0,1.64c0,0.279,0.195,0.391,0.437,0.252l1.733-1 c0.241-0.139,0.437-0.478,0.437-0.757v-1.64C76.012,247.69,75.926,247.578,75.798,247.564z M74.709,246.964 c0.42-0.242,0.761-0.045,0.761,0.439l0,0.279l-1.522,0.879v-0.279C73.948,247.798,74.29,247.206,74.709,246.964z  M74.926,249.571v0.499l-0.433,0.25v-0.499c-0.095-0.024-0.157-0.115-0.157-0.26c0-0.238,0.167-0.528,0.373-0.647 c0.206-0.119,0.374-0.023,0.374,0.216C75.083,249.275,75.021,249.438,74.926,249.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M75.577,251.085l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777v-2.533 c0-0.855,0.606-1.903,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777v2.533 C76.923,249.609,76.317,250.658,75.577,251.085z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M87.475,244.216l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777v-2.533 c0-0.855,0.605-1.904,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777l0,2.533 C88.82,242.74,88.215,243.789,87.475,244.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M87.336,239.912v2.422c0.154-0.155,0.364-0.264,0.568-0.277c0.329-0.021,0.518,0.215,0.42,0.527 c-0.098,0.312-0.444,0.582-0.773,0.604c-0.276,0.018-0.452-0.145-0.445-0.382l-0.001,0v-2.591l-1.379,0.089v2.96 c0.154-0.155,0.364-0.264,0.568-0.277c0.329-0.021,0.518,0.215,0.42,0.527c-0.097,0.312-0.444,0.583-0.773,0.604 c-0.281,0.018-0.458-0.151-0.444-0.395l-0.002,0.001c0-1.236,0-2.453,0-3.692C85.593,240.024,87.24,239.918,87.336,239.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M69.628,254.52l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777v-2.533 c0-0.855,0.605-1.904,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777v2.533 C70.974,253.043,70.368,254.092,69.628,254.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "68.818,252.544 70.299,250.484 70.299,252.77 67.235,254.539 67.235,252.171  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.235,252.048 67.411,252.089 68.767,252.409 70.123,250.524 70.299,250.279  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M69.678,261.085l-1.967,1.136c-0.74,0.427-1.346,0.078-1.346-0.777v-2.533 c0-0.855,0.605-1.904,1.346-2.331l1.967-1.136c0.74-0.427,1.346-0.078,1.346,0.777v2.533 C71.024,259.608,70.418,260.657,69.678,261.085z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "67.542,261.21 70.24,259.652 70.24,256.536 67.542,258.094  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "68.085,259.566 68.701,259.955 69.679,258.031 70.24,258.851 70.24,259.652  67.542,261.21 67.542,260.431  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M68.085,258.638c0-0.231,0.162-0.512,0.362-0.627c0.2-0.116,0.362-0.022,0.362,0.209 c0,0.231-0.162,0.512-0.362,0.627C68.247,258.962,68.085,258.869,68.085,258.638z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M253.234,239.907v11.6h-90.361v51.311h-40.587c-0.423,0.4-0.863,0.802-1.324,1.204 c-2.218,1.934-5.029,3.884-8.435,5.85c-6.813,3.934-12.572,6.456-17.272,7.565c-2.352,0.555-4.516,0.951-6.493,1.187 c-0.742,0.088-1.457,0.154-2.145,0.198c-0.459,0.029-0.906,0.048-1.342,0.056c-0.653,0.013-8.031,14.604-8.632,14.572v11.396 l28.497,16.56c1.446,0.118,3.231,0.095,5.35-0.059c2.118-0.153,4.651-0.605,7.597-1.355c2.944-0.751,6.326-1.901,10.148-3.455 c3.819-1.553,8.105-3.699,12.855-6.442c14.141-8.164,24.713-17.445,31.715-27.846c2.994-4.445,5.342-8.992,7.049-13.639 l14.337,8.332l97.091-57.03l-21.129-10.173L253.234,239.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M332.692,178.583l-10.207,19.431h-34.084v21.634l-24.56-14.02l-16.058,10.904 l45.735,26.448c-0.035-0.021-0.069-0.044-0.104-0.065c0.244,0.144,0.491,0.285,0.741,0.419c4.547,2.428,9.861,3.159,15.944,2.2 c6.083-0.96,12.547-3.415,19.394-7.368c7.038-4.064,13.617-9.139,19.735-15.223c6.115-6.084,11.384-12.925,15.807-20.532 c0.395-0.679,0.779-1.367,1.159-2.057L332.692,178.583z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000055682188957490957270000015897662716032935079_",
    style: {
      enableBackground: "new"
    },
    d: "M307.051,209.989 l-28.497-16.56c2.049,1.191,4.41,1.736,7.083,1.637c3.513-0.127,7.541-1.501,12.084-4.125 c4.438-2.563,8.437-5.822,11.992-9.776c3.557-3.954,6.542-8.38,8.959-13.282c2.415-4.896,4.26-10.15,5.538-15.761l28.497,16.56 c-1.279,5.611-3.124,10.865-5.538,15.761c-2.417,4.902-5.402,9.328-8.959,13.282c-3.556,3.954-7.554,7.214-11.992,9.776 c-4.543,2.623-8.572,3.998-12.084,4.125C311.461,211.725,309.1,211.18,307.051,209.989z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055682188957490957270000015897662716032935079_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065044453133481272660000007908447603619317901_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000055682188957490957270000015897662716032935079_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065044453133481272660000007908447603619317901_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M307.051,209.989l-28.497-16.56c2.049,1.191,4.41,1.736,7.083,1.637 c3.513-0.127,7.541-1.501,12.084-4.125c4.438-2.563,8.437-5.822,11.992-9.776c3.557-3.954,6.542-8.38,8.959-13.282 c2.415-4.896,4.26-10.15,5.538-15.761l28.497,16.56c-1.279,5.611-3.124,10.865-5.538,15.761 c-2.417,4.902-5.402,9.328-8.959,13.282c-3.556,3.954-7.554,7.214-11.992,9.776c-4.543,2.623-8.572,3.998-12.084,4.125 C311.461,211.725,309.1,211.18,307.051,209.989L307.051,209.989z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044888330646090832830000016797774654978208672_",
    style: {
      enableBackground: "new"
    },
    d: "M316.705,108.591 l28.497,16.561c0.633,0.368,1.234,0.797,1.805,1.288c2.435,2.1,4.304,5.241,5.61,9.415c1.303,4.18,1.966,9.292,1.983,15.341 c0.017,6.049-0.615,11.879-1.89,17.486l-28.497-16.56c1.275-5.607,1.907-11.437,1.89-17.486 c-0.017-6.049-0.68-11.162-1.983-15.341c-1.307-4.174-3.175-7.314-5.61-9.415C317.939,109.388,317.337,108.959,316.705,108.591 z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044888330646090832830000016797774654978208672_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042007904350864688660000015235451252960191371_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044888330646090832830000016797774654978208672_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000042007904350864688660000015235451252960191371_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M352.709,168.682l-28.497-16.56c1.275-5.607,1.907-11.437,1.89-17.486 c-0.017-6.049-0.68-11.162-1.983-15.341c-1.307-4.174-3.175-7.314-5.61-9.415c-0.571-0.491-1.172-0.921-1.805-1.288 l28.497,16.561c0.633,0.368,1.234,0.797,1.805,1.288c2.435,2.1,4.304,5.241,5.61,9.415c1.303,4.18,1.966,9.292,1.983,15.341 C354.616,157.245,353.984,163.075,352.709,168.682L352.709,168.682z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011031295424895111040000011783349909905255044_",
    style: {
      enableBackground: "new"
    },
    d: "M287.779,237.029 l-28.497-16.56c-4.546-2.642-8.157-7.014-10.834-13.111c-2.811-6.396-4.229-14.873-4.259-25.43 c-0.03-10.557,1.388-20.673,4.256-30.349c2.865-9.675,6.744-18.657,11.633-26.945c4.886-8.286,10.554-15.656,16.998-22.11 c6.442-6.453,13.228-11.737,20.35-15.849c7.33-4.232,14.25-6.861,20.761-7.886c6.511-1.026,12.199-0.211,17.068,2.443 c0.171,0.094,0.341,0.189,0.51,0.287l28.497,16.561c-0.169-0.098-0.339-0.194-0.51-0.287 c-4.869-2.654-10.556-3.469-17.067-2.443c-6.511,1.026-13.431,3.654-20.761,7.887c-7.121,4.112-13.907,9.396-20.35,15.849 c-6.444,6.454-12.112,13.824-16.997,22.11c-4.89,8.288-8.768,17.27-11.634,26.945c-2.869,9.676-4.286,19.792-4.256,30.349 c0.03,10.557,1.448,19.035,4.259,25.43C279.622,230.015,283.233,234.387,287.779,237.029z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011031295424895111040000011783349909905255044_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044882790957953399610000015218300832931582340_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011031295424895111040000011783349909905255044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044882790957953399610000015218300832931582340_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M287.779,237.029l-28.497-16.56c-4.546-2.642-8.157-7.014-10.834-13.111 c-2.811-6.396-4.229-14.873-4.259-25.43c-0.03-10.557,1.388-20.673,4.256-30.349c2.865-9.675,6.744-18.657,11.633-26.945 c4.886-8.286,10.554-15.656,16.998-22.11c6.442-6.453,13.228-11.737,20.35-15.849c7.33-4.232,14.25-6.861,20.761-7.886 c6.511-1.026,12.199-0.211,17.068,2.443c0.171,0.094,0.341,0.189,0.51,0.287l28.497,16.561 c-0.169-0.098-0.339-0.194-0.51-0.287c-4.869-2.654-10.556-3.469-17.067-2.443c-6.511,1.026-13.431,3.654-20.761,7.887 c-7.121,4.112-13.907,9.396-20.35,15.849c-6.444,6.454-12.112,13.824-16.997,22.11c-4.89,8.288-8.768,17.27-11.634,26.945 c-2.869,9.676-4.286,19.792-4.256,30.349c0.03,10.557,1.448,19.035,4.259,25.43 C279.622,230.015,283.233,234.387,287.779,237.029L287.779,237.029z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M375.268,111.371c2.811,6.398,4.229,14.876,4.259,25.433c0.03,10.558-1.312,20.629-4.024,30.213 c-2.714,9.586-6.438,18.452-11.169,26.587c-4.734,8.143-10.375,15.466-16.921,21.978c-6.549,6.513-13.591,11.945-21.125,16.295 c-7.33,4.232-14.249,6.859-20.76,7.887c-6.511,1.026-12.201,0.244-17.068-2.356c-4.868-2.593-8.706-7.092-11.515-13.49 c-2.811-6.396-4.229-14.873-4.259-25.43c-0.03-10.557,1.388-20.673,4.256-30.349c2.865-9.675,6.744-18.657,11.634-26.945 c4.886-8.286,10.553-15.656,16.997-22.11c6.442-6.453,13.228-11.737,20.35-15.849c7.33-4.232,14.25-6.861,20.761-7.887 c6.512-1.026,12.199-0.211,17.067,2.443C368.619,100.447,372.459,104.972,375.268,111.371z M352.709,168.682 c1.275-5.607,1.907-11.437,1.89-17.486c-0.017-6.049-0.68-11.161-1.983-15.341c-1.306-4.174-3.175-7.314-5.61-9.415 c-2.436-2.097-5.437-3.069-9.005-2.91c-3.566,0.16-7.57,1.52-12.009,4.083c-4.544,2.623-8.566,5.924-12.068,9.907 c-3.505,3.985-6.467,8.428-8.882,13.326c-2.416,4.901-4.263,10.186-5.538,15.851c-1.279,5.671-1.907,11.469-1.89,17.399 c0.017,6.049,0.677,11.134,1.982,15.25c1.303,4.12,3.174,7.23,5.61,9.325c2.435,2.1,5.411,3.085,8.927,2.955 c3.513-0.127,7.541-1.501,12.084-4.125c4.438-2.563,8.437-5.822,11.992-9.776c3.557-3.953,6.542-8.38,8.959-13.282 C349.586,179.547,351.43,174.293,352.709,168.682L352.709,168.682z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "218.29,268.388 189.793,251.828 241.665,221.879 270.162,238.44  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "218.141,215.9 189.645,199.339 232.536,174.576 261.033,191.136  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "194.2,305.642 165.703,289.081 165.354,165.779 193.851,182.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4DBEF"
    },
    points: "193.851,182.34 165.354,165.779 237.821,123.94 266.318,140.501  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEFEFE"
    },
    points: "266.318,140.501 266.384,163.808 218.073,191.701 218.141,215.9 261.033,191.136  261.098,213.909 218.206,238.673 218.29,268.388 270.162,238.44 270.228,261.747 194.2,305.642 193.851,182.34  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4DBEF"
    },
    points: "105.148,350.105 76.652,333.545 83.403,307.549 111.899,324.11  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016762983981993031490000012949109788425905308_",
    style: {
      enableBackground: "new"
    },
    d: "M126.833,269.313 l28.497,16.561c1.996,1.16,2.999,3.305,3.008,6.433c0.005,1.901-0.25,3.771-0.76,5.609c-0.514,1.841-1.439,3.713-2.777,5.612 c-1.339,1.904-3.118,3.823-5.334,5.754c-2.218,1.934-5.03,3.884-8.435,5.85c-6.813,3.934-12.572,6.457-17.272,7.565 c-4.703,1.111-8.658,1.584-11.861,1.412l-28.497-16.561c3.203,0.171,7.158-0.302,11.861-1.412 c4.699-1.109,10.458-3.631,17.272-7.565c3.406-1.966,6.217-3.916,8.435-5.85c2.217-1.932,3.995-3.85,5.335-5.754 c1.338-1.9,2.263-3.771,2.777-5.612c0.51-1.838,0.765-3.708,0.76-5.608C129.832,272.618,128.83,270.473,126.833,269.313z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016762983981993031490000012949109788425905308_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124142661894834273500000017635439980266298798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016762983981993031490000012949109788425905308_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124142661894834273500000017635439980266298798_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M111.899,324.11l-28.497-16.561c3.203,0.171,7.158-0.302,11.861-1.412 c4.699-1.109,10.458-3.631,17.272-7.565c3.406-1.966,6.217-3.916,8.435-5.85c2.217-1.932,3.995-3.85,5.335-5.754 c1.338-1.9,2.263-3.771,2.777-5.612c0.51-1.838,0.765-3.708,0.76-5.608c-0.009-3.128-1.012-5.273-3.009-6.433l28.497,16.561 c1.996,1.16,2.999,3.305,3.008,6.433c0.005,1.901-0.25,3.771-0.76,5.609c-0.514,1.841-1.439,3.713-2.777,5.612 c-1.339,1.904-3.118,3.823-5.334,5.754c-2.218,1.934-5.03,3.884-8.435,5.85c-6.813,3.934-12.572,6.457-17.272,7.565 C119.057,323.808,115.103,324.281,111.899,324.11L111.899,324.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146484463402045939640000010080262277416034460_",
    style: {
      enableBackground: "new"
    },
    d: "M146.827,240.394 l28.497,16.56c-0.085-0.05-0.172-0.098-0.258-0.146c-2.745-1.503-6.186-2.22-10.32-2.149 c-4.137,0.071-8.995,0.531-14.576,1.376l-28.497-16.561c5.581-0.845,10.439-1.305,14.576-1.376 c4.134-0.071,7.574,0.646,10.32,2.149C146.656,240.295,146.741,240.344,146.827,240.394z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146484463402045939640000010080262277416034460_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032610227258678668560000013744477494029748152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146484463402045939640000010080262277416034460_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032610227258678668560000013744477494029748152_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M150.169,256.035l-28.497-16.561c5.581-0.845,10.439-1.305,14.576-1.376 c4.134-0.071,7.574,0.646,10.32,2.149c0.087,0.048,0.173,0.096,0.258,0.146l28.497,16.56c-0.085-0.05-0.172-0.098-0.258-0.146 c-2.745-1.503-6.186-2.22-10.32-2.149C160.609,254.73,155.751,255.189,150.169,256.035L150.169,256.035z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000165927049638207554810000009403064463680978328_",
    style: {
      enableBackground: "new"
    },
    d: "M134.215,256.285 l-28.497-16.561c0.755,0.439,1.654,0.738,2.697,0.899c1.707,0.26,3.671,0.258,5.894-0.017c2.223-0.273,4.676-0.65,7.364-1.132 l28.497,16.561c-2.688,0.482-5.141,0.859-7.364,1.132c-2.223,0.275-4.186,0.278-5.894,0.018 C135.869,257.023,134.97,256.724,134.215,256.285z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165927049638207554810000009403064463680978328_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170966568594170327650000005703074820318823061_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165927049638207554810000009403064463680978328_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170966568594170327650000005703074820318823061_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M134.215,256.285l-28.497-16.561c0.755,0.439,1.654,0.738,2.697,0.899 c1.707,0.26,3.671,0.258,5.894-0.017c2.223-0.273,4.676-0.65,7.364-1.132l28.497,16.561c-2.688,0.482-5.141,0.859-7.364,1.132 c-2.223,0.275-4.186,0.278-5.894,0.018C135.869,257.023,134.97,256.724,134.215,256.285L134.215,256.285z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106133469540711537020000010401092360190457527_",
    style: {
      enableBackground: "new"
    },
    d: "M146.154,207.025 l-28.497-16.56c7.225-4.171,13.473-6.887,18.744-8.148c5.27-1.259,9.611-1.807,13.022-1.637l28.497,16.56 c-3.412-0.169-7.753,0.378-13.022,1.637C159.627,200.138,153.378,202.854,146.154,207.025z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106133469540711537020000010401092360190457527_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090268442749525981130000016778320239865046439_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106133469540711537020000010401092360190457527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090268442749525981130000016778320239865046439_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M146.154,207.025l-28.497-16.56c7.225-4.171,13.473-6.887,18.744-8.148 c5.27-1.259,9.611-1.807,13.022-1.637l28.497,16.56c-3.412-0.169-7.753,0.378-13.022,1.637 C159.627,200.138,153.378,202.854,146.154,207.025L146.154,207.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129922988363546398540000001181160436217430437_",
    style: {
      enableBackground: "new"
    },
    d: "M114.765,285.262 l-28.497-16.561c-2.113-1.228-3.886-3.044-5.319-5.45c-1.768-2.957-2.656-7.287-2.672-12.98 c-0.016-5.693,0.897-11.359,2.743-17c1.846-5.637,4.466-11.045,7.865-16.213c3.396-5.17,7.516-10.013,12.366-14.536 c4.845-4.519,10.313-8.54,16.406-12.057l28.497,16.56c-6.092,3.518-11.561,7.538-16.406,12.057 c-4.85,4.523-8.97,9.366-12.366,14.536c-3.399,5.169-6.019,10.576-7.865,16.213c-1.845,5.641-2.759,11.306-2.743,17 c0.016,5.694,0.904,10.024,2.673,12.98C110.88,282.218,112.653,284.034,114.765,285.262z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129922988363546398540000001181160436217430437_",
    style: {
      overflow: "visible",
      fill: "#D4DBEF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150098667727867485870000002997624253357357231_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129922988363546398540000001181160436217430437_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150098667727867485870000002997624253357357231_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M114.765,285.262l-28.497-16.561c-2.113-1.228-3.886-3.044-5.319-5.45 c-1.768-2.957-2.656-7.287-2.672-12.98c-0.016-5.693,0.897-11.359,2.743-17c1.846-5.637,4.466-11.045,7.865-16.213 c3.396-5.17,7.516-10.013,12.366-14.536c4.845-4.519,10.313-8.54,16.406-12.057l28.497,16.56 c-6.092,3.518-11.561,7.538-16.406,12.057c-4.85,4.523-8.97,9.366-12.366,14.536c-3.399,5.169-6.019,10.576-7.865,16.213 c-1.845,5.641-2.759,11.306-2.743,17c0.016,5.694,0.904,10.024,2.673,12.98C110.88,282.218,112.653,284.034,114.765,285.262 L114.765,285.262z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M146.154,207.025c7.225-4.171,13.473-6.887,18.744-8.148c5.269-1.259,9.61-1.807,13.022-1.637 l-6.904,25.908c-3.001-0.05-6.334,0.301-10.002,1.05c-3.67,0.756-8.084,2.619-13.245,5.599 c-5.781,3.337-9.933,6.656-12.456,9.952c-2.526,3.303-3.781,6.848-3.771,10.643c0.007,2.255,0.476,3.885,1.41,4.889 c0.934,1.006,2.254,1.64,3.96,1.903c1.708,0.26,3.671,0.257,5.894-0.018c2.223-0.273,4.677-0.65,7.364-1.132 c5.581-0.845,10.439-1.305,14.576-1.376c4.133-0.071,7.574,0.646,10.32,2.149c2.742,1.509,4.793,3.947,6.147,7.324 c1.353,3.379,2.038,8.032,2.055,13.96c0.033,11.508-3.451,22.46-10.453,32.857c-7.002,10.401-17.573,19.682-31.715,27.846 c-4.75,2.743-9.036,4.888-12.855,6.442c-3.823,1.553-7.205,2.704-10.149,3.454c-2.945,0.75-5.478,1.202-7.596,1.355 c-2.12,0.154-3.904,0.176-5.351,0.059l6.751-25.995c3.203,0.171,7.158-0.302,11.861-1.412c4.7-1.109,10.459-3.632,17.272-7.565 c3.406-1.966,6.217-3.916,8.435-5.85c2.216-1.931,3.995-3.85,5.334-5.754c1.337-1.9,2.263-3.771,2.777-5.612 c0.51-1.838,0.765-3.708,0.76-5.609c-0.011-4.03-1.673-6.428-4.983-7.191c-3.314-0.761-8.998-0.357-17.057,1.204 c-3.515,0.603-7.03,1.002-10.545,1.188c-3.516,0.19-6.67-0.306-9.465-1.486c-2.796-1.177-5.077-3.245-6.842-6.209 c-1.769-2.957-2.657-7.287-2.673-12.98c-0.016-5.694,0.897-11.359,2.743-17c1.846-5.637,4.466-11.045,7.865-16.213 c3.396-5.17,7.517-10.013,12.366-14.536C134.593,214.563,140.061,210.542,146.154,207.025z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M186.018,161.471c5.303,3.062,5.303,8.027,0,11.089 c-5.304,3.062-13.902,3.062-19.206,0c-5.303-3.062-5.303-8.027,0-11.089C172.115,158.409,180.714,158.409,186.018,161.471z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10191B"
    },
    d: "M158.659,185.506c-1.952,1.128-3.777,2.46-5.599,3.789c-0.52,0.38-1.042,0.514-1.497,0.972 c-0.372,0.374-0.869,1.131-0.871,1.684c-0.003,0.725,1.489,1.161,2.058,1.294c0.796,0.186,1.549,0.187,2.339-0.002 c0.769-0.185,1.257-0.593,1.73-1.223c0.424-0.566,0.837-1.194,1.484-1.481c0.606-0.27,1.383-0.225,1.825-0.717 c0.228-0.253,0.314-0.599,0.373-0.934c0.112-0.629,0.038-1.283,0.146-1.901c0.08-0.454,0.261-0.939,0.194-1.41 c-0.057-0.402-0.502-0.715-0.879-0.796c-0.42-0.09-0.867,0.027-1.231,0.255L158.659,185.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M173.089,152.317c0.908-2.114,1.766-4.903,2.959-8.374c0.321-0.934,0.504-1.932,0.517-2.927 c0.014-1.004-0.302-1.852-0.773-2.759c-0.213-0.411-0.509-0.851-0.972-0.946c-0.422-0.086-0.826,0.15-1.157,0.401 c-1.997,1.511-3.099,4.024-3.557,6.41c-0.427,2.218-0.318,4.855-0.497,7.121c-0.034,0.43,0.151,4.132,1.547,3.503 C171.839,154.437,172.595,153.467,173.089,152.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M172.637,150.199c-0.482-0.371-2.229-1.133-2.529-0.67c-0.208,0.32-1.371,2.659-2.347,4.005 c1.293,0.899,2.436,1.95,3.524,3.055c1.459-1.768,2.772-3.717,2.755-4.949C174.033,151.016,173.276,150.691,172.637,150.199z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10191B"
    },
    d: "M167.38,189.977c-1.731,1.398-3.309,2.977-4.882,4.552c-0.45,0.45-0.901,0.905-1.276,1.422 c-0.305,0.422-0.712,0.992-0.63,1.531c0.107,0.708,1.627,0.907,2.202,0.95c0.803,0.06,1.538-0.054,2.278-0.359 c0.722-0.298,1.135-0.77,1.501-1.458c0.329-0.617,0.636-1.292,1.223-1.672c0.55-0.355,1.314-0.43,1.671-0.978 c0.183-0.282,0.215-0.633,0.222-0.969c0.013-0.63-0.157-1.257-0.145-1.877c0.008-0.454,0.111-0.956-0.024-1.405 c-0.116-0.383-0.597-0.621-0.977-0.642c-0.423-0.023-0.84,0.16-1.161,0.437L167.38,189.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M185.209,156.066l-0.01,0.011c-0.102,0.796-0.169,1.597-0.198,2.399 C185.04,157.67,185.108,156.866,185.209,156.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M185.001,158.476c-0.023,0.489-0.035,0.979-0.035,1.469c0.009-0.005,0.019-0.009,0.028-0.014 C184.981,159.446,184.984,158.961,185.001,158.476z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404B63"
    },
    d: "M156.982,167.92c-1.169,0.763-2.48,5.858,2.034,6.047c2.331,0.098,4.45-1.214,6.545-2.241 c2.887-1.416,5.984-2.353,8.906-3.696c0.896-0.411,1.781-0.865,2.549-1.482c1.871-1.503,2.914-3.979,2.68-6.367 c-0.033-0.337-0.092-0.679-0.257-0.974c-0.783-1.399-5.722-0.93-6.874-0.36C168.314,160.952,158.19,167.131,156.982,167.92z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404B63"
    },
    d: "M155.604,171.542c0.066,1.247,0.18,2.472,0.363,3.715c0.203,1.375,0.423,2.749,0.493,4.139 c0.075,1.495-0.026,2.99-0.002,4.486c0.015,0.933-0.014,1.889,0.231,2.797c0.116,0.429,0.261,0.899,0.651,1.138 c0.457,0.281,1.011,0.447,1.54,0.518c0.367,0.05,0.747,0.052,1.1-0.063c1.185-0.384,1.23-2.041,1.469-3.061 c0.221-0.942,0.384-1.897,0.509-2.856c0.245-1.882,0.335-3.777,0.441-5.67c0.064-1.258,0.129-2.518,0.083-3.778 c-0.041-1.15-0.081-2.336-0.616-3.361c-0.525-1.009-1.707-1.742-2.799-1.965c-1.238-0.252-2.413,0.227-3.029,1.355 c-0.365,0.668-0.488,1.449-0.454,2.209C155.591,171.278,155.597,171.41,155.604,171.542z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546282"
    },
    d: "M164.704,172.29c-1.058,0.871-1.976,6.236,2.315,6.116c2.216-0.062,4.14-1.567,6.061-2.777 c6.16-3.88,13.832-5.234,12.659-12.933c-0.107-0.707-0.293-3.704-0.841-4.044c-0.395-0.245-2.61,0.537-3.108,0.619 c-4.794,0.795-5.415,0.816-6.206,1.358c-0.131,3.596-0.709,4.222-2.678,5.404 C171.997,166.579,165.501,171.634,164.704,172.29z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546282"
    },
    d: "M163.777,175.865c0.15,1.239,0.346,2.454,0.612,3.681c0.295,1.357,0.608,2.715,0.77,4.096 c0.175,1.487,0.176,2.986,0.3,4.476c0.077,0.929,0.113,1.885,0.419,2.775c0.145,0.42,0.321,0.88,0.726,1.092 c0.476,0.25,1.04,0.378,1.572,0.414c0.37,0.025,0.749,0.001,1.093-0.137c1.157-0.463,1.089-2.12,1.26-3.153 c0.157-0.954,0.256-1.918,0.316-2.883c0.118-1.895,0.079-3.791,0.058-5.687c-0.021-1.259-0.042-2.521-0.171-3.774 c-0.118-1.146-0.238-2.326-0.84-3.313c-0.592-0.971-1.821-1.623-2.925-1.771c-1.252-0.168-2.393,0.388-2.931,1.555 c-0.319,0.691-0.389,1.478-0.304,2.235C163.746,175.602,163.761,175.734,163.777,175.865z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDE3F4"
    },
    d: "M185.209,140.573c-1.42-0.962-4.257-2.227-7.03-3.095c-3.884-1.216-4.43,0.2-5.547,3.299 c-1.04,2.884-0.739,7.64-0.273,10.71c0.246,1.626,0.398,3.266,0.454,4.91c0.02,0.595-0.106,1.208-0.177,1.796 c-0.032,0.262-0.116,0.546-0.015,0.784c0.131,0.309,0.591,0.634,0.844,0.844c1.202,0.993,2.742,1.547,4.289,1.665 c2.172,0.162,4.518-0.237,6.582-0.899c0.435-0.14,0.889-0.313,1.168-0.674c0.245-0.317,0.318-0.731,0.374-1.128 c0.183-1.278,0.285-2.569,0.305-3.86c0.009-0.58,0.001-1.161,0.046-1.74c0.066-0.85,0.244-1.687,0.427-2.52 c0.25-1.143,0.508-2.285,0.773-3.424c0.133-0.57,0.267-1.139,0.404-1.708c0.101-0.421,0.273-0.78,0.25-1.217 C187.994,142.621,186.499,141.447,185.209,140.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M180.133,149.18c-0.835,4.054-1.669,8.229-5.605,10.256c-0.311,0.16-0.601,0.339-0.876,0.533 c1.173,0.9,2.633,1.405,4.101,1.517c2.172,0.162,4.518-0.237,6.582-0.899c0.435-0.14,0.889-0.313,1.168-0.674 c0.245-0.317,0.318-0.731,0.374-1.128c0.183-1.278,0.285-2.569,0.305-3.86c0.009-0.58,0.001-1.161,0.046-1.74 c0.066-0.85,0.244-1.687,0.427-2.52c0.25-1.143,0.508-2.285,0.773-3.424c0.133-0.57,0.267-1.139,0.404-1.708 c0.101-0.421,0.273-0.78,0.25-1.217c-0.012-0.238-0.053-0.465-0.116-0.683c-0.659,0.275-1.33,0.521-1.99,0.778 C183.591,145.363,180.61,146.676,180.133,149.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9ECF5"
    },
    d: "M187.365,157.456c0.68-2.198,1.239-5.062,2.059-8.639c0.221-0.963,0.298-1.975,0.206-2.966 c-0.092-0.999-0.496-1.81-1.06-2.662c-0.255-0.386-0.596-0.793-1.066-0.839c-0.428-0.041-0.805,0.236-1.109,0.52 c-1.827,1.713-2.657,4.329-2.862,6.749c-0.191,2.252-0.696,4.47-0.868,6.732c-0.033,0.43-0.096,0.889-0.039,1.322 c0.268,2.056,1.75,3.174,3.072,2.401C186.345,159.696,186.995,158.651,187.365,157.456z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M178.082,158.22c-0.412,0.35-0.9,0.769-1.304,1.118c-0.586-0.921-0.603-0.997-1.146-1.921 c-0.017-5.48,0.218-10.616,1.527-15.862c0.507,0.36,0.761,0.539,1.274,0.901C177.767,147.474,177.355,152.698,178.082,158.22 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283032"
    },
    d: "M176.614,141.429c-0.006,0.023-0.009,0.047-0.008,0.077c0.005,0.155,0.1,0.348,0.152,0.492 c0.113,0.313,0.256,0.616,0.426,0.903c0.093,0.157,0.204,0.318,0.373,0.387c0.189,0.077,0.41,0.021,0.588-0.08 c0.204-0.115,0.577-0.284,0.531-0.539c-0.04-0.221-0.119-0.446-0.191-0.659c-0.149-0.436-0.351-0.976-0.754-1.243 c-0.452-0.3-0.773,0.15-1.012,0.484C176.67,141.323,176.63,141.366,176.614,141.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9C76"
    },
    d: "M182.336,139.21c-0.035-1.101-0.781-1.391-0.558-3.486c0.075-0.707,0.847-1.719-1.147-1.682 c-0.547,0.01-1.089,0.141-1.606,0.311c-1.863,0.613-2.126,1.072-2.244,4.928c1.588-0.152,2.991-1.904,4.609-0.864 c0.431,0.323,0.721,0.74,0.923,1.199C182.333,139.487,182.341,139.352,182.336,139.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5A783"
    },
    d: "M181.391,138.417c-1.618-1.04-3.021,0.712-4.609,0.864c-0.001,0.055-0.003,0.107-0.005,0.163 c-0.079,2.743,5.137,2.823,5.536,0.171C182.112,139.156,181.822,138.74,181.391,138.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.718,141.096c-0.102,0.327-0.534,0.441-0.819,0.631c-0.126,0.084-0.343,0.246-0.507,0.211 c-0.166-0.034-0.265-0.255-0.321-0.391c-0.406-0.987-0.637-2.063-0.647-3.131c-0.003-0.339,0.051-0.717,0.317-0.956 c0.238-0.214,0.649-0.26,0.941-0.132c0.314,0.137,0.39,0.755,0.278,1.04C176.558,139.393,177.014,140.572,177.718,141.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.673,141.109c0,0,0.499,0.788,1.107,1.329c0.151,0.134,0.272,0.299,0.473,0.235 c0.985-0.316,3.059-2.058,3.472-3.16c0.149-0.398-0.139-0.892-0.366-1.205c-0.04-0.055-0.357-0.485-0.418-0.527 c-0.041,0.062-0.255,0.852-0.601,1.363C180.543,140.319,179.087,140.917,177.673,141.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M174.803,129.597c-0.397,0.634-0.63,1.367-0.622,2.145c0.004,0.335,0.059,0.669,0.171,0.985 c0.106,0.3,0.295,0.582,0.298,0.909c0.004,0.383-0.272,0.811-0.397,1.172c-0.113,0.327-0.177,0.692-0.048,1.013 c0.074,0.183,0.206,0.337,0.312,0.505c0.507,0.796,0.029,1.97,0.911,2.542c0.22,0.143,0.48,0.171,0.742,0.185 c0.326,0.017,1.798-0.395,2.368-0.647c0.629-0.277,1.242-0.993,1.697-1.51c0.355-0.404,0.952-0.923,1.179-1.409 c0.07-0.149-0.098-0.176,0.054-0.25c0.092-0.045,0.203-0.63,0.305-0.641c0.121-0.013,0.285-0.147,0.388-0.216 c0.197-0.132,0.291,0.348,0.356,0.119c0.276-0.969,0.627-1.958,0.585-2.98c-0.038-0.936-0.017-1.739-0.62-2.535 c-0.452-0.598-1.099-1.033-1.8-1.3c-1.071-0.407-2.284-0.429-3.368-0.06C176.289,127.974,175.376,128.684,174.803,129.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M183.104,131.519c-0.038-0.936-0.017-1.739-0.62-2.535c-0.452-0.598-1.099-1.033-1.8-1.3 c-0.639-0.243-1.329-0.346-2.012-0.313c-1.022,2.041,0.458,4.656-0.656,6.773c-0.373,0.497-1.119,0.87-1.119,1.492 c-0.248,1.117,0.866,2.11,0.252,3.226c0.511-0.137,1.082-0.319,1.39-0.456c0.629-0.277,1.242-0.993,1.697-1.51 c0.355-0.404,0.952-0.923,1.179-1.409c0.07-0.149-0.098-0.176,0.054-0.25c0.092-0.045,0.203-0.63,0.305-0.641 c0.121-0.013,0.285-0.147,0.388-0.216c0.197-0.132,0.291,0.347,0.356,0.119C182.795,133.53,183.145,132.541,183.104,131.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M183.758,131.372c0.07-2.729-1.822-3.237-1.822-3.237s-0.834-1.414-3.033-1.308 c-1.156,0.055-2.287,0.431-3.264,1.041c-0.039,0.024-0.078,0.049-0.117,0.075c-0.473,0.308-0.923,0.674-1.229,1.149 c-0.844,1.304,0.293,2.35,1.66,2.131c0.644-0.103,1.238-0.401,1.853-0.617c0.427-0.149,0.908-0.258,1.32-0.072 c0.411,0.185,0.656,0.63,0.722,1.076c0.144,0.982-0.194,1.963-0.222,2.937c-0.004,0.146,0.005,0.299,0.077,0.427 c0.196,0.347,0.564,0.158,0.772-0.062c0.133-0.141,0.237-0.307,0.365-0.452c0.128-0.146,0.288-0.276,0.479-0.31 c0.305-0.055,0.539,0.185,0.588,0.467c0.044,0.258-0.004,0.516-0.072,0.765c-0.016,0.059-0.145,0.508,0.04,0.51 C182.059,135.891,183.685,134.217,183.758,131.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251B29"
    },
    d: "M178.354,130.459c0.264-0.042,0.53-0.035,0.772,0.074c0.411,0.185,0.656,0.63,0.722,1.076 c0.144,0.982-0.194,1.963-0.222,2.937c-0.004,0.146,0.005,0.299,0.077,0.427c0.196,0.347,0.564,0.158,0.772-0.062 c0.133-0.141,0.237-0.307,0.365-0.452c0.128-0.146,0.288-0.276,0.479-0.31c0.305-0.055,0.539,0.185,0.588,0.467 c0.044,0.258-0.004,0.516-0.072,0.765c-0.016,0.059-0.145,0.508,0.04,0.51c0.185,0.002,1.811-1.672,1.884-4.517 c0.07-2.729-1.822-3.237-1.822-3.237s-0.8,0.135-1.79,0.796C179.104,129.625,178.354,130.459,178.354,130.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M181.97,135.345c-0.377,0.525-0.979,0.737-1.346,0.474c-0.367-0.263-0.36-0.902,0.015-1.426 c0.376-0.525,0.979-0.738,1.346-0.475C182.353,134.181,182.346,134.82,181.97,135.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M181.626,134.479c0.11,0.131,0.102,0.345-0.016,0.468c-0.145,0.153-0.419,0.17-0.505,0.363 c-0.032,0.072-0.038,0.169-0.109,0.203c-0.077,0.037-0.171-0.043-0.177-0.128c-0.006-0.086,0.045-0.164,0.102-0.229 c0.056-0.065,0.121-0.126,0.151-0.207c0.031-0.086,0.017-0.18,0.012-0.271C181.067,134.363,181.42,134.232,181.626,134.479z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#10191B"
    },
    points: "155.203,165.289 155.207,166.599 170.359,175.405 170.356,174.094  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#251B29"
    },
    points: "170.356,174.094 170.359,175.405 179.761,169.977 179.758,168.666  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "155.203,165.289 170.356,174.094 179.758,168.666 164.605,159.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0D1315"
    },
    points: "167.032,164.449 171.149,166.826 173.395,165.529 169.278,163.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0D1315"
    },
    points: "175.633,170.125 161.794,162.082 156.85,164.942 170.689,172.985  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M166.154,161.878c-0.12,0.248-0.564,0.9-0.76,1.095c-0.195,0.194-0.059-0.619-0.334-0.609 c-0.419,0.016-0.874,0.283-1.191,0.009c-0.253-0.219-0.503-0.448-0.693-0.724c-0.189-0.276-0.314-0.608-0.29-0.942 c0.01-0.129,0.042-0.26,0.116-0.367c0.05-0.072,0.117-0.132,0.183-0.19c0.372-0.33,0.745-0.659,1.117-0.989 c0.081-0.072,0.163-0.144,0.258-0.197c0.128-0.071,0.275-0.101,0.422-0.109c0.519-0.03,1.013,0.225,1.36,0.6 c0.167,0.18,0.362,0.432,0.417,0.678c0.046,0.206-0.098,0.436-0.163,0.629C166.468,161.141,166.329,161.518,166.154,161.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M166.643,160.878c0.027,0.544,0.054,1.088,0.081,1.633c0.01,0.209,0.02,0.423-0.029,0.627 c-0.038,0.158-0.111,0.306-0.166,0.459c-0.05,0.14-0.085,0.286-0.147,0.421c-0.186,0.408-0.587,0.67-0.968,0.908 c-0.156,0.097-0.316,0.197-0.497,0.228c-0.115,0.021-0.26-0.004-0.302-0.113c-0.02-0.052-0.011-0.111-0.001-0.165 c0.03-0.158,0.064-0.321,0.16-0.45c0.116-0.156,0.305-0.241,0.435-0.386c0.222-0.25,0.224-0.632,0.121-0.951 c-0.104-0.318-0.294-0.6-0.427-0.907c-0.133-0.307-0.204-0.668-0.06-0.97c0.051-0.107,0.126-0.2,0.205-0.289 c0.181-0.206,0.387-0.397,0.637-0.51c0.212-0.096,0.461-0.131,0.688-0.066C166.624,160.419,166.631,160.64,166.643,160.878z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M164.122,161.552c0.304-0.142,0.926,0.525,0.981,0.703c0.132,0.429-0.309,0.069-0.867,0.931 c-0.162,0.251-0.327,0.508-0.395,0.799c-0.049,0.212-0.072,0.476-0.271,0.565c-0.153,0.068-0.337-0.022-0.427-0.164 c-0.047,0.302-0.503,0.058-0.594-0.246c-0.174-0.589-0.623-0.052-0.691-1.083c-0.056,0.024-0.112,0.049-0.169,0.073 c-0.692-0.568,0.751-2.223,1.378-2.868C164.175,159.12,164.429,160.908,164.122,161.552z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M171.286,156.481c-1.063-1.078-1.678-3.056-2.94-3.934c-1.14,1.571-3.179,4.723-3.789,6.071 c-0.567,1.252,1.851,2.421,2.433,1.776C167.468,159.864,169.995,158.046,171.286,156.481z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M173.427,166.552c-0.271,0.143-0.98,0.663-1.189,0.888c-0.209,0.225,0.692,0.042,0.69,0.349 c-0.002,0.467-0.281,0.984,0.037,1.326c0.254,0.273,0.518,0.543,0.833,0.742c0.315,0.2,0.689,0.326,1.06,0.286 c0.144-0.016,0.288-0.057,0.404-0.143c0.079-0.059,0.143-0.135,0.205-0.211c0.352-0.428,0.704-0.855,1.057-1.282 c0.077-0.093,0.155-0.187,0.209-0.296c0.073-0.146,0.102-0.311,0.105-0.474c0.013-0.578-0.291-1.119-0.721-1.49 c-0.207-0.179-0.495-0.386-0.771-0.438c-0.232-0.043-0.482,0.126-0.694,0.205C174.237,166.174,173.822,166.344,173.427,166.552 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M174.523,165.969c-0.607-0.008-1.214-0.017-1.821-0.026c-0.234-0.003-0.471-0.006-0.697,0.057 c-0.174,0.049-0.336,0.135-0.504,0.203c-0.154,0.061-0.315,0.105-0.463,0.18c-0.448,0.223-0.722,0.68-0.973,1.113 c-0.102,0.177-0.206,0.36-0.235,0.561c-0.018,0.129,0.015,0.29,0.138,0.332c0.059,0.02,0.123,0.007,0.184-0.006 c0.175-0.039,0.355-0.084,0.495-0.196c0.17-0.135,0.257-0.349,0.413-0.499c0.269-0.257,0.695-0.273,1.053-0.171 c0.358,0.102,0.679,0.304,1.026,0.44c0.347,0.136,0.753,0.201,1.082,0.029c0.118-0.061,0.219-0.148,0.314-0.239 c0.222-0.209,0.426-0.446,0.543-0.729c0.099-0.24,0.129-0.519,0.047-0.768C175.035,165.972,174.788,165.973,174.523,165.969z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9ECF5"
    },
    d: "M176.427,167.749c0.759,0.16,1.534-0.346,2.12-0.781c1.413-1.047,8.317-6.774,8.781-9.441 c0.117-0.673-0.645-1.031-1.243-1.569c-0.452-0.406-2.809,0.077-3.232,0.574c-0.663,0.779-5.745,5.926-7.492,8.504 c-0.231,0.341-0.455,0.717-0.449,1.122C174.923,166.809,175.839,167.626,176.427,167.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M173.87,168.802c0.146-0.343-0.621-1.011-0.821-1.064c-0.483-0.129-0.066,0.346-1.003,1.001 c-0.272,0.19-0.552,0.384-0.873,0.471c-0.234,0.063-0.527,0.099-0.618,0.324c-0.07,0.172,0.037,0.374,0.199,0.469 c-0.334,0.063-0.045,0.563,0.298,0.651c0.662,0.171,0.083,0.692,1.233,0.727c-0.025,0.064-0.049,0.128-0.075,0.192 c0.659,0.747,2.445-0.923,3.139-1.646C176.575,168.648,174.575,168.436,173.87,168.802z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000056395650719812376630000003613650090828295570_",
    d: "M153.023,156.231l-1.133,0.659 c0.079-0.046,0.187-0.039,0.307,0.03l1.133-0.659C153.21,156.192,153.102,156.186,153.023,156.231z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176734437375055469830000008943394153225090737_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056395650719812376630000003613650090828295570_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168093539952557478460000012161853222735903898_",
    d: "M153.023,156.231l-1.133,0.659 c0.079-0.046,0.187-0.039,0.307,0.03l1.133-0.659C153.21,156.192,153.102,156.186,153.023,156.231z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168093539952557478460000012161853222735903898_",
    style: {
      overflow: "visible",
      fill: "#372B3D"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045579831810471257120000012340749716884162997_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168093539952557478460000012161853222735903898_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000045579831810471257120000012340749716884162997_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M152.197,156.921l1.133-0.659c-0.046-0.027-0.09-0.044-0.132-0.053l-1.133,0.659 C152.107,156.876,152.151,156.894,152.197,156.921L152.197,156.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M152.065,156.868l1.133-0.659c-0.063-0.014-0.121-0.007-0.168,0.018l-1.133,0.658 C151.945,156.861,152.002,156.854,152.065,156.868L152.065,156.868z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "151.898,156.886 153.031,156.228 153.023,156.231 151.89,156.89 151.898,156.886  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173844300087303350800000012442965525510137525_",
    d: "M153.023,156.231l-1.133,0.659 c0.079-0.046,0.187-0.039,0.307,0.03l1.133-0.659C153.21,156.192,153.102,156.186,153.023,156.231z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092432042006630921600000004953770722598142893_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173844300087303350800000012442965525510137525_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "166.488,165.227 167.621,164.568 153.33,156.262 152.197,156.921  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000019680398867319664560000004399668555309328030_",
    d: "M166.92,165.973l1.134-0.659 c0.001-0.274-0.194-0.608-0.433-0.746l-1.133,0.659C166.727,165.365,166.921,165.698,166.92,165.973z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143616592418640953140000005933249303429989779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019680398867319664560000004399668555309328030_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089572217626763178300000014835053829559598740_",
    d: "M166.92,165.973l1.134-0.659 c0.001-0.274-0.194-0.608-0.433-0.746l-1.133,0.659C166.727,165.365,166.921,165.698,166.92,165.973z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089572217626763178300000014835053829559598740_",
    style: {
      overflow: "visible",
      fill: "#372B3D"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118398249001364250400000011107883504294429059_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089572217626763178300000014835053829559598740_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118398249001364250400000011107883504294429059_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M166.699,165.411l1.133-0.659c-0.062-0.076-0.134-0.14-0.211-0.184l-1.133,0.659 C166.565,165.271,166.636,165.335,166.699,165.411L166.699,165.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M166.845,165.648l1.133-0.659c-0.038-0.084-0.088-0.166-0.146-0.237l-1.133,0.659 C166.757,165.482,166.807,165.563,166.845,165.648L166.845,165.648z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000001633960622974010000000008195361858614521790_",
    d: "M166.92,165.973l1.134-0.659 c0.001-0.274-0.194-0.608-0.433-0.746l-1.133,0.659C166.727,165.365,166.921,165.698,166.92,165.973z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150082130755323413930000005037371412860289205_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001633960622974010000000008195361858614521790_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10191B"
    },
    d: "M152.197,156.921c-0.239-0.137-0.432-0.027-0.433,0.247l3.439,8.121l15.156,8.805l-3.385-8.135 c0,0-0.095-0.503-0.487-0.733L152.197,156.921z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#251B29"
    },
    points: "170.359,174.094 171.493,173.436 167.978,164.989 166.845,165.648  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M304.154,312.626c20.509,11.841,20.509,31.039,0,42.88 c-20.509,11.841-53.76,11.841-74.269,0c-20.509-11.841-20.509-31.039,0-42.88C250.394,300.784,283.645,300.784,304.154,312.626z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0D889F"
    },
    points: "225.026,296.427 225.068,311.317 238.856,319.33 238.814,304.44  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M225.026,296.427c-6.393,3.691-10.389,7.679-12.748,12.721l18.86,2.929 c1.314-2.797,3.874-5.442,7.676-7.637L225.026,296.427z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A89317"
    },
    points: "212.279,309.148 212.32,324.038 231.18,326.967 231.138,312.077  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070109273686174849820000002538907775857973426_",
    style: {
      enableBackground: "new"
    },
    d: "M231.138,312.077 l0.042,14.89c1.314-2.797,3.874-5.442,7.676-7.637l-0.042-14.89C235.012,306.635,232.452,309.28,231.138,312.077z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074399895748271991870000002267361740397312703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070109273686174849820000002538907775857973426_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074399895748271991870000002267361740397312703_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M231.138,312.077l0.042,14.89c1.314-2.797,3.874-5.442,7.676-7.637l-0.042-14.89 C235.012,306.635,232.452,309.28,231.138,312.077L231.138,312.077z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146493471681372413930000002314001550112143762_",
    style: {
      enableBackground: "new"
    },
    d: "M230.101,316.613 l0.042,14.89c-0.004-1.526,0.342-3.053,1.038-4.536l-0.042-14.89C230.443,313.56,230.097,315.087,230.101,316.613z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119834064671862084200000008534438658287233466_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146493471681372413930000002314001550112143762_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119834064671862084200000008534438658287233466_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D12842"
    },
    d: "M230.101,316.613l0.042,14.89c-0.004-1.526,0.342-3.053,1.038-4.536l-0.042-14.89 C230.443,313.56,230.097,315.087,230.101,316.613L230.101,316.613z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111878046675681568930000017781916572362865810_",
    style: {
      enableBackground: "new"
    },
    d: "M289.176,331.337 l-0.042-14.89c-0.013-4.348-2.869-8.69-8.577-12.006c-11.488-6.676-30.179-6.678-41.742-0.001l0.042,14.89 c11.564-6.676,30.254-6.675,41.743,0.001C286.306,322.648,289.163,326.99,289.176,331.337z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069370575833969390780000015569761364635861160_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111878046675681568930000017781916572362865810_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000069370575833969390780000015569761364635861160_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18B6D6"
    },
    d: "M238.814,304.44l0.042,14.89c11.564-6.676,30.254-6.675,41.743,0.001 c5.707,3.317,8.564,7.658,8.576,12.006l-0.042-14.89c-0.013-4.348-2.869-8.69-8.577-12.006 C269.068,297.765,250.378,297.763,238.814,304.44L238.814,304.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14D2F5"
    },
    d: "M225.026,296.427l13.788,8.013c11.564-6.676,30.254-6.675,41.742,0.001 c7.687,4.467,10.203,10.793,7.564,16.488l18.701,2.905c7.087-15.135-8.333-30.694-34.44-34.75 C254.995,286.383,237.806,289.048,225.026,296.427z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121971400729455759150000009149491140892939446_",
    style: {
      enableBackground: "new"
    },
    d: "M308.586,331.225 l-0.042-14.89c0.007,2.475-0.549,4.993-1.723,7.499l0.042,14.89C308.037,336.218,308.593,333.701,308.586,331.225z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123431921446234543150000017059336707501174173_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121971400729455759150000009149491140892939446_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000123431921446234543150000017059336707501174173_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18B6D6"
    },
    d: "M306.821,323.834l0.042,14.89c1.173-2.506,1.73-5.024,1.723-7.499l-0.042-14.89 C308.551,318.81,307.995,321.328,306.821,323.834L306.821,323.834z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0E8FA7"
    },
    points: "288.12,320.93 288.163,335.819 306.863,338.724 306.821,323.834  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9ECF5"
    },
    d: "M267.119,333.055l4.954,10.841c8.709-1.35,16.216-3.846,22.137-7.264 c5.92-3.418,10.253-7.758,12.612-12.798l-18.701-2.905c-1.307,2.818-3.874,5.481-7.699,7.689 C276.594,330.828,271.987,332.307,267.119,333.055z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083078224359418366560000002086953670136157361_",
    style: {
      enableBackground: "new"
    },
    d: "M272.072,343.896 l0.042,14.89c8.709-1.35,16.216-3.846,22.136-7.264c5.92-3.418,10.253-7.758,12.612-12.798l-0.042-14.89 c-2.36,5.04-6.692,9.381-12.612,12.798C288.289,340.051,280.782,342.546,272.072,343.896z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024685048303346095910000008390786839832329099_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083078224359418366560000002086953670136157361_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000024685048303346095910000008390786839832329099_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M272.072,343.896l0.042,14.89c8.709-1.35,16.216-3.846,22.136-7.264 c5.92-3.418,10.253-7.758,12.612-12.798l-0.042-14.89c-2.36,5.04-6.692,9.381-12.612,12.798 C288.289,340.051,280.782,342.546,272.072,343.896L272.072,343.896z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000077320043558193628900000000862079170401736601_",
    style: {
      enableBackground: "new"
    },
    d: "M210.555,316.648 l0.042,14.89c0.035,12.473,14.376,23.865,36.161,27.248c8.695,1.351,16.646,1.351,25.356,0l-0.042-14.89 c-8.71,1.351-16.661,1.351-25.356,0C224.931,340.513,210.591,329.121,210.555,316.648z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042008205413090131590000011257188880562946991_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077320043558193628900000000862079170401736601_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000042008205413090131590000011257188880562946991_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D12842"
    },
    d: "M210.555,316.648l0.042,14.89c0.035,12.473,14.376,23.865,36.161,27.248 c8.695,1.351,16.646,1.351,25.356,0l-0.042-14.89c-8.71,1.351-16.661,1.351-25.356,0 C224.931,340.513,210.591,329.121,210.555,316.648L210.555,316.648z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF445F"
    },
    d: "M212.279,309.148c-7.087,15.136,8.329,30.694,34.438,34.749c8.695,1.351,16.646,1.351,25.356,0 l-4.954-10.841c-9.843,1.511-20.754,0.032-28.441-4.435c-7.711-4.481-10.219-10.831-7.54-16.543L212.279,309.148z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M316.229,271.171c7.919,4.572,7.919,11.985,0,16.558 c-7.919,4.572-20.759,4.572-28.678,0c-7.919-4.573-7.919-11.986,0-16.558C295.471,266.599,308.31,266.599,316.229,271.171z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "278.032,165.406 279.59,164.5 312.375,275.579 310.818,276.484  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1C161F"
    },
    points: "275.922,165.188 277.48,164.283 279.59,164.5 278.032,165.406  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1822"
    },
    points: "278.032,165.406 310.818,276.484 308.708,276.267 275.922,165.188  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "265.051,187.609 263.823,186.895 263.817,185.052 265.046,185.766  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "265.046,185.766 263.817,185.052 280.048,175.681 281.276,176.394  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "281.276,176.394 282.587,177.484 265.051,187.609 265.046,185.766  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "269.085,201.014 267.857,200.301 267.852,198.457 269.08,199.171  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "269.08,199.171 267.852,198.457 284.083,189.087 285.31,189.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "285.31,189.8 286.622,190.889 269.085,201.014 269.08,199.171  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "272.996,214.472 271.768,213.759 271.763,211.915 272.991,212.629  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "272.991,212.629 271.763,211.915 287.994,202.545 289.222,203.258  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "289.222,203.258 290.533,204.348 272.996,214.472 272.991,212.629  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "277.038,227.873 275.81,227.159 275.805,225.316 277.033,226.029  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "277.033,226.029 275.805,225.316 292.036,215.945 293.264,216.659  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "293.264,216.659 294.575,217.748 277.038,227.873 277.033,226.029  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "280.95,241.331 279.721,240.617 279.716,238.774 280.944,239.488  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "280.944,239.488 279.716,238.774 295.947,229.403 297.175,230.117  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "297.175,230.117 298.486,231.206 280.95,241.331 280.944,239.488  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "280.959,241.331 279.731,240.617 279.726,238.774 280.954,239.488  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "280.954,239.488 279.726,238.774 295.957,229.403 297.185,230.117  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "284.87,254.789 283.642,254.075 283.637,252.232 284.865,252.946  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "284.865,252.946 283.637,252.232 299.868,242.861 301.096,243.575  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "301.096,243.575 302.407,244.664 284.87,254.789 284.865,252.946  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "288.848,268.226 287.62,267.513 287.615,265.669 288.842,266.383  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "288.842,266.383 287.615,265.669 303.845,256.298 305.073,257.012  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "305.073,257.012 306.385,258.102 288.848,268.226 288.842,266.383  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1821"
    },
    points: "292.823,281.647 291.595,280.934 291.59,279.091 292.818,279.804  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F1923"
    },
    points: "292.818,279.804 291.59,279.091 307.821,269.72 309.049,270.434  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "309.049,270.434 310.36,271.523 292.823,281.647 292.818,279.804  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#372B3D"
    },
    points: "260.699,175.5 262.257,174.595 295.043,285.673 293.485,286.578  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1C161F"
    },
    points: "258.589,175.282 260.147,174.377 262.257,174.595 260.699,175.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1E1822"
    },
    points: "260.699,175.5 293.485,286.578 291.375,286.361 258.589,175.282  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "man_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_79_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M298.817,264.784c-0.185-0.274-0.375-0.129-0.631-0.127 c-0.318,0.002-0.654-0.126-0.938-0.259c-0.366-0.171-0.703-0.396-1.055-0.595c-0.909-0.517-1.914-0.866-2.948-1.024 c-0.466-0.071-0.992-0.094-1.438,0.077c-0.342,0.131-0.682,0.286-0.952,0.534c-0.211,0.194-0.377,0.452-0.427,0.738 c-0.046,0.269,0.045,0.565,0.107,0.827c0.059,0.246,0.138,0.49,0.268,0.706c0.261,0.437,0.704,0.73,1.143,0.987 c0.507,0.297,1.039,0.569,1.616,0.681c0.471,0.091,0.962,0.073,1.42,0.216c0.309,0.096,0.588,0.262,0.846,0.452 c0.205,0.151,0.389,0.368,0.636,0.443c0.514,0.156,1.094,0.234,1.623,0.119c1.042-0.226,1.706-1.093,1.437-2.158 c-0.097-0.382-0.273-0.738-0.449-1.091C298.966,265.087,298.901,264.908,298.817,264.784z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "man_77_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828CC0"
    },
    d: "M307.318,270.875c-0.121-0.308-0.338-0.207-0.589-0.261 c-0.311-0.067-0.611-0.265-0.859-0.457c-0.32-0.246-0.6-0.539-0.9-0.81c-0.775-0.702-1.68-1.261-2.655-1.64 c-0.629-0.245-1.297-0.439-1.959-0.202c-0.371,0.133-0.699,0.379-0.934,0.695c-0.228,0.308-0.23,0.672-0.225,1.041 c0.003,0.253,0.028,0.508,0.108,0.748c0.16,0.483,0.529,0.865,0.901,1.212c0.43,0.4,0.891,0.782,1.429,1.016 c0.44,0.191,0.924,0.28,1.34,0.519c0.28,0.161,0.517,0.384,0.728,0.626c0.167,0.191,0.299,0.443,0.525,0.57 c0.468,0.264,1.017,0.466,1.559,0.469c1.066,0.006,1.902-0.696,1.871-1.794c-0.011-0.394-0.106-0.78-0.201-1.162 C307.398,271.203,307.372,271.014,307.318,270.875z"
  }))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F4961"
    },
    d: "M301.608,244.252c-0.005-0.322,0.042-0.537,0.456-0.665c1.17-0.364,2.353-0.743,3.544-1.032 c0.707-0.171,1.417-0.289,2.133-0.304l1.559-1.406c0.193,1.355,0.307,2.733,0.151,4.093c-0.339,2.962-1.113,9.799-1.315,13.059 c-0.137,2.21-0.14,4.425-0.154,6.638c-0.013,2.166-0.185,4.334-0.344,6.494c-0.035,0.485-0.08,0.996-0.435,1.355 c-0.348,0.351-0.88,0.565-1.363,0.623c-0.78,0.093-1.592-0.201-2.149-0.755c-0.353-0.351-0.339-1.043-0.392-1.511 c-0.048-0.424-0.071-0.851-0.087-1.279c-0.046-1.232-0.047-2.465-0.088-3.696c-0.043-1.3-0.112-2.6-0.202-3.897 c-0.059-0.853-0.127-1.704-0.201-2.555c-0.041-0.47-0.085-0.939-0.129-1.408c-0.137-1.321-0.348-2.637-0.477-3.976 c-0.241-2.503-0.395-5.014-0.462-7.527c-0.017-0.628-0.028-1.257-0.034-1.885C301.616,244.482,301.609,244.361,301.608,244.252z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546282"
    },
    d: "M299.103,238.665c1.119-0.328,3.107,1.693,3.986,2.182c0.811,0.451,1.643,0.863,2.482,1.258 c0.372,0.175,0.814,0.473,1.215,0.559c0.348,0.074,0.711-0.05,1.075,0.03c0.285,0.062,1.26-0.122,1.382,0.143 c0.185,0.405-0.739,1.23-1.014,1.581c-2.444,3.118-6.162,4.946-8.528,8.109c-0.995,1.33-1.664,2.87-2.533,4.285 c-0.108,0.175-0.22,0.351-0.375,0.486c-0.268,0.233-0.633,0.319-0.985,0.367c-1.269,0.174-1.124-0.591-1.863-1.778 c-0.554-0.891-2.135-0.506-2.245-1.549c-0.161-1.533,0.733-2.901,1.205-3.838c1.8-3.57,3.44-7.23,5.276-10.794 c0.184-0.356,0.383-0.728,0.72-0.945C298.963,238.717,299.031,238.686,299.103,238.665z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M295.015,225.964c-0.029,0.367,0.033,1.085,0.392,1.326c0.296,0.199,0.944,0.126,1.28,0.157 c1.056,0.098,2.111,0.166,3.167,0.234c0.479,0.031,0.958,0.062,1.436,0.077c1.403,0.044,2.798-0.048,4.164-0.274 c0.53-0.088,1.411-0.215,1.833-0.568c0.418-0.349,0.457-0.914,0.387-1.478c-0.125-1.006-0.622-1.992-1.579-2.376 c-0.96-0.385-1.908-0.221-2.86-0.099c-2.2,0.281-4.373,0.702-6.504,1.261c-0.379,0.1-0.765,0.207-1.082,0.436 C295.287,224.921,295.057,225.431,295.015,225.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M278.597,222.326c0.005,0.041,0.014,0.076,0.029,0.101c0.09,0.154,0.333,0.1,0.424-0.032 c0.068-0.099,0.089-0.221,0.114-0.338c0.056-0.26,0.142-0.513,0.254-0.754c0.016-0.034,0.035-0.071,0.07-0.086 c0.027-0.012,0.058-0.009,0.088-0.006c0.041,0.005,0.082,0.009,0.123,0.014c0.032,0.003,0.066,0.008,0.095,0.023 c0.054,0.029,0.08,0.091,0.109,0.146c0.12,0.231,0.321,0.341,0.515,0.497c0.171,0.139,0.278,0.347,0.413,0.523 c0.346,0.456,0.671,0.93,0.933,1.44c0.25,0.488,0.443,0.906,0.524,1.446c0.063,0.42,0.108,0.849,0.089,1.274 c-0.013,0.289-0.039,0.696-0.271,0.907c-0.261,0.236-0.623,0.06-0.872-0.104c-0.392-0.257-0.597-0.663-0.929-0.972 c-0.156-0.144-0.246-0.322-0.394-0.462c-0.174-0.165-0.437-0.235-0.656-0.317c-0.506-0.19-0.979-0.469-1.394-0.815 c-0.404-0.338-0.782-0.624-0.862-1.162c-0.083-0.563-0.061-1.144,0.097-1.692c0.09-0.313,0.233-0.626,0.487-0.83 c0.254-0.204,0.641-0.268,0.907-0.079c0.076,0.054,0.139,0.128,0.169,0.216c0.029,0.085,0.024,0.177,0.018,0.267 C278.665,221.692,278.569,222.104,278.597,222.326z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M295.387,224.758c0.001-0.034,0.001-0.068,0.002-0.101 c0.013-0.578,0.014-1.25,0.349-1.754c0.293-0.441,0.864-0.669,1.295-0.945c1.449-0.926,3.001-1.691,4.619-2.274 c2.463-0.887,4.977-2.694,7.605-1.21c0.267,0.151,0.521,0.33,0.741,0.544c1.353,1.318,1.199,3.444,0.987,5.149 c-0.273,2.196-0.925,4.321-1.307,6.497c-0.08,0.454-0.148,0.91-0.205,1.367c-0.198,1.58-0.056,3.203-0.27,4.769 c-0.187,1.362,0.24,2.917,0.418,4.284c0.11,0.843,0.204,1.767-0.258,2.482c-0.497,0.77-1.474,1.046-2.367,1.251 c-3.272,0.751-6.771,1.326-9.923,0.172c-0.561-0.206-1.151-0.512-1.374-1.067c-0.147-0.365-0.107-0.774-0.068-1.165 c0.442-4.417,0.559-8.878,0.117-13.295C295.591,227.898,295.362,226.333,295.387,224.758z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M300.94,227.182c0.31-0.96,0.412-1.951-0.054-2.956c-0.447-0.964-1.333-1.708-2.352-2.003 c-0.897-0.26-2.229-0.171-2.796,0.68c-0.335,0.504-0.336,1.176-0.349,1.754c-0.001,0.034-0.001,0.068-0.002,0.101 c-0.025,1.575,0.204,3.139,0.36,4.703c0.442,4.417,0.325,8.878-0.117,13.295c-0.039,0.391-0.078,0.801,0.068,1.165 c0.119,0.294,0.341,0.519,0.607,0.695c-0.046-1.775,0.115-3.552,0.428-5.299c0.429-2.389,1.137-4.722,2.013-6.984 c0.442-1.141,0.928-2.266,1.448-3.374C300.466,228.382,300.744,227.788,300.94,227.182z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M300.389,220.193c0.446-0.19,0.922-0.385,1.263-0.508 c1.711-0.616,3.446-1.675,5.227-1.768c0.859,1.294,0.165,2.776-1.1,3.466c-1.59,0.795-3.683,0.707-5.192-0.361 C300.287,220.809,300.06,220.447,300.389,220.193z"
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M294.661,223.497c0.907-0.756,2.12-1.383,3.331-1.065c0.458,0.12,0.858,0.398,1.217,0.706 c0.29,0.248,0.563,0.521,0.774,0.839c0.49,0.737,0.577,1.702,0.301,2.535c-0.345,1.04-1.041,1.589-1.935,2.145 c-0.783,0.486-1.538,1.015-2.288,1.551c-1.497,1.07-2.978,2.176-4.608,3.037c-0.954,0.504-2.068,0.928-3.093,0.589 c-0.691-0.229-1.255-0.812-1.46-1.51c-0.499-1.694,0.75-2.215,0.914-2.365C292.963,225.24,294.78,223.398,294.661,223.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M280.512,224.789c-0.274,0.247-0.723,0.809-0.629,1.231c0.078,0.348,0.598,0.741,0.82,0.995 c0.698,0.798,1.416,1.575,2.134,2.351c0.326,0.352,0.652,0.705,0.988,1.045c0.986,0.998,2.061,1.893,3.208,2.67 c0.445,0.302,1.171,0.816,1.72,0.851c0.543,0.035,0.961-0.348,1.298-0.805c0.602-0.815,0.921-1.873,0.492-2.81 c-0.43-0.94-1.232-1.475-2.005-2.042c-1.789-1.312-3.654-2.503-5.584-3.566c-0.343-0.189-0.697-0.377-1.084-0.429 C281.427,224.221,280.908,224.432,280.512,224.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M300.995,217.545c-0.095-0.651-0.587-0.5-0.338-1.09c0.211-0.501,0.532-0.963,0.962-1.295 c0.43-0.333,0.974-0.53,1.517-0.499c0.187,0.01,0.312,0.117,0.498,0.118c0.513,0.001,1.028-0.096,1.539-0.022 c0.509,0.074,0.98,0.111,0.979,0.685c0,0.766-0.035,1.503,0.21,2.256c0.131,0.402,0.33,0.79,0.364,1.212 c0.069,0.829-0.536,1.602-1.285,1.964c-0.921,0.445-1.961,0.405-2.941,0.262c-0.492-0.071-1.183-0.17-1.472-0.638 c-0.217-0.353-0.124-0.816-0.077-1.201C301.022,218.71,301.082,218.133,300.995,217.545z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M298.812,209.216c-0.309,0.376-0.551,0.799-0.625,1.295c-0.165,1.105,0.28,2.241,0.04,3.338 c-0.233,1.062,0.223,3.475,2.318,4.094c1.06,0.313,3.152-0.053,3.825-0.376c0.903-0.433,1.5-1.308,2.033-2.156 C310.781,208.462,301.78,205.603,298.812,209.216z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251B29"
    },
    d: "M307.684,207.85c-0.212-0.218-0.472-0.406-0.79-0.554c-0.096-0.045-0.199-0.087-0.267-0.168 c-0.051-0.061-0.077-0.137-0.11-0.209c-0.149-0.32-0.447-0.546-0.755-0.718c-1.167-0.65-2.584-0.681-3.906-0.491 c-0.447,0.064-0.894,0.153-1.309,0.331c-0.473,0.203-0.891,0.517-1.27,0.866c-0.535,0.493-1.043,1.073-1.321,1.755 c-0.129,0.317-0.155,0.652-0.246,0.973c-0.082,0.289,0.018,0.63,0.259,0.814c0.103,0.079,0.226,0.13,0.334,0.203 c0.444,0.299,0.527,0.991,0.719,1.458c0.121,0.296,0.361,0.457,0.43,0.775c0.071,0.331,0.065,0.676,0.17,1 c0.05,0.154,0.152,0.32,0.313,0.33c0.066,0.004,0.132-0.02,0.189-0.055c0.187-0.116,0.284-0.333,0.346-0.545 c0.062-0.211,0.101-0.433,0.219-0.619c0.017-0.027,0.038-0.055,0.068-0.067c0.024-0.009,0.052-0.007,0.078-0.001 c0.225,0.044,0.373,0.211,0.481,0.401c0.13,0.23,0.2,0.488,0.268,0.743c0.108,0.401,0.121,0.74,0.171,1.139 c0.051,0.404,0.165,0.836,0.449,1.141c0.635,0.686,1.858,0.647,2.686,0.464c0.299-0.066,0.6-0.137,0.876-0.27 c0.638-0.307,1.073-0.91,1.48-1.489c0.372-0.53,0.748-1.071,0.944-1.687c0.111-0.348,0.161-0.711,0.211-1.073 C308.602,210.831,308.756,208.952,307.684,207.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M301.181,212.264c0.823-0.179,1.187,0.822,0.734,1.703c-0.132,0.257-0.396,0.507-0.586,0.725 c-1.302,1.488-1.879,0.172-1.469-0.33C300.809,213.196,300.146,212.489,301.181,212.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M301.162,213.868c0.083-0.102,0.947-0.801,0.245-1.086c-0.194-0.079-0.37,0.107-0.369,0.3 c0,0.1,0.046,0.196,0.046,0.296c0,0.059-0.017,0.117-0.04,0.172c-0.064,0.149-0.331,0.323-0.246,0.515 C300.874,214.237,301.114,213.927,301.162,213.868z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546282"
    },
    d: "M292.119,255.845c0.018,0.045,0.036,0.089,0.053,0.134c0.798,2.079,1.38,4.228,2.076,6.34 c0.463,1.406,1.487,5.257,3.121,5.234c0.81-0.011,2.336-0.335,2.521-1.073c0.69-2.758-1.685-10.742-2.378-12.989 c-0.174-0.566-0.171-0.337-0.333-0.908c-0.129-0.456-0.15-1.163-0.452-1.544c-0.579-0.731-1.683,0.172-2.24,0.569 c-0.809,0.577-1.894,1.095-2.485,1.877C291.41,254.264,291.817,255.092,292.119,255.845z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M396.298,216.852c6.785,3.917,6.785,10.269,0,14.187 c-6.785,3.917-17.786,3.917-24.571,0c-6.785-3.917-6.785-10.269,0-14.187C378.511,212.934,389.513,212.934,396.298,216.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M366.127,230.038c6.785,3.917,6.785,10.269,0,14.186 c-6.785,3.918-17.786,3.918-24.571,0c-6.785-3.917-6.785-10.269,0-14.186C348.341,226.12,359.342,226.12,366.127,230.038z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M398.171,222.135v0.125v0.004c-0.003,0.167-0.016,0.331-0.032,0.497 c-0.003,0.003-0.003,0.003-0.003,0.006c-0.074,0.703-0.286,1.404-0.633,2.087c-0.755,1.494-2.155,2.9-4.194,4.076 c-6.452,3.725-16.882,3.725-23.292,0c-1.924-1.118-3.269-2.444-4.03-3.854c-0.003-0.004-0.006-0.01-0.006-0.01 c-0.376-0.694-0.607-1.404-0.7-2.12c-0.029-0.193-0.045-0.382-0.048-0.575c-0.004-0.048-0.004-0.093-0.004-0.141l-0.003-0.835 v-0.411l-0.004-0.95l-0.006-2.126c0.01,2.424,1.603,4.846,4.788,6.699c6.41,3.725,16.84,3.725,23.295,0 c3.24-1.873,4.862-4.329,4.862-6.779l0.004,2.1l0.003,0.967v0.376L398.171,222.135z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M370.08,211.114c-6.453,3.726-6.488,9.766-0.076,13.492c6.412,3.726,16.841,3.726,23.294,0 c6.454-3.726,6.487-9.767,0.076-13.493C386.962,207.388,376.534,207.388,370.08,211.114z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M395.456,218.595c-0.292,1.799-1.635,3.552-4.018,4.933c-5.42,3.128-14.178,3.128-19.56-0.003 c-2.351-1.365-3.667-3.099-3.956-4.881c-0.379-2.302,0.964-4.685,4.018-6.448c5.421-3.128,14.178-3.128,19.563,0 C394.514,213.948,395.831,216.308,395.456,218.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M395.456,218.595c-0.292,1.799-1.635,3.552-4.018,4.933c-5.42,3.128-14.178,3.128-19.56-0.003 c-2.351-1.365-3.667-3.099-3.956-4.881c0.292-1.798,1.635-3.552,4.018-4.929c5.421-3.131,14.178-3.131,19.563,0 C393.85,215.078,395.166,216.812,395.456,218.595z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "390.431,213.866 390.427,214.981 388.583,216.053 388.587,214.938  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "390.626,216.835 390.623,217.95 387.94,218.868 387.943,217.753  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099636936450399745160000015509784535259902133_",
    style: {
      enableBackground: "new"
    },
    d: " M382.491,217.002l0.003-1.115c0-0.069,0.015-0.135,0.045-0.196c0.057-0.124,0.182-0.241,0.371-0.351 c0.307-0.178,0.681-0.25,1.12-0.216c0.439,0.034,0.944,0.216,1.517,0.546c0.571,0.33,1.057,0.679,1.457,1.046 c0.397,0.368,0.712,0.713,0.938,1.036l-0.003,1.115c-0.227-0.324-0.542-0.668-0.939-1.036 c-0.401-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.078-0.512-1.517-0.547c-0.439-0.034-0.813,0.037-1.12,0.216 c-0.189,0.11-0.314,0.227-0.37,0.351C382.507,216.867,382.492,216.932,382.491,217.002z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099636936450399745160000015509784535259902133_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114031268673439616030000005189004525257776551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099636936450399745160000015509784535259902133_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114031268673439616030000005189004525257776551_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M387.943,217.753l-0.003,1.115c-0.227-0.324-0.542-0.668-0.939-1.036 c-0.401-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.078-0.512-1.517-0.547c-0.439-0.034-0.813,0.037-1.12,0.216 c-0.189,0.11-0.314,0.227-0.37,0.351c-0.03,0.061-0.045,0.126-0.045,0.196l0.003-1.115c0-0.069,0.015-0.135,0.045-0.196 c0.057-0.124,0.182-0.241,0.371-0.351c0.307-0.178,0.681-0.25,1.12-0.216c0.439,0.034,0.944,0.216,1.517,0.546 c0.571,0.33,1.057,0.679,1.457,1.046C387.401,217.085,387.716,217.43,387.943,217.753L387.943,217.753z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034796151058966394940000005296564247139424668_",
    style: {
      enableBackground: "new"
    },
    d: " M380.947,219.486l-0.003,1.114c0-0.1-0.021-0.206-0.064-0.32c-0.073-0.193-0.199-0.414-0.385-0.664 c-0.186-0.252-0.409-0.535-0.672-0.852c-0.252-0.308-0.479-0.622-0.682-0.938c-0.204-0.315-0.334-0.633-0.388-0.954 c-0.014-0.078-0.02-0.155-0.02-0.233l0.003-1.114c0,0.077,0.006,0.155,0.02,0.233c0.054,0.32,0.184,0.639,0.388,0.954 c0.204,0.317,0.43,0.63,0.682,0.939c0.263,0.316,0.485,0.6,0.671,0.851c0.186,0.25,0.313,0.472,0.385,0.664 C380.925,219.279,380.947,219.385,380.947,219.486z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034796151058966394940000005296564247139424668_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114788686248592777640000008185740137632897673_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034796151058966394940000005296564247139424668_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114788686248592777640000008185740137632897673_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M380.947,219.486l-0.003,1.114c0-0.1-0.021-0.206-0.064-0.32 c-0.073-0.193-0.199-0.414-0.385-0.664c-0.186-0.252-0.409-0.535-0.672-0.852c-0.252-0.308-0.479-0.622-0.682-0.938 c-0.204-0.315-0.334-0.633-0.388-0.954c-0.014-0.078-0.02-0.155-0.02-0.233l0.003-1.114c0,0.077,0.006,0.155,0.02,0.233 c0.054,0.32,0.184,0.639,0.388,0.954c0.204,0.317,0.43,0.63,0.682,0.939c0.263,0.316,0.485,0.6,0.671,0.851 c0.186,0.25,0.313,0.472,0.385,0.664C380.925,219.279,380.947,219.385,380.947,219.486L380.947,219.486z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121986601708998328970000014420721423381650352_",
    style: {
      enableBackground: "new"
    },
    d: " M374.59,220.464l-0.003,1.114c-0.797-0.542-1.369-1.027-1.717-1.454c-0.345-0.426-0.586-0.752-0.718-0.979l0.003-1.114 c0.132,0.227,0.372,0.552,0.717,0.979C373.222,219.437,373.793,219.922,374.59,220.464z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121986601708998328970000014420721423381650352_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036224138629341550920000014331275712780654758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121986601708998328970000014420721423381650352_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036224138629341550920000014331275712780654758_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M374.59,220.464l-0.003,1.114c-0.797-0.542-1.369-1.027-1.717-1.454 c-0.345-0.426-0.586-0.752-0.718-0.979l0.003-1.114c0.132,0.227,0.372,0.552,0.717,0.979 C373.222,219.437,373.793,219.922,374.59,220.464L374.59,220.464z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111158074959692726970000005238748787190808207_",
    style: {
      enableBackground: "new"
    },
    d: " M384.631,219.841l-0.003,1.114c-0.001,0.298-0.087,0.588-0.26,0.869c-0.207,0.332-0.569,0.65-1.09,0.953 c-0.353,0.206-0.76,0.379-1.215,0.52c-0.455,0.141-0.958,0.225-1.502,0.252c-0.544,0.027-1.124-0.012-1.736-0.118 c-0.611-0.108-1.257-0.301-1.934-0.583l0.003-1.115c0.677,0.282,1.322,0.476,1.934,0.584 c0.612,0.106,1.191,0.145,1.736,0.118c0.545-0.027,1.047-0.111,1.503-0.252c0.455-0.141,0.862-0.314,1.215-0.52 c0.521-0.303,0.883-0.62,1.09-0.953C384.544,220.428,384.63,220.138,384.631,219.841z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111158074959692726970000005238748787190808207_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164500491795327638610000002084921999227284870_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111158074959692726970000005238748787190808207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000164500491795327638610000002084921999227284870_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M384.631,219.841l-0.003,1.114c-0.001,0.298-0.087,0.588-0.26,0.869 c-0.207,0.332-0.569,0.65-1.09,0.953c-0.353,0.206-0.76,0.379-1.215,0.52c-0.455,0.141-0.958,0.225-1.502,0.252 c-0.544,0.027-1.124-0.012-1.736-0.118c-0.611-0.108-1.257-0.301-1.934-0.583l0.003-1.115 c0.677,0.282,1.322,0.476,1.934,0.584c0.612,0.106,1.191,0.145,1.736,0.118c0.545-0.027,1.047-0.111,1.503-0.252 c0.455-0.141,0.862-0.314,1.215-0.52c0.521-0.303,0.883-0.62,1.09-0.953C384.544,220.428,384.63,220.138,384.631,219.841 L384.631,219.841z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "376.894,221.732 376.891,222.847 374.726,224.105 374.729,222.991  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M390.431,213.866l-1.844,1.072c0.559,0.393,1.003,0.752,1.33,1.078 c0.329,0.326,0.565,0.6,0.709,0.82l-2.684,0.918c-0.226-0.324-0.542-0.668-0.938-1.036c-0.401-0.368-0.886-0.717-1.457-1.046 c-0.573-0.331-1.078-0.512-1.517-0.546c-0.439-0.035-0.813,0.037-1.12,0.216c-0.189,0.11-0.314,0.227-0.371,0.351 c-0.06,0.124-0.059,0.265,0.001,0.423c0.06,0.159,0.162,0.337,0.306,0.536c0.144,0.2,0.328,0.434,0.556,0.703 c0.333,0.411,0.61,0.812,0.832,1.201c0.222,0.389,0.351,0.761,0.389,1.119c0.037,0.357-0.046,0.703-0.251,1.036 c-0.207,0.333-0.569,0.651-1.09,0.953c-0.353,0.206-0.76,0.379-1.215,0.52c-0.455,0.141-0.958,0.225-1.503,0.252 c-0.544,0.028-1.124-0.012-1.736-0.118c-0.612-0.108-1.257-0.302-1.934-0.584l-2.165,1.258l-2.25-1.3l2.111-1.227 c-0.797-0.543-1.369-1.028-1.718-1.454c-0.345-0.427-0.585-0.752-0.717-0.979l2.809-0.742c0.216,0.358,0.53,0.75,0.941,1.18 c0.413,0.43,0.939,0.83,1.582,1.201c0.726,0.419,1.321,0.65,1.784,0.691c0.463,0.042,0.872-0.041,1.227-0.248 c0.224-0.13,0.364-0.272,0.415-0.428c0.053-0.154,0.042-0.328-0.031-0.52c-0.072-0.192-0.199-0.414-0.385-0.664 c-0.186-0.252-0.408-0.535-0.671-0.851c-0.252-0.309-0.479-0.622-0.682-0.939c-0.204-0.314-0.334-0.633-0.388-0.954 c-0.056-0.32,0.005-0.636,0.181-0.953c0.176-0.317,0.518-0.623,1.027-0.918c0.39-0.227,0.822-0.411,1.296-0.555 c0.473-0.145,0.979-0.235,1.511-0.269c0.534-0.033,1.095-0.001,1.684,0.098c0.587,0.1,1.19,0.273,1.809,0.52l1.915-1.113 L390.431,213.866z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "374.729,222.991 374.726,224.105 372.476,222.806 372.479,221.691  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M398.168,221.271c-0.52,2.014-2.142,3.876-4.699,5.353c-6.538,3.777-17.142,3.777-23.638,0 c-2.482-1.442-4.069-3.259-4.605-5.228l0.003,0.835c0,0.048,0,0.093,0.004,0.141c0.742,1.702,2.254,3.263,4.438,4.531 c3.292,1.914,7.624,2.871,11.962,2.871c4.339,0,8.684-0.957,11.998-2.871c2.248-1.297,3.796-2.896,4.541-4.64v-0.004v-0.125 L398.168,221.271z M369.671,225.533c3.292,1.914,7.624,2.871,11.962,2.871c4.339,0,8.684-0.957,11.998-2.871 c2.244-1.297,3.792-2.893,4.538-4.637l-0.003-0.967c-0.53,2.007-2.152,3.857-4.695,5.328c-6.538,3.773-17.142,3.773-23.638,0 c-2.482-1.442-4.072-3.26-4.608-5.222l0.004,0.95C365.965,222.697,367.477,224.261,369.671,225.533z M393.469,227.996 c-6.538,3.773-17.142,3.773-23.638,0c-2.405-1.4-3.969-3.15-4.551-5.048c0.093,0.716,0.325,1.426,0.697,2.117 c0,0,0.007,0.009,0.01,0.013c0.845,1.182,2.084,2.267,3.683,3.195c3.292,1.914,7.624,2.871,11.962,2.871 c4.339,0,8.684-0.957,11.998-2.871c1.712-0.986,3.019-2.148,3.873-3.417c0.347-0.684,0.559-1.384,0.633-2.087 C397.58,224.733,395.975,226.551,393.469,227.996z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M395.751,216.949v0.125v0.003c-0.003,0.167-0.016,0.331-0.032,0.498 c-0.003,0.003-0.003,0.003-0.003,0.006c-0.074,0.703-0.286,1.403-0.633,2.087c-0.755,1.493-2.155,2.9-4.194,4.075 c-6.452,3.725-16.882,3.725-23.291,0c-1.924-1.118-3.269-2.444-4.031-3.854c-0.003-0.003-0.007-0.01-0.01-0.013 c-0.372-0.691-0.604-1.4-0.696-2.116c-0.029-0.193-0.045-0.382-0.048-0.575c-0.003-0.048-0.003-0.093-0.003-0.142l-0.003-0.835 v-0.411l-0.003-0.95l-0.007-2.126c0.01,2.425,1.603,4.846,4.788,6.699c6.41,3.725,16.84,3.725,23.295,0 c3.24-1.872,4.862-4.329,4.862-6.779l0.003,2.1l0.003,0.966v0.376L395.751,216.949z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M367.66,205.928c-6.453,3.726-6.488,9.766-0.076,13.492c6.411,3.726,16.841,3.726,23.294,0 c6.454-3.726,6.487-9.767,0.076-13.492C384.542,202.202,374.113,202.202,367.66,205.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M393.035,213.408c-0.292,1.798-1.634,3.552-4.017,4.933c-5.421,3.128-14.178,3.128-19.56-0.003 c-2.351-1.365-3.668-3.099-3.957-4.881c-0.379-2.303,0.963-4.685,4.017-6.448c5.421-3.128,14.178-3.128,19.563,0 C392.094,208.761,393.411,211.122,393.035,213.408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M393.035,213.408c-0.292,1.798-1.634,3.552-4.017,4.933c-5.421,3.128-14.178,3.128-19.56-0.003 c-2.351-1.365-3.668-3.099-3.957-4.881c0.292-1.799,1.634-3.552,4.017-4.93c5.421-3.131,14.178-3.131,19.563,0 C391.43,209.892,392.746,211.626,393.035,213.408z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "388.01,208.68 388.007,209.794 386.163,210.866 386.166,209.752  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "388.206,211.648 388.203,212.763 385.519,213.681 385.522,212.567  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103261016747532490710000017205818323210250632_",
    style: {
      enableBackground: "new"
    },
    d: " M380.071,211.815l0.003-1.115c0-0.069,0.015-0.135,0.045-0.196c0.056-0.124,0.181-0.241,0.37-0.351 c0.307-0.178,0.681-0.25,1.12-0.216c0.439,0.035,0.944,0.216,1.517,0.547c0.571,0.33,1.057,0.679,1.457,1.046 c0.397,0.368,0.712,0.713,0.939,1.036l-0.003,1.114c-0.226-0.323-0.542-0.668-0.939-1.036 c-0.4-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.079-0.512-1.517-0.546c-0.439-0.034-0.812,0.037-1.12,0.216 c-0.189,0.11-0.314,0.227-0.371,0.351C380.086,211.68,380.071,211.746,380.071,211.815z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103261016747532490710000017205818323210250632_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059278705080022423960000000846747516256198793_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103261016747532490710000017205818323210250632_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000059278705080022423960000000846747516256198793_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M385.522,212.567l-0.003,1.114c-0.226-0.323-0.542-0.668-0.939-1.036 c-0.4-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.079-0.512-1.517-0.546c-0.439-0.034-0.812,0.037-1.12,0.216 c-0.189,0.11-0.314,0.227-0.371,0.351c-0.03,0.061-0.045,0.127-0.045,0.196l0.003-1.115c0-0.069,0.015-0.135,0.045-0.196 c0.056-0.124,0.181-0.241,0.37-0.351c0.307-0.178,0.681-0.25,1.12-0.216c0.439,0.035,0.944,0.216,1.517,0.547 c0.571,0.33,1.057,0.679,1.457,1.046C384.981,211.899,385.296,212.243,385.522,212.567L385.522,212.567z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013182280430633797270000015802834992984764557_",
    style: {
      enableBackground: "new"
    },
    d: " M378.526,214.299l-0.003,1.115c0-0.1-0.021-0.206-0.064-0.32c-0.073-0.192-0.199-0.414-0.385-0.664 c-0.186-0.252-0.409-0.536-0.671-0.852c-0.252-0.309-0.479-0.622-0.683-0.939c-0.203-0.314-0.334-0.633-0.388-0.954 c-0.013-0.078-0.02-0.155-0.02-0.233l0.003-1.114c0,0.077,0.007,0.155,0.02,0.233c0.054,0.321,0.184,0.639,0.388,0.954 c0.204,0.316,0.43,0.63,0.683,0.938c0.263,0.317,0.485,0.6,0.671,0.852c0.186,0.25,0.312,0.472,0.385,0.664 C378.505,214.092,378.526,214.199,378.526,214.299z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013182280430633797270000015802834992984764557_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003791594502667301620000016631030753814767768_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013182280430633797270000015802834992984764557_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003791594502667301620000016631030753814767768_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M378.526,214.299l-0.003,1.115c0-0.1-0.021-0.206-0.064-0.32 c-0.073-0.192-0.199-0.414-0.385-0.664c-0.186-0.252-0.409-0.536-0.671-0.852c-0.252-0.309-0.479-0.622-0.683-0.939 c-0.203-0.314-0.334-0.633-0.388-0.954c-0.013-0.078-0.02-0.155-0.02-0.233l0.003-1.114c0,0.077,0.007,0.155,0.02,0.233 c0.054,0.321,0.184,0.639,0.388,0.954c0.204,0.316,0.43,0.63,0.683,0.938c0.263,0.317,0.485,0.6,0.671,0.852 c0.186,0.25,0.312,0.472,0.385,0.664C378.505,214.092,378.526,214.199,378.526,214.299L378.526,214.299z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158023849405574376110000010739917864823261577_",
    style: {
      enableBackground: "new"
    },
    d: " M372.17,215.278l-0.003,1.115c-0.797-0.542-1.368-1.028-1.717-1.454c-0.345-0.427-0.586-0.752-0.717-0.979l0.003-1.115 c0.131,0.227,0.372,0.553,0.717,0.979C370.801,214.251,371.373,214.736,372.17,215.278z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158023849405574376110000010739917864823261577_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093871867992299074160000006765655196257941380_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158023849405574376110000010739917864823261577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093871867992299074160000006765655196257941380_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M372.17,215.278l-0.003,1.115c-0.797-0.542-1.368-1.028-1.717-1.454 c-0.345-0.427-0.586-0.752-0.717-0.979l0.003-1.115c0.131,0.227,0.372,0.553,0.717,0.979 C370.801,214.251,371.373,214.736,372.17,215.278L372.17,215.278z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152262813342180645470000008924414630606191509_",
    style: {
      enableBackground: "new"
    },
    d: " M382.21,214.654l-0.003,1.115c-0.001,0.298-0.087,0.588-0.26,0.869c-0.207,0.332-0.569,0.65-1.089,0.953 c-0.354,0.205-0.76,0.379-1.216,0.52s-0.958,0.225-1.502,0.252c-0.545,0.028-1.124-0.012-1.736-0.118 c-0.611-0.108-1.256-0.302-1.933-0.584l0.003-1.114c0.677,0.282,1.322,0.476,1.933,0.583 c0.611,0.106,1.191,0.145,1.736,0.118c0.544-0.027,1.047-0.111,1.502-0.252c0.455-0.141,0.862-0.314,1.216-0.52 c0.52-0.303,0.882-0.62,1.089-0.953C382.123,215.241,382.21,214.952,382.21,214.654z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152262813342180645470000008924414630606191509_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070097107751369933740000003049110081345091247_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152262813342180645470000008924414630606191509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070097107751369933740000003049110081345091247_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M382.21,214.654l-0.003,1.115c-0.001,0.298-0.087,0.588-0.26,0.869 c-0.207,0.332-0.569,0.65-1.089,0.953c-0.354,0.205-0.76,0.379-1.216,0.52s-0.958,0.225-1.502,0.252 c-0.545,0.028-1.124-0.012-1.736-0.118c-0.611-0.108-1.256-0.302-1.933-0.584l0.003-1.114 c0.677,0.282,1.322,0.476,1.933,0.583c0.611,0.106,1.191,0.145,1.736,0.118c0.544-0.027,1.047-0.111,1.502-0.252 c0.455-0.141,0.862-0.314,1.216-0.52c0.52-0.303,0.882-0.62,1.089-0.953C382.123,215.241,382.21,214.952,382.21,214.654 L382.21,214.654z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "374.474,216.546 374.471,217.661 372.306,218.919 372.309,217.804  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M388.01,208.68l-1.844,1.072c0.559,0.393,1.003,0.752,1.331,1.078 c0.329,0.326,0.566,0.6,0.709,0.819l-2.684,0.919c-0.227-0.324-0.542-0.668-0.939-1.036c-0.4-0.368-0.886-0.717-1.457-1.046 c-0.573-0.331-1.078-0.512-1.517-0.547c-0.439-0.034-0.813,0.038-1.12,0.216c-0.189,0.11-0.314,0.227-0.37,0.351 c-0.06,0.124-0.059,0.265,0,0.422c0.06,0.16,0.162,0.337,0.306,0.536c0.144,0.2,0.328,0.435,0.556,0.702 c0.333,0.411,0.61,0.813,0.832,1.202c0.222,0.389,0.351,0.761,0.389,1.119c0.037,0.357-0.047,0.702-0.252,1.036 c-0.207,0.333-0.569,0.65-1.089,0.953c-0.354,0.206-0.76,0.379-1.216,0.52c-0.455,0.141-0.958,0.225-1.502,0.252 c-0.545,0.027-1.124-0.012-1.736-0.118c-0.611-0.108-1.257-0.301-1.933-0.583l-2.165,1.258l-2.251-1.299l2.111-1.227 c-0.797-0.542-1.369-1.027-1.717-1.454c-0.345-0.426-0.586-0.752-0.717-0.979l2.808-0.742c0.216,0.358,0.53,0.75,0.941,1.181 c0.413,0.429,0.939,0.83,1.582,1.201c0.726,0.419,1.321,0.65,1.784,0.691c0.463,0.042,0.872-0.041,1.227-0.248 c0.224-0.13,0.364-0.272,0.416-0.428c0.053-0.154,0.041-0.327-0.031-0.52c-0.073-0.193-0.199-0.414-0.385-0.664 c-0.186-0.252-0.409-0.535-0.671-0.852c-0.252-0.309-0.479-0.622-0.683-0.938c-0.204-0.314-0.334-0.633-0.388-0.954 c-0.056-0.32,0.005-0.636,0.181-0.952c0.176-0.316,0.519-0.623,1.027-0.918c0.39-0.227,0.822-0.411,1.297-0.556 c0.473-0.145,0.978-0.234,1.511-0.269c0.534-0.033,1.095-0.001,1.684,0.098c0.587,0.1,1.19,0.273,1.81,0.52l1.915-1.113 L388.01,208.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "372.309,217.804 372.306,218.919 370.055,217.619 370.059,216.505  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M395.747,216.085c-0.52,2.014-2.142,3.876-4.698,5.353c-6.538,3.776-17.142,3.776-23.639,0 c-2.482-1.442-4.069-3.26-4.605-5.228l0.003,0.835c0,0.048,0,0.093,0.003,0.142c0.742,1.702,2.254,3.263,4.438,4.531 c3.292,1.914,7.624,2.871,11.962,2.871c4.338,0,8.683-0.957,11.997-2.871c2.248-1.297,3.796-2.896,4.541-4.64v-0.003v-0.125 L395.747,216.085z M367.25,220.346c3.292,1.914,7.624,2.871,11.962,2.871c4.338,0,8.683-0.957,11.997-2.871 c2.245-1.297,3.792-2.894,4.538-4.637l-0.003-0.966c-0.53,2.007-2.152,3.857-4.695,5.328c-6.538,3.774-17.142,3.774-23.639,0 c-2.482-1.442-4.072-3.26-4.608-5.221l0.003,0.95C363.544,217.511,365.057,219.075,367.25,220.346z M391.049,222.81 c-6.538,3.773-17.142,3.773-23.639,0c-2.405-1.4-3.969-3.151-4.55-5.048c0.093,0.716,0.324,1.426,0.696,2.116 c0.003,0.003,0.006,0.01,0.01,0.013c0.845,1.182,2.084,2.267,3.683,3.195c3.292,1.914,7.624,2.871,11.962,2.871 c4.338,0,8.683-0.957,11.997-2.871c1.712-0.986,3.019-2.148,3.873-3.417c0.347-0.684,0.559-1.384,0.633-2.087 C395.16,219.547,393.554,221.364,391.049,222.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M401.352,211.347v0.125c0,0,0,0,0,0.003c-0.003,0.167-0.016,0.331-0.032,0.498 c-0.003,0.003-0.003,0.003-0.003,0.003c-0.074,0.707-0.286,1.406-0.633,2.09c-0.755,1.494-2.155,2.9-4.194,4.076 c-6.452,3.725-16.882,3.725-23.292,0c-1.923-1.118-3.269-2.444-4.03-3.854c-0.003-0.003-0.006-0.01-0.01-0.013 c-0.372-0.69-0.604-1.4-0.697-2.116c-0.029-0.193-0.045-0.382-0.048-0.575c-0.003-0.048-0.003-0.093-0.003-0.142l-0.003-0.835 v-0.411l-0.003-0.95l-0.006-2.126c0.01,2.425,1.602,4.846,4.788,6.699c6.41,3.725,16.84,3.725,23.295,0 c3.24-1.872,4.862-4.329,4.862-6.779l0.003,2.1l0.003,0.966v0.376L401.352,211.347z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M373.261,200.326c-6.453,3.726-6.488,9.766-0.076,13.492c6.411,3.726,16.841,3.726,23.294,0 c6.454-3.726,6.487-9.767,0.076-13.492C390.143,196.6,379.715,196.6,373.261,200.326z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M398.637,207.807c-0.292,1.798-1.635,3.552-4.017,4.932 c-5.421,3.128-14.178,3.128-19.561-0.003c-2.351-1.365-3.667-3.099-3.956-4.881c-0.379-2.302,0.963-4.685,4.017-6.448 c5.421-3.128,14.178-3.128,19.563,0C397.695,203.16,399.012,205.521,398.637,207.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M398.637,207.807c-0.292,1.798-1.635,3.552-4.017,4.932 c-5.421,3.128-14.178,3.128-19.561-0.003c-2.351-1.365-3.667-3.099-3.956-4.881c0.292-1.798,1.634-3.552,4.017-4.929 c5.421-3.131,14.178-3.131,19.563,0C397.031,204.29,398.347,206.025,398.637,207.807z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "393.612,203.079 393.608,204.193 391.764,205.264 391.767,204.15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "393.807,206.048 393.804,207.162 391.121,208.08 391.124,206.966  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062910173804897809530000005498785267114689931_",
    style: {
      enableBackground: "new"
    },
    d: " M385.672,206.214l0.003-1.115c0-0.069,0.015-0.135,0.045-0.196c0.057-0.124,0.181-0.241,0.371-0.351 c0.307-0.178,0.68-0.25,1.119-0.216c0.439,0.034,0.944,0.216,1.517,0.546c0.571,0.33,1.057,0.679,1.457,1.046 c0.397,0.368,0.712,0.713,0.939,1.036l-0.003,1.115c-0.227-0.324-0.542-0.668-0.939-1.037 c-0.4-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.079-0.512-1.517-0.546s-0.813,0.037-1.119,0.216 c-0.189,0.11-0.314,0.227-0.371,0.351C385.687,206.079,385.673,206.145,385.672,206.214z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062910173804897809530000005498785267114689931_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090290986023211375430000014202506557967367044_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062910173804897809530000005498785267114689931_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090290986023211375430000014202506557967367044_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M391.124,206.966l-0.003,1.115c-0.227-0.324-0.542-0.668-0.939-1.037 c-0.4-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.079-0.512-1.517-0.546s-0.813,0.037-1.119,0.216 c-0.189,0.11-0.314,0.227-0.371,0.351c-0.03,0.062-0.045,0.127-0.045,0.196l0.003-1.115c0-0.069,0.015-0.135,0.045-0.196 c0.057-0.124,0.181-0.241,0.371-0.351c0.307-0.178,0.68-0.25,1.119-0.216c0.439,0.034,0.944,0.216,1.517,0.546 c0.571,0.33,1.057,0.679,1.457,1.046C390.582,206.297,390.897,206.642,391.124,206.966L391.124,206.966z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118399135155990904810000009315783310090524837_",
    style: {
      enableBackground: "new"
    },
    d: " M384.128,208.697l-0.003,1.115c0-0.1-0.022-0.206-0.064-0.32c-0.073-0.193-0.199-0.415-0.385-0.664 c-0.186-0.252-0.409-0.536-0.671-0.852c-0.252-0.309-0.479-0.622-0.683-0.939c-0.204-0.314-0.334-0.633-0.388-0.954 c-0.014-0.078-0.02-0.155-0.02-0.233l0.003-1.114c0,0.077,0.006,0.155,0.02,0.233c0.054,0.32,0.184,0.639,0.388,0.953 c0.204,0.316,0.43,0.63,0.682,0.938c0.263,0.317,0.486,0.6,0.672,0.852c0.186,0.25,0.312,0.472,0.385,0.664 C384.106,208.491,384.128,208.598,384.128,208.697z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118399135155990904810000009315783310090524837_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107556873108917106980000006809815165386056322_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118399135155990904810000009315783310090524837_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107556873108917106980000006809815165386056322_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M384.128,208.697l-0.003,1.115c0-0.1-0.022-0.206-0.064-0.32 c-0.073-0.193-0.199-0.415-0.385-0.664c-0.186-0.252-0.409-0.536-0.671-0.852c-0.252-0.309-0.479-0.622-0.683-0.939 c-0.204-0.314-0.334-0.633-0.388-0.954c-0.014-0.078-0.02-0.155-0.02-0.233l0.003-1.114c0,0.077,0.006,0.155,0.02,0.233 c0.054,0.32,0.184,0.639,0.388,0.953c0.204,0.316,0.43,0.63,0.682,0.938c0.263,0.317,0.486,0.6,0.672,0.852 c0.186,0.25,0.312,0.472,0.385,0.664C384.106,208.491,384.128,208.598,384.128,208.697L384.128,208.697z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147918096873215031840000006297812249251196575_",
    style: {
      enableBackground: "new"
    },
    d: " M377.771,209.677l-0.003,1.115c-0.797-0.543-1.369-1.027-1.717-1.454c-0.345-0.426-0.586-0.752-0.717-0.979l0.003-1.115 c0.132,0.227,0.372,0.553,0.717,0.979C376.402,208.649,376.974,209.134,377.771,209.677z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147918096873215031840000006297812249251196575_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135655833683518243850000015005899959343625863_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147918096873215031840000006297812249251196575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000135655833683518243850000015005899959343625863_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M377.771,209.677l-0.003,1.115c-0.797-0.543-1.369-1.027-1.717-1.454 c-0.345-0.426-0.586-0.752-0.717-0.979l0.003-1.115c0.132,0.227,0.372,0.553,0.717,0.979 C376.402,208.649,376.974,209.134,377.771,209.677L377.771,209.677z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139977270984569156800000017766770541472830900_",
    style: {
      enableBackground: "new"
    },
    d: " M387.812,209.052l-0.003,1.115c-0.001,0.298-0.087,0.587-0.26,0.869c-0.207,0.332-0.569,0.65-1.089,0.953 c-0.354,0.206-0.76,0.379-1.215,0.52c-0.455,0.141-0.958,0.225-1.502,0.252c-0.545,0.027-1.124-0.012-1.736-0.118 c-0.611-0.108-1.256-0.302-1.933-0.583l0.003-1.115c0.677,0.282,1.322,0.476,1.934,0.583 c0.611,0.106,1.191,0.145,1.736,0.118c0.545-0.027,1.047-0.111,1.502-0.252c0.455-0.141,0.862-0.314,1.216-0.52 c0.52-0.302,0.882-0.62,1.089-0.953C387.724,209.64,387.811,209.35,387.812,209.052z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139977270984569156800000017766770541472830900_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061452649338475130760000017662820432700233142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139977270984569156800000017766770541472830900_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061452649338475130760000017662820432700233142_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M387.812,209.052l-0.003,1.115c-0.001,0.298-0.087,0.587-0.26,0.869 c-0.207,0.332-0.569,0.65-1.089,0.953c-0.354,0.206-0.76,0.379-1.215,0.52c-0.455,0.141-0.958,0.225-1.502,0.252 c-0.545,0.027-1.124-0.012-1.736-0.118c-0.611-0.108-1.256-0.302-1.933-0.583l0.003-1.115 c0.677,0.282,1.322,0.476,1.934,0.583c0.611,0.106,1.191,0.145,1.736,0.118c0.545-0.027,1.047-0.111,1.502-0.252 c0.455-0.141,0.862-0.314,1.216-0.52c0.52-0.302,0.882-0.62,1.089-0.953C387.724,209.64,387.811,209.35,387.812,209.052 L387.812,209.052z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "380.075,210.945 380.073,212.059 377.908,213.317 377.911,212.203  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M393.612,203.079l-1.844,1.072c0.559,0.393,1.003,0.752,1.331,1.078 c0.329,0.326,0.565,0.599,0.709,0.82l-2.684,0.918c-0.227-0.324-0.542-0.669-0.939-1.036 c-0.401-0.368-0.886-0.717-1.457-1.046c-0.573-0.331-1.079-0.512-1.517-0.546c-0.439-0.034-0.813,0.037-1.119,0.216 c-0.189,0.11-0.314,0.227-0.371,0.351c-0.06,0.124-0.06,0.265,0.001,0.423c0.06,0.159,0.162,0.337,0.306,0.536 c0.144,0.2,0.328,0.435,0.556,0.703c0.333,0.411,0.61,0.812,0.832,1.201c0.222,0.389,0.351,0.761,0.389,1.119 c0.037,0.357-0.047,0.702-0.252,1.036c-0.207,0.333-0.569,0.651-1.089,0.953c-0.354,0.206-0.76,0.379-1.216,0.52 c-0.455,0.141-0.958,0.225-1.502,0.252c-0.544,0.027-1.124-0.012-1.736-0.118c-0.611-0.108-1.256-0.301-1.934-0.583 l-2.165,1.258l-2.251-1.3l2.111-1.227c-0.797-0.542-1.369-1.028-1.717-1.454c-0.345-0.427-0.586-0.752-0.717-0.979 l2.808-0.742c0.216,0.358,0.53,0.75,0.941,1.18c0.413,0.429,0.939,0.83,1.582,1.201c0.726,0.419,1.321,0.65,1.784,0.691 c0.463,0.042,0.872-0.041,1.227-0.248c0.224-0.13,0.364-0.272,0.416-0.427c0.053-0.154,0.041-0.328-0.031-0.52 c-0.073-0.193-0.199-0.414-0.385-0.664c-0.186-0.252-0.409-0.535-0.672-0.852c-0.252-0.308-0.479-0.622-0.682-0.938 c-0.204-0.314-0.334-0.633-0.388-0.953c-0.056-0.32,0.005-0.636,0.181-0.953c0.176-0.316,0.519-0.623,1.027-0.918 c0.39-0.227,0.822-0.411,1.297-0.555c0.473-0.145,0.978-0.235,1.511-0.269c0.534-0.033,1.095-0.001,1.684,0.098 c0.587,0.1,1.19,0.273,1.81,0.52l1.915-1.113L393.612,203.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "377.911,212.203 377.908,213.317 375.657,212.018 375.66,210.903  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M401.349,210.484c-0.52,2.014-2.142,3.876-4.698,5.353c-6.539,3.776-17.142,3.776-23.639,0 c-2.482-1.442-4.069-3.26-4.605-5.228l0.003,0.835c0,0.048,0,0.093,0.003,0.142c0.742,1.702,2.254,3.263,4.438,4.531 c3.292,1.914,7.624,2.871,11.962,2.871c4.338,0,8.683-0.957,11.997-2.871c2.248-1.297,3.796-2.897,4.541-4.641 c0-0.003,0-0.003,0-0.003v-0.125L401.349,210.484z M372.852,214.745c3.292,1.914,7.624,2.871,11.962,2.871 c4.338,0,8.683-0.957,11.997-2.871c2.245-1.297,3.792-2.893,4.538-4.637l-0.003-0.966c-0.53,2.007-2.152,3.857-4.695,5.327 c-6.539,3.774-17.142,3.774-23.639,0c-2.482-1.442-4.072-3.259-4.608-5.221l0.003,0.95 C369.146,211.909,370.658,213.473,372.852,214.745z M396.651,217.208c-6.539,3.773-17.142,3.773-23.639,0 c-2.405-1.4-3.969-3.151-4.551-5.048c0.093,0.716,0.325,1.426,0.697,2.116c0.003,0.003,0.006,0.01,0.01,0.013 c0.845,1.182,2.084,2.267,3.684,3.195c3.292,1.914,7.624,2.871,11.962,2.871c4.338,0,8.683-0.957,11.997-2.871 c1.712-0.986,3.019-2.148,3.873-3.417c0.347-0.684,0.559-1.384,0.633-2.087C400.761,213.945,399.155,215.763,396.651,217.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M369.108,235.952v0.125c0,0,0,0,0,0.003c-0.003,0.167-0.016,0.331-0.032,0.498 c-0.003,0.003-0.003,0.003-0.003,0.003c-0.074,0.707-0.286,1.406-0.633,2.09c-0.755,1.493-2.155,2.9-4.194,4.075 c-6.451,3.725-16.882,3.725-23.292,0c-1.924-1.118-3.269-2.444-4.03-3.854c-0.003-0.003-0.006-0.01-0.01-0.013 c-0.373-0.691-0.604-1.4-0.697-2.116c-0.029-0.193-0.045-0.382-0.048-0.575c-0.003-0.048-0.003-0.093-0.003-0.141l-0.003-0.835 v-0.411l-0.003-0.951l-0.007-2.126c0.01,2.425,1.603,4.846,4.788,6.699c6.41,3.725,16.84,3.725,23.295,0 c3.24-1.872,4.862-4.329,4.862-6.779l0.003,2.1l0.004,0.966v0.376L369.108,235.952z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M341.018,224.93c-6.453,3.726-6.488,9.767-0.076,13.493c6.411,3.726,16.841,3.726,23.294,0 c6.453-3.726,6.487-9.767,0.076-13.492C357.899,221.205,347.471,221.205,341.018,224.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M366.393,232.411c-0.292,1.798-1.635,3.552-4.018,4.933c-5.421,3.128-14.178,3.128-19.56-0.003 c-2.351-1.365-3.667-3.099-3.957-4.881c-0.379-2.303,0.964-4.686,4.018-6.449c5.42-3.128,14.178-3.128,19.563,0 C365.452,227.764,366.769,230.125,366.393,232.411z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M366.393,232.411c-0.292,1.798-1.635,3.552-4.018,4.933c-5.421,3.128-14.178,3.128-19.56-0.003 c-2.351-1.365-3.667-3.099-3.957-4.881c0.292-1.798,1.635-3.552,4.018-4.93c5.42-3.131,14.178-3.131,19.563,0 C364.787,228.895,366.104,230.629,366.393,232.411z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M369.105,235.088c-0.52,2.013-2.142,3.876-4.698,5.353c-6.538,3.776-17.142,3.776-23.639,0 c-2.483-1.442-4.069-3.26-4.605-5.228l0.003,0.835c0,0.048,0,0.093,0.003,0.141c0.742,1.702,2.255,3.263,4.438,4.531 c3.291,1.914,7.624,2.871,11.962,2.871c4.339,0,8.684-0.957,11.997-2.871c2.248-1.297,3.796-2.896,4.541-4.64 c0-0.003,0-0.003,0-0.003v-0.125L369.105,235.088z M340.608,239.349c3.291,1.914,7.624,2.871,11.962,2.871 c4.339,0,8.684-0.957,11.997-2.871c2.245-1.297,3.793-2.894,4.538-4.637l-0.004-0.966c-0.53,2.007-2.152,3.857-4.695,5.327 c-6.538,3.773-17.142,3.773-23.639,0c-2.483-1.442-4.072-3.26-4.608-5.222l0.003,0.951 C336.902,236.514,338.415,238.078,340.608,239.349z M364.407,241.812c-6.538,3.774-17.142,3.774-23.639,0 c-2.405-1.4-3.969-3.15-4.551-5.048c0.093,0.716,0.324,1.426,0.697,2.116c0.003,0.003,0.007,0.01,0.01,0.013 c0.845,1.182,2.084,2.267,3.683,3.195c3.291,1.914,7.624,2.871,11.962,2.871c4.339,0,8.684-0.957,11.997-2.871 c1.712-0.986,3.019-2.148,3.873-3.417c0.347-0.684,0.559-1.384,0.633-2.087C368.517,238.549,366.912,240.367,364.407,241.812z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "346.13,229.018 346.127,230.107 344,228.879 344.003,227.79  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142897161090482855680000002351134292420490926_",
    style: {
      enableBackground: "new"
    },
    d: " M348.429,231.578l0.003-1.088c0-0.04,0.005-0.081,0.016-0.123c0.07-0.262,0.456-0.599,1.158-1.007 c0.625-0.363,1.298-0.659,2.02-0.891c0.723-0.23,1.384-0.408,1.988-0.528l-0.003,1.088c-0.604,0.12-1.266,0.297-1.988,0.527 c-0.723,0.233-1.395,0.529-2.021,0.892c-0.703,0.408-1.088,0.745-1.158,1.007 C348.435,231.497,348.429,231.538,348.429,231.578z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142897161090482855680000002351134292420490926_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057850757459911288190000006880028592265935232_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142897161090482855680000002351134292420490926_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057850757459911288190000006880028592265935232_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M353.615,227.941l-0.003,1.088c-0.604,0.12-1.266,0.297-1.988,0.527 c-0.723,0.233-1.395,0.529-2.021,0.892c-0.703,0.408-1.088,0.745-1.158,1.007c-0.01,0.042-0.016,0.083-0.016,0.123 l0.003-1.088c0-0.04,0.005-0.081,0.016-0.123c0.07-0.262,0.456-0.599,1.158-1.007c0.625-0.363,1.298-0.659,2.02-0.891 C352.349,228.238,353.011,228.061,353.615,227.941L353.615,227.941z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155114611783888583580000007142516317409291423_",
    style: {
      enableBackground: "new"
    },
    d: " M357.305,232.961l-0.003,1.088c0.001-0.2-0.127-0.373-0.382-0.52c-0.186-0.107-0.383-0.178-0.591-0.211 c-0.209-0.034-0.447-0.034-0.714,0c-0.265,0.034-0.567,0.091-0.903,0.171c-0.334,0.08-0.728,0.184-1.181,0.311 c-0.694,0.188-1.369,0.343-2.022,0.466c-0.654,0.125-1.284,0.197-1.885,0.217c-0.603,0.021-1.184-0.028-1.746-0.144 c-0.563-0.117-1.101-0.324-1.612-0.619c-0.348-0.2-0.641-0.431-0.879-0.69c-0.24-0.258-0.383-0.542-0.431-0.85 c-0.01-0.066-0.015-0.133-0.015-0.201l0.003-1.088c0,0.068,0.005,0.135,0.015,0.2c0.047,0.308,0.192,0.592,0.431,0.85 c0.238,0.259,0.531,0.489,0.879,0.69c0.512,0.296,1.05,0.502,1.613,0.619c0.561,0.116,1.142,0.165,1.746,0.144 c0.601-0.019,1.231-0.091,1.885-0.216c0.653-0.123,1.329-0.279,2.022-0.467c0.453-0.127,0.846-0.231,1.181-0.311 c0.336-0.08,0.638-0.137,0.903-0.171c0.267-0.034,0.504-0.034,0.714,0c0.207,0.034,0.405,0.104,0.59,0.211 C357.178,232.587,357.306,232.761,357.305,232.961z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155114611783888583580000007142516317409291423_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052074913693648272020000012729297228591243433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155114611783888583580000007142516317409291423_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052074913693648272020000012729297228591243433_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M357.305,232.961l-0.003,1.088c0.001-0.2-0.127-0.373-0.382-0.52 c-0.186-0.107-0.383-0.178-0.591-0.211c-0.209-0.034-0.447-0.034-0.714,0c-0.265,0.034-0.567,0.091-0.903,0.171 c-0.334,0.08-0.728,0.184-1.181,0.311c-0.694,0.188-1.369,0.343-2.022,0.466c-0.654,0.125-1.284,0.197-1.885,0.217 c-0.603,0.021-1.184-0.028-1.746-0.144c-0.563-0.117-1.101-0.324-1.612-0.619c-0.348-0.2-0.641-0.431-0.879-0.69 c-0.24-0.258-0.383-0.542-0.431-0.85c-0.01-0.066-0.015-0.133-0.015-0.201l0.003-1.088c0,0.068,0.005,0.135,0.015,0.2 c0.047,0.308,0.192,0.592,0.431,0.85c0.238,0.259,0.531,0.489,0.879,0.69c0.512,0.296,1.05,0.502,1.613,0.619 c0.561,0.116,1.142,0.165,1.746,0.144c0.601-0.019,1.231-0.091,1.885-0.216c0.653-0.123,1.329-0.279,2.022-0.467 c0.453-0.127,0.846-0.231,1.181-0.311c0.336-0.08,0.638-0.137,0.903-0.171c0.267-0.034,0.504-0.034,0.714,0 c0.207,0.034,0.405,0.104,0.59,0.211C357.178,232.587,357.306,232.761,357.305,232.961L357.305,232.961z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000049928347121832919500000007090628814686031271_",
    style: {
      enableBackground: "new"
    },
    d: " M360.787,232.617l-0.003,1.088c0,0.227-0.063,0.461-0.184,0.704c-0.167,0.331-0.457,0.672-0.871,1.021l0.003-1.088 c0.414-0.349,0.704-0.69,0.871-1.022C360.724,233.077,360.786,232.843,360.787,232.617z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049928347121832919500000007090628814686031271_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064348726878749433600000001973701859282328226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049928347121832919500000007090628814686031271_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064348726878749433600000001973701859282328226_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M360.787,232.617l-0.003,1.088c0,0.227-0.063,0.461-0.184,0.704 c-0.167,0.331-0.457,0.672-0.871,1.021l0.003-1.088c0.414-0.349,0.704-0.69,0.871-1.022 C360.724,233.077,360.786,232.843,360.787,232.617L360.787,232.617z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "359.431,236.698 359.428,237.786 357.616,236.74 357.619,235.652  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "361.614,235.429 361.611,236.517 359.428,237.786 359.431,236.698  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054255136803385073710000016543330740016602280_",
    style: {
      enableBackground: "new"
    },
    d: " M357.619,235.652l-0.003,1.088c-0.659,0.314-1.262,0.564-1.812,0.749c-0.549,0.185-1.007,0.317-1.377,0.398l0.003-1.088 c0.37-0.081,0.828-0.212,1.377-0.398C356.356,236.216,356.96,235.965,357.619,235.652z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054255136803385073710000016543330740016602280_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168111601303969551850000008999341848564107430_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054255136803385073710000016543330740016602280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168111601303969551850000008999341848564107430_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M357.619,235.652l-0.003,1.088c-0.659,0.314-1.262,0.564-1.812,0.749 c-0.549,0.185-1.007,0.317-1.377,0.398l0.003-1.088c0.37-0.081,0.828-0.212,1.377-0.398 C356.356,236.216,356.96,235.965,357.619,235.652L357.619,235.652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M352.353,226.351l1.262,1.59c-0.604,0.12-1.266,0.297-1.988,0.528 c-0.722,0.232-1.395,0.528-2.02,0.891c-0.702,0.408-1.088,0.745-1.158,1.007c-0.067,0.262,0.073,0.493,0.422,0.695 c0.22,0.127,0.462,0.206,0.722,0.236c0.262,0.029,0.552,0.024,0.878-0.015c0.324-0.04,0.698-0.113,1.118-0.217 c0.423-0.103,0.901-0.229,1.434-0.377c0.519-0.142,1.047-0.269,1.578-0.382c0.532-0.115,1.066-0.187,1.606-0.217 c0.538-0.03,1.073,0.004,1.608,0.104c0.532,0.102,1.05,0.297,1.549,0.585c0.383,0.221,0.699,0.466,0.944,0.735 c0.243,0.268,0.397,0.553,0.455,0.855c0.061,0.302,0.007,0.618-0.16,0.952c-0.166,0.331-0.457,0.672-0.871,1.022l1.882,1.086 l-2.183,1.269l-1.812-1.046c-0.659,0.314-1.262,0.564-1.812,0.749c-0.549,0.185-1.008,0.317-1.377,0.398l-1.557-1.52 c0.545-0.127,1.125-0.303,1.744-0.528s1.205-0.499,1.759-0.821c0.554-0.322,0.858-0.607,0.916-0.856 c0.056-0.248-0.067-0.459-0.369-0.633c-0.186-0.107-0.383-0.178-0.59-0.211c-0.21-0.034-0.447-0.034-0.714,0 c-0.265,0.034-0.567,0.091-0.903,0.171c-0.334,0.08-0.728,0.184-1.181,0.311c-0.694,0.188-1.369,0.343-2.022,0.467 c-0.654,0.125-1.284,0.197-1.885,0.216c-0.603,0.021-1.184-0.028-1.746-0.144c-0.563-0.117-1.101-0.324-1.613-0.619 c-0.348-0.2-0.641-0.431-0.879-0.69c-0.239-0.258-0.384-0.541-0.431-0.85c-0.046-0.309,0.017-0.635,0.195-0.982 c0.178-0.344,0.502-0.708,0.976-1.09l-2.127-1.228l2.183-1.269l2.075,1.198c0.913-0.45,1.729-0.772,2.444-0.967 C351.422,226.559,351.972,226.423,352.353,226.351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "354.43,236.798 354.427,237.886 352.87,236.366 352.873,235.278  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    cx: 157.099,
    cy: 361.948,
    rx: 18.925,
    ry: 10.927
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M172.522,359.976v0.136c0,0,0,0,0,0.003c-0.004,0.182-0.018,0.36-0.035,0.542 c-0.004,0.003-0.004,0.003-0.004,0.003c-0.08,0.77-0.311,1.532-0.689,2.277c-0.822,1.627-2.347,3.159-4.568,4.439 c-7.027,4.057-18.388,4.057-25.37,0c-2.095-1.217-3.561-2.662-4.39-4.198l-0.007-0.01c-0.409-0.756-0.661-1.529-0.762-2.309 c-0.031-0.21-0.049-0.416-0.053-0.626c-0.003-0.053-0.003-0.102-0.003-0.154l-0.004-0.909v-0.447l-0.003-1.036l-0.007-2.315 c0.01,2.641,1.745,5.278,5.215,7.296c6.982,4.058,18.343,4.058,25.374,0c3.529-2.039,5.296-4.715,5.296-7.384l0.004,2.287 l0.003,1.053v0.41L172.522,359.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M141.924,347.972c-7.029,4.058-7.067,10.638-0.083,14.697c6.983,4.058,18.343,4.058,25.372,0 c7.03-4.059,7.066-10.638,0.083-14.696C160.312,343.914,148.954,343.913,141.924,347.972z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M169.563,356.12c-0.318,1.959-1.781,3.868-4.376,5.373c-5.904,3.407-15.443,3.407-21.305-0.004 c-2.561-1.486-3.995-3.375-4.31-5.316c-0.412-2.508,1.049-5.104,4.376-7.024c5.905-3.407,15.443-3.407,21.309,0 C168.538,351.059,169.973,353.629,169.563,356.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M169.563,356.12c-0.318,1.959-1.781,3.868-4.376,5.373c-5.904,3.407-15.443,3.407-21.305-0.004 c-2.561-1.486-3.995-3.375-4.31-5.316c0.318-1.959,1.781-3.869,4.376-5.369c5.905-3.411,15.443-3.411,21.309,0 C167.814,352.29,169.249,354.178,169.563,356.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "164.09,350.97 164.087,352.184 162.078,353.351 162.081,352.137  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "164.303,354.203 164.3,355.418 161.377,356.418 161.38,355.204  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000001645853433353298900000004141121330428457092_",
    style: {
      enableBackground: "new"
    },
    d: " M155.443,354.384l0.003-1.214c0-0.075,0.016-0.147,0.049-0.213c0.062-0.135,0.198-0.262,0.404-0.382 c0.335-0.195,0.742-0.272,1.219-0.235c0.478,0.037,1.029,0.235,1.652,0.595c0.622,0.359,1.151,0.739,1.588,1.14 c0.432,0.401,0.776,0.776,1.023,1.129l-0.003,1.214c-0.247-0.352-0.59-0.728-1.023-1.129 c-0.436-0.401-0.966-0.781-1.588-1.14c-0.624-0.36-1.175-0.558-1.652-0.596c-0.478-0.037-0.885,0.041-1.219,0.235 c-0.206,0.12-0.342,0.247-0.404,0.382C155.459,354.238,155.443,354.309,155.443,354.384z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001645853433353298900000004141121330428457092_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061451472704276142100000000725729332000967571_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000001645853433353298900000004141121330428457092_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061451472704276142100000000725729332000967571_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M161.38,355.204l-0.003,1.214c-0.247-0.352-0.59-0.728-1.023-1.129 c-0.436-0.401-0.966-0.781-1.588-1.14c-0.624-0.36-1.175-0.558-1.652-0.596c-0.478-0.037-0.885,0.041-1.219,0.235 c-0.206,0.12-0.342,0.247-0.404,0.382c-0.032,0.067-0.049,0.138-0.049,0.213l0.003-1.214c0-0.075,0.016-0.147,0.049-0.213 c0.062-0.135,0.198-0.262,0.404-0.382c0.335-0.195,0.742-0.272,1.219-0.235c0.478,0.037,1.029,0.235,1.652,0.595 c0.622,0.359,1.151,0.739,1.588,1.14C160.79,354.476,161.134,354.851,161.38,355.204L161.38,355.204z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044877644065779579160000015557321372675662008_",
    style: {
      enableBackground: "new"
    },
    d: "M153.76,357.09 l-0.003,1.214c0-0.109-0.023-0.225-0.069-0.348c-0.079-0.21-0.217-0.451-0.419-0.724c-0.202-0.275-0.445-0.583-0.731-0.928 c-0.275-0.336-0.522-0.678-0.743-1.022c-0.222-0.343-0.364-0.69-0.423-1.039c-0.015-0.085-0.022-0.169-0.022-0.254 l0.004-1.214c-0.001,0.084,0.007,0.169,0.022,0.254c0.059,0.35,0.201,0.696,0.423,1.039c0.222,0.345,0.468,0.686,0.743,1.022 c0.286,0.345,0.529,0.653,0.731,0.928c0.202,0.272,0.34,0.514,0.419,0.724C153.737,356.866,153.76,356.981,153.76,357.09z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044877644065779579160000015557321372675662008_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145028826360006658540000004936364646388942517_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044877644065779579160000015557321372675662008_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145028826360006658540000004936364646388942517_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M153.76,357.09l-0.003,1.214c0-0.109-0.023-0.225-0.069-0.348 c-0.079-0.21-0.217-0.451-0.419-0.724c-0.202-0.275-0.445-0.583-0.731-0.928c-0.275-0.336-0.522-0.678-0.743-1.022 c-0.222-0.343-0.364-0.69-0.423-1.039c-0.015-0.085-0.022-0.169-0.022-0.254l0.004-1.214 c-0.001,0.084,0.007,0.169,0.022,0.254c0.059,0.35,0.201,0.696,0.423,1.039c0.222,0.345,0.468,0.686,0.743,1.022 c0.286,0.345,0.529,0.653,0.731,0.928c0.202,0.272,0.34,0.514,0.419,0.724C153.737,356.866,153.76,356.981,153.76,357.09 L153.76,357.09z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106138631782888794640000001971944607213360026_",
    style: {
      enableBackground: "new"
    },
    d: " M146.836,358.156l-0.003,1.215c-0.868-0.591-1.491-1.119-1.871-1.584c-0.376-0.464-0.638-0.819-0.781-1.066l0.003-1.214 c0.144,0.247,0.405,0.602,0.782,1.066C145.346,357.037,145.968,357.565,146.836,358.156z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106138631782888794640000001971944607213360026_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070115023529863016400000008310639744899351743_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106138631782888794640000001971944607213360026_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070115023529863016400000008310639744899351743_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M146.836,358.156l-0.003,1.215c-0.868-0.591-1.491-1.119-1.871-1.584 c-0.376-0.464-0.638-0.819-0.781-1.066l0.003-1.214c0.144,0.247,0.405,0.602,0.782,1.066 C145.346,357.037,145.968,357.565,146.836,358.156L146.836,358.156z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118362506832671399840000007482993313324980123_",
    style: {
      enableBackground: "new"
    },
    d: " M157.773,357.477l-0.003,1.214c-0.001,0.324-0.095,0.64-0.283,0.947c-0.226,0.362-0.62,0.708-1.187,1.037 c-0.385,0.224-0.828,0.413-1.324,0.566c-0.496,0.154-1.043,0.245-1.636,0.275c-0.593,0.029-1.225-0.013-1.891-0.129 c-0.666-0.118-1.369-0.328-2.106-0.635l0.003-1.214c0.738,0.307,1.44,0.518,2.106,0.635c0.667,0.115,1.298,0.158,1.891,0.128 c0.593-0.029,1.141-0.121,1.636-0.274c0.496-0.154,0.938-0.343,1.324-0.567c0.567-0.33,0.961-0.675,1.187-1.038 C157.678,358.117,157.772,357.801,157.773,357.477z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118362506832671399840000007482993313324980123_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105411744304790276930000012269756952595640215_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118362506832671399840000007482993313324980123_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105411744304790276930000012269756952595640215_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M157.773,357.477l-0.003,1.214c-0.001,0.324-0.095,0.64-0.283,0.947 c-0.226,0.362-0.62,0.708-1.187,1.037c-0.385,0.224-0.828,0.413-1.324,0.566c-0.496,0.154-1.043,0.245-1.636,0.275 c-0.593,0.029-1.225-0.013-1.891-0.129c-0.666-0.118-1.369-0.328-2.106-0.635l0.003-1.214 c0.738,0.307,1.44,0.518,2.106,0.635c0.667,0.115,1.298,0.158,1.891,0.128c0.593-0.029,1.141-0.121,1.636-0.274 c0.496-0.154,0.938-0.343,1.324-0.567c0.567-0.33,0.961-0.675,1.187-1.038C157.678,358.117,157.772,357.801,157.773,357.477 L157.773,357.477z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "149.346,359.538 149.343,360.752 146.985,362.122 146.988,360.908  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M164.09,350.97l-2.008,1.167c0.609,0.428,1.093,0.819,1.449,1.173 c0.359,0.356,0.616,0.654,0.773,0.893l-2.923,1c-0.247-0.353-0.59-0.728-1.023-1.129c-0.436-0.401-0.965-0.781-1.588-1.14 c-0.623-0.36-1.175-0.558-1.652-0.595c-0.478-0.037-0.885,0.04-1.219,0.235c-0.206,0.12-0.342,0.247-0.404,0.382 c-0.066,0.135-0.065,0.289,0.001,0.46c0.065,0.173,0.176,0.367,0.333,0.584c0.156,0.218,0.357,0.474,0.605,0.766 c0.363,0.448,0.665,0.885,0.906,1.309c0.241,0.424,0.382,0.829,0.424,1.219c0.04,0.389-0.05,0.766-0.274,1.129 c-0.225,0.362-0.62,0.708-1.187,1.038c-0.385,0.224-0.828,0.413-1.324,0.567c-0.495,0.154-1.043,0.245-1.636,0.274 c-0.593,0.03-1.224-0.013-1.891-0.128c-0.666-0.118-1.368-0.328-2.106-0.635l-2.358,1.37l-2.452-1.416l2.299-1.336 c-0.868-0.591-1.491-1.119-1.87-1.583c-0.376-0.464-0.638-0.819-0.782-1.066l3.059-0.808c0.235,0.39,0.577,0.817,1.025,1.286 c0.45,0.468,1.023,0.903,1.723,1.307c0.791,0.457,1.439,0.708,1.943,0.753c0.505,0.046,0.95-0.045,1.337-0.27 c0.244-0.142,0.396-0.297,0.452-0.466c0.058-0.168,0.045-0.357-0.033-0.566c-0.079-0.209-0.217-0.451-0.419-0.724 c-0.202-0.275-0.445-0.583-0.731-0.928c-0.275-0.336-0.521-0.678-0.743-1.022c-0.222-0.343-0.364-0.689-0.423-1.039 c-0.061-0.348,0.006-0.693,0.197-1.037c0.191-0.345,0.565-0.679,1.118-1.001c0.425-0.247,0.896-0.448,1.413-0.605 c0.515-0.158,1.066-0.256,1.645-0.293c0.582-0.037,1.193-0.001,1.834,0.107c0.64,0.108,1.297,0.297,1.971,0.566l2.086-1.212 L164.09,350.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "146.988,360.908 146.985,362.122 144.533,360.707 144.537,359.492  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M172.518,359.035c-0.567,2.193-2.333,4.222-5.117,5.831c-7.121,4.113-18.672,4.113-25.748,0 c-2.704-1.57-4.432-3.55-5.016-5.695l0.004,0.909c0,0.052,0,0.102,0.003,0.154c0.808,1.854,2.455,3.554,4.834,4.935 c3.586,2.085,8.304,3.127,13.029,3.127c4.726,0,9.459-1.042,13.068-3.127c2.448-1.413,4.135-3.155,4.946-5.054 c0-0.003,0-0.003,0-0.003v-0.136L172.518,359.035z M141.478,363.677c3.586,2.085,8.304,3.127,13.029,3.127 c4.726,0,9.459-1.042,13.068-3.127c2.445-1.413,4.131-3.151,4.942-5.051l-0.003-1.053c-0.577,2.186-2.344,4.201-5.114,5.803 c-7.121,4.11-18.672,4.11-25.748,0c-2.704-1.57-4.435-3.55-5.02-5.688l0.003,1.036 C137.441,360.588,139.089,362.292,141.478,363.677z M167.4,366.36c-7.121,4.11-18.672,4.11-25.748,0 c-2.62-1.525-4.323-3.431-4.957-5.499c0.102,0.78,0.353,1.553,0.759,2.305l0.01,0.014c0.92,1.287,2.27,2.47,4.012,3.48 c3.586,2.085,8.304,3.127,13.029,3.127c4.726,0,9.459-1.042,13.068-3.127c1.864-1.073,3.288-2.34,4.218-3.722 c0.378-0.745,0.609-1.507,0.689-2.273C171.878,362.806,170.129,364.786,167.4,366.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M169.885,354.327v0.136c0,0,0,0,0,0.004c-0.004,0.181-0.018,0.36-0.036,0.542 c-0.003,0.004-0.003,0.004-0.003,0.004c-0.08,0.769-0.311,1.532-0.689,2.277c-0.822,1.626-2.347,3.159-4.568,4.439 c-7.027,4.058-18.389,4.058-25.37,0c-2.095-1.217-3.561-2.662-4.39-4.197c0,0-0.007-0.01-0.01-0.014 c-0.406-0.752-0.658-1.526-0.759-2.305c-0.032-0.21-0.049-0.416-0.053-0.626c-0.004-0.052-0.004-0.101-0.004-0.154l-0.003-0.91 v-0.447l-0.003-1.036l-0.007-2.315c0.01,2.641,1.745,5.278,5.215,7.296c6.982,4.058,18.343,4.058,25.374,0 c3.529-2.039,5.296-4.715,5.296-7.384l0.004,2.287l0.003,1.053v0.409L169.885,354.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M139.288,342.322c-7.029,4.059-7.067,10.638-0.083,14.697c6.983,4.058,18.343,4.058,25.372,0 c7.03-4.059,7.066-10.638,0.083-14.696C157.676,338.264,146.317,338.264,139.288,342.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M166.927,350.471c-0.318,1.959-1.781,3.869-4.376,5.373 c-5.904,3.407-15.443,3.407-21.305-0.004c-2.561-1.486-3.995-3.375-4.31-5.316c-0.413-2.508,1.049-5.104,4.376-7.024 c5.905-3.407,15.443-3.407,21.309,0C165.902,345.409,167.337,347.98,166.927,350.471z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M166.927,350.471c-0.318,1.959-1.781,3.869-4.376,5.373 c-5.904,3.407-15.443,3.407-21.305-0.004c-2.561-1.486-3.995-3.375-4.31-5.316c0.318-1.959,1.781-3.869,4.376-5.369 c5.905-3.411,15.443-3.411,21.309,0C165.178,346.64,166.613,348.53,166.927,350.471z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "161.454,345.32 161.45,346.534 159.442,347.702 159.445,346.488  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "161.667,348.554 161.664,349.768 158.741,350.768 158.744,349.554  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031197444898549147140000013404440996044987570_",
    style: {
      enableBackground: "new"
    },
    d: " M152.807,348.735l0.003-1.214c0-0.075,0.016-0.146,0.049-0.213c0.062-0.135,0.198-0.262,0.403-0.382 c0.335-0.194,0.742-0.272,1.22-0.235c0.478,0.038,1.029,0.235,1.652,0.596c0.622,0.359,1.151,0.739,1.587,1.14 c0.433,0.401,0.776,0.776,1.023,1.129l-0.003,1.214c-0.247-0.352-0.59-0.728-1.023-1.129 c-0.436-0.401-0.966-0.781-1.587-1.14c-0.624-0.36-1.175-0.558-1.653-0.595c-0.478-0.037-0.885,0.041-1.219,0.235 c-0.206,0.12-0.342,0.247-0.404,0.382C152.823,348.589,152.807,348.66,152.807,348.735z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031197444898549147140000013404440996044987570_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060742483705709705730000001067994304877935806_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031197444898549147140000013404440996044987570_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000060742483705709705730000001067994304877935806_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M158.744,349.554l-0.003,1.214c-0.247-0.352-0.59-0.728-1.023-1.129 c-0.436-0.401-0.966-0.781-1.587-1.14c-0.624-0.36-1.175-0.558-1.653-0.595c-0.478-0.037-0.885,0.041-1.219,0.235 c-0.206,0.12-0.342,0.247-0.404,0.382c-0.032,0.067-0.049,0.138-0.049,0.213l0.003-1.214c0-0.075,0.016-0.146,0.049-0.213 c0.062-0.135,0.198-0.262,0.403-0.382c0.335-0.194,0.742-0.272,1.22-0.235c0.478,0.038,1.029,0.235,1.652,0.596 c0.622,0.359,1.151,0.739,1.587,1.14C158.154,348.826,158.497,349.202,158.744,349.554L158.744,349.554z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000004537481616381258820000011281534139883126710_",
    style: {
      enableBackground: "new"
    },
    d: " M151.124,351.441l-0.003,1.214c0-0.109-0.023-0.225-0.07-0.348c-0.079-0.209-0.216-0.451-0.419-0.723 c-0.202-0.275-0.445-0.583-0.731-0.927c-0.275-0.336-0.522-0.678-0.743-1.023c-0.222-0.342-0.364-0.689-0.423-1.038 c-0.015-0.085-0.022-0.169-0.022-0.254l0.004-1.214c-0.001,0.085,0.007,0.169,0.022,0.254 c0.058,0.349,0.201,0.696,0.423,1.039c0.221,0.345,0.468,0.686,0.743,1.022c0.286,0.345,0.529,0.654,0.731,0.928 c0.202,0.272,0.34,0.514,0.419,0.723C151.101,351.216,151.124,351.332,151.124,351.441z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004537481616381258820000011281534139883126710_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154396307313307635850000000446830957829521851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004537481616381258820000011281534139883126710_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154396307313307635850000000446830957829521851_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M151.124,351.441l-0.003,1.214c0-0.109-0.023-0.225-0.07-0.348 c-0.079-0.209-0.216-0.451-0.419-0.723c-0.202-0.275-0.445-0.583-0.731-0.927c-0.275-0.336-0.522-0.678-0.743-1.023 c-0.222-0.342-0.364-0.689-0.423-1.038c-0.015-0.085-0.022-0.169-0.022-0.254l0.004-1.214 c-0.001,0.085,0.007,0.169,0.022,0.254c0.058,0.349,0.201,0.696,0.423,1.039c0.221,0.345,0.468,0.686,0.743,1.022 c0.286,0.345,0.529,0.654,0.731,0.928c0.202,0.272,0.34,0.514,0.419,0.723C151.101,351.216,151.124,351.332,151.124,351.441 L151.124,351.441z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072980846362022358820000003501907870311985560_",
    style: {
      enableBackground: "new"
    },
    d: "M144.2,352.507 l-0.003,1.214c-0.868-0.591-1.491-1.119-1.871-1.584c-0.376-0.464-0.638-0.819-0.781-1.066l0.003-1.215 c0.143,0.247,0.405,0.602,0.781,1.066C142.709,351.388,143.332,351.916,144.2,352.507z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072980846362022358820000003501907870311985560_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023238858546606334320000013360255423580914581_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072980846362022358820000003501907870311985560_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023238858546606334320000013360255423580914581_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M144.2,352.507l-0.003,1.214c-0.868-0.591-1.491-1.119-1.871-1.584 c-0.376-0.464-0.638-0.819-0.781-1.066l0.003-1.215c0.143,0.247,0.405,0.602,0.781,1.066 C142.709,351.388,143.332,351.916,144.2,352.507L144.2,352.507z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020374221735878297690000017301088250461623987_",
    style: {
      enableBackground: "new"
    },
    d: " M155.137,351.828l-0.003,1.214c-0.001,0.324-0.095,0.64-0.283,0.947c-0.226,0.362-0.62,0.708-1.187,1.037 c-0.386,0.224-0.828,0.413-1.324,0.566c-0.496,0.154-1.043,0.245-1.636,0.275c-0.593,0.03-1.225-0.013-1.891-0.128 c-0.666-0.117-1.369-0.328-2.106-0.635l0.003-1.214c0.738,0.307,1.44,0.518,2.106,0.635c0.666,0.115,1.298,0.158,1.891,0.129 c0.593-0.03,1.141-0.121,1.636-0.275c0.496-0.154,0.938-0.342,1.324-0.566c0.567-0.329,0.961-0.675,1.187-1.038 C155.041,352.467,155.135,352.152,155.137,351.828z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020374221735878297690000017301088250461623987_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125596163843037714710000001129749633654419847_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020374221735878297690000017301088250461623987_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125596163843037714710000001129749633654419847_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M155.137,351.828l-0.003,1.214c-0.001,0.324-0.095,0.64-0.283,0.947 c-0.226,0.362-0.62,0.708-1.187,1.037c-0.386,0.224-0.828,0.413-1.324,0.566c-0.496,0.154-1.043,0.245-1.636,0.275 c-0.593,0.03-1.225-0.013-1.891-0.128c-0.666-0.117-1.369-0.328-2.106-0.635l0.003-1.214c0.738,0.307,1.44,0.518,2.106,0.635 c0.666,0.115,1.298,0.158,1.891,0.129c0.593-0.03,1.141-0.121,1.636-0.275c0.496-0.154,0.938-0.342,1.324-0.566 c0.567-0.329,0.961-0.675,1.187-1.038C155.041,352.467,155.135,352.152,155.137,351.828L155.137,351.828z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "146.71,353.888 146.706,355.103 144.349,356.473 144.352,355.259  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M161.454,345.32l-2.008,1.168c0.609,0.428,1.093,0.819,1.449,1.173 c0.359,0.356,0.616,0.654,0.773,0.893l-2.923,1c-0.247-0.352-0.59-0.728-1.023-1.129c-0.436-0.401-0.965-0.781-1.587-1.14 c-0.624-0.36-1.175-0.558-1.652-0.596c-0.478-0.037-0.885,0.041-1.22,0.235c-0.206,0.12-0.342,0.247-0.403,0.382 c-0.066,0.135-0.065,0.289,0,0.46c0.066,0.173,0.177,0.367,0.334,0.584c0.156,0.218,0.357,0.473,0.605,0.766 c0.363,0.448,0.665,0.885,0.906,1.309c0.241,0.424,0.382,0.829,0.424,1.219c0.04,0.389-0.05,0.766-0.274,1.129 c-0.225,0.363-0.62,0.709-1.187,1.038c-0.385,0.224-0.828,0.413-1.324,0.566c-0.495,0.154-1.043,0.245-1.636,0.275 c-0.593,0.03-1.225-0.013-1.891-0.129c-0.666-0.117-1.368-0.328-2.106-0.635l-2.358,1.37l-2.451-1.416l2.299-1.336 c-0.868-0.591-1.491-1.119-1.87-1.584c-0.376-0.464-0.638-0.819-0.781-1.066l3.059-0.808c0.235,0.39,0.577,0.817,1.025,1.286 c0.449,0.467,1.023,0.903,1.723,1.307c0.791,0.457,1.439,0.709,1.943,0.752c0.505,0.046,0.95-0.045,1.337-0.27 c0.244-0.142,0.396-0.296,0.452-0.466c0.058-0.168,0.045-0.357-0.033-0.567c-0.079-0.209-0.217-0.451-0.419-0.723 c-0.202-0.275-0.445-0.583-0.731-0.928c-0.275-0.336-0.522-0.677-0.743-1.022c-0.222-0.343-0.364-0.69-0.423-1.039 c-0.061-0.348,0.005-0.693,0.197-1.037c0.191-0.345,0.565-0.679,1.118-1.001c0.425-0.247,0.896-0.448,1.412-0.605 c0.515-0.158,1.066-0.256,1.646-0.293c0.582-0.036,1.193-0.001,1.834,0.107c0.64,0.108,1.296,0.298,1.971,0.566l2.086-1.212 L161.454,345.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "144.352,355.259 144.349,356.473 141.897,355.058 141.9,353.843  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M169.882,353.386c-0.566,2.193-2.333,4.222-5.117,5.831c-7.122,4.113-18.672,4.113-25.748,0 c-2.704-1.57-4.432-3.55-5.016-5.695l0.003,0.91c0,0.052,0,0.101,0.004,0.154c0.808,1.854,2.455,3.554,4.834,4.936 c3.585,2.084,8.304,3.127,13.029,3.127c4.726,0,9.459-1.042,13.068-3.127c2.448-1.413,4.135-3.155,4.946-5.054 c0-0.004,0-0.004,0-0.004v-0.136L169.882,353.386z M138.841,358.027c3.585,2.085,8.304,3.127,13.029,3.127 c4.726,0,9.459-1.042,13.068-3.127c2.445-1.413,4.131-3.151,4.942-5.051l-0.003-1.053c-0.577,2.186-2.344,4.201-5.114,5.803 c-7.122,4.11-18.672,4.11-25.748,0c-2.704-1.571-4.435-3.55-5.02-5.688l0.003,1.036 C134.805,354.939,136.452,356.642,138.841,358.027z M164.764,360.711c-7.122,4.11-18.672,4.11-25.748,0 c-2.62-1.526-4.323-3.432-4.957-5.499c0.101,0.78,0.353,1.553,0.759,2.305c0.003,0.003,0.007,0.01,0.007,0.01 c0.924,1.29,2.274,2.473,4.015,3.484c3.585,2.085,8.304,3.127,13.029,3.127c4.726,0,9.459-1.042,13.068-3.127 c1.864-1.074,3.288-2.34,4.218-3.722c0.378-0.745,0.609-1.508,0.689-2.274C169.242,357.157,167.492,359.137,164.764,360.711z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M175.986,348.226v0.136c0,0,0,0,0,0.003c-0.003,0.182-0.018,0.36-0.035,0.542 c-0.003,0.003-0.003,0.003-0.003,0.003c-0.081,0.77-0.312,1.532-0.69,2.277c-0.822,1.627-2.347,3.159-4.568,4.439 c-7.027,4.057-18.388,4.057-25.37,0c-2.096-1.217-3.561-2.662-4.39-4.198c0,0-0.007-0.01-0.01-0.014 c-0.406-0.752-0.657-1.525-0.759-2.305c-0.031-0.21-0.049-0.416-0.053-0.626c-0.003-0.053-0.003-0.102-0.003-0.154l-0.003-0.909 v-0.447l-0.004-1.036l-0.007-2.315c0.011,2.641,1.745,5.278,5.216,7.296c6.982,4.058,18.343,4.058,25.373,0 c3.529-2.039,5.296-4.715,5.296-7.384l0.004,2.288l0.004,1.053v0.41L175.986,348.226z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M145.389,336.221c-7.029,4.058-7.067,10.638-0.083,14.697c6.983,4.058,18.343,4.058,25.372,0 c7.03-4.059,7.066-10.638,0.083-14.697C163.777,332.163,152.418,332.163,145.389,336.221z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M173.029,344.37c-0.318,1.958-1.781,3.868-4.376,5.373c-5.904,3.407-15.443,3.407-21.305-0.004 c-2.56-1.486-3.995-3.376-4.31-5.317c-0.412-2.508,1.049-5.103,4.376-7.024c5.904-3.407,15.443-3.407,21.309,0 C172.003,339.308,173.438,341.879,173.029,344.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC400"
    },
    d: "M173.029,344.37c-0.318,1.958-1.781,3.868-4.376,5.373c-5.904,3.407-15.443,3.407-21.305-0.004 c-2.56-1.486-3.995-3.376-4.31-5.317c0.319-1.959,1.781-3.868,4.376-5.369c5.904-3.411,15.443-3.411,21.309,0 C171.279,340.539,172.714,342.428,173.029,344.37z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "167.555,339.219 167.551,340.433 165.543,341.6 165.547,340.386  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "167.768,342.453 167.765,343.667 164.842,344.667 164.845,343.453  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000028310824988497362760000002411623279772105620_",
    style: {
      enableBackground: "new"
    },
    d: " M158.908,342.634l0.003-1.214c0.001-0.076,0.016-0.147,0.049-0.213c0.062-0.136,0.198-0.262,0.404-0.382 c0.335-0.195,0.742-0.272,1.219-0.235c0.478,0.037,1.029,0.235,1.653,0.595c0.622,0.359,1.151,0.739,1.587,1.14 c0.433,0.4,0.776,0.776,1.023,1.129l-0.003,1.214c-0.247-0.353-0.59-0.728-1.022-1.129c-0.436-0.401-0.966-0.781-1.588-1.14 c-0.624-0.36-1.175-0.558-1.653-0.595c-0.478-0.037-0.885,0.041-1.219,0.235c-0.206,0.12-0.342,0.247-0.404,0.382 C158.924,342.487,158.908,342.559,158.908,342.634z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028310824988497362760000002411623279772105620_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178200727555801446380000013039422252835638674_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028310824988497362760000002411623279772105620_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178200727555801446380000013039422252835638674_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M164.845,343.453l-0.003,1.214c-0.247-0.353-0.59-0.728-1.022-1.129 c-0.436-0.401-0.966-0.781-1.588-1.14c-0.624-0.36-1.175-0.558-1.653-0.595c-0.478-0.037-0.885,0.041-1.219,0.235 c-0.206,0.12-0.342,0.247-0.404,0.382c-0.032,0.067-0.049,0.138-0.049,0.213l0.003-1.214 c0.001-0.076,0.016-0.147,0.049-0.213c0.062-0.136,0.198-0.262,0.404-0.382c0.335-0.195,0.742-0.272,1.219-0.235 c0.478,0.037,1.029,0.235,1.653,0.595c0.622,0.359,1.151,0.739,1.587,1.14C164.255,342.725,164.598,343.1,164.845,343.453 L164.845,343.453z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031179943082612723420000005363780874918330524_",
    style: {
      enableBackground: "new"
    },
    d: " M157.225,345.34l-0.003,1.214c0-0.109-0.023-0.225-0.069-0.348c-0.079-0.21-0.217-0.451-0.419-0.724 c-0.202-0.275-0.445-0.583-0.731-0.928c-0.275-0.336-0.522-0.677-0.743-1.022c-0.222-0.343-0.364-0.69-0.423-1.039 c-0.015-0.085-0.022-0.17-0.022-0.254l0.003-1.214c0,0.084,0.007,0.169,0.022,0.254c0.059,0.349,0.201,0.696,0.423,1.039 c0.222,0.345,0.469,0.686,0.743,1.022c0.286,0.345,0.529,0.654,0.732,0.928c0.202,0.272,0.34,0.513,0.419,0.723 C157.202,345.115,157.225,345.231,157.225,345.34z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031179943082612723420000005363780874918330524_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107567010425876777360000006123625108027315379_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031179943082612723420000005363780874918330524_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107567010425876777360000006123625108027315379_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M157.225,345.34l-0.003,1.214c0-0.109-0.023-0.225-0.069-0.348 c-0.079-0.21-0.217-0.451-0.419-0.724c-0.202-0.275-0.445-0.583-0.731-0.928c-0.275-0.336-0.522-0.677-0.743-1.022 c-0.222-0.343-0.364-0.69-0.423-1.039c-0.015-0.085-0.022-0.17-0.022-0.254l0.003-1.214c0,0.084,0.007,0.169,0.022,0.254 c0.059,0.349,0.201,0.696,0.423,1.039c0.222,0.345,0.469,0.686,0.743,1.022c0.286,0.345,0.529,0.654,0.732,0.928 c0.202,0.272,0.34,0.513,0.419,0.723C157.202,345.115,157.225,345.231,157.225,345.34L157.225,345.34z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103228648471147077590000009701116104178944174_",
    style: {
      enableBackground: "new"
    },
    d: " M150.301,346.406l-0.004,1.214c-0.868-0.591-1.491-1.119-1.87-1.584c-0.376-0.464-0.638-0.819-0.781-1.066l0.003-1.214 c0.144,0.247,0.405,0.602,0.781,1.066C148.811,345.287,149.434,345.815,150.301,346.406z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103228648471147077590000009701116104178944174_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106846416474750504530000007871237620676479361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103228648471147077590000009701116104178944174_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106846416474750504530000007871237620676479361_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M150.301,346.406l-0.004,1.214c-0.868-0.591-1.491-1.119-1.87-1.584 c-0.376-0.464-0.638-0.819-0.781-1.066l0.003-1.214c0.144,0.247,0.405,0.602,0.781,1.066 C148.811,345.287,149.434,345.815,150.301,346.406L150.301,346.406z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000077285676865665150480000009112831278059035565_",
    style: {
      enableBackground: "new"
    },
    d: " M161.238,345.726l-0.003,1.214c-0.001,0.324-0.095,0.64-0.283,0.946c-0.225,0.363-0.62,0.709-1.187,1.038 c-0.386,0.224-0.828,0.413-1.324,0.567c-0.495,0.154-1.043,0.245-1.636,0.275c-0.593,0.029-1.225-0.013-1.891-0.129 c-0.666-0.118-1.368-0.328-2.106-0.635l0.004-1.215c0.737,0.308,1.44,0.518,2.106,0.636c0.666,0.115,1.297,0.158,1.89,0.128 c0.593-0.029,1.141-0.121,1.636-0.275c0.496-0.154,0.938-0.343,1.324-0.567c0.567-0.33,0.961-0.675,1.187-1.038 C161.143,346.366,161.237,346.051,161.238,345.726z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077285676865665150480000009112831278059035565_",
    style: {
      overflow: "visible",
      fill: "#FF9900"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122001398294448120060000009106956869202173570_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077285676865665150480000009112831278059035565_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122001398294448120060000009106956869202173570_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M161.238,345.726l-0.003,1.214c-0.001,0.324-0.095,0.64-0.283,0.946 c-0.225,0.363-0.62,0.709-1.187,1.038c-0.386,0.224-0.828,0.413-1.324,0.567c-0.495,0.154-1.043,0.245-1.636,0.275 c-0.593,0.029-1.225-0.013-1.891-0.129c-0.666-0.118-1.368-0.328-2.106-0.635l0.004-1.215 c0.737,0.308,1.44,0.518,2.106,0.636c0.666,0.115,1.297,0.158,1.89,0.128c0.593-0.029,1.141-0.121,1.636-0.275 c0.496-0.154,0.938-0.343,1.324-0.567c0.567-0.33,0.961-0.675,1.187-1.038C161.143,346.366,161.237,346.051,161.238,345.726 L161.238,345.726z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "152.811,347.787 152.808,349.001 150.45,350.372 150.454,349.157  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M167.555,339.219l-2.008,1.167c0.609,0.429,1.093,0.819,1.449,1.174 c0.358,0.355,0.616,0.653,0.773,0.892l-2.923,1.001c-0.247-0.353-0.59-0.728-1.023-1.129c-0.436-0.401-0.965-0.781-1.587-1.14 c-0.624-0.36-1.175-0.558-1.653-0.595c-0.478-0.037-0.885,0.041-1.219,0.235c-0.206,0.12-0.342,0.247-0.404,0.382 c-0.066,0.135-0.064,0.289,0.001,0.46c0.065,0.173,0.176,0.367,0.333,0.584c0.156,0.218,0.357,0.473,0.605,0.766 c0.363,0.448,0.664,0.885,0.906,1.309c0.241,0.424,0.382,0.829,0.424,1.219c0.04,0.389-0.051,0.766-0.274,1.129 c-0.225,0.363-0.62,0.708-1.187,1.038c-0.385,0.224-0.828,0.413-1.324,0.567c-0.495,0.154-1.043,0.245-1.636,0.275 c-0.593,0.03-1.224-0.013-1.89-0.128c-0.666-0.118-1.369-0.328-2.106-0.636l-2.358,1.37l-2.452-1.415l2.3-1.336 c-0.868-0.591-1.491-1.119-1.871-1.583c-0.376-0.465-0.638-0.819-0.781-1.066l3.059-0.808c0.235,0.39,0.577,0.817,1.025,1.286 c0.45,0.468,1.023,0.904,1.723,1.308c0.791,0.457,1.439,0.708,1.943,0.752c0.504,0.046,0.949-0.045,1.337-0.27 c0.244-0.142,0.396-0.297,0.452-0.466c0.058-0.168,0.045-0.357-0.033-0.567c-0.079-0.21-0.217-0.451-0.419-0.723 c-0.203-0.275-0.445-0.583-0.732-0.928c-0.275-0.336-0.521-0.677-0.743-1.022c-0.222-0.343-0.364-0.69-0.423-1.039 c-0.061-0.348,0.006-0.693,0.197-1.037c0.191-0.345,0.565-0.679,1.119-1.001c0.425-0.247,0.896-0.448,1.413-0.605 c0.514-0.158,1.066-0.256,1.645-0.293c0.582-0.037,1.193-0.001,1.833,0.106c0.64,0.109,1.297,0.298,1.971,0.567l2.086-1.212 L167.555,339.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9900"
    },
    points: "150.454,349.157 150.45,350.372 147.998,348.956 148.001,347.742  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M175.983,347.285c-0.567,2.193-2.333,4.222-5.118,5.831c-7.121,4.113-18.672,4.113-25.748,0 c-2.704-1.571-4.432-3.55-5.016-5.695l0.003,0.909c0,0.052,0,0.102,0.003,0.154c0.808,1.854,2.456,3.554,4.834,4.935 c3.586,2.085,8.304,3.127,13.029,3.127c4.726,0,9.459-1.042,13.068-3.127c2.449-1.413,4.135-3.155,4.946-5.054 c0-0.003,0-0.003,0-0.003v-0.136L175.983,347.285z M144.942,351.927c3.586,2.085,8.304,3.127,13.029,3.127 c4.726,0,9.459-1.042,13.068-3.127c2.445-1.413,4.131-3.152,4.943-5.051l-0.004-1.053c-0.577,2.186-2.344,4.201-5.114,5.803 c-7.121,4.11-18.672,4.11-25.748,0c-2.704-1.57-4.435-3.551-5.019-5.688l0.004,1.036 C140.906,348.838,142.553,350.541,144.942,351.927z M170.865,354.609c-7.121,4.11-18.672,4.11-25.748,0 c-2.62-1.525-4.323-3.431-4.956-5.498c0.102,0.78,0.353,1.553,0.759,2.305c0.003,0.004,0.007,0.01,0.007,0.01 c0.924,1.291,2.274,2.473,4.015,3.484c3.586,2.085,8.304,3.127,13.029,3.127c4.726,0,9.459-1.042,13.068-3.127 c1.864-1.073,3.288-2.34,4.218-3.722c0.378-0.745,0.609-1.507,0.69-2.273C175.343,351.055,173.594,353.035,170.865,354.609z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "man_99_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M198.585,371.829c-7.388,4.266-7.388,11.181,0,15.447 c7.388,4.265,19.365,4.265,26.753,0c7.388-4.266,7.388-11.181,0-15.447C217.951,367.564,205.973,367.564,198.585,371.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M192.527,320.432c0.155-0.216,0.42-0.455,0.649-0.32c0.215,0.127,0.198,0.49,0.227,0.7 c0.044,0.328-0.015,0.596-0.149,0.9c-0.128,0.29-0.281,0.583-0.284,0.9c-0.001,0.086,0.012,0.175,0.048,0.252 c-0.586,0.435-1.115,0.931-1.637,1.455c-0.088-0.194-0.151-0.39-0.161-0.572C191.148,322.536,191.85,321.376,192.527,320.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBF99"
    },
    d: "M207.555,320.833c-0.029,0.021,0.042,0.022,0.053-0.012c0.103-0.347-0.015-0.714-0.063-1.071 c-0.125-0.92,0.211-1.86,0.059-2.776c-0.045-0.27-0.135-0.538-0.309-0.749c-0.157-0.189-0.371-0.319-0.58-0.445 c-0.07-0.042-1.029-0.609-1.008-0.648c-0.649,1.161-0.751,2.614-0.27,3.855L207.555,320.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M209.448,320.436c2.139,0.42,4.257,0.974,6.341,1.661c0.936,0.308,1.889,0.576,2.608,1.358 c0.717,0.78,0.741,1.915,0.412,2.903c-0.185,0.553-0.471,1.06-1.014,1.199c-0.548,0.14-1.42-0.132-1.951-0.285 c-1.367-0.395-2.702-0.928-3.983-1.59c-0.437-0.226-0.868-0.466-1.298-0.707c-0.646-0.361-1.291-0.723-1.932-1.092 C209.313,322.869,209.63,321.643,209.448,320.436z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128453656003426781290000017035263218677338039_",
    style: {
      enableBackground: "new"
    },
    d: "M193.85,327.693 l-0.369-0.214c-0.143-0.083-0.231-0.26-0.232-0.51l0.37,0.214C193.619,327.434,193.708,327.611,193.85,327.693z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128453656003426781290000017035263218677338039_",
    style: {
      overflow: "visible",
      fill: "#EFF6FE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000217234667019791290000008479893643794154152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128453656003426781290000017035263218677338039_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000217234667019791290000008479893643794154152_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M193.85,327.693l-0.369-0.214c-0.143-0.083-0.231-0.26-0.232-0.51l0.37,0.214 C193.619,327.434,193.708,327.611,193.85,327.693L193.85,327.693z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFF6FE"
    },
    points: "193.619,327.183 193.249,326.969 193.228,319.495 193.597,319.709  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFF6FE"
    },
    points: "194.39,318.337 194.02,318.122 204.719,311.945 205.089,312.159  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142162977016907881340000003988676376549865139_",
    style: {
      enableBackground: "new"
    },
    d: " M193.597,319.709l-0.369-0.215c-0.001-0.505,0.354-1.119,0.792-1.372l0.37,0.215 C193.951,318.59,193.596,319.204,193.597,319.709z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142162977016907881340000003988676376549865139_",
    style: {
      overflow: "visible",
      fill: "#EFF6FE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106139474594987338250000015241542919269941143_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142162977016907881340000003988676376549865139_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106139474594987338250000015241542919269941143_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M193.597,319.709l-0.369-0.215c-0.001-0.193,0.051-0.403,0.14-0.602l0.37,0.215 C193.649,319.306,193.597,319.516,193.597,319.709L193.597,319.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M193.738,319.107l-0.37-0.215c0.069-0.155,0.161-0.303,0.268-0.434l0.369,0.215 C193.898,318.803,193.806,318.952,193.738,319.107L193.738,319.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M194.005,318.673l-0.369-0.215c0.114-0.138,0.245-0.256,0.384-0.336l0.37,0.215 C194.25,318.418,194.119,318.535,194.005,318.673L194.005,318.673z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M205.089,312.159c0.438-0.253,0.796-0.05,0.798,0.455l0.021,7.474 c0.001,0.504-0.354,1.119-0.793,1.373l-10.699,6.177c-0.438,0.253-0.795,0.049-0.797-0.455l-0.022-7.474 c-0.001-0.505,0.354-1.119,0.792-1.372L205.089,312.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M205.471,320.09c0.001,0.346-0.273,0.82-0.575,0.993l-10.699,6.177 c-0.061,0.035-0.102,0.045-0.123,0.049c-0.008-0.02-0.019-0.059-0.02-0.127v-0.068l-0.021-7.405 c-0.001-0.346,0.273-0.819,0.573-0.993l10.6-6.12l0.1-0.057c0.062-0.035,0.103-0.046,0.124-0.049 c0.008,0.02,0.018,0.059,0.019,0.127L205.471,320.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15D9FD"
    },
    d: "M205.228,320.001c0.001,0.346-0.273,0.819-0.574,0.993l-10.6,6.12l-0.021-7.405 c-0.001-0.346,0.273-0.819,0.573-0.993l10.6-6.12L205.228,320.001z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M205.285,311.889l0.369,0.215c-0.144-0.085-0.345-0.072-0.566,0.055l-0.37-0.214 C204.94,311.817,205.141,311.806,205.285,311.889z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "196.914,323.959 203.41,320.208 203.41,317.93 196.914,321.681  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#47E0FF"
    },
    points: "196.649,317.537 194.04,321.74 194.044,323.331 198.686,316.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#47E0FF"
    },
    points: "194.05,325.308 194.055,327.114 194.627,326.783 203.831,313.389  200.749,315.169  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M193.051,322.923c0.05,0.07,0.124,0.119,0.199,0.161c0.263,0.147,0.777,0.37,0.893-0.068 c0.035-0.133,0.013-0.275-0.01-0.411c-0.047-0.283-0.094-0.566-0.14-0.849c-0.026-0.156-0.018-0.367,0.134-0.408 c0.104-0.027,0.204,0.051,0.277,0.131c0.211,0.227,0.365,0.497,0.501,0.777c0.054,0.111,0.106,0.223,0.156,0.334 c0.403,0.884,0.803,1.717,1.026,2.664c0.129,0.548,0.218,1.013,0.167,1.571c-0.04,0.435-0.101,0.873-0.225,1.293 c-0.084,0.285-0.21,0.685-0.494,0.838c-0.318,0.171-0.636-0.094-0.844-0.319c-0.327-0.353-0.433-0.809-0.688-1.198 c-0.12-0.182-0.166-0.382-0.279-0.558c-0.133-0.208-0.379-0.342-0.577-0.478c-0.459-0.314-0.861-0.708-1.19-1.156 c-0.183-0.25-0.42-0.587-0.576-0.929c0.522-0.524,1.05-1.021,1.637-1.455C193.028,322.884,193.038,322.905,193.051,322.923z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man_100_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M217.446,379.086c-0.065-0.204-0.195-0.313-0.564-0.343c-0.437-0.036-0.876-0.056-1.314-0.083 c-0.593-0.038-1.185-0.075-1.778-0.113c0.031-0.481,0.044-0.968,0.097-1.445c-0.629,0.135-0.98-0.049-1.583-0.272 c-0.711-0.263-1.431-0.5-2.158-0.711c-0.311-0.09-0.637-0.176-0.953-0.112c-0.801,0.163-1.238,1.481-1.131,2.173 c0.077,0.489,0.407,0.906,0.796,1.213c0.583,0.461,1.405,0.835,2.14,0.945c0.788,0.118,1.511,0.363,2.146,0.86 c0.821,0.643,1.406,1.321,2.494,1.399c1.092,0.079,1.998-0.584,2.04-1.713c0.015-0.404-0.056-0.807-0.127-1.205 C217.506,379.428,217.493,379.232,217.446,379.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M214.124,380.438c-0.001-0.086,0.001-0.172,0.006-0.259c0.058-0.888-0.283-1.638-0.607-2.459 c-0.121-0.306-0.252-0.627-0.51-0.832c-0.587-0.467-1.517-0.057-1.889,0.594c-0.173,0.302-0.268,0.641-0.423,0.953 c-0.294,0.591-0.886,1.296-1.599,1.328c-0.958,0.043-2.036-0.287-3.006-0.345c-0.378-0.023-0.77-0.036-1.121,0.106 c-0.828,0.335-1.066,1.67-0.771,2.416c0.183,0.461,0.598,0.794,1.045,1.007c0.671,0.32,1.555,0.503,2.296,0.448 c0.794-0.059,1.554,0.02,2.283,0.364c1.251,0.59,2.706,1.439,3.969,0.288c0.337-0.307,0.503-0.768,0.542-1.223 C214.408,382.018,214.135,381.238,214.124,380.438z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4CB3"
    },
    d: "M213.734,362.029l-0.448-1.879C213.464,360.769,213.611,361.396,213.734,362.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4CB3"
    },
    d: "M221.089,346.982c0.154,1.453,0.21,2.868,0.092,4.33c-0.125,1.547-0.424,2.892-0.963,5.55 c-0.522,2.577-0.644,2.981-0.702,4.333c0.123-0.092,0.909,9.004-1.553,17.25c-0.151,0.508-0.341,1.07-0.821,1.364 c-0.238,0.146-0.521,0.201-0.798,0.237c-0.273,0.035-0.55,0.054-0.822,0.014c-0.29-0.042-0.602-0.157-0.795-0.385 c-0.22-0.26-0.366-0.599-0.46-0.923c-0.168-0.576-0.184-1.184-0.189-1.784c-0.022-2.818,0.174-5.633,0.178-8.451 c0.002-1.633-0.063-3.275-0.27-4.893c-0.529-1.866-0.928-3.769-1.19-5.69c-0.249-1.821-0.14-3.688-0.556-5.481 c-0.314-1.342-0.553-3.506-0.549-5.471H221.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E3E9E"
    },
    d: "M213.847,342.852c0.031,0.298,2.306,1.419,2.908,0.81c0.148-0.15,0.358-0.484,0.637-0.834 c2.364,2.538,3.018,6.78,1.693,9.54c-0.986,2.009-2.384,6.844-2.868,12.329c-0.537,6.084-0.111,12.869-0.208,15.38 c-0.163,0.009-0.326,0.007-0.487-0.016c-0.289-0.042-0.602-0.157-0.794-0.385c-0.22-0.26-0.366-0.599-0.46-0.923 c-0.168-0.576-0.184-1.184-0.189-1.784c-0.022-2.818,0.174-5.633,0.178-8.451c0.002-1.633-0.063-3.275-0.27-4.894 c-0.529-1.866-0.928-3.769-1.19-5.69c-0.249-1.821-0.14-3.688-0.556-5.481C211.464,349.127,211.144,340.756,213.847,342.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8763CD"
    },
    d: "M212.579,344.248c-0.259-0.133-1.588-0.801-1.577-1.162c0.007-0.242-0.647-0.444-0.816-0.441 c-0.305,0.006-0.612,0.202-0.858,0.378c-0.606,0.434-1.053,1.099-1.329,1.812c-0.379,0.979-0.47,2.053-0.528,3.11 c-0.175,3.15-0.093,6.316,0.241,9.452c0.168,1.584,0.402,3.159,0.698,4.722c0.148,0.781,0.313,1.559,0.493,2.332 c0.173,0.743,0.327,0.976,0.952,1.369c1.339,0.842,3.753,0.731,4.711-0.786c1.031-1.631,0.602-4.172,0.932-6.007 c0.479-2.667,2.253-4.622,3.069-7.155c0.599-1.859,0.517-3.614,0.204-5.51c-0.148-0.896-0.425-3.039-1.338-3.563 c-0.242-0.139-1.884-0.513-3.213,0.807C213.445,344.377,213.535,344.74,212.579,344.248z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF5FE"
    },
    d: "M221.699,336.886c0.059-0.469,0.129-0.937,0.211-1.404c0.393-2.236,1.063-4.42,1.343-6.676 c0.219-1.752,0.377-3.937-1.013-5.291c-0.226-0.22-0.487-0.404-0.762-0.559c-2.7-1.525-5.284,0.332-7.815,1.244 c-1.663,0.599-3.257,1.384-4.746,2.336c-0.518,0.331-1.049,0.559-1.398,1.075c-0.37,0.547-0.568,1.138-0.605,1.798 c-0.043,0.75,0.095,1.497,0.22,2.238c0.728,4.314,1.048,8.726,0.528,13.07c-0.224,1.87-0.445,6.98-0.445,6.98 c0.622,0.27,1.02,0.526,4.037,0.579c6.231,0.111,9.677-1.46,10.035-1.787c0.359-0.328,0.233-1.084,0.246-1.537 c0.039-1.356,0.012-2.712-0.02-4.067C221.452,342.219,221.365,339.54,221.699,336.886z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E2FC"
    },
    d: "M206.912,329.409c0.037-0.661,0.236-1.252,0.605-1.798c0.349-0.516,0.879-0.743,1.398-1.075 c0.313-0.2,0.632-0.391,0.954-0.576c1.971,1.659,4.682,3.648,3.299,6.068c-3.612,6.444-4.44,13.196-4.628,20.075 c-0.701-0.109-0.979-0.255-1.326-0.405c0,0,0.222-5.11,0.446-6.98c0.521-4.344,0.2-8.755-0.528-13.07 C207.007,330.907,206.87,330.16,206.912,329.409z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M212.364,324.722c0.459-0.195,0.948-0.396,1.298-0.522c1.758-0.633,3.541-1.722,5.372-1.817 c0.882,1.329,0.17,2.853-1.131,3.562c-1.635,0.817-3.784,0.726-5.335-0.371C212.258,325.355,212.025,324.983,212.364,324.722 z"
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8763CD"
    },
    d: "M208.996,365.696c0.117,1.365,0.225,2.731,0.321,4.099c0.076,1.082,0.143,2.164,0.2,3.246 c0.044,0.834,0.081,1.668,0.11,2.502c0.158,4.568-0.325,5.595,1.828,6.186c0.483,0.133,0.995,0.173,1.48,0.052 c1.403-0.347,1.645-1.579,1.818-3.107c0.097-0.859,0.141-1.893,0.169-2.762c0.024-0.734,0.039-1.468,0.052-2.202 c0.017-0.994,0.028-1.987,0.038-2.981c0.013-1.31,0.023-2.621,0.033-3.931c0.012-1.676,0.156-3.386,0.166-5.061 c0.001-0.243-0.152-0.495-0.346-0.624c-0.252-0.165-5.298,1.679-5.811,2.251C209.053,363.365,208.85,364.008,208.996,365.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.013,327.051c0.907-0.618,1.989-1.11,2.998-0.651c0.418,0.19,0.748,0.533,1.024,0.9 c0.726,0.964,1.244,2.073,1.167,3.304c-0.015,0.235-0.05,0.472-0.136,0.692c-0.318,0.81-1.085,1.05-1.79,1.399 c-0.849,0.42-1.674,0.886-2.493,1.359c-1.637,0.946-3.261,1.93-5.015,2.65c-1.026,0.421-2.207,0.745-3.222,0.296 c-0.684-0.303-1.203-0.954-1.344-1.689c-0.343-1.782,0.987-2.191,1.169-2.329C206.104,328.665,208.145,326.962,208.013,327.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.609,325.881c-0.334,0.179-0.921,0.63-0.93,1.073c-0.008,0.366,0.414,0.887,0.573,1.194 c0.5,0.968,1.026,1.919,1.551,2.871c0.239,0.431,0.477,0.863,0.729,1.285c0.739,1.239,1.591,2.396,2.544,3.453 c0.37,0.411,0.968,1.102,1.507,1.272c0.534,0.169,1.045-0.111,1.493-0.483c0.801-0.665,1.38-1.642,1.183-2.683 c-0.198-1.044-0.866-1.774-1.499-2.531c-1.462-1.748-3.03-3.396-4.694-4.931c-0.296-0.273-0.602-0.548-0.976-0.695 C195.662,325.539,195.093,325.622,194.609,325.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBF99"
    },
    d: "M204.603,318.114c0.241,0.648,0.385,1.332,0.439,2.029c0.023,0.29,0.023,0.585,0.101,0.865 c0.147,0.522,0.553,0.932,0.99,1.252c0.202,0.148,0.47,0.319,0.729,0.261c-0.058-0.184-0.09-0.369-0.065-0.567 c0.027-0.259,0.13-0.491,0.311-0.676c0.128-0.132,0.348-0.206,0.429-0.379c0.166-0.352-0.065-0.67-0.174-0.987 c-0.118-0.341-0.098-0.722-0.232-1.071c-0.04-0.103-0.087-0.207-0.167-0.283s-0.202-0.117-0.304-0.077 c-0.169,0.067-0.193,0.29-0.219,0.47c-0.005,0.031-0.011,0.065-0.034,0.086c-0.062,0.057-0.154-0.02-0.2-0.09 c-0.228-0.346-0.437-0.705-0.662-1.052c-0.183-0.281-0.327-0.619-0.61-0.817c-0.044-0.03-0.094-0.055-0.144-0.061 c-0.012,0-0.025,0-0.031,0.007c-0.131,0.014-0.211,0.146-0.241,0.278C204.447,317.567,204.507,317.853,204.603,318.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.837,321.24c0.274-0.475,0.714-0.847,1.166-0.929c0.396-0.072,0.8-0.001,1.196,0.075 c0.083,0.016,0.166,0.033,0.249,0.05c0.182,1.207-0.135,2.433-0.816,3.446c-0.301-0.174-0.602-0.349-0.901-0.527 c-0.298-0.178-0.931-0.397-1.117-0.712C206.387,322.26,206.648,321.568,206.837,321.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M212.987,322.001c-0.098-0.669-0.603-0.514-0.348-1.12c0.217-0.515,0.546-0.989,0.989-1.331 c0.442-0.342,1.001-0.545,1.558-0.514c0.192,0.011,0.321,0.121,0.512,0.121c0.527,0.002,1.057-0.099,1.582-0.023 c0.523,0.076,1.006,0.114,1.006,0.704c0,0.787-0.036,1.545,0.215,2.318c0.135,0.413,0.339,0.812,0.375,1.245 c0.071,0.852-0.551,1.646-1.321,2.018c-0.946,0.458-2.016,0.416-3.022,0.27c-0.505-0.073-1.216-0.174-1.512-0.655 c-0.223-0.362-0.127-0.838-0.08-1.234C213.014,323.199,213.075,322.605,212.987,322.001z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M210.742,313.442c-0.318,0.386-0.566,0.821-0.642,1.331c-0.17,1.136,0.288,2.303,0.041,3.43 c-0.239,1.092,0.229,3.572,2.382,4.207c1.089,0.322,3.239-0.055,3.931-0.386c0.928-0.444,1.541-1.344,2.09-2.215 C223.043,312.667,213.793,309.73,210.742,313.442z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6AF75"
    },
    d: "M219.86,312.039c-0.218-0.224-0.486-0.417-0.812-0.569c-0.099-0.046-0.204-0.089-0.274-0.173 c-0.052-0.062-0.079-0.141-0.113-0.215c-0.153-0.329-0.459-0.562-0.776-0.738c-1.2-0.667-2.655-0.699-4.014-0.504 c-0.459,0.066-0.919,0.157-1.345,0.34c-0.487,0.209-0.916,0.531-1.305,0.89c-0.722,0.666-1.583,1.699-1.541,2.746 c0.009,0.229,0.141,0.416,0.255,0.618c0.083,0.147,0.205,0.267,0.31,0.399c0.348,0.438,0.504,1.073,0.714,1.584 c0.091,0.221,0.192,0.455,0.391,0.588c0.387,0.257,0.923,0.005,1.368,0.141c0.259,0.08,0.464,0.287,0.598,0.523 c0.133,0.236,0.205,0.502,0.276,0.763c0.111,0.412,0.124,0.761,0.176,1.171c0.052,0.415,0.169,0.859,0.461,1.172 c0.652,0.705,1.909,0.665,2.759,0.477c0.307-0.068,0.617-0.14,0.901-0.277c0.655-0.316,1.102-0.935,1.52-1.53 c0.382-0.544,0.768-1.1,0.97-1.734c0.113-0.357,0.165-0.731,0.217-1.102C220.803,315.102,220.961,313.171,219.86,312.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M213.203,316.657c0.862-0.073,1.099,0.995,0.521,1.833c-0.169,0.245-0.471,0.464-0.694,0.66 c-1.524,1.344-1.937-0.075-1.453-0.532C212.7,317.557,212.118,316.749,213.203,316.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M212.969,318.29c0.098-0.093,1.072-0.69,0.395-1.074c-0.187-0.107-0.391,0.059-0.416,0.257 c-0.013,0.102,0.021,0.206,0.007,0.308c-0.008,0.06-0.032,0.118-0.063,0.17c-0.085,0.144-0.381,0.286-0.319,0.493 C212.628,318.627,212.913,318.343,212.969,318.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0,
      fill: "#7F7F7F"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 104.934,
    ry: 60.586
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9979)",
    style: {
      opacity: 0.0196,
      fill: "#818181"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 102.907,
    ry: 59.415
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.998)",
    style: {
      opacity: 0.0392,
      fill: "#838484"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 100.88,
    ry: 58.245
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6167 372.9979)",
    style: {
      opacity: 0.0588,
      fill: "#868686"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 98.853,
    ry: 57.074
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9977)",
    style: {
      opacity: 0.0784,
      fill: "#888889"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 96.826,
    ry: 55.904
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9978)",
    style: {
      opacity: 0.098,
      fill: "#8A8B8B"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 94.798,
    ry: 54.733
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9977)",
    style: {
      opacity: 0.1176,
      fill: "#8C8D8E"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 92.771,
    ry: 53.563
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0.1373,
      fill: "#8E8F90"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 90.744,
    ry: 52.392
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0.1569,
      fill: "#919293"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 88.717,
    ry: 51.222
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9978)",
    style: {
      opacity: 0.1765,
      fill: "#939495"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 86.689,
    ry: 50.052
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9979)",
    style: {
      opacity: 0.1961,
      fill: "#959698"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 84.662,
    ry: 48.881
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9979)",
    style: {
      opacity: 0.2157,
      fill: "#97999A"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 82.635,
    ry: 47.711
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6167 372.998)",
    style: {
      opacity: 0.2353,
      fill: "#999B9D"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 80.608,
    ry: 46.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9978)",
    style: {
      opacity: 0.2549,
      fill: "#9C9D9F"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 78.581,
    ry: 45.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9977)",
    style: {
      opacity: 0.2745,
      fill: "#9EA0A2"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 76.554,
    ry: 44.199
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0.2941,
      fill: "#A0A2A4"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 74.526,
    ry: 43.029
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0.3137,
      fill: "#A2A4A7"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 72.499,
    ry: 41.859
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9976)",
    style: {
      opacity: 0.3333,
      fill: "#A4A7A9"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 70.472,
    ry: 40.688
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6167 372.998)",
    style: {
      opacity: 0.3529,
      fill: "#A7A9AC"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 68.445,
    ry: 39.518
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9978)",
    style: {
      opacity: 0.3725,
      fill: "#A9ABAE"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 66.418,
    ry: 38.347
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6166 372.9979)",
    style: {
      opacity: 0.3922,
      fill: "#ABAEB1"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 64.39,
    ry: 37.177
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9978)",
    style: {
      opacity: 0.4118,
      fill: "#ADB0B3"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 62.363,
    ry: 36.006
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9978)",
    style: {
      opacity: 0.4314,
      fill: "#AFB2B6"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 60.336,
    ry: 34.836
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9976)",
    style: {
      opacity: 0.451,
      fill: "#B2B5B8"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 58.309,
    ry: 33.665
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9975)",
    style: {
      opacity: 0.4706,
      fill: "#B4B7BB"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 56.282,
    ry: 32.495
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9976)",
    style: {
      opacity: 0.4902,
      fill: "#B6B9BD"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 54.254,
    ry: 31.325
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0.5098,
      fill: "#B8BCC0"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 52.227,
    ry: 30.154
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6169 372.9982)",
    style: {
      opacity: 0.5294,
      fill: "#BABEC2"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 50.2,
    ry: 28.984
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6167 372.998)",
    style: {
      opacity: 0.549,
      fill: "#BCC0C5"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 48.173,
    ry: 27.813
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9977)",
    style: {
      opacity: 0.5686,
      fill: "#BFC3C7"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 46.145,
    ry: 26.643
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6164 372.9978)",
    style: {
      opacity: 0.5882,
      fill: "#C1C5CA"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 44.118,
    ry: 25.472
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9976)",
    style: {
      opacity: 0.6078,
      fill: "#C3C7CC"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 42.091,
    ry: 24.302
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9977)",
    style: {
      opacity: 0.6275,
      fill: "#C5CACF"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 40.064,
    ry: 23.132
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6162 372.9975)",
    style: {
      opacity: 0.6471,
      fill: "#C7CCD1"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 38.037,
    ry: 21.961
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6163 372.9975)",
    style: {
      opacity: 0.6667,
      fill: "#CACED4"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 36.009,
    ry: 20.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6168 372.9982)",
    style: {
      opacity: 0.6863,
      fill: "#CCD1D6"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 33.982,
    ry: 19.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9978)",
    style: {
      opacity: 0.7059,
      fill: "#CED3D9"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 31.955,
    ry: 18.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6165 372.9979)",
    style: {
      opacity: 0.7255,
      fill: "#D0D5DB"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 29.928,
    ry: 17.279
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6168 372.9981)",
    style: {
      opacity: 0.7451,
      fill: "#D2D8DE"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 27.901,
    ry: 16.109
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7647,
      fill: "#D5DAE0"
    },
    d: "M387.129,96.408c0.089,11.616-8.03,25.844-18.133,31.78 c-10.104,5.936-18.367,1.332-18.456-10.284s8.03-25.844,18.133-31.78C378.776,80.189,387.039,84.793,387.129,96.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7843,
      fill: "#D7DCE3"
    },
    d: "M385.695,97.251c0.082,10.705-7.4,23.819-16.713,29.29 c-9.312,5.471-16.928,1.228-17.01-9.478c-0.082-10.705,7.4-23.819,16.713-29.29C377.997,82.302,385.613,86.545,385.695,97.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8039,
      fill: "#D9DFE5"
    },
    d: "M384.262,98.093c0.075,9.795-6.771,21.794-15.292,26.8 c-8.521,5.006-15.489,1.123-15.564-8.672s6.771-21.794,15.292-26.8C377.218,84.415,384.187,88.297,384.262,98.093z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6169 372.9983)",
    style: {
      opacity: 0.8235,
      fill: "#DBE1E8"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 19.792,
    ry: 11.427
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8431,
      fill: "#DDE3EA"
    },
    d: "M381.395,99.777c0.061,7.975-5.513,17.744-12.45,21.82 c-6.937,4.076-12.611,0.915-12.672-7.061c-0.061-7.975,5.513-17.744,12.45-21.82C375.66,88.641,381.334,91.802,381.395,99.777z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 91.6168 372.998)",
    style: {
      opacity: 0.8627,
      fill: "#E0E6ED"
    },
    cx: 368.834,
    cy: 107.157,
    rx: 15.737,
    ry: 9.086
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8824,
      fill: "#E2E8EF"
    },
    d: "M378.528,101.461c0.047,6.155-4.255,13.695-9.609,16.84 c-5.354,3.146-9.733,0.706-9.78-5.449c-0.047-6.155,4.255-13.695,9.609-16.84C374.102,92.866,378.481,95.306,378.528,101.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902,
      fill: "#E4EAF2"
    },
    d: "M377.095,102.303c0.04,5.245-3.626,11.67-8.188,14.35 c-4.562,2.68-8.294,0.601-8.334-4.644c-0.04-5.245,3.626-11.67,8.188-14.35C373.323,94.979,377.055,97.058,377.095,102.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9216,
      fill: "#E6EDF4"
    },
    d: "M375.661,103.146c0.033,4.335-2.997,9.645-6.767,11.86 c-3.771,2.215-6.855,0.497-6.888-3.838c-0.033-4.335,2.997-9.645,6.767-11.86C372.544,97.092,375.628,98.811,375.661,103.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9412,
      fill: "#E8EFF7"
    },
    d: "M374.228,103.988c0.026,3.425-2.367,7.62-5.346,9.37 c-2.979,1.75-5.415,0.393-5.442-3.032c-0.026-3.425,2.367-7.62,5.347-9.37C371.765,99.205,374.202,100.563,374.228,103.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9608,
      fill: "#EBF1F9"
    },
    d: "M372.795,104.83c0.019,2.515-1.738,5.595-3.926,6.88 c-2.188,1.285-3.976,0.288-3.996-2.226c-0.019-2.515,1.738-5.595,3.926-6.88C370.986,101.318,372.775,102.315,372.795,104.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9804,
      fill: "#EDF4FC"
    },
    d: "M371.361,105.672c0.012,1.605-1.109,3.57-2.505,4.39 c-1.396,0.82-2.537,0.184-2.55-1.421c-0.012-1.605,1.109-3.57,2.505-4.39C370.207,103.431,371.349,104.067,371.361,105.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M369.928,106.514c0.005,0.695-0.48,1.545-1.084,1.9c-0.604,0.355-1.098,0.08-1.104-0.615 c-0.005-0.694,0.48-1.545,1.084-1.9C369.428,105.544,369.922,105.819,369.928,106.514z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "146.249,67.667 137.226,72.876 128.203,67.667 137.226,62.457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9945,
      fill: "#FFFFFF"
    },
    points: "146.249,67.463 137.226,72.672 128.203,67.463 137.226,62.253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.989,
      fill: "#FFFFFF"
    },
    points: "146.249,67.259 137.226,72.468 128.203,67.259 137.226,62.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9834,
      fill: "#FFFFFF"
    },
    points: "146.249,67.055 137.226,72.264 128.203,67.055 137.226,61.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9779,
      fill: "#FFFFFF"
    },
    points: "146.249,66.851 137.226,72.06 128.203,66.851 137.226,61.641  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9724,
      fill: "#FFFFFF"
    },
    points: "146.249,66.647 137.226,71.856 128.203,66.647 137.226,61.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9669,
      fill: "#FFFFFF"
    },
    points: "146.249,66.443 137.226,71.652 128.203,66.443 137.226,61.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9613,
      fill: "#FFFFFF"
    },
    points: "146.249,66.238 137.226,71.448 128.203,66.238 137.226,61.029  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9558,
      fill: "#FFFFFF"
    },
    points: "146.249,66.034 137.226,71.244 128.203,66.034 137.226,60.825  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9503,
      fill: "#FFFFFF"
    },
    points: "146.249,65.83 137.226,71.04 128.203,65.83 137.226,60.621  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9448,
      fill: "#FFFFFF"
    },
    points: "146.249,65.626 137.226,70.836 128.203,65.626 137.226,60.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9392,
      fill: "#FFFFFF"
    },
    points: "146.249,65.422 137.226,70.632 128.203,65.422 137.226,60.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9337,
      fill: "#FFFFFF"
    },
    points: "146.249,65.218 137.226,70.428 128.203,65.218 137.226,60.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9282,
      fill: "#FFFFFF"
    },
    points: "146.249,65.014 137.226,70.224 128.203,65.014 137.226,59.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9227,
      fill: "#FFFFFF"
    },
    points: "146.249,64.81 137.226,70.02 128.203,64.81 137.226,59.601  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9171,
      fill: "#FFFFFF"
    },
    points: "146.249,64.606 137.226,69.816 128.203,64.606 137.226,59.397  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9116,
      fill: "#FFFFFF"
    },
    points: "146.249,64.402 137.226,69.612 128.203,64.402 137.226,59.193  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9061,
      fill: "#FFFFFF"
    },
    points: "146.249,64.198 137.226,69.408 128.203,64.198 137.226,58.989  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9006,
      fill: "#FFFFFF"
    },
    points: "146.249,63.994 137.226,69.204 128.203,63.994 137.226,58.785  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.895,
      fill: "#FFFFFF"
    },
    points: "146.249,63.79 137.226,69 128.203,63.79 137.226,58.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8895,
      fill: "#FFFFFF"
    },
    points: "146.249,63.586 137.226,68.796 128.203,63.586 137.226,58.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.884,
      fill: "#FFFFFF"
    },
    points: "146.249,63.382 137.226,68.591 128.203,63.382 137.226,58.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8785,
      fill: "#FFFFFF"
    },
    points: "146.249,63.178 137.226,68.387 128.203,63.178 137.226,57.968  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8729,
      fill: "#FFFFFF"
    },
    points: "146.249,62.974 137.226,68.183 128.203,62.974 137.226,57.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8674,
      fill: "#FFFFFF"
    },
    points: "146.249,62.77 137.226,67.979 128.203,62.77 137.226,57.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8619,
      fill: "#FFFFFF"
    },
    points: "146.249,62.566 137.226,67.775 128.203,62.566 137.226,57.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8564,
      fill: "#FFFFFF"
    },
    points: "146.249,62.362 137.226,67.571 128.203,62.362 137.226,57.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8508,
      fill: "#FFFFFF"
    },
    points: "146.249,62.158 137.226,67.367 128.203,62.158 137.226,56.948  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8453,
      fill: "#FFFFFF"
    },
    points: "146.249,61.954 137.226,67.163 128.203,61.954 137.226,56.744  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8398,
      fill: "#FFFFFF"
    },
    points: "146.249,61.75 137.226,66.959 128.203,61.75 137.226,56.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8343,
      fill: "#FFFFFF"
    },
    points: "146.249,61.546 137.226,66.755 128.203,61.546 137.226,56.336  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8287,
      fill: "#FFFFFF"
    },
    points: "146.249,61.342 137.226,66.551 128.203,61.342 137.226,56.132  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8232,
      fill: "#FFFFFF"
    },
    points: "146.249,61.138 137.226,66.347 128.203,61.138 137.226,55.928  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8177,
      fill: "#FFFFFF"
    },
    points: "146.249,60.933 137.226,66.143 128.203,60.933 137.226,55.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8122,
      fill: "#FFFFFF"
    },
    points: "146.249,60.729 137.226,65.939 128.203,60.729 137.226,55.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8066,
      fill: "#FFFFFF"
    },
    points: "146.249,60.525 137.226,65.735 128.203,60.525 137.226,55.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8011,
      fill: "#FFFFFF"
    },
    points: "146.249,60.321 137.226,65.531 128.203,60.321 137.226,55.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7956,
      fill: "#FFFFFF"
    },
    points: "146.249,60.117 137.226,65.327 128.203,60.117 137.226,54.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7901,
      fill: "#FFFFFF"
    },
    points: "146.249,59.913 137.226,65.123 128.203,59.913 137.226,54.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7845,
      fill: "#FFFFFF"
    },
    points: "146.249,59.709 137.226,64.919 128.203,59.709 137.226,54.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.779,
      fill: "#FFFFFF"
    },
    points: "146.249,59.505 137.226,64.715 128.203,59.505 137.226,54.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7735,
      fill: "#FFFFFF"
    },
    points: "146.249,59.301 137.226,64.511 128.203,59.301 137.226,54.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.768,
      fill: "#FFFFFF"
    },
    points: "146.249,59.097 137.226,64.307 128.203,59.097 137.226,53.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7624,
      fill: "#FFFFFF"
    },
    points: "146.249,58.893 137.226,64.103 128.203,58.893 137.226,53.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7569,
      fill: "#FFFFFF"
    },
    points: "146.249,58.689 137.226,63.899 128.203,58.689 137.226,53.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7514,
      fill: "#FFFFFF"
    },
    points: "146.249,58.485 137.226,63.695 128.203,58.485 137.226,53.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7459,
      fill: "#FFFFFF"
    },
    points: "146.249,58.281 137.226,63.49 128.203,58.281 137.226,53.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7403,
      fill: "#FFFFFF"
    },
    points: "146.249,58.077 137.226,63.286 128.203,58.077 137.226,52.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7348,
      fill: "#FFFFFF"
    },
    points: "146.249,57.873 137.226,63.082 128.203,57.873 137.226,52.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7293,
      fill: "#FFFFFF"
    },
    points: "146.249,57.669 137.226,62.878 128.203,57.669 137.226,52.459  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7238,
      fill: "#FFFFFF"
    },
    points: "146.249,57.465 137.226,62.674 128.203,57.465 137.226,52.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7182,
      fill: "#FFFFFF"
    },
    points: "146.249,57.261 137.226,62.47 128.203,57.261 137.226,52.051  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7127,
      fill: "#FFFFFF"
    },
    points: "146.249,57.057 137.226,62.266 128.203,57.057 137.226,51.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7072,
      fill: "#FFFFFF"
    },
    points: "146.249,56.853 137.226,62.062 128.203,56.853 137.226,51.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7017,
      fill: "#FFFFFF"
    },
    points: "146.249,56.649 137.226,61.858 128.203,56.649 137.226,51.439  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6961,
      fill: "#FFFFFF"
    },
    points: "146.249,56.445 137.226,61.654 128.203,56.445 137.226,51.235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6906,
      fill: "#FFFFFF"
    },
    points: "146.249,56.241 137.226,61.45 128.203,56.241 137.226,51.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6851,
      fill: "#FFFFFF"
    },
    points: "146.249,56.037 137.226,61.246 128.203,56.037 137.226,50.827  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6796,
      fill: "#FFFFFF"
    },
    points: "146.249,55.832 137.226,61.042 128.203,55.832 137.226,50.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.674,
      fill: "#FFFFFF"
    },
    points: "146.249,55.628 137.226,60.838 128.203,55.628 137.226,50.419  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6685,
      fill: "#FFFFFF"
    },
    points: "146.249,55.424 137.226,60.634 128.203,55.424 137.226,50.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.663,
      fill: "#FFFFFF"
    },
    points: "146.249,55.22 137.226,60.43 128.203,55.22 137.226,50.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6575,
      fill: "#FFFFFF"
    },
    points: "146.249,55.016 137.226,60.226 128.203,55.016 137.226,49.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6519,
      fill: "#FFFFFF"
    },
    points: "146.249,54.812 137.226,60.022 128.203,54.812 137.226,49.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6464,
      fill: "#FFFFFF"
    },
    points: "146.249,54.608 137.226,59.818 128.203,54.608 137.226,49.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6409,
      fill: "#FFFFFF"
    },
    points: "146.249,54.404 137.226,59.614 128.203,54.404 137.226,49.195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6354,
      fill: "#FFFFFF"
    },
    points: "146.249,54.2 137.226,59.41 128.203,54.2 137.226,48.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6298,
      fill: "#FFFFFF"
    },
    points: "146.249,53.996 137.226,59.206 128.203,53.996 137.226,48.787  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6243,
      fill: "#FFFFFF"
    },
    points: "146.249,53.792 137.226,59.002 128.203,53.792 137.226,48.583  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6188,
      fill: "#FFFFFF"
    },
    points: "146.249,53.588 137.226,58.798 128.203,53.588 137.226,48.379  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6133,
      fill: "#FFFFFF"
    },
    points: "146.249,53.384 137.226,58.594 128.203,53.384 137.226,48.174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6077,
      fill: "#FFFFFF"
    },
    points: "146.249,53.18 137.226,58.389 128.203,53.18 137.226,47.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6022,
      fill: "#FFFFFF"
    },
    points: "146.249,52.976 137.226,58.185 128.203,52.976 137.226,47.766  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5967,
      fill: "#FFFFFF"
    },
    points: "146.249,52.772 137.226,57.981 128.203,52.772 137.226,47.562  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5912,
      fill: "#FFFFFF"
    },
    points: "146.249,52.568 137.226,57.777 128.203,52.568 137.226,47.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5856,
      fill: "#FFFFFF"
    },
    points: "146.249,52.364 137.226,57.573 128.203,52.364 137.226,47.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5801,
      fill: "#FFFFFF"
    },
    points: "146.249,52.16 137.226,57.369 128.203,52.16 137.226,46.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5746,
      fill: "#FFFFFF"
    },
    points: "146.249,51.956 137.226,57.165 128.203,51.956 137.226,46.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5691,
      fill: "#FFFFFF"
    },
    points: "146.249,51.752 137.226,56.961 128.203,51.752 137.226,46.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5635,
      fill: "#FFFFFF"
    },
    points: "146.249,51.548 137.226,56.757 128.203,51.548 137.226,46.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.558,
      fill: "#FFFFFF"
    },
    points: "146.249,51.344 137.226,56.553 128.203,51.344 137.226,46.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5525,
      fill: "#FFFFFF"
    },
    points: "146.249,51.14 137.226,56.349 128.203,51.14 137.226,45.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.547,
      fill: "#FFFFFF"
    },
    points: "146.249,50.936 137.226,56.145 128.203,50.936 137.226,45.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5414,
      fill: "#FFFFFF"
    },
    points: "146.249,50.731 137.226,55.941 128.203,50.731 137.226,45.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5359,
      fill: "#FFFFFF"
    },
    points: "146.249,50.527 137.226,55.737 128.203,50.527 137.226,45.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5304,
      fill: "#FFFFFF"
    },
    points: "146.249,50.323 137.226,55.533 128.203,50.323 137.226,45.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5249,
      fill: "#FFFFFF"
    },
    points: "146.249,50.119 137.226,55.329 128.203,50.119 137.226,44.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5193,
      fill: "#FFFFFF"
    },
    points: "146.249,49.915 137.226,55.125 128.203,49.915 137.226,44.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5138,
      fill: "#FFFFFF"
    },
    points: "146.249,49.711 137.226,54.921 128.203,49.711 137.226,44.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5083,
      fill: "#FFFFFF"
    },
    points: "146.249,49.507 137.226,54.717 128.203,49.507 137.226,44.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5028,
      fill: "#FFFFFF"
    },
    points: "146.249,49.303 137.226,54.513 128.203,49.303 137.226,44.094  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4972,
      fill: "#FFFFFF"
    },
    points: "146.249,49.099 137.226,54.309 128.203,49.099 137.226,43.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4917,
      fill: "#FFFFFF"
    },
    points: "146.249,48.895 137.226,54.105 128.203,48.895 137.226,43.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4862,
      fill: "#FFFFFF"
    },
    points: "146.249,48.691 137.226,53.901 128.203,48.691 137.226,43.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4807,
      fill: "#FFFFFF"
    },
    points: "146.249,48.487 137.226,53.697 128.203,48.487 137.226,43.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4751,
      fill: "#FFFFFF"
    },
    points: "146.249,48.283 137.226,53.493 128.203,48.283 137.226,43.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4696,
      fill: "#FFFFFF"
    },
    points: "146.249,48.079 137.226,53.288 128.203,48.079 137.226,42.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4641,
      fill: "#FFFFFF"
    },
    points: "146.249,47.875 137.226,53.084 128.203,47.875 137.226,42.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4586,
      fill: "#FFFFFF"
    },
    points: "146.249,47.671 137.226,52.88 128.203,47.671 137.226,42.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.453,
      fill: "#FFFFFF"
    },
    points: "146.249,47.467 137.226,52.676 128.203,47.467 137.226,42.257  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4475,
      fill: "#FFFFFF"
    },
    points: "146.249,47.263 137.226,52.472 128.203,47.263 137.226,42.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.442,
      fill: "#FFFFFF"
    },
    points: "146.249,47.059 137.226,52.268 128.203,47.059 137.226,41.849  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4365,
      fill: "#FFFFFF"
    },
    points: "146.249,46.855 137.226,52.064 128.203,46.855 137.226,41.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4309,
      fill: "#FFFFFF"
    },
    points: "146.249,46.651 137.226,51.86 128.203,46.651 137.226,41.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4254,
      fill: "#FFFFFF"
    },
    points: "146.249,46.447 137.226,51.656 128.203,46.447 137.226,41.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4199,
      fill: "#FFFFFF"
    },
    points: "146.249,46.243 137.226,51.452 128.203,46.243 137.226,41.033  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4144,
      fill: "#FFFFFF"
    },
    points: "146.249,46.039 137.226,51.248 128.203,46.039 137.226,40.829  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4088,
      fill: "#FFFFFF"
    },
    points: "146.249,45.835 137.226,51.044 128.203,45.835 137.226,40.625  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4033,
      fill: "#FFFFFF"
    },
    points: "146.249,45.63 137.226,50.84 128.203,45.63 137.226,40.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3978,
      fill: "#FFFFFF"
    },
    points: "146.249,45.426 137.226,50.636 128.203,45.426 137.226,40.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3923,
      fill: "#FFFFFF"
    },
    points: "146.249,45.222 137.226,50.432 128.203,45.222 137.226,40.013  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3867,
      fill: "#FFFFFF"
    },
    points: "146.249,45.018 137.226,50.228 128.203,45.018 137.226,39.809  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3812,
      fill: "#FFFFFF"
    },
    points: "146.249,44.814 137.226,50.024 128.203,44.814 137.226,39.605  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3757,
      fill: "#FFFFFF"
    },
    points: "146.249,44.61 137.226,49.82 128.203,44.61 137.226,39.401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3702,
      fill: "#FFFFFF"
    },
    points: "146.249,44.406 137.226,49.616 128.203,44.406 137.226,39.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3646,
      fill: "#FFFFFF"
    },
    points: "146.249,44.202 137.226,49.412 128.203,44.202 137.226,38.993  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3591,
      fill: "#FFFFFF"
    },
    points: "146.249,43.998 137.226,49.208 128.203,43.998 137.226,38.789  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3536,
      fill: "#FFFFFF"
    },
    points: "146.249,43.794 137.226,49.004 128.203,43.794 137.226,38.585  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3481,
      fill: "#FFFFFF"
    },
    points: "146.249,43.59 137.226,48.8 128.203,43.59 137.226,38.381  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3425,
      fill: "#FFFFFF"
    },
    points: "146.249,43.386 137.226,48.596 128.203,43.386 137.226,38.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.337,
      fill: "#FFFFFF"
    },
    points: "146.249,43.182 137.226,48.392 128.203,43.182 137.226,37.972  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3315,
      fill: "#FFFFFF"
    },
    points: "146.249,42.978 137.226,48.187 128.203,42.978 137.226,37.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.326,
      fill: "#FFFFFF"
    },
    points: "146.249,42.774 137.226,47.983 128.203,42.774 137.226,37.564  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3204,
      fill: "#FFFFFF"
    },
    points: "146.249,42.57 137.226,47.779 128.203,42.57 137.226,37.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3149,
      fill: "#FFFFFF"
    },
    points: "146.249,42.366 137.226,47.575 128.203,42.366 137.226,37.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3094,
      fill: "#FFFFFF"
    },
    points: "146.249,42.162 137.226,47.371 128.203,42.162 137.226,36.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3039,
      fill: "#FFFFFF"
    },
    points: "146.249,41.958 137.226,47.167 128.203,41.958 137.226,36.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2983,
      fill: "#FFFFFF"
    },
    points: "146.249,41.754 137.226,46.963 128.203,41.754 137.226,36.544  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2928,
      fill: "#FFFFFF"
    },
    points: "146.249,41.55 137.226,46.759 128.203,41.55 137.226,36.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2873,
      fill: "#FFFFFF"
    },
    points: "146.249,41.346 137.226,46.555 128.203,41.346 137.226,36.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2818,
      fill: "#FFFFFF"
    },
    points: "146.249,41.142 137.226,46.351 128.203,41.142 137.226,35.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2762,
      fill: "#FFFFFF"
    },
    points: "146.249,40.938 137.226,46.147 128.203,40.938 137.226,35.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2707,
      fill: "#FFFFFF"
    },
    points: "146.249,40.734 137.226,45.943 128.203,40.734 137.226,35.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2652,
      fill: "#FFFFFF"
    },
    points: "146.249,40.529 137.226,45.739 128.203,40.529 137.226,35.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2597,
      fill: "#FFFFFF"
    },
    points: "146.249,40.325 137.226,45.535 128.203,40.325 137.226,35.116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2541,
      fill: "#FFFFFF"
    },
    points: "146.249,40.121 137.226,45.331 128.203,40.121 137.226,34.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2486,
      fill: "#FFFFFF"
    },
    points: "146.249,39.917 137.226,45.127 128.203,39.917 137.226,34.708  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2431,
      fill: "#FFFFFF"
    },
    points: "146.249,39.713 137.226,44.923 128.203,39.713 137.226,34.504  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2376,
      fill: "#FFFFFF"
    },
    points: "146.249,39.509 137.226,44.719 128.203,39.509 137.226,34.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.232,
      fill: "#FFFFFF"
    },
    points: "146.249,39.305 137.226,44.515 128.203,39.305 137.226,34.096  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2265,
      fill: "#FFFFFF"
    },
    points: "146.249,39.101 137.226,44.311 128.203,39.101 137.226,33.892  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.221,
      fill: "#FFFFFF"
    },
    points: "146.249,38.897 137.226,44.107 128.203,38.897 137.226,33.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2155,
      fill: "#FFFFFF"
    },
    points: "146.249,38.693 137.226,43.903 128.203,38.693 137.226,33.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2099,
      fill: "#FFFFFF"
    },
    points: "146.249,38.489 137.226,43.699 128.203,38.489 137.226,33.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2044,
      fill: "#FFFFFF"
    },
    points: "146.249,38.285 137.226,43.495 128.203,38.285 137.226,33.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1989,
      fill: "#FFFFFF"
    },
    points: "146.249,38.081 137.226,43.291 128.203,38.081 137.226,32.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1934,
      fill: "#FFFFFF"
    },
    points: "146.249,37.877 137.226,43.086 128.203,37.877 137.226,32.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1878,
      fill: "#FFFFFF"
    },
    points: "146.249,37.673 137.226,42.882 128.203,37.673 137.226,32.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1823,
      fill: "#FFFFFF"
    },
    points: "146.249,37.469 137.226,42.678 128.203,37.469 137.226,32.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1768,
      fill: "#FFFFFF"
    },
    points: "146.249,37.265 137.226,42.474 128.203,37.265 137.226,32.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1713,
      fill: "#FFFFFF"
    },
    points: "146.249,37.061 137.226,42.27 128.203,37.061 137.226,31.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1657,
      fill: "#FFFFFF"
    },
    points: "146.249,36.857 137.226,42.066 128.203,36.857 137.226,31.647  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1602,
      fill: "#FFFFFF"
    },
    points: "146.249,36.653 137.226,41.862 128.203,36.653 137.226,31.443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1547,
      fill: "#FFFFFF"
    },
    points: "146.249,36.449 137.226,41.658 128.203,36.449 137.226,31.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1492,
      fill: "#FFFFFF"
    },
    points: "146.249,36.245 137.226,41.454 128.203,36.245 137.226,31.035  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1436,
      fill: "#FFFFFF"
    },
    points: "146.249,36.041 137.226,41.25 128.203,36.041 137.226,30.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1381,
      fill: "#FFFFFF"
    },
    points: "146.249,35.837 137.226,41.046 128.203,35.837 137.226,30.627  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1326,
      fill: "#FFFFFF"
    },
    points: "146.249,35.633 137.226,40.842 128.203,35.633 137.226,30.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1271,
      fill: "#FFFFFF"
    },
    points: "146.249,35.428 137.226,40.638 128.203,35.428 137.226,30.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1215,
      fill: "#FFFFFF"
    },
    points: "146.249,35.224 137.226,40.434 128.203,35.224 137.226,30.015  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.116,
      fill: "#FFFFFF"
    },
    points: "146.249,35.02 137.226,40.23 128.203,35.02 137.226,29.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1105,
      fill: "#FFFFFF"
    },
    points: "146.249,34.816 137.226,40.026 128.203,34.816 137.226,29.607  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.105,
      fill: "#FFFFFF"
    },
    points: "146.249,34.612 137.226,39.822 128.203,34.612 137.226,29.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0994,
      fill: "#FFFFFF"
    },
    points: "146.249,34.408 137.226,39.618 128.203,34.408 137.226,29.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0939,
      fill: "#FFFFFF"
    },
    points: "146.249,34.204 137.226,39.414 128.203,34.204 137.226,28.995  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0884,
      fill: "#FFFFFF"
    },
    points: "146.249,34 137.226,39.21 128.203,34 137.226,28.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0829,
      fill: "#FFFFFF"
    },
    points: "146.249,33.796 137.226,39.006 128.203,33.796 137.226,28.587  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0773,
      fill: "#FFFFFF"
    },
    points: "146.249,33.592 137.226,38.802 128.203,33.592 137.226,28.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0718,
      fill: "#FFFFFF"
    },
    points: "146.249,33.388 137.226,38.598 128.203,33.388 137.226,28.179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0663,
      fill: "#FFFFFF"
    },
    points: "146.249,33.184 137.226,38.394 128.203,33.184 137.226,27.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0608,
      fill: "#FFFFFF"
    },
    points: "146.249,32.98 137.226,38.19 128.203,32.98 137.226,27.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0552,
      fill: "#FFFFFF"
    },
    points: "146.249,32.776 137.226,37.985 128.203,32.776 137.226,27.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0497,
      fill: "#FFFFFF"
    },
    points: "146.249,32.572 137.226,37.781 128.203,32.572 137.226,27.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0442,
      fill: "#FFFFFF"
    },
    points: "146.249,32.368 137.226,37.577 128.203,32.368 137.226,27.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0387,
      fill: "#FFFFFF"
    },
    points: "146.249,32.164 137.226,37.373 128.203,32.164 137.226,26.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0331,
      fill: "#FFFFFF"
    },
    points: "146.249,31.96 137.226,37.169 128.203,31.96 137.226,26.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0276,
      fill: "#FFFFFF"
    },
    points: "146.249,31.756 137.226,36.965 128.203,31.756 137.226,26.546  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0221,
      fill: "#FFFFFF"
    },
    points: "146.249,31.552 137.226,36.761 128.203,31.552 137.226,26.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0166,
      fill: "#FFFFFF"
    },
    points: "146.249,31.348 137.226,36.557 128.203,31.348 137.226,26.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.011,
      fill: "#FFFFFF"
    },
    points: "146.249,31.144 137.226,36.353 128.203,31.144 137.226,25.934  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0055,
      fill: "#FFFFFF"
    },
    points: "146.249,30.94 137.226,36.149 128.203,30.94 137.226,25.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0,
      fill: "#FFFFFF"
    },
    points: "146.249,30.736 137.226,35.945 128.203,30.736 137.226,25.526  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15D9FD"
    },
    d: "M137.226,83.779c-0.079,0-0.159-0.021-0.23-0.062c-0.142-0.082-0.23-0.234-0.23-0.398V72.948 c0-0.164,0.088-0.316,0.23-0.398l9.023-5.21c0.142-0.082,0.318-0.082,0.46,0c0.142,0.082,0.23,0.234,0.23,0.398V78.11 c0,0.164-0.088,0.316-0.23,0.398l-9.023,5.209C137.385,83.758,137.305,83.779,137.226,83.779z M137.686,73.213v9.309 l8.103-4.678v-9.309L137.686,73.213z M146.249,78.11h0.009H146.249z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15D9FD"
    },
    d: "M137.226,83.779c-0.079,0-0.159-0.021-0.23-0.062l-9.023-5.209 c-0.142-0.082-0.23-0.234-0.23-0.398V67.738c0-0.164,0.088-0.316,0.23-0.398c0.142-0.082,0.318-0.082,0.46,0l9.023,5.21 c0.142,0.082,0.23,0.234,0.23,0.398v10.371c0,0.164-0.088,0.316-0.23,0.398C137.385,83.758,137.305,83.779,137.226,83.779z  M128.663,77.844l8.103,4.678v-9.309l-8.103-4.678V77.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15D9FD"
    },
    d: "M137.226,73.408c-0.079,0-0.159-0.021-0.23-0.062l-9.023-5.21 c-0.142-0.082-0.23-0.234-0.23-0.398c0-0.164,0.088-0.316,0.23-0.398l9.023-5.21c0.142-0.082,0.318-0.082,0.46,0l9.023,5.21 c0.142,0.082,0.23,0.234,0.23,0.398c0,0.164-0.088,0.316-0.23,0.398l-9.023,5.21C137.385,73.387,137.305,73.408,137.226,73.408z  M129.123,67.738l8.103,4.679l8.103-4.679l-8.103-4.679L129.123,67.738z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15D9FD"
    },
    d: "M145.964,78.624c-0.159,0-0.314-0.082-0.399-0.23c-0.053-0.092-0.071-0.194-0.057-0.292 l-8.282-4.781l-8.793,5.077c-0.221,0.126-0.501,0.052-0.629-0.169c-0.127-0.22-0.052-0.501,0.169-0.628l9.023-5.209 c0.142-0.082,0.318-0.082,0.46,0l9.023,5.209c0.142,0.082,0.23,0.234,0.23,0.398c0,0.164-0.088,0.316-0.23,0.399l-0.285,0.165 C146.122,78.604,146.043,78.624,145.964,78.624z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15D9FD"
    },
    d: "M137.226,73.25c-0.254,0-0.46-0.206-0.46-0.46V62.528c0-0.254,0.206-0.46,0.46-0.46 s0.46,0.206,0.46,0.46V72.79C137.686,73.044,137.48,73.25,137.226,73.25z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "35.376,189.774 27.637,194.242 19.899,189.774 27.637,185.306  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9945,
      fill: "#FFFFFF"
    },
    points: "35.376,189.626 27.637,194.094 19.899,189.626 27.637,185.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.989,
      fill: "#FFFFFF"
    },
    points: "35.376,189.478 27.637,193.945 19.899,189.478 27.637,185.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9834,
      fill: "#FFFFFF"
    },
    points: "35.376,189.329 27.637,193.797 19.899,189.329 27.637,184.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9779,
      fill: "#FFFFFF"
    },
    points: "35.376,189.181 27.637,193.649 19.899,189.181 27.637,184.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9724,
      fill: "#FFFFFF"
    },
    points: "35.376,189.033 27.637,193.501 19.899,189.033 27.637,184.565  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9669,
      fill: "#FFFFFF"
    },
    points: "35.376,188.884 27.637,193.352 19.899,188.884 27.637,184.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9613,
      fill: "#FFFFFF"
    },
    points: "35.376,188.736 27.637,193.204 19.899,188.736 27.637,184.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9558,
      fill: "#FFFFFF"
    },
    points: "35.376,188.588 27.637,193.056 19.899,188.588 27.637,184.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9503,
      fill: "#FFFFFF"
    },
    points: "35.376,188.439 27.637,192.907 19.899,188.439 27.637,183.971  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9448,
      fill: "#FFFFFF"
    },
    points: "35.376,188.291 27.637,192.759 19.899,188.291 27.637,183.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9392,
      fill: "#FFFFFF"
    },
    points: "35.376,188.143 27.637,192.611 19.899,188.143 27.637,183.675  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9337,
      fill: "#FFFFFF"
    },
    points: "35.376,187.995 27.637,192.462 19.899,187.995 27.637,183.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9282,
      fill: "#FFFFFF"
    },
    points: "35.376,187.846 27.637,192.314 19.899,187.846 27.637,183.378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9227,
      fill: "#FFFFFF"
    },
    points: "35.376,187.698 27.637,192.166 19.899,187.698 27.637,183.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9171,
      fill: "#FFFFFF"
    },
    points: "35.376,187.549 27.637,192.017 19.899,187.549 27.637,183.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9116,
      fill: "#FFFFFF"
    },
    points: "35.376,187.401 27.637,191.869 19.899,187.401 27.637,182.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9061,
      fill: "#FFFFFF"
    },
    points: "35.376,187.253 27.637,191.721 19.899,187.253 27.637,182.785  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9006,
      fill: "#FFFFFF"
    },
    points: "35.376,187.105 27.637,191.572 19.899,187.105 27.637,182.637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.895,
      fill: "#FFFFFF"
    },
    points: "35.376,186.956 27.637,191.424 19.899,186.956 27.637,182.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8895,
      fill: "#FFFFFF"
    },
    points: "35.376,186.808 27.637,191.276 19.899,186.808 27.637,182.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.884,
      fill: "#FFFFFF"
    },
    points: "35.376,186.66 27.637,191.128 19.899,186.66 27.637,182.192  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8785,
      fill: "#FFFFFF"
    },
    points: "35.376,186.511 27.637,190.979 19.899,186.511 27.637,182.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8729,
      fill: "#FFFFFF"
    },
    points: "35.376,186.363 27.637,190.831 19.899,186.363 27.637,181.895  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8674,
      fill: "#FFFFFF"
    },
    points: "35.376,186.215 27.637,190.683 19.899,186.215 27.637,181.747  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8619,
      fill: "#FFFFFF"
    },
    points: "35.376,186.066 27.637,190.534 19.899,186.066 27.637,181.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8564,
      fill: "#FFFFFF"
    },
    points: "35.376,185.918 27.637,190.386 19.899,185.918 27.637,181.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8508,
      fill: "#FFFFFF"
    },
    points: "35.376,185.77 27.637,190.238 19.899,185.77 27.637,181.302  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8453,
      fill: "#FFFFFF"
    },
    points: "35.376,185.621 27.637,190.089 19.899,185.621 27.637,181.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8398,
      fill: "#FFFFFF"
    },
    points: "35.376,185.473 27.637,189.941 19.899,185.473 27.637,181.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8343,
      fill: "#FFFFFF"
    },
    points: "35.376,185.325 27.637,189.793 19.899,185.325 27.637,180.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8287,
      fill: "#FFFFFF"
    },
    points: "35.376,185.176 27.637,189.644 19.899,185.176 27.637,180.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8232,
      fill: "#FFFFFF"
    },
    points: "35.376,185.028 27.637,189.496 19.899,185.028 27.637,180.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8177,
      fill: "#FFFFFF"
    },
    points: "35.376,184.88 27.637,189.348 19.899,184.88 27.637,180.412  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8122,
      fill: "#FFFFFF"
    },
    points: "35.376,184.732 27.637,189.199 19.899,184.732 27.637,180.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8066,
      fill: "#FFFFFF"
    },
    points: "35.376,184.583 27.637,189.051 19.899,184.583 27.637,180.115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8011,
      fill: "#FFFFFF"
    },
    points: "35.376,184.435 27.637,188.903 19.899,184.435 27.637,179.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7956,
      fill: "#FFFFFF"
    },
    points: "35.376,184.287 27.637,188.755 19.899,184.287 27.637,179.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7901,
      fill: "#FFFFFF"
    },
    points: "35.376,184.138 27.637,188.606 19.899,184.138 27.637,179.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7845,
      fill: "#FFFFFF"
    },
    points: "35.376,183.99 27.637,188.458 19.899,183.99 27.637,179.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.779,
      fill: "#FFFFFF"
    },
    points: "35.376,183.842 27.637,188.31 19.899,183.842 27.637,179.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7735,
      fill: "#FFFFFF"
    },
    points: "35.376,183.693 27.637,188.161 19.899,183.693 27.637,179.225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.768,
      fill: "#FFFFFF"
    },
    points: "35.376,183.545 27.637,188.013 19.899,183.545 27.637,179.077  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7624,
      fill: "#FFFFFF"
    },
    points: "35.376,183.397 27.637,187.865 19.899,183.397 27.637,178.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7569,
      fill: "#FFFFFF"
    },
    points: "35.376,183.248 27.637,187.716 19.899,183.248 27.637,178.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7514,
      fill: "#FFFFFF"
    },
    points: "35.376,183.1 27.637,187.568 19.899,183.1 27.637,178.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7459,
      fill: "#FFFFFF"
    },
    points: "35.376,182.952 27.637,187.42 19.899,182.952 27.637,178.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7403,
      fill: "#FFFFFF"
    },
    points: "35.376,182.803 27.637,187.271 19.899,182.803 27.637,178.336  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7348,
      fill: "#FFFFFF"
    },
    points: "35.376,182.655 27.637,187.123 19.899,182.655 27.637,178.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7293,
      fill: "#FFFFFF"
    },
    points: "35.376,182.507 27.637,186.975 19.899,182.507 27.637,178.039  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7238,
      fill: "#FFFFFF"
    },
    points: "35.376,182.359 27.637,186.827 19.899,182.359 27.637,177.891  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7182,
      fill: "#FFFFFF"
    },
    points: "35.376,182.21 27.637,186.678 19.899,182.21 27.637,177.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7127,
      fill: "#FFFFFF"
    },
    points: "35.376,182.062 27.637,186.53 19.899,182.062 27.637,177.594  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7072,
      fill: "#FFFFFF"
    },
    points: "35.376,181.914 27.637,186.382 19.899,181.914 27.637,177.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7017,
      fill: "#FFFFFF"
    },
    points: "35.376,181.765 27.637,186.233 19.899,181.765 27.637,177.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6961,
      fill: "#FFFFFF"
    },
    points: "35.376,181.617 27.637,186.085 19.899,181.617 27.637,177.149  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6906,
      fill: "#FFFFFF"
    },
    points: "35.376,181.469 27.637,185.937 19.899,181.469 27.637,177.001  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6851,
      fill: "#FFFFFF"
    },
    points: "35.376,181.32 27.637,185.788 19.899,181.32 27.637,176.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6796,
      fill: "#FFFFFF"
    },
    points: "35.376,181.172 27.637,185.64 19.899,181.172 27.637,176.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.674,
      fill: "#FFFFFF"
    },
    points: "35.376,181.024 27.637,185.492 19.899,181.024 27.637,176.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6685,
      fill: "#FFFFFF"
    },
    points: "35.376,180.875 27.637,185.343 19.899,180.875 27.637,176.408  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.663,
      fill: "#FFFFFF"
    },
    points: "35.376,180.727 27.637,185.195 19.899,180.727 27.637,176.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6575,
      fill: "#FFFFFF"
    },
    points: "35.376,180.579 27.637,185.047 19.899,180.579 27.637,176.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6519,
      fill: "#FFFFFF"
    },
    points: "35.376,180.43 27.637,184.898 19.899,180.43 27.637,175.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6464,
      fill: "#FFFFFF"
    },
    points: "35.376,180.282 27.637,184.75 19.899,180.282 27.637,175.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6409,
      fill: "#FFFFFF"
    },
    points: "35.376,180.134 27.637,184.602 19.899,180.134 27.637,175.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6354,
      fill: "#FFFFFF"
    },
    points: "35.376,179.986 27.637,184.454 19.899,179.986 27.637,175.518  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6298,
      fill: "#FFFFFF"
    },
    points: "35.376,179.837 27.637,184.305 19.899,179.837 27.637,175.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6243,
      fill: "#FFFFFF"
    },
    points: "35.376,179.689 27.637,184.157 19.899,179.689 27.637,175.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6188,
      fill: "#FFFFFF"
    },
    points: "35.376,179.541 27.637,184.008 19.899,179.541 27.637,175.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6133,
      fill: "#FFFFFF"
    },
    points: "35.376,179.392 27.637,183.86 19.899,179.392 27.637,174.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6077,
      fill: "#FFFFFF"
    },
    points: "35.376,179.244 27.637,183.712 19.899,179.244 27.637,174.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6022,
      fill: "#FFFFFF"
    },
    points: "35.376,179.096 27.637,183.564 19.899,179.096 27.637,174.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5967,
      fill: "#FFFFFF"
    },
    points: "35.376,178.947 27.637,183.415 19.899,178.947 27.637,174.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5912,
      fill: "#FFFFFF"
    },
    points: "35.376,178.799 27.637,183.267 19.899,178.799 27.637,174.331  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5856,
      fill: "#FFFFFF"
    },
    points: "35.376,178.651 27.637,183.119 19.899,178.651 27.637,174.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5801,
      fill: "#FFFFFF"
    },
    points: "35.376,178.502 27.637,182.97 19.899,178.502 27.637,174.035  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5746,
      fill: "#FFFFFF"
    },
    points: "35.376,178.354 27.637,182.822 19.899,178.354 27.637,173.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5691,
      fill: "#FFFFFF"
    },
    points: "35.376,178.206 27.637,182.674 19.899,178.206 27.637,173.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5635,
      fill: "#FFFFFF"
    },
    points: "35.376,178.057 27.637,182.525 19.899,178.057 27.637,173.589  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.558,
      fill: "#FFFFFF"
    },
    points: "35.376,177.909 27.637,182.377 19.899,177.909 27.637,173.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5525,
      fill: "#FFFFFF"
    },
    points: "35.376,177.761 27.637,182.229 19.899,177.761 27.637,173.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.547,
      fill: "#FFFFFF"
    },
    points: "35.376,177.613 27.637,182.08 19.899,177.613 27.637,173.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5414,
      fill: "#FFFFFF"
    },
    points: "35.376,177.464 27.637,181.932 19.899,177.464 27.637,172.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5359,
      fill: "#FFFFFF"
    },
    points: "35.376,177.316 27.637,181.784 19.899,177.316 27.637,172.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5304,
      fill: "#FFFFFF"
    },
    points: "35.376,177.168 27.637,181.635 19.899,177.168 27.637,172.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5249,
      fill: "#FFFFFF"
    },
    points: "35.376,177.019 27.637,181.487 19.899,177.019 27.637,172.551  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5193,
      fill: "#FFFFFF"
    },
    points: "35.376,176.871 27.637,181.339 19.899,176.871 27.637,172.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5138,
      fill: "#FFFFFF"
    },
    points: "35.376,176.723 27.637,181.191 19.899,176.723 27.637,172.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5083,
      fill: "#FFFFFF"
    },
    points: "35.376,176.574 27.637,181.042 19.899,176.574 27.637,172.106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5028,
      fill: "#FFFFFF"
    },
    points: "35.376,176.426 27.637,180.894 19.899,176.426 27.637,171.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4972,
      fill: "#FFFFFF"
    },
    points: "35.376,176.278 27.637,180.746 19.899,176.278 27.637,171.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4917,
      fill: "#FFFFFF"
    },
    points: "35.376,176.129 27.637,180.597 19.899,176.129 27.637,171.661  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4862,
      fill: "#FFFFFF"
    },
    points: "35.376,175.981 27.637,180.449 19.899,175.981 27.637,171.513  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4807,
      fill: "#FFFFFF"
    },
    points: "35.376,175.833 27.637,180.301 19.899,175.833 27.637,171.365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4751,
      fill: "#FFFFFF"
    },
    points: "35.376,175.684 27.637,180.152 19.899,175.684 27.637,171.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4696,
      fill: "#FFFFFF"
    },
    points: "35.376,175.536 27.637,180.004 19.899,175.536 27.637,171.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4641,
      fill: "#FFFFFF"
    },
    points: "35.376,175.388 27.637,179.856 19.899,175.388 27.637,170.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4586,
      fill: "#FFFFFF"
    },
    points: "35.376,175.24 27.637,179.707 19.899,175.24 27.637,170.772  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.453,
      fill: "#FFFFFF"
    },
    points: "35.376,175.091 27.637,179.559 19.899,175.091 27.637,170.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4475,
      fill: "#FFFFFF"
    },
    points: "35.376,174.943 27.637,179.411 19.899,174.943 27.637,170.475  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.442,
      fill: "#FFFFFF"
    },
    points: "35.376,174.795 27.637,179.262 19.899,174.795 27.637,170.327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4365,
      fill: "#FFFFFF"
    },
    points: "35.376,174.646 27.637,179.114 19.899,174.646 27.637,170.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4309,
      fill: "#FFFFFF"
    },
    points: "35.376,174.498 27.637,178.966 19.899,174.498 27.637,170.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4254,
      fill: "#FFFFFF"
    },
    points: "35.376,174.35 27.637,178.818 19.899,174.35 27.637,169.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4199,
      fill: "#FFFFFF"
    },
    points: "35.376,174.201 27.637,178.669 19.899,174.201 27.637,169.733  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4144,
      fill: "#FFFFFF"
    },
    points: "35.376,174.053 27.637,178.521 19.899,174.053 27.637,169.585  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4088,
      fill: "#FFFFFF"
    },
    points: "35.376,173.905 27.637,178.373 19.899,173.905 27.637,169.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4033,
      fill: "#FFFFFF"
    },
    points: "35.376,173.756 27.637,178.224 19.899,173.756 27.637,169.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3978,
      fill: "#FFFFFF"
    },
    points: "35.376,173.608 27.637,178.076 19.899,173.608 27.637,169.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3923,
      fill: "#FFFFFF"
    },
    points: "35.376,173.46 27.637,177.928 19.899,173.46 27.637,168.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3867,
      fill: "#FFFFFF"
    },
    points: "35.376,173.311 27.637,177.779 19.899,173.311 27.637,168.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3812,
      fill: "#FFFFFF"
    },
    points: "35.376,173.163 27.637,177.631 19.899,173.163 27.637,168.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3757,
      fill: "#FFFFFF"
    },
    points: "35.376,173.015 27.637,177.483 19.899,173.015 27.637,168.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3702,
      fill: "#FFFFFF"
    },
    points: "35.376,172.867 27.637,177.334 19.899,172.867 27.637,168.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3646,
      fill: "#FFFFFF"
    },
    points: "35.376,172.718 27.637,177.186 19.899,172.718 27.637,168.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3591,
      fill: "#FFFFFF"
    },
    points: "35.376,172.57 27.637,177.038 19.899,172.57 27.637,168.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3536,
      fill: "#FFFFFF"
    },
    points: "35.376,172.421 27.637,176.889 19.899,172.421 27.637,167.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3481,
      fill: "#FFFFFF"
    },
    points: "35.376,172.273 27.637,176.741 19.899,172.273 27.637,167.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3425,
      fill: "#FFFFFF"
    },
    points: "35.376,172.125 27.637,176.593 19.899,172.125 27.637,167.657  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.337,
      fill: "#FFFFFF"
    },
    points: "35.376,171.977 27.637,176.445 19.899,171.977 27.637,167.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3315,
      fill: "#FFFFFF"
    },
    points: "35.376,171.828 27.637,176.296 19.899,171.828 27.637,167.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.326,
      fill: "#FFFFFF"
    },
    points: "35.376,171.68 27.637,176.148 19.899,171.68 27.637,167.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3204,
      fill: "#FFFFFF"
    },
    points: "35.376,171.532 27.637,176 19.899,171.532 27.637,167.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3149,
      fill: "#FFFFFF"
    },
    points: "35.376,171.383 27.637,175.851 19.899,171.383 27.637,166.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3094,
      fill: "#FFFFFF"
    },
    points: "35.376,171.235 27.637,175.703 19.899,171.235 27.637,166.767  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3039,
      fill: "#FFFFFF"
    },
    points: "35.376,171.087 27.637,175.555 19.899,171.087 27.637,166.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2983,
      fill: "#FFFFFF"
    },
    points: "35.376,170.938 27.637,175.406 19.899,170.938 27.637,166.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2928,
      fill: "#FFFFFF"
    },
    points: "35.376,170.79 27.637,175.258 19.899,170.79 27.637,166.322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2873,
      fill: "#FFFFFF"
    },
    points: "35.376,170.642 27.637,175.11 19.899,170.642 27.637,166.174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2818,
      fill: "#FFFFFF"
    },
    points: "35.376,170.493 27.637,174.961 19.899,170.493 27.637,166.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2762,
      fill: "#FFFFFF"
    },
    points: "35.376,170.345 27.637,174.813 19.899,170.345 27.637,165.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2707,
      fill: "#FFFFFF"
    },
    points: "35.376,170.197 27.637,174.665 19.899,170.197 27.637,165.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2652,
      fill: "#FFFFFF"
    },
    points: "35.376,170.048 27.637,174.516 19.899,170.048 27.637,165.581  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2597,
      fill: "#FFFFFF"
    },
    points: "35.376,169.9 27.637,174.368 19.899,169.9 27.637,165.432  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2541,
      fill: "#FFFFFF"
    },
    points: "35.376,169.752 27.637,174.22 19.899,169.752 27.637,165.284  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2486,
      fill: "#FFFFFF"
    },
    points: "35.376,169.604 27.637,174.072 19.899,169.604 27.637,165.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2431,
      fill: "#FFFFFF"
    },
    points: "35.376,169.455 27.637,173.923 19.899,169.455 27.637,164.987  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2376,
      fill: "#FFFFFF"
    },
    points: "35.376,169.307 27.637,173.775 19.899,169.307 27.637,164.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.232,
      fill: "#FFFFFF"
    },
    points: "35.376,169.159 27.637,173.627 19.899,169.159 27.637,164.691  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2265,
      fill: "#FFFFFF"
    },
    points: "35.376,169.01 27.637,173.478 19.899,169.01 27.637,164.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.221,
      fill: "#FFFFFF"
    },
    points: "35.376,168.862 27.637,173.33 19.899,168.862 27.637,164.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2155,
      fill: "#FFFFFF"
    },
    points: "35.376,168.714 27.637,173.182 19.899,168.714 27.637,164.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2099,
      fill: "#FFFFFF"
    },
    points: "35.376,168.565 27.637,173.033 19.899,168.565 27.637,164.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2044,
      fill: "#FFFFFF"
    },
    points: "35.376,168.417 27.637,172.885 19.899,168.417 27.637,163.949  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1989,
      fill: "#FFFFFF"
    },
    points: "35.376,168.269 27.637,172.737 19.899,168.269 27.637,163.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1934,
      fill: "#FFFFFF"
    },
    points: "35.376,168.12 27.637,172.588 19.899,168.12 27.637,163.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1878,
      fill: "#FFFFFF"
    },
    points: "35.376,167.972 27.637,172.44 19.899,167.972 27.637,163.504  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1823,
      fill: "#FFFFFF"
    },
    points: "35.376,167.824 27.637,172.292 19.899,167.824 27.637,163.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1768,
      fill: "#FFFFFF"
    },
    points: "35.376,167.676 27.637,172.143 19.899,167.676 27.637,163.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1713,
      fill: "#FFFFFF"
    },
    points: "35.376,167.527 27.637,171.995 19.899,167.527 27.637,163.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1657,
      fill: "#FFFFFF"
    },
    points: "35.376,167.379 27.637,171.847 19.899,167.379 27.637,162.911  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1602,
      fill: "#FFFFFF"
    },
    points: "35.376,167.231 27.637,171.699 19.899,167.231 27.637,162.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1547,
      fill: "#FFFFFF"
    },
    points: "35.376,167.082 27.637,171.55 19.899,167.082 27.637,162.614  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1492,
      fill: "#FFFFFF"
    },
    points: "35.376,166.934 27.637,171.402 19.899,166.934 27.637,162.466  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1436,
      fill: "#FFFFFF"
    },
    points: "35.376,166.786 27.637,171.253 19.899,166.786 27.637,162.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1381,
      fill: "#FFFFFF"
    },
    points: "35.376,166.637 27.637,171.105 19.899,166.637 27.637,162.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1326,
      fill: "#FFFFFF"
    },
    points: "35.376,166.489 27.637,170.957 19.899,166.489 27.637,162.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1271,
      fill: "#FFFFFF"
    },
    points: "35.376,166.341 27.637,170.809 19.899,166.341 27.637,161.873  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1215,
      fill: "#FFFFFF"
    },
    points: "35.376,166.192 27.637,170.66 19.899,166.192 27.637,161.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.116,
      fill: "#FFFFFF"
    },
    points: "35.376,166.044 27.637,170.512 19.899,166.044 27.637,161.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1105,
      fill: "#FFFFFF"
    },
    points: "35.376,165.896 27.637,170.364 19.899,165.896 27.637,161.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.105,
      fill: "#FFFFFF"
    },
    points: "35.376,165.747 27.637,170.215 19.899,165.747 27.637,161.279  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0994,
      fill: "#FFFFFF"
    },
    points: "35.376,165.599 27.637,170.067 19.899,165.599 27.637,161.131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0939,
      fill: "#FFFFFF"
    },
    points: "35.376,165.451 27.637,169.919 19.899,165.451 27.637,160.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0884,
      fill: "#FFFFFF"
    },
    points: "35.376,165.303 27.637,169.77 19.899,165.303 27.637,160.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0829,
      fill: "#FFFFFF"
    },
    points: "35.376,165.154 27.637,169.622 19.899,165.154 27.637,160.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0773,
      fill: "#FFFFFF"
    },
    points: "35.376,165.006 27.637,169.474 19.899,165.006 27.637,160.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0718,
      fill: "#FFFFFF"
    },
    points: "35.376,164.858 27.637,169.326 19.899,164.858 27.637,160.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0663,
      fill: "#FFFFFF"
    },
    points: "35.376,164.709 27.637,169.177 19.899,164.709 27.637,160.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0608,
      fill: "#FFFFFF"
    },
    points: "35.376,164.561 27.637,169.029 19.899,164.561 27.637,160.093  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0552,
      fill: "#FFFFFF"
    },
    points: "35.376,164.413 27.637,168.88 19.899,164.413 27.637,159.945  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0497,
      fill: "#FFFFFF"
    },
    points: "35.376,164.264 27.637,168.732 19.899,164.264 27.637,159.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0442,
      fill: "#FFFFFF"
    },
    points: "35.376,164.116 27.637,168.584 19.899,164.116 27.637,159.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0387,
      fill: "#FFFFFF"
    },
    points: "35.376,163.968 27.637,168.436 19.899,163.968 27.637,159.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0331,
      fill: "#FFFFFF"
    },
    points: "35.376,163.819 27.637,168.287 19.899,163.819 27.637,159.351  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0276,
      fill: "#FFFFFF"
    },
    points: "35.376,163.671 27.637,168.139 19.899,163.671 27.637,159.203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0221,
      fill: "#FFFFFF"
    },
    points: "35.376,163.523 27.637,167.991 19.899,163.523 27.637,159.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0166,
      fill: "#FFFFFF"
    },
    points: "35.376,163.374 27.637,167.842 19.899,163.374 27.637,158.906  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.011,
      fill: "#FFFFFF"
    },
    points: "35.376,163.226 27.637,167.694 19.899,163.226 27.637,158.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0055,
      fill: "#FFFFFF"
    },
    points: "35.376,163.078 27.637,167.546 19.899,163.078 27.637,158.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0,
      fill: "#FFFFFF"
    },
    points: "35.376,162.93 27.637,167.397 19.899,162.93 27.637,158.462  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M27.638,203.658c-0.079,0-0.159-0.021-0.23-0.062c-0.142-0.082-0.23-0.234-0.23-0.398v-8.895 c0-0.164,0.088-0.316,0.23-0.398l7.738-4.468c0.142-0.082,0.318-0.082,0.46,0c0.142,0.082,0.23,0.234,0.23,0.398v8.895 c0,0.165-0.088,0.316-0.23,0.398l-7.738,4.468C27.797,203.637,27.717,203.658,27.638,203.658z M28.098,194.569v7.832 l6.818-3.936v-7.832L28.098,194.569z M35.376,198.73h0.009H35.376z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M27.638,203.658c-0.079,0-0.159-0.021-0.23-0.062l-7.739-4.468 c-0.142-0.082-0.23-0.234-0.23-0.398v-8.895c0-0.165,0.088-0.316,0.23-0.398c0.142-0.082,0.318-0.082,0.46,0l7.739,4.468 c0.142,0.082,0.23,0.234,0.23,0.398v8.895c0,0.164-0.088,0.316-0.23,0.398C27.797,203.637,27.717,203.658,27.638,203.658z  M20.359,198.465l6.819,3.936v-7.832l-6.819-3.936V198.465z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M27.638,194.763c-0.079,0-0.159-0.021-0.23-0.062l-7.739-4.468 c-0.142-0.082-0.23-0.234-0.23-0.398c0-0.165,0.088-0.316,0.23-0.398l7.739-4.468c0.142-0.082,0.318-0.082,0.46,0l7.738,4.468 c0.142,0.082,0.23,0.234,0.23,0.398c0,0.164-0.088,0.316-0.23,0.398l-7.738,4.468C27.797,194.743,27.717,194.763,27.638,194.763 z M20.819,189.835l6.819,3.937l6.818-3.937l-6.818-3.937L20.819,189.835z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M35.131,199.237c-0.159,0-0.314-0.083-0.398-0.23c-0.045-0.078-0.065-0.163-0.062-0.247 l-7.034-4.061l-7.509,4.335c-0.22,0.126-0.502,0.052-0.628-0.168c-0.128-0.22-0.052-0.501,0.168-0.629l7.739-4.468 c0.142-0.082,0.318-0.082,0.46,0l7.738,4.468c0.142,0.082,0.23,0.234,0.23,0.398s-0.088,0.316-0.23,0.398l-0.244,0.141 C35.289,199.217,35.209,199.237,35.131,199.237z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6FE"
    },
    d: "M27.638,194.628c-0.254,0-0.46-0.206-0.46-0.46v-8.801c0-0.254,0.206-0.46,0.46-0.46 c0.254,0,0.46,0.206,0.46,0.46v8.801C28.098,194.422,27.892,194.628,27.638,194.628z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "500.189,168.277 502.218,167.092 502.288,146.82 500.259,148.004  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "500.259,148.004 502.288,146.82 468.346,127.067 466.317,128.251  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DDE3F4"
    },
    points: "466.317,128.251 466.247,148.523 500.189,168.277 500.259,148.004  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M477.629,142.592c0.077,0.351,0.162,0.745,0.256,1.183c0.093,0.438,0.193,0.893,0.299,1.365 c0.106,0.471,0.214,0.944,0.323,1.418c0.109,0.474,0.215,0.916,0.318,1.326c0.084-0.332,0.17-0.696,0.257-1.093 c0.087-0.397,0.17-0.812,0.247-1.244c0.078-0.432,0.154-0.864,0.228-1.295c0.074-0.431,0.144-0.847,0.209-1.25l1.564,0.907 c-0.227,1.167-0.487,2.333-0.782,3.497c-0.294,1.165-0.613,2.249-0.956,3.251l-1.377-0.799 c-0.225-0.846-0.443-1.725-0.655-2.634c-0.212-0.91-0.421-1.82-0.626-2.73c-0.206,0.671-0.413,1.341-0.619,2.008 c-0.206,0.668-0.422,1.294-0.648,1.88l-1.376-0.798c-0.342-1.4-0.661-2.853-0.954-4.359c-0.294-1.506-0.554-2.974-0.781-4.403 l1.631,0.946c0.064,0.478,0.136,0.976,0.213,1.495c0.077,0.519,0.158,1.041,0.243,1.567c0.084,0.526,0.17,1.038,0.257,1.537 c0.087,0.498,0.176,0.964,0.267,1.397c0.116-0.298,0.229-0.621,0.339-0.968c0.11-0.347,0.216-0.695,0.319-1.046 c0.103-0.35,0.198-0.691,0.285-1.021c0.087-0.33,0.166-0.624,0.237-0.881L477.629,142.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M482.284,152.217l0-7.756l4.517,2.619v1.466l-3.011-1.746v1.522l2.673,1.55l0,1.433l-2.673-1.55 v1.869l3.233,1.875v1.466L482.284,152.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M490.361,157.001c-0.367-0.212-0.732-0.438-1.095-0.674c-0.364-0.237-0.742-0.517-1.134-0.842 l0-7.52c0.309,0.112,0.647,0.257,1.013,0.436c0.367,0.179,0.708,0.36,1.023,0.543c0.425,0.246,0.815,0.508,1.173,0.786 c0.357,0.278,0.664,0.577,0.922,0.898c0.257,0.321,0.458,0.663,0.603,1.027c0.145,0.364,0.217,0.751,0.217,1.161 c0,0.619-0.258,0.959-0.772,1.018c0.425,0.433,0.715,0.854,0.868,1.264c0.154,0.411,0.232,0.817,0.232,1.22 c0,0.813-0.256,1.277-0.767,1.39C492.132,157.823,491.371,157.587,490.361,157.001z M489.599,153.079l0,2.003 c0.11,0.078,0.229,0.159,0.357,0.241c0.129,0.082,0.27,0.168,0.424,0.257c0.451,0.261,0.814,0.397,1.091,0.409 c0.277,0.011,0.415-0.185,0.415-0.588c0-0.358-0.116-0.681-0.347-0.968c-0.232-0.287-0.563-0.556-0.994-0.806L489.599,153.079z  M489.599,151.747l0.734,0.425c0.463,0.269,0.795,0.392,0.994,0.369c0.199-0.022,0.299-0.186,0.299-0.493 c0-0.313-0.103-0.593-0.309-0.839c-0.206-0.246-0.508-0.485-0.908-0.716c-0.129-0.075-0.267-0.153-0.415-0.235 c-0.148-0.082-0.28-0.149-0.396-0.201V151.747z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "519.091,125.913 521.12,124.729 521.19,99.989 519.161,101.173  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "519.161,101.173 521.19,99.989 499.256,87.285 497.227,88.469  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DDE3F4"
    },
    points: "497.227,88.469 497.157,113.209 519.091,125.913 519.161,101.173  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M506.998,102.009l2.26,1.31l0.635-3.471l2.532,1.468l-0.635,3.471l1.414,0.82v2.597l-1.844-1.069 l-0.46,2.512l2.304,1.336v2.598l-2.734-1.585l-0.635,3.471l-2.532-1.468l0.635-3.471l-2.259-1.31l-0.636,3.471l-2.532-1.468 l0.635-3.471l-1.415-0.82v-2.598l1.845,1.07l0.459-2.512l-2.304-1.336v-2.597l2.735,1.585l0.635-3.471l2.532,1.468 L506.998,102.009z M506.108,106.869l2.26,1.31l0.459-2.511l-2.259-1.31L506.108,106.869z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCC5DF"
    },
    points: "478.597,119.426 480.626,118.242 480.696,98.348 478.667,99.532  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "478.667,99.532 480.696,98.348 410.782,57.813 408.753,58.997  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DDE3F4"
    },
    points: "408.753,58.997 408.683,78.891 478.597,119.426 478.667,99.532  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M421.981,81.94c-0.092-0.384-0.19-0.782-0.295-1.192c-0.105-0.41-0.21-0.819-0.315-1.225 l-3.211-1.862c-0.104,0.287-0.208,0.576-0.312,0.865c-0.104,0.289-0.201,0.572-0.291,0.849l-1.922-1.114 c0.309-0.848,0.603-1.627,0.88-2.337c0.278-0.71,0.55-1.374,0.815-1.99c0.266-0.616,0.528-1.196,0.786-1.739 c0.258-0.543,0.526-1.064,0.803-1.563l1.754,1.017c0.27,0.817,0.536,1.648,0.798,2.492c0.262,0.844,0.527,1.729,0.793,2.654 c0.266,0.924,0.538,1.903,0.817,2.936c0.278,1.033,0.572,2.152,0.882,3.359L421.981,81.94z M419.758,73.277 c-0.042,0.114-0.102,0.268-0.181,0.46c-0.08,0.192-0.17,0.415-0.272,0.669c-0.102,0.253-0.215,0.532-0.341,0.834 c-0.126,0.303-0.253,0.623-0.383,0.96l2.351,1.363c-0.125-0.486-0.247-0.952-0.365-1.397s-0.23-0.855-0.336-1.229 c-0.106-0.374-0.199-0.703-0.279-0.987C419.872,73.665,419.807,73.441,419.758,73.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M430.536,86.9c-0.53-1.399-1.104-2.809-1.72-4.23c-0.617-1.422-1.273-2.807-1.97-4.155v6.245 l-1.827-1.059v-9.534l1.507,0.874c0.261,0.454,0.55,0.993,0.866,1.616c0.316,0.624,0.638,1.281,0.967,1.971 c0.328,0.69,0.654,1.398,0.979,2.122c0.324,0.725,0.629,1.417,0.914,2.077v-5.627l1.839,1.066v9.534L430.536,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M439.504,92.099c-0.091-0.384-0.189-0.782-0.295-1.192c-0.106-0.41-0.21-0.819-0.315-1.225 l-3.211-1.862c-0.104,0.288-0.208,0.576-0.312,0.865c-0.104,0.289-0.201,0.572-0.291,0.849l-1.922-1.114 c0.309-0.848,0.603-1.627,0.88-2.337c0.278-0.71,0.549-1.374,0.815-1.99c0.266-0.617,0.527-1.196,0.785-1.739 c0.258-0.543,0.526-1.064,0.803-1.563l1.754,1.017c0.27,0.817,0.537,1.648,0.799,2.492c0.262,0.844,0.526,1.729,0.793,2.654 c0.266,0.925,0.538,1.904,0.816,2.936c0.278,1.033,0.572,2.152,0.882,3.359L439.504,92.099z M437.281,83.436 c-0.041,0.114-0.102,0.268-0.181,0.46c-0.08,0.192-0.17,0.415-0.272,0.668c-0.101,0.254-0.215,0.532-0.341,0.834 c-0.125,0.303-0.253,0.623-0.383,0.96l2.351,1.363c-0.126-0.486-0.247-0.952-0.366-1.397c-0.118-0.445-0.23-0.855-0.336-1.229 c-0.106-0.374-0.199-0.703-0.28-0.987C437.395,83.824,437.33,83.6,437.281,83.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M448.035,95.201v1.843l-5.493-3.185v-9.534l1.851,1.073v7.69L448.035,95.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M451.046,93.167c0.332-0.457,0.649-0.922,0.95-1.397c0.301-0.475,0.578-0.968,0.832-1.48 l2.041,1.183c-0.451,0.766-0.918,1.49-1.4,2.173c-0.483,0.683-0.992,1.355-1.531,2.015v3.646l-1.851-1.073v-3.618 c-0.538-1.284-1.05-2.553-1.536-3.807c-0.487-1.254-0.955-2.525-1.406-3.814l2.148,1.245c0.253,0.805,0.525,1.617,0.817,2.436 C450.402,91.495,450.714,92.326,451.046,93.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M458.001,101.186c0.261,0.151,0.477,0.251,0.646,0.299c0.17,0.048,0.307,0.059,0.41,0.031 c0.103-0.027,0.174-0.09,0.214-0.186c0.039-0.096,0.059-0.218,0.059-0.365c0-0.312-0.126-0.644-0.38-0.997 c-0.253-0.353-0.688-0.827-1.305-1.424c-0.269-0.266-0.538-0.548-0.807-0.846c-0.269-0.298-0.51-0.617-0.724-0.956 c-0.214-0.339-0.388-0.701-0.522-1.087c-0.135-0.385-0.202-0.798-0.202-1.238c0-0.44,0.071-0.796,0.214-1.066 c0.142-0.27,0.344-0.454,0.605-0.55c0.261-0.097,0.577-0.103,0.949-0.021c0.372,0.083,0.791,0.259,1.258,0.529 c0.554,0.321,1.032,0.668,1.435,1.039c0.404,0.371,0.736,0.715,0.997,1.032l-0.534,1.382c-0.229-0.271-0.484-0.54-0.765-0.808 c-0.281-0.268-0.619-0.517-1.014-0.746c-0.443-0.257-0.762-0.37-0.955-0.341c-0.194,0.03-0.291,0.192-0.291,0.485 c0,0.174,0.035,0.341,0.106,0.502c0.071,0.16,0.172,0.326,0.303,0.499c0.131,0.172,0.281,0.346,0.451,0.523 s0.358,0.366,0.564,0.567c0.427,0.431,0.799,0.828,1.115,1.19c0.316,0.362,0.579,0.723,0.789,1.083 c0.209,0.36,0.366,0.73,0.469,1.111c0.103,0.381,0.154,0.8,0.154,1.259c0,0.89-0.269,1.424-0.807,1.603 c-0.538,0.179-1.349-0.046-2.432-0.674c-0.364-0.211-0.692-0.427-0.985-0.647c-0.293-0.22-0.552-0.432-0.777-0.636 c-0.225-0.204-0.419-0.394-0.581-0.571c-0.162-0.176-0.298-0.333-0.409-0.471l0.522-1.403c0.245,0.298,0.548,0.613,0.908,0.946 C457.038,100.566,457.479,100.883,458.001,101.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M462.663,95.992l1.851,1.073v9.534l-1.851-1.073V95.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M468.654,107.362c0.261,0.151,0.476,0.251,0.646,0.299c0.17,0.048,0.306,0.058,0.409,0.031 c0.103-0.028,0.174-0.089,0.214-0.186c0.04-0.096,0.059-0.218,0.059-0.365c0-0.312-0.126-0.645-0.38-0.997 c-0.253-0.353-0.688-0.828-1.305-1.424c-0.269-0.266-0.538-0.548-0.807-0.846c-0.269-0.298-0.51-0.617-0.724-0.956 c-0.213-0.339-0.387-0.702-0.522-1.087c-0.135-0.385-0.202-0.798-0.202-1.238c0-0.44,0.071-0.796,0.214-1.066 c0.143-0.27,0.344-0.454,0.605-0.55c0.261-0.096,0.577-0.103,0.949-0.021c0.372,0.083,0.791,0.259,1.258,0.53 c0.554,0.321,1.032,0.667,1.436,1.039c0.403,0.371,0.735,0.715,0.996,1.032l-0.534,1.383c-0.229-0.271-0.484-0.54-0.765-0.808 c-0.281-0.268-0.619-0.517-1.014-0.746c-0.443-0.257-0.762-0.37-0.955-0.34c-0.194,0.03-0.291,0.191-0.291,0.485 c0,0.174,0.036,0.342,0.107,0.502c0.071,0.16,0.172,0.327,0.302,0.498c0.13,0.172,0.281,0.347,0.451,0.523 c0.17,0.177,0.358,0.366,0.564,0.567c0.427,0.432,0.799,0.828,1.115,1.19c0.316,0.362,0.579,0.724,0.789,1.083 c0.21,0.36,0.366,0.73,0.469,1.111c0.103,0.381,0.154,0.801,0.154,1.259c0,0.89-0.269,1.424-0.807,1.603 c-0.538,0.179-1.348-0.046-2.432-0.674c-0.364-0.211-0.692-0.426-0.985-0.646c-0.293-0.22-0.552-0.432-0.777-0.636 c-0.226-0.204-0.419-0.395-0.581-0.571c-0.163-0.177-0.299-0.334-0.41-0.471l0.522-1.403c0.245,0.298,0.547,0.613,0.908,0.946 C467.691,106.742,468.132,107.06,468.654,107.362z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#BCC5DF"
    },
    d: "M456.627,270.151c-6.323,3.651-6.323,9.57,0,13.22c6.323,3.651,16.575,3.651,22.898,0 c6.323-3.651,6.323-9.57,0-13.22C473.202,266.5,462.95,266.5,456.627,270.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#BCC5DF"
    },
    d: "M417.701,277.371c-6.323,3.651-6.323,9.57,0,13.22c6.323,3.651,16.575,3.651,22.898,0 c6.323-3.65,6.323-9.57,0-13.22C434.276,273.72,424.024,273.72,417.701,277.371z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "woman_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M471.041,273.498c-0.004,0.179-0.219,0.459-0.296,0.615c-0.153,0.309-0.345,0.618-0.479,0.931 c-0.173,0.403-0.239,0.892-0.352,1.316c-0.232,0.868-0.463,1.735-0.695,2.603c-0.092,0.346-0.185,0.694-0.204,1.052 c-0.02,0.357,0.039,0.728,0.229,1.031c0.346,0.551,1.035,0.76,1.667,0.913c0.371,0.089,0.777,0.17,1.12,0.003 c0.271-0.132,0.45-0.395,0.604-0.653c0.704-1.177,1.037-2.455,1.402-3.759c0.193-0.691,0.354-1.406,0.285-2.12 c-0.038-0.396-0.154-0.791-0.357-1.135c-0.106-0.179-0.235-0.346-0.389-0.487c-0.151-0.139-0.298-0.198-0.4-0.382 c-0.19-0.346-0.328-0.769-0.625-1.048c-0.253-0.239-0.718-0.21-1.013-0.062c-0.329,0.165-0.565,0.483-0.686,0.831 c0.006,0.112,0.173,0.213,0.186,0.324C471.041,273.479,471.041,273.489,471.041,273.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M463.03,274.209c0.178-0.471,0.458-0.898,0.778-1.284c0.411-0.495,0.889-0.928,1.35-1.377 c0.608-0.593,1.188-1.216,1.736-1.864c0.036-0.043,0.074-0.083,0.111-0.124h3.656c0.1,0.28,0.193,0.56,0.213,0.855 c0.034,0.518-0.142,1.054-0.506,1.429c-0.409,0.424-0.991,0.626-1.492,0.937c-0.63,0.392-1.071,0.94-1.422,1.584 c-0.328,0.601-0.912,1.193-1.494,1.552c-0.388,0.24-0.854,0.394-1.301,0.305c-0.464-0.092-0.839-0.427-1.17-0.765 c-0.174-0.177-0.349-0.368-0.462-0.592C462.903,274.611,462.932,274.469,463.03,274.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M461.459,247.785c-0.222,2.562-0.086,5.105,0.027,7.667c0.053,1.19-0.4,4.146,1.669,3.948 c1.013-0.097,2.981-1.524,3.485-3.612c0.271-1.125,0.48-2.756,0.732-3.886c0.521-2.337,4.077-9.541-0.487-11.799 c-0.685-0.339-2.54-2.37-3.238-1.968C461.655,239.283,461.663,245.441,461.459,247.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M461.647,258.305c0.428,0.996,1.036,1.684,1.678,2.838c1.227,2.204,2.402,4.021,3.08,6.456 c0.155,0.556,0.304,1.114,0.457,1.67c0.183,0.666,0.454,1.416,1.144,1.639c0.356,0.115,0.764,0.058,1.126-0.081 c0.551-0.211,1.004-0.607,1.3-1.091c0.367-0.601,0.086-1.048-0.134-1.634c-0.661-1.768-0.323-3.772-0.634-5.64 c-0.157-0.939-0.477-1.838-0.796-2.732c-0.628-1.762-1.583-3.158-2.909-4.499c-0.32-0.324-0.738-0.651-1.219-0.569 L461.647,258.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M475.8,243.228c-0.156-1.818-0.778-3.657-2.068-4.949l0.058,1.581 c-0.091-0.357-0.197-0.71-0.325-1.056c-0.06-0.163-0.121-0.283-0.186-0.37c-0.264-0.356-0.587-0.147-1.172-0.014 c-0.706,0.161-1.441,0.118-2.155,0.22c-2.265,0.324-2.436,0.807-3.939-0.391c-0.283,1.879,0.111,3.642,0.102,4.059 c-0.051,2.151,1.613,2.327,1.687,3.462c0.172,2.628,0.493,7.82,0.845,10.425c0.137,1.013,0.681,2.032,1.139,2.901 c0.534,1.013,1.07,1.578,2.058,1.468c0.448-0.05,1.219-0.558,1.466-0.937c0.159-0.243,0.194-0.724,0.284-1.01 c0.262-0.827,0.483-1.666,0.665-2.514c0.038-0.176,0.072-0.354,0.107-0.532l0,0.007c0.004-0.02,0.006-0.04,0.01-0.06 c0.446-2.257,0.697-4.57,1.036-6.843C475.685,246.872,475.955,245.047,475.8,243.228z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "people_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M465.941,223.879c1.525-2.746,1.134-5.667-0.141-6.026c-2.183-0.615-2.957,0.977-4.736,5.615 c-0.039,0.102-0.079,0.204-0.119,0.306c-0.443,1.125-0.881,2.252-1.223,3.412c-0.192,0.651-0.357,1.313-0.454,1.986 c-0.022,0.155-0.042,0.311-0.054,0.466c-0.012,0.161,0.044,0.314,0.074,0.473c0.075,0.404,0.168,0.809,0.354,1.178 c0.23,0.458,0.624,0.86,1.124,0.972c0.571,0.128,1.174-0.149,1.578-0.573c0.404-0.423,0.644-0.974,0.856-1.52 c0.236-0.605,0.446-1.22,0.647-1.839c0.135-0.418,0.264-0.838,0.396-1.257c0.104-0.332,0.335-0.66,0.499-0.971 C465.133,225.357,465.533,224.615,465.941,223.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1582D6"
    },
    d: "M465.941,223.879c1.525-2.746,1.134-5.667-0.141-6.026c-2.183-0.615-2.957,0.977-4.736,5.615 c-0.039,0.102-0.079,0.204-0.119,0.306c-0.443,1.125-0.881,2.252-1.223,3.412c-0.192,0.651-0.357,1.313-0.454,1.986 c-0.022,0.155-0.042,0.311-0.054,0.466c-0.012,0.161,0.044,0.314,0.074,0.473c0.075,0.404,0.168,0.809,0.354,1.178 c0.23,0.458,0.624,0.86,1.124,0.972c0.571,0.128,1.174-0.149,1.578-0.573c0.404-0.423,0.644-0.974,0.856-1.52 c0.236-0.605,0.446-1.22,0.647-1.839c0.135-0.418,0.264-0.838,0.396-1.257c0.104-0.332,0.335-0.66,0.499-0.971 C465.133,225.357,465.533,224.615,465.941,223.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B09061"
    },
    d: "M479.126,210.943c0.193,1.29,0.031,2.501,0.059,3.798c0.029,1.381,0.167,2.762,0.454,4.114 c0.258,1.213,0.634,2.405,0.768,3.638c0.134,1.233,0.001,2.547-0.684,3.581c-0.175,0.264-0.39,0.511-0.667,0.664 c-0.369,0.204-0.816,0.222-1.231,0.151c-1.287-0.222-2.328-1.263-2.823-2.471c-0.495-1.208-0.514-2.562-0.356-3.858 c0.158-1.297,0.483-2.567,0.652-3.862c0.206-1.574,0.052-3.056-0.055-4.624c-0.034-0.501,0.035-0.816-0.335-1.209 c-0.398-0.421-0.981-0.701-1.549-0.79c-0.527-0.083-1.084-0.019-1.579-0.217c-0.67-0.267-1.099-1.035-0.975-1.745 c0.088-0.505,0.413-0.934,0.76-1.31c0.765-0.83,1.759-1.535,2.884-1.608c1.144-0.075,2.26,0.533,3.005,1.405 c0.745,0.871,1.164,1.977,1.43,3.093C478.983,210.101,479.063,210.52,479.126,210.943z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M473.703,217.915c-1.06-0.482-1.445-0.746-2.559-0.997c-0.181-0.041-0.787,0.188-0.968,0.149 c-1.353-0.286-2.794-0.222-4.049,0.33c-0.014,0.006-0.027,0.013-0.042,0.02v8.306h7.96L473.703,217.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M477.585,221.834c0.019-0.157,0.007-0.324-0.053-0.519c-0.519-1.697-2.431-2.555-3.829-3.4 c0.096,0.058-0.237,1.061-0.277,1.179c-0.129,0.375-0.298,0.738-0.522,1.066c-0.951,1.396-2.555,1.809-4.088,1.151 c-1.973-0.847-0.954-2.318-1.698-3.662c-0.142-0.257-0.412-0.381-0.699-0.402c-0.52-0.039-1.047,0.104-1.329,0.557 c-0.214,0.344-0.333,0.755-0.484,1.129c-0.243,0.602-0.514,1.193-0.803,1.775c-0.411,0.826-0.864,1.635-1.191,2.498 c-0.324,0.857-0.623,1.888-0.591,2.815c0.039,1.096,1.295,5.24,1.301,7.916c0.004,1.815-0.881,3.644-0.6,5.45 c0.025,0.163,0.062,0.324,0.112,0.48c0.241,0.764,0.787,1.406,1.431,1.882c0.644,0.477,1.385,0.803,2.133,1.092 c1.518,0.587,3.087,1.036,4.673,1.404c1.395,0.323,3.582,0.53,4.619-0.729c0.358-0.434,0.506-1.012,0.511-1.574 c0.004-0.562-0.124-1.117-0.267-1.661c-0.402-1.529-1.073-2.965-1.479-4.49c-0.486-1.827-0.892-3.734-0.397-5.611 c0.209-0.794,0.546-1.548,0.882-2.297c0.515-1.15,1.03-2.299,1.545-3.449c0.252-0.562,0.503-1.124,0.755-1.686 C477.395,222.402,477.548,222.137,477.585,221.834z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M473.283,218.273c0.087,2.935-5.035,2.985-4.961,0.225c0.102-3.846,0.32-4.288,2.006-4.885 c0.462-0.163,0.945-0.289,1.433-0.298c1.78-0.035,1.09,0.936,1.023,1.614C472.586,216.939,473.251,217.217,473.283,218.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9C76"
    },
    d: "M470.328,213.613c0.462-0.163,0.945-0.289,1.433-0.298c1.78-0.035,1.09,0.936,1.023,1.614 c-0.054,0.552-0.042,0.971,0.003,1.315c-1.098,1.466-2.693,2.45-4.4,2.809c-0.045-0.171-0.07-0.354-0.065-0.555 C468.424,214.652,468.642,214.21,470.328,213.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M470.916,216.774c0.151-0.127,0.299-0.257,0.444-0.391c0.5-0.466,1.068-1.007,1.415-1.596 c1.115-1.893,1.169-4.428-0.419-6.077c-1.127-1.169-2.916-1.652-4.478-1.208c-0.423,0.12-0.826,0.301-1.217,0.503 c-0.338,0.173-0.673,0.367-0.93,0.647c-0.169,0.183-0.299,0.399-0.418,0.618c-0.134,0.247-0.257,0.502-0.324,0.775 c-0.304,1.225,0.511,2.477,0.045,3.685c-0.102,0.264-0.255,0.508-0.348,0.775c-0.093,0.267-0.12,0.576,0.027,0.815 c0.139,0.227,0.323,0.342,0.405,0.594c0.111,0.341,0.187,0.704,0.284,1.051c0.106,0.379,0.213,0.762,0.405,1.105 c0.469,0.84,1.147,0.892,1.986,0.563C468.927,218.185,469.985,217.553,470.916,216.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6AF75"
    },
    d: "M474.679,211.023c-0.084-2.385-0.786-2.789-1.692-3.548c-0.878-0.737-2.061-1.069-3.201-1.034 c-1.166,0.035-2.305,0.435-3.29,1.049c-0.04,0.025-0.079,0.049-0.118,0.075c-0.51,0.332-0.962,0.712-1.233,1.267 c-0.143,0.293-0.253,0.612-0.307,0.934c-0.101,0.608,0.427,0.864,0.96,1.031c0.716,0.224,1.731-0.082,2.463-0.161 c0.342-0.037,0.694-0.074,1.028,0.014c0.333,0.087,0.65,0.326,0.727,0.662c0.08,0.351-0.109,0.698-0.188,1.049 c-0.156,0.694,0.195,1.449,0.779,1.836c0.346,0.23,0.589,0.247,0.96,0.078c0.333-0.152,0.674-0.41,1.041-0.183 c0.339,0.21,0.212,0.652,0.132,0.971c-0.016,0.06-0.146,0.512,0.04,0.514C472.967,215.577,474.78,213.889,474.679,211.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B09061"
    },
    d: "M470.017,211.311c0.08,0.351-0.109,0.698-0.188,1.049c-0.156,0.694,0.195,1.449,0.779,1.836 c0.346,0.23,0.589,0.247,0.96,0.078c0.333-0.152,0.674-0.41,1.041-0.183c0.339,0.21,0.212,0.652,0.132,0.971 c-0.016,0.06-0.146,0.512,0.04,0.514c0.187,0.002,2-1.687,1.899-4.553c-0.049-1.397-0.31-2.115-0.701-2.622 c0,0-1.088,0.42-2.058,1.107C471.014,210.15,470.017,211.311,470.017,211.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M472.408,213.197c0.813-0.055,1.02,0.955,0.462,1.735c-0.163,0.228-0.451,0.43-0.664,0.611 c-1.457,1.241-1.823-0.102-1.36-0.524C471.92,214.037,471.385,213.266,472.408,213.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M471.888,215.047c0.094-0.086,1.021-0.633,0.389-1.005c-0.174-0.103-0.369,0.05-0.396,0.235 c-0.014,0.096,0.016,0.195,0.002,0.29c-0.008,0.057-0.032,0.11-0.063,0.159c-0.082,0.134-0.363,0.263-0.308,0.459 C471.561,215.359,471.835,215.096,471.888,215.047z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M480.131,222.446c-1.667-2.663-4.413-3.731-5.344-2.789c-1.594,1.614-0.772,3.375,2.429,7.173 c0.779,0.924,3.391,4.117,5.223,5.28c1.188,0.755,2.688,0.286,2.819-0.213C485.694,230.237,483.411,227.685,480.131,222.446z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE23"
    },
    d: "M468.675,255.335c0.194,2.613,1.253,4.505,1.692,7.085c0.461,2.705,0.628,5.341,0.495,8.089 c-0.028,0.574-0.042,1.152-0.091,1.724c-0.039,0.461-0.144,1.076,0.022,1.52c0.167,0.448,0.64,0.702,1.098,0.841 c0.337,0.103,0.692,0.166,1.043,0.133c0.329-0.031,0.662-0.155,0.914-0.373c0.241-0.209,0.302-0.566,0.365-0.872 c0.131-0.637,0.076-1.265,0.156-1.899c0.067-0.533,0.207-1.091,0.335-1.616c0.292-1.197,0.705-2.367,0.886-3.589 c0.151-1.022,0.134-2.061,0.118-3.095c-0.034-2.037-0.727-4.832-1.557-6.684c-0.201-0.447-0.258,0.086-0.74-0.001 L468.675,255.335z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M474.453,237.985c-0.056-0.7,8.356-10.688,10.413-7.713c0.313,0.453,0.543,1.366,0.272,1.891 c-0.337,0.652-5.889,4.027-8.471,6.404c-0.274,0.252-0.36,0.19-0.723,0.139C475.361,238.623,474.496,238.527,474.453,237.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M480.131,222.446c-1.667-2.663-4.413-3.731-5.344-2.789c-1.594,1.614-0.772,3.375,2.429,7.173 c0.779,0.924,3.391,4.117,5.223,5.28c1.188,0.755,2.688,0.286,2.819-0.213C485.694,230.237,483.411,227.685,480.131,222.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M474.099,242.896c0.033,0.117,0.09,0.232,0.197,0.268c0.154,0.051,0.315-0.12,0.389-0.236 c0.125-0.193,0.167-0.431,0.175-0.658c0.011-0.298-0.031-0.599,0.006-0.896c0.01-0.082,0.029-0.167,0.081-0.232 c0.052-0.065,0.147-0.102,0.221-0.065c0.137,0.068,0.147,0.348,0.175,0.478c0.044,0.209,0.072,0.42,0.085,0.633 c0.025,0.415-0.01,0.834-0.106,1.239c-0.053,0.224-0.124,0.449-0.108,0.679c0.018,0.252,0.142,0.46,0.321,0.63 c0.109,0.103,0.127,0.091,0.255,0.002c0.105-0.074,0.205-0.156,0.299-0.243c0.385-0.357,0.673-0.813,0.856-1.304 c0.24-0.644,0.305-1.345,0.255-2.031c-0.047-0.639-0.191-1.268-0.348-1.889c-0.08-0.316-0.164-0.631-0.251-0.946 c-0.067-0.241-0.103-0.608-0.255-0.809c-0.294-0.392-0.821-0.513-1.262-0.325c-0.089,0.038-0.173,0.085-0.251,0.142 c-0.299,0.218-0.444,0.56-0.507,0.915c-0.031,0.179-0.095,1.032-0.135,1.286c-0.164,1.044-0.265,2.11-0.13,3.163 C474.069,242.755,474.079,242.826,474.099,242.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M452.212,231.858c-0.247-0.053-0.475-0.169-0.717-0.24c-0.325-0.095-0.669-0.106-1.008-0.116 c-0.967-0.029-1.934-0.058-2.901-0.087c-0.159-0.005-0.358,0.016-0.413,0.164c-0.024,0.065-0.011,0.139,0.016,0.204 c0.082,0.2,0.281,0.331,0.487,0.392c0.207,0.062,0.426,0.066,0.64,0.083c0.358,0.029,0.713,0.097,1.057,0.203 c0.031,0.009,0.064,0.021,0.081,0.048c0.033,0.05-0.008,0.115-0.049,0.16c-0.187,0.201-0.413,0.362-0.654,0.492 c-0.125,0.068-0.254,0.127-0.386,0.181c-0.121,0.049-0.221,0.132-0.342,0.17c-0.661,0.211-1.364,0.306-1.981,0.622 c-0.206,0.106-0.471,0.425-0.102,0.524c0.304,0.082,0.626-0.001,0.932-0.074c0.373-0.089,0.75-0.162,1.129-0.22 c0.089-0.013,0.182-0.02,0.27-0.041c0.041-0.01,0.108-0.053,0.152-0.038c0.245,0.084-0.3,0.412-0.363,0.457 c-0.249,0.183-0.499,0.365-0.748,0.548c-0.281,0.206-0.583,0.443-0.65,0.785c-0.022,0.111-0.028,0.206,0.073,0.257 c0.076,0.038,0.21,0.035,0.292,0.018c0.181-0.038,0.329-0.164,0.473-0.28c0.352-0.285,0.728-0.542,1.121-0.767 c0.183-0.105,0.389-0.235,0.588-0.305c0.26-0.092,0.163,0.162,0.042,0.275c-0.267,0.249-0.548,0.493-0.753,0.797 c-0.085,0.127-0.204,0.309-0.232,0.46c-0.035,0.188,0.168,0.248,0.316,0.2c0.147-0.047,0.266-0.157,0.378-0.264 c0.272-0.258,0.545-0.516,0.817-0.774c0.112-0.106,0.235-0.272,0.372-0.344c0.103-0.053,0.222-0.043,0.202,0.099 c-0.026,0.191-0.155,0.351-0.231,0.529c-0.053,0.124-0.08,0.258-0.079,0.393c0,0.062,0.016,0.137,0.074,0.158 c0.047,0.017,0.097-0.01,0.138-0.038c0.227-0.149,0.452-0.329,0.588-0.568c0.146-0.256,0.381-0.494,0.574-0.716 c0.397-0.456,0.849-0.879,1.399-1.143c0.332-0.159,0.691-0.257,1.012-0.436c0.077-0.043,0.155-0.094,0.193-0.174 c0.044-0.091,0.026-0.2,0-0.298c-0.085-0.323-0.244-0.626-0.455-0.884c-0.155-0.189-0.462-0.572-0.734-0.479 C452.62,231.865,452.439,231.907,452.212,231.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13B7FD"
    },
    d: "M474.453,237.985c-0.056-0.7,8.356-10.688,10.413-7.713c0.313,0.453,0.543,1.366,0.272,1.891 c-0.337,0.652-5.889,4.027-8.471,6.404c-0.274,0.252-0.36,0.19-0.723,0.139C475.361,238.623,474.496,238.527,474.453,237.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1582D6"
    },
    d: "M462.309,230.244c0.109,0.54-0.04,1.469-0.497,1.844c-0.43,0.354-5.074,0.937-8.343,1.719 c-0.369-0.686-0.571-1.373-0.606-2.059C456.444,230.114,461.851,227.97,462.309,230.244z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "man_7_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118367768229898614530000006240083411271925406_",
    style: {
      enableBackground: "new"
    },
    d: " M425.769,212.585l-2.288,1.33c0.162-0.094,0.386-0.081,0.632,0.061l2.288-1.33 C426.155,212.503,425.931,212.491,425.769,212.585z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056414064143859626080000002898849009400243595_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118367768229898614530000006240083411271925406_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056414064143859626080000002898849009400243595_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F89A6"
    },
    d: "M424.113,213.975l2.288-1.33c-0.246-0.142-0.47-0.155-0.632-0.061l-2.288,1.33 C423.642,213.82,423.867,213.833,424.113,213.975L424.113,213.975z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "man_76_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_78_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F1317"
    },
    d: "M421.212,281.913c0.076-0.21,0.215-0.32,0.602-0.337c0.458-0.021,0.917-0.025,1.376-0.038 c0.621-0.017,1.241-0.034,1.861-0.051c-0.014-0.503-0.01-1.012-0.047-1.512c0.653,0.164,1.026-0.015,1.664-0.225 c0.752-0.248,1.513-0.469,2.281-0.662c0.328-0.083,0.672-0.16,1-0.081c0.83,0.2,1.237,1.594,1.099,2.312 c-0.098,0.508-0.459,0.931-0.877,1.237c-0.627,0.459-1.499,0.82-2.271,0.907c-0.827,0.094-1.592,0.323-2.273,0.818 c-0.882,0.64-1.518,1.327-2.657,1.367c-1.144,0.041-2.065-0.686-2.067-1.866c0-0.423,0.089-0.84,0.178-1.254 C421.137,282.267,421.158,282.064,421.212,281.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C232A"
    },
    d: "M425.776,284.169c0.001-0.09-0.001-0.18-0.007-0.271c-0.061-0.928,0.297-1.712,0.635-2.57 c0.126-0.32,0.263-0.656,0.533-0.87c0.613-0.488,1.585-0.06,1.974,0.62c0.18,0.315,0.279,0.671,0.441,0.996 c0.307,0.617,0.926,1.354,1.671,1.388c1.001,0.045,2.127-0.3,3.141-0.361c0.395-0.024,0.805-0.037,1.172,0.111 c0.865,0.35,1.115,1.745,0.806,2.525c-0.191,0.481-0.625,0.83-1.092,1.052c-0.701,0.334-1.625,0.526-2.399,0.469 c-0.83-0.062-1.624,0.021-2.386,0.38c-1.307,0.617-2.827,1.504-4.147,0.302c-0.352-0.321-0.525-0.803-0.566-1.278 C425.479,285.82,425.765,285.005,425.776,284.169z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4CB3"
    },
    d: "M426.185,264.93l0.468-1.964C426.466,263.614,426.312,264.27,426.185,264.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F4961"
    },
    d: "M418.93,246.357c0.225-1.167-0.087-3.38,1.588-3.557c1.515-0.16,2.342,1.703,2.746,2.142 c0.606,0.658,3.023-0.427,3.067-0.737c2.903-2.087,2.253,6.643,1.317,10.088c-0.502,1.857-0.458,3.811-0.786,5.703 c-0.346,1.997-0.835,3.969-1.457,5.898c-0.277,1.683-0.406,3.395-0.465,5.101c-0.102,2.943-0.003,5.891-0.131,8.833 c-0.027,0.626-0.066,1.262-0.264,1.857c-0.111,0.334-0.276,0.684-0.516,0.946c-0.21,0.231-0.541,0.339-0.844,0.373 c-0.285,0.031-0.574,0.001-0.858-0.046c-0.289-0.048-0.582-0.116-0.825-0.277c-0.49-0.325-0.667-0.919-0.806-1.455 c-0.173-0.667-0.332-1.338-0.474-2.012c-0.372-1.762-0.633-3.547-0.78-5.342c-0.143-1.758-0.178-3.523-0.126-5.286 c0.026-0.901,0.074-1.801,0.139-2.7c0.033-0.459,0.071-0.919,0.113-1.377c0.021-0.233,0.043-0.465,0.066-0.697 c0.008-0.083,0.119-0.635,0.07-0.676c0.006,0.005,0.012,0.01,0.019,0.015c-0.005-0.69-0.044-1.378-0.156-2.051 c-0.235-1.417-0.469-2.833-0.704-4.249c-0.205-1.239-0.41-2.481-0.489-3.734C418.229,250.85,418.501,248.579,418.93,246.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546282"
    },
    d: "M427.391,246.348c0.271-0.14,1.66-0.837,1.648-1.214c-0.008-0.253,0.676-0.464,0.853-0.461 c0.319,0.006,0.64,0.211,0.896,0.395c0.633,0.453,1.101,1.149,1.388,1.894c0.395,1.023,0.491,2.146,0.552,3.251 c0.183,3.292,0.097,6.601-0.252,9.878c-0.177,1.655-0.42,3.302-0.73,4.935c-0.155,0.816-0.327,1.629-0.515,2.437 c-0.181,0.777-0.342,1.02-0.994,1.431c-1.4,0.881-3.922,0.764-4.924-0.821c-1.077-1.705-0.63-4.361-0.974-6.278 c-0.5-2.787-2.355-4.83-3.207-7.478c-0.626-1.943-0.54-3.776-0.213-5.758c0.155-0.936,0.445-3.176,1.398-3.723 c0.253-0.145,1.97-0.536,3.358,0.843C426.486,246.483,426.392,246.863,427.391,246.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E4CB3"
    },
    d: "M417.86,238.655c-0.062-0.491-0.134-0.98-0.22-1.468c-0.411-2.337-1.111-4.619-1.404-6.977 c-0.228-1.831-0.393-4.114,1.059-5.529c0.237-0.231,0.509-0.422,0.796-0.584c2.822-1.594,5.522,0.347,8.168,1.3 c1.737,0.626,3.404,1.447,4.96,2.442c0.542,0.347,1.096,0.584,1.461,1.123c0.386,0.571,0.593,1.189,0.633,1.88 c0.045,0.784-0.099,1.565-0.23,2.339c-0.761,4.509-1.096,9.119-0.551,13.659c0.174,1.452,0.24,2.922,0.32,4.381 c0.03,0.55,0.378,1.416,0.099,1.92c-0.291,0.528-1.362,0.971-1.879,1.233c-1.431,0.726-3.018,1.149-4.622,1.214 c-2.483,0.1-4.992-0.657-7.006-2.112c-0.865-0.626-1.507-1.325-1.451-2.399c0.07-1.347,0.028-2.71,0.06-4.062 C418.118,244.228,418.209,241.428,417.86,238.655z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E3E9E"
    },
    d: "M426.803,230.291c0.449-2.157,2.512-2.825,4.517-2.391c0.509,0.314,1.018,0.555,1.36,1.061 c0.386,0.571,0.593,1.189,0.633,1.88c0.045,0.784-0.099,1.565-0.23,2.339c-0.761,4.509-1.096,9.119-0.551,13.659 c0.174,1.452,0.24,2.922,0.32,4.381c0.03,0.55,0.378,1.416,0.099,1.92c-0.291,0.528-1.362,0.971-1.879,1.233 c-0.095,0.049-0.192,0.095-0.289,0.141c-0.037-0.645-0.102-1.294-0.203-1.947 C429.408,244.881,424.979,238.107,426.803,230.291z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCFB"
    },
    d: "M427.616,225.942c-0.479-0.205-0.991-0.414-1.356-0.546 c-1.838-0.662-3.701-1.799-5.614-1.899c-0.922,1.39-0.177,2.981,1.182,3.723c1.708,0.854,3.955,0.759,5.575-0.388 C427.726,226.604,427.97,226.215,427.616,225.942z"
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546282"
    },
    d: "M431.136,268.763c-0.123,1.427-0.236,2.855-0.335,4.284c-0.079,1.13-0.15,2.261-0.209,3.393 c-0.046,0.871-0.085,1.743-0.115,2.615c-0.165,4.773,0.339,5.847-1.911,6.465c-0.505,0.139-1.039,0.18-1.547,0.055 c-1.466-0.363-1.719-1.65-1.9-3.247c-0.102-0.897-0.147-1.979-0.177-2.886c-0.025-0.767-0.04-1.534-0.053-2.301 c-0.018-1.038-0.03-2.077-0.04-3.115c-0.013-1.369-0.024-2.739-0.034-4.109c-0.013-1.751-0.163-3.538-0.174-5.289 c-0.002-0.254,0.159-0.518,0.361-0.652c0.263-0.173,5.537,1.755,6.074,2.352C431.076,266.327,431.288,266.999,431.136,268.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M426.965,223.098c0.102-0.699,0.63-0.537,0.363-1.171c-0.227-0.538-0.571-1.034-1.033-1.391 c-0.462-0.357-1.046-0.569-1.629-0.537c-0.201,0.011-0.336,0.126-0.535,0.127c-0.551,0.002-1.104-0.103-1.653-0.023 c-0.546,0.079-1.052,0.119-1.052,0.736c0,0.822,0.038,1.614-0.225,2.423c-0.14,0.432-0.354,0.848-0.391,1.301 c-0.074,0.89,0.576,1.72,1.38,2.109c0.989,0.478,2.106,0.434,3.158,0.282c0.528-0.076,1.271-0.182,1.58-0.685 c0.234-0.379,0.133-0.876,0.084-1.29C426.937,224.35,426.872,223.73,426.965,223.098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M429.31,214.154c0.332,0.404,0.591,0.858,0.671,1.391c0.178,1.187-0.301,2.407-0.043,3.585 c0.25,1.141-0.24,3.733-2.49,4.397c-1.138,0.336-3.385-0.057-4.108-0.404c-0.97-0.465-1.61-1.404-2.184-2.315 C416.456,213.344,426.122,210.274,429.31,214.154z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6AF75"
    },
    d: "M419.014,217.462c0.031,0.221,0.062,0.442,0.105,0.661c0.032,0.166,0.07,0.33,0.122,0.491 c0.044,0.139,0.097,0.275,0.157,0.406c0.223,0.5,0.541,0.957,0.857,1.407c0.437,0.622,0.904,1.269,1.59,1.599 c0.296,0.143,0.62,0.219,0.941,0.29c0.889,0.197,2.202,0.238,2.884-0.499c0.304-0.327,0.427-0.791,0.482-1.225 c0.054-0.428,0.068-0.792,0.184-1.222c0.028-0.106,0.057-0.21,0.089-0.315c0.051-0.167,0.112-0.332,0.198-0.484 c0.141-0.246,0.354-0.463,0.626-0.546c0.465-0.142,1.024,0.122,1.429-0.147c0.209-0.139,0.315-0.384,0.409-0.614 c0.094-0.229,0.177-0.484,0.272-0.736c0.125-0.332,0.268-0.659,0.474-0.92c0.109-0.138,0.237-0.264,0.323-0.417 c0.12-0.21,0.257-0.406,0.267-0.645c0.045-1.094-0.856-2.173-1.611-2.87c-0.406-0.373-0.855-0.711-1.363-0.93 c-0.446-0.191-0.926-0.286-1.406-0.354c-1.421-0.205-2.942-0.171-4.196,0.527c-0.331,0.184-0.651,0.426-0.812,0.772 c-0.036,0.076-0.063,0.159-0.119,0.224c-0.072,0.086-0.183,0.132-0.286,0.181c-0.341,0.158-0.621,0.359-0.849,0.594 C418.631,213.87,418.796,215.888,419.014,217.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M426.739,217.514c-0.901-0.076-1.149,1.04-0.545,1.915c0.176,0.256,0.493,0.485,0.725,0.691 c1.593,1.404,2.025-0.079,1.519-0.556C427.264,218.454,427.873,217.609,426.739,217.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M426.982,219.22c-0.102-0.097-1.12-0.721-0.412-1.123c0.196-0.111,0.409,0.062,0.435,0.268 c0.013,0.107-0.022,0.216-0.008,0.322c0.008,0.063,0.034,0.123,0.066,0.178c0.089,0.15,0.398,0.298,0.333,0.515 C427.34,219.572,427.041,219.275,426.982,219.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M455.631,242.525c0.228-0.257,0.19-0.817-0.113-0.686c0.079-0.163,0.055-0.385-0.094-0.485 c-0.195-0.132-0.451-0.002-0.674,0.074c-0.306,0.104-0.636,0.1-0.959,0.094c-0.68-0.012-1.386-0.363-1.31-0.454 c0.191-0.227,0.479-0.404,0.771-0.354c0.169,0.029,0.322,0.132,0.493,0.146c0.142,0.012,0.28-0.039,0.413-0.091 c0.046-0.018,0.094-0.038,0.124-0.077c0.062-0.082,0.013-0.203-0.056-0.28c-0.109-0.12-0.258-0.194-0.404-0.266 c-0.357-0.175-0.741-0.354-1.135-0.303c-0.13,0.017-0.256,0.059-0.385,0.087c-0.141,0.031-0.285,0.045-0.422,0.09 c-0.177,0.058-1.209,0.462-1.565,0.71c-1.806,0.514-1.826,1.621-1.008,2.473c0.393,0.408,1.68,0.86,2.404,1.045 c0.022,0.006,0.04,0.016,0.063,0.021c0.04,0.009,0.087,0.018,0.132,0.027c0,0,0.005,0.001,0.007,0.002 c0.003,0.001,0.004,0.001,0.007,0.001c1.024,0.209,3.157,0.509,3.277-0.405c-0.055-0.038-0.109-0.076-0.164-0.115 C455.94,243.127,455.19,243.021,455.631,242.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8763CD"
    },
    d: "M450.505,242.072c0.047,0.393,0.013,1.165-0.362,1.44c-0.308,0.226-1.007,0.177-1.366,0.225 c-1.852,0.249-12.703,0.587-14.464-0.763c-0.912-0.699,0.271-3.118,1.951-3.875c1.798-0.811,10.443,0.771,12.322,1.182 c0.411,0.09,0.83,0.188,1.18,0.42C450.167,240.965,450.436,241.502,450.505,242.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8763CD"
    },
    d: "M434.035,230.486c-0.49-1.037-1.203-2.054-2.356-2.174c-0.477-0.05-0.956,0.084-1.399,0.268 c-1.165,0.484-2.219,1.209-2.801,2.359c-0.111,0.22-0.205,0.452-0.244,0.696c-0.142,0.898,0.421,1.521,0.871,2.208 c0.542,0.828,1.039,1.685,1.526,2.546c0.974,1.719,1.916,3.467,3.114,5.044c0.702,0.924,1.594,1.84,2.746,1.973 c0.777,0.09,1.589-0.222,2.106-0.81c1.253-1.424,0.744-2.655,0.652-2.874C435.373,232.794,433.964,230.336,434.035,230.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDE3F4"
    },
    d: "M473.598,188.636l-10.189,5.882c-1.284,0.742-2.326,2.545-2.326,4.029l0.001,2.636 c-0.421,1.513-1.899,6.845-1.994,7.338l3.257-4.212c0.44-0.569,0.947-1.029,1.465-1.327l9.787-5.65 c1.284-0.742,2.326-2.546,2.326-4.029l0-3.325C475.923,188.496,474.882,187.894,473.598,188.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDE3F4"
    },
    d: "M406.434,206.031l10.189-5.882c1.284-0.742,2.326-0.14,2.326,1.343v2.636 c0.42,1.027,1.898,4.653,1.994,5.037l-3.257-0.451c-0.44-0.061-0.947,0.065-1.465,0.364l-9.786,5.65 c-1.285,0.741-2.326,0.14-2.326-1.343l0-3.325C404.108,208.576,405.15,206.772,406.434,206.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDE3F4"
    },
    d: "M442.481,192.451l10.189,5.882c1.284,0.742,2.326,2.545,2.326,4.029v2.636 c0.42,1.513,1.898,6.845,1.993,7.338l-3.257-4.212c-0.44-0.569-0.947-1.029-1.465-1.328l-9.786-5.65 c-1.284-0.742-2.326-2.545-2.326-4.029v-3.325C440.155,192.31,441.197,191.709,442.481,192.451z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M368.69,346.496c-1.146-0.662-2.184-0.723-2.934-0.287l-10.312,5.992 c-0.488-0.396-0.993-0.749-1.512-1.047c-2.104-1.215-4.01-1.328-5.386-0.528l-45.172,26.251c0.005-0.003,0.009-0.005,0.014-0.007 c-1.366,0.786-2.214,2.467-2.22,4.86c-0.014,4.803,3.363,10.65,7.544,13.064c2.163,1.249,4.116,1.33,5.5,0.454 c-0.039,0.024-0.076,0.051-0.116,0.074l45.172-26.252c1.358-0.789,2.2-2.467,2.207-4.853c0.002-0.644-0.062-1.307-0.175-1.978 l10.296-5.983c0.74-0.43,1.199-1.345,1.203-2.645C372.805,350.996,370.966,347.809,368.69,346.496z M305.466,376.367 c-0.052-0.001-0.102,0.001-0.153,0.002C305.365,376.369,305.415,376.366,305.466,376.367z M303.652,376.732 c-0.043,0.021-0.085,0.044-0.128,0.066C303.567,376.776,303.609,376.752,303.652,376.732z M305.139,376.372 c-0.052,0.002-0.102,0.008-0.153,0.012C305.037,376.38,305.088,376.374,305.139,376.372z M304.821,376.399 c-0.05,0.006-0.099,0.015-0.149,0.024C304.722,376.415,304.771,376.405,304.821,376.399z M304.513,376.449 c-0.049,0.01-0.096,0.023-0.144,0.034C304.417,376.472,304.464,376.459,304.513,376.449z M304.215,376.521 c-0.047,0.013-0.093,0.03-0.139,0.045C304.122,376.551,304.168,376.534,304.215,376.521z M303.928,376.615 c-0.045,0.017-0.089,0.037-0.133,0.056C303.839,376.652,303.883,376.632,303.928,376.615z M305.646,376.377 c0.052,0.003,0.104,0.005,0.157,0.009C305.751,376.382,305.698,376.38,305.646,376.377z M305.988,376.409 c0.053,0.007,0.107,0.011,0.161,0.02C306.094,376.42,306.041,376.416,305.988,376.409z M306.339,376.464 c0.054,0.01,0.108,0.018,0.163,0.031C306.447,376.483,306.393,376.475,306.339,376.464z M306.7,376.544 c0.054,0.013,0.107,0.025,0.162,0.04C306.807,376.569,306.754,376.557,306.7,376.544z M307.065,376.648 c0.055,0.017,0.109,0.033,0.164,0.052C307.174,376.68,307.12,376.665,307.065,376.648z M307.441,376.778 c0.054,0.02,0.108,0.038,0.162,0.06C307.549,376.816,307.495,376.798,307.441,376.778z M307.825,376.933 c0.053,0.023,0.105,0.044,0.159,0.069C307.931,376.977,307.878,376.956,307.825,376.933z M308.236,377.125 c0.044,0.022,0.089,0.042,0.134,0.066C308.325,377.167,308.28,377.147,308.236,377.125z M314.331,395.17 c0.042-0.029,0.082-0.061,0.123-0.092C314.413,395.109,314.373,395.141,314.331,395.17z M314.569,394.992 c0.039-0.032,0.077-0.068,0.116-0.102C314.646,394.924,314.608,394.959,314.569,394.992z M314.793,394.793 c0.037-0.036,0.073-0.075,0.108-0.113C314.866,394.718,314.831,394.757,314.793,394.793z M316.291,390.908 c0.007-0.144,0.011-0.291,0.011-0.44C316.302,390.617,316.298,390.764,316.291,390.908z M315.004,394.574 c0.035-0.039,0.068-0.082,0.102-0.123C315.072,394.492,315.039,394.534,315.004,394.574z M315.2,394.335 c0.033-0.043,0.064-0.09,0.096-0.135C315.264,394.245,315.234,394.291,315.2,394.335z M315.383,394.076 c0.03-0.047,0.058-0.096,0.086-0.144C315.44,393.98,315.413,394.03,315.383,394.076z M315.55,393.797 c0.027-0.049,0.052-0.101,0.078-0.152C315.602,393.697,315.577,393.748,315.55,393.797z M315.702,393.5 c0.025-0.053,0.048-0.11,0.071-0.165C315.749,393.39,315.727,393.447,315.702,393.5z M315.837,393.185 c0.023-0.057,0.042-0.118,0.063-0.177C315.88,393.067,315.86,393.127,315.837,393.185z M315.957,392.85 c0.02-0.062,0.037-0.128,0.056-0.192C315.994,392.722,315.977,392.788,315.957,392.85z M316.059,392.497 c0.017-0.068,0.032-0.138,0.048-0.207C316.091,392.36,316.077,392.43,316.059,392.497z M316.144,392.127 c0.015-0.074,0.027-0.151,0.039-0.227C316.171,391.975,316.159,392.052,316.144,392.127z M316.212,391.738 c0.012-0.081,0.02-0.165,0.03-0.248C316.232,391.573,316.223,391.657,316.212,391.738z M316.261,391.331 c0.009-0.09,0.014-0.183,0.02-0.275C316.275,391.148,316.27,391.242,316.261,391.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M434.403,315.376c18.759,10.831,18.759,28.391,0,39.222 c-18.759,10.831-49.174,10.831-67.933,0c-18.759-10.831-18.759-28.392,0-39.222C385.229,304.544,415.644,304.544,434.403,315.376z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000017501956214280259630000004802296182824784556_",
    style: {
      enableBackground: "new"
    },
    d: " M425.379,323.429l-0.033,11.663c0.013-4.793-3.15-9.592-9.484-13.249c-12.586-7.267-32.925-7.266-45.43,0.001 c-6.213,3.61-9.322,8.335-9.336,13.066l0.033-11.663c0.013-4.732,3.124-9.456,9.336-13.066 c12.504-7.267,32.844-7.268,45.43-0.001C422.229,313.836,425.393,318.636,425.379,323.429z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017501956214280259630000004802296182824784556_",
    style: {
      overflow: "visible",
      fill: "#BCC5DF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001628017640722868320000013988517507294116534_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017501956214280259630000004802296182824784556_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000001628017640722868320000013988517507294116534_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M425.379,323.429l-0.033,11.663c0.006-2.27-0.7-4.541-2.118-6.692l0.033-11.663 C424.679,318.888,425.385,321.159,425.379,323.429L425.379,323.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M423.261,316.737l-0.033,11.663c-1.576-2.391-4.032-4.632-7.366-6.557 c-8.369-4.832-20.167-6.45-30.809-4.856l0.033-11.663c10.642-1.595,22.439,0.024,30.808,4.856 C419.229,312.104,421.685,314.346,423.261,316.737L423.261,316.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M385.087,305.324l-0.033,11.663c-5.362,0.803-10.431,2.423-14.621,4.858 c-6.213,3.61-9.322,8.335-9.336,13.066l0.033-11.663c0.013-4.732,3.124-9.456,9.336-13.066 C374.655,307.746,379.724,306.127,385.087,305.324L385.087,305.324z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183942581702677705110000004778881580913279635_",
    style: {
      enableBackground: "new"
    },
    d: " M437.002,323.464l-0.033,11.663c-0.018,6.444-4.253,12.876-12.712,17.792c-17.029,9.896-44.727,9.896-61.87-0.001 c-8.625-4.98-12.932-11.516-12.914-18.042l0.033-11.663c-0.018,6.527,4.289,13.063,12.914,18.042 c17.142,9.897,44.841,9.897,61.869,0.001C432.749,336.34,436.984,329.907,437.002,323.464z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183942581702677705110000004778881580913279635_",
    style: {
      overflow: "visible",
      fill: "#BCC5DF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083071836402302006030000004369238562825140132_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183942581702677705110000004778881580913279635_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083071836402302006030000004369238562825140132_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD5EF"
    },
    d: "M437.002,323.464l-0.033,11.663c-0.018,6.444-4.253,12.876-12.712,17.792 c-5.705,3.315-12.607,5.52-19.908,6.614l0.033-11.663c7.301-1.094,14.204-3.298,19.908-6.614 C432.749,336.34,436.984,329.907,437.002,323.464L437.002,323.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD5EF"
    },
    d: "M404.382,347.87l-0.033,11.663c-14.494,2.172-30.562-0.033-41.962-6.615 c-4.54-2.621-7.884-5.673-10.03-8.929l0.033-11.663c2.146,3.255,5.49,6.308,10.03,8.929 C373.82,347.837,389.888,350.042,404.382,347.87L404.382,347.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD5EF"
    },
    d: "M352.391,332.326l-0.033,11.663c-1.931-2.929-2.893-6.023-2.884-9.114l0.033-11.663 C349.497,326.304,350.459,329.397,352.391,332.326L352.391,332.326z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000161610157284170498490000014965308210976077963_",
    style: {
      enableBackground: "new"
    },
    d: " M325.193,359.934l31.62-18.376c0.75-0.436,1.788-0.374,2.934,0.287l-31.62,18.376 C326.981,359.56,325.943,359.498,325.193,359.934z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161610157284170498490000014965308210976077963_",
    style: {
      overflow: "visible",
      fill: "#372B3D"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065758081364848153240000003615751162922205627_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161610157284170498490000014965308210976077963_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065758081364848153240000003615751162922205627_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M325.193,359.934l31.62-18.376c0.75-0.436,1.788-0.374,2.934,0.287l-31.62,18.376 C326.981,359.56,325.943,359.498,325.193,359.934L325.193,359.934z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000061444096325771294020000000017865348097611193_",
    style: {
      enableBackground: "new"
    },
    d: " M362.652,351.605l-31.62,18.376c0.74-0.43,1.199-1.345,1.203-2.645c0.007-2.614-1.832-5.8-4.107-7.114l31.62-18.376 c2.275,1.313,4.115,4.5,4.108,7.114C363.852,350.26,363.392,351.175,362.652,351.605z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061444096325771294020000000017865348097611193_",
    style: {
      overflow: "visible",
      fill: "#372B3D"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086666826143955196690000014887503502762053545_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061444096325771294020000000017865348097611193_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000086666826143955196690000014887503502762053545_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M328.128,360.221l31.62-18.376c2.275,1.313,4.115,4.5,4.108,7.114 c-0.004,1.3-0.463,2.215-1.203,2.645l-31.62,18.376c0.74-0.43,1.199-1.345,1.203-2.645 C332.242,364.722,330.403,361.535,328.128,360.221L328.128,360.221z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372B3D"
    },
    d: "M328.128,360.221c2.275,1.314,4.115,4.5,4.107,7.114c-0.008,2.617-1.859,3.672-4.135,2.358 c-2.277-1.315-4.117-4.501-4.109-7.117C323.999,359.962,325.85,358.907,328.128,360.221z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096763642085823096500000015344703640422425229_",
    style: {
      enableBackground: "new"
    },
    d: " M294.431,372.227l45.172-26.252c1.376-0.799,3.283-0.686,5.387,0.528l-45.172,26.251 C297.714,371.54,295.808,371.427,294.431,372.227z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096763642085823096500000015344703640422425229_",
    style: {
      overflow: "visible",
      fill: "#E5354F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176002768678782131740000012192587804366172072_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096763642085823096500000015344703640422425229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176002768678782131740000012192587804366172072_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5354F"
    },
    d: "M294.431,372.227l45.172-26.252c1.376-0.799,3.283-0.686,5.387,0.528l-45.172,26.251 C297.714,371.54,295.808,371.427,294.431,372.227L294.431,372.227z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000019668453291344281190000003619463973982237825_",
    style: {
      enableBackground: "new"
    },
    d: " M350.325,364.419l-45.172,26.251c1.358-0.789,2.2-2.467,2.207-4.853c0.013-4.803-3.364-10.65-7.542-13.063l45.172-26.251 c4.178,2.412,7.555,8.259,7.542,13.062C352.525,361.952,351.683,363.63,350.325,364.419z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019668453291344281190000003619463973982237825_",
    style: {
      overflow: "visible",
      fill: "#E5354F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100381704158018974410000013155809979859380374_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019668453291344281190000003619463973982237825_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000100381704158018974410000013155809979859380374_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5354F"
    },
    d: "M299.818,372.755l45.172-26.251c4.178,2.412,7.555,8.259,7.542,13.062 c-0.007,2.386-0.849,4.065-2.207,4.854l-45.172,26.251c1.358-0.789,2.2-2.467,2.207-4.853 C307.373,381.014,303.996,375.167,299.818,372.755L299.818,372.755z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D12842"
    },
    d: "M299.818,372.755c4.178,2.412,7.555,8.259,7.542,13.063c-0.014,4.803-3.413,6.738-7.591,4.326 c-4.18-2.413-7.557-8.26-7.544-13.064C292.239,372.276,295.638,370.341,299.818,372.755z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#13B7FD"
    },
    d: "M370.611,340.072c12.588,7.268,32.928,7.267,45.432,0 c12.505-7.267,12.44-19.048-0.148-26.316c-12.586-7.267-32.925-7.266-45.43,0.001 C357.962,321.025,358.026,332.806,370.611,340.072L370.611,340.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#13B7FD"
    },
    d: "M416.043,340.073c-12.505,7.265-32.844,7.269-45.431,0 c-5.776-3.337-8.917-7.622-9.411-11.986c1.241,1.123,2.708,2.182,4.403,3.162c12.588,7.269,32.926,7.265,45.432,0 c6.764-3.931,9.851-9.182,9.265-14.326C428.274,324.117,426.864,333.785,416.043,340.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F8FF"
    },
    d: "M424.086,305.419c17.142,9.897,17.232,25.941,0.204,35.837 c-17.028,9.896-44.727,9.896-61.869-0.001c-17.14-9.896-17.23-25.94-0.202-35.835 C379.247,295.524,406.946,295.524,424.086,305.419z M370.611,336.495c12.588,7.268,32.928,7.267,45.432,0 c12.505-7.267,12.44-19.048-0.148-26.316c-12.586-7.267-32.925-7.266-45.43,0.001 C357.962,317.448,358.026,329.229,370.611,336.495L370.611,336.495z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "woman_10_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#BCC5DF"
    },
    d: "M340.458,379.572c-7.81,4.529-7.81,11.87,0,16.399c7.81,4.529,20.473,4.529,28.283,0 c7.81-4.528,7.81-11.87,0-16.399C360.931,375.044,348.268,375.044,340.458,379.572z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "woman_11_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M352.061,367.343c-0.8-1.871-1.556-4.339-2.606-7.409c-0.283-0.827-0.444-1.71-0.456-2.591 c-0.012-0.888,0.266-1.639,0.681-2.442c0.188-0.363,0.449-0.753,0.856-0.837c0.371-0.076,0.728,0.133,1.02,0.354 c1.76,1.337,2.065,3.156,2.47,5.267c0.377,1.963,0.326,4.524,0.483,6.529c0.03,0.38,0.486,3.834-0.743,3.277 C353.163,369.219,352.496,368.36,352.061,367.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M352.459,365.469c0.425-0.329,0.926-2.191,1.191-1.781c0.182,0.283,2.245,3.54,3.106,4.731 c-1.14,0.796-2.146,1.726-3.106,2.703c-1.285-1.564-2.442-3.289-2.428-4.379C351.23,366.192,351.897,365.904,352.459,365.469z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1582D6"
    },
    d: "M358.773,374.622c2.487,0.727,4.827,1.785,7.192,2.829c1.099,0.485,1.877,2.744,0.939,4.623 c-0.46,0.92-0.355,0.65-2.5,0.361c-1.156-0.156-2.764-0.555-3.917-0.731c-2.384-0.363-13.117-1.463-13.576-6.593 c-0.069-0.771,1.368-1.443,2-1.954C350.716,371.698,356.498,373.957,358.773,374.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1582D6"
    },
    d: "M365.942,383.379c-0.307,0.297-0.64,0.571-0.97,0.84c-2.392,1.951-5.201,3.295-7.288,5.664 c-0.385,0.437-0.766,0.879-1.15,1.318c-0.46,0.524-1.035,1.087-1.758,0.985c-0.374-0.053-0.719-0.285-0.986-0.571 c-0.406-0.436-0.642-0.997-0.697-1.568c-0.068-0.709,0.384-0.991,0.841-1.427c1.196-1.143,1.775-2.742,2.602-4.14 c0.82-1.387,2.129-2.697,3.316-3.783c0.685-0.627,1.419-1.213,2.253-1.618c1.391-0.676,3.461-0.772,4.604,0.486 c0.627,0.69,0.587,1.798,0.156,2.626C366.632,382.639,366.307,383.026,365.942,383.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCC5DF"
    },
    d: "M351.794,397.948c0.4-0.314,0.727-0.712,1.002-1.138c0.353-0.546,0.627-1.138,0.921-1.717 c0.389-0.766,0.814-1.513,1.274-2.238c0.031-0.048,1.076-1.392,1.105-1.44l-2.113-2.237c-0.299-0.012-0.597-0.018-0.885,0.052 c-0.508,0.123-0.971,0.455-1.223,0.918c-0.285,0.523-0.306,1.145-0.455,1.723c-0.188,0.727-0.584,1.318-1.098,1.85 c-0.48,0.497-0.875,1.239-1.046,1.91c-0.114,0.447-0.123,0.943,0.096,1.348c0.228,0.421,0.662,0.682,1.086,0.9 c0.224,0.116,0.459,0.227,0.708,0.268C351.445,398.192,351.573,398.121,351.794,397.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M341.357,374.93c0.713-1.689,1.917-3.244,3.65-4.052l-0.54,1.494 c0.204-0.312,0.42-0.615,0.658-0.903c0.112-0.136,0.212-0.231,0.305-0.293c0.382-0.253,0.654,0.054,1.222,0.375 c0.685,0.388,1.462,0.591,2.172,0.926c2.256,1.062,2.288,1.581,4.213,0.932c-0.275,1.893-0.964,4.247-1.08,4.65 c-0.599,2.077-2.382,1.693-2.803,2.755c-0.976,2.46-3.139,6.527-4.294,8.905c-0.449,0.924-1.324,1.719-2.063,2.4 c-0.862,0.793-1.54,1.008-2.585,0.723c-0.827-0.225-1.933-1.398-1.618-4.964c0.108-1.218,1.174-5.315,1.511-7.604 C340.372,378.457,340.645,376.62,341.357,374.93z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "people_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B09061"
    },
    d: "M337.31,347.507c-0.19,1.277-0.031,2.476-0.057,3.76c-0.028,1.367-0.165,2.734-0.448,4.074 c-0.254,1.201-0.625,2.381-0.757,3.602c-0.132,1.221-0.001,2.522,0.674,3.546c0.172,0.261,0.384,0.506,0.658,0.658 c0.364,0.202,0.804,0.22,1.214,0.149c1.269-0.22,2.296-1.25,2.783-2.447c0.488-1.196,0.506-2.536,0.351-3.82 c-0.156-1.283-0.476-2.542-0.643-3.824c-0.203-1.559-0.051-3.026,0.054-4.578c0.034-0.496-0.034-0.809,0.33-1.197 c0.392-0.417,0.967-0.694,1.527-0.783c0.519-0.082,1.068-0.019,1.557-0.215c0.661-0.264,1.083-1.025,0.961-1.728 c-0.087-0.499-0.407-0.924-0.75-1.297c-0.755-0.821-1.734-1.52-2.844-1.593c-1.128-0.074-2.228,0.528-2.963,1.391 c-0.735,0.862-1.147,1.958-1.409,3.062C337.451,346.674,337.373,347.089,337.31,347.507z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M342.828,354.865c1.067-0.487,1.456-0.754,2.578-1.009c0.182-0.041,0.793,0.19,0.975,0.151 c1.363-0.29,2.815-0.225,4.079,0.333c0.014,0.006,0.028,0.014,0.042,0.021v8.403h-8.019L342.828,354.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E2FC"
    },
    d: "M338.917,358.829c-0.019-0.159-0.007-0.328,0.053-0.525c0.523-1.717,2.449-2.585,3.858-3.44 c-0.097,0.058,0.238,1.073,0.279,1.193c0.129,0.38,0.3,0.746,0.526,1.079c0.957,1.412,2.574,1.83,4.118,1.165 c1.988-0.857,0.961-2.345,1.711-3.705c0.143-0.26,0.415-0.385,0.705-0.407c0.524-0.039,1.055,0.105,1.339,0.564 c0.216,0.348,0.335,0.764,0.487,1.142c0.245,0.61,0.518,1.207,0.809,1.795c0.415,0.836,0.871,1.654,1.2,2.527 c0.327,0.867,0.628,1.911,0.595,2.848c-0.039,1.109-1.005,3.698-1.011,6.406c-0.004,1.836,0.888,3.686,0.604,5.514 c-0.025,0.164-0.062,0.327-0.112,0.486c-0.243,0.773-0.792,1.422-1.441,1.904c-0.649,0.482-1.396,0.812-2.149,1.105 c-1.53,0.593-3.11,1.048-4.708,1.42c-1.405,0.327-3.609,0.536-4.653-0.738c-0.361-0.439-0.51-1.023-0.514-1.592 c-0.004-0.569,0.125-1.13,0.269-1.68c0.405-1.547,1.081-3,1.49-4.543c0.49-1.848,0.599-2.174,0.101-4.074 c-0.211-0.803-0.551-1.566-0.889-2.324c-0.518-1.163-1.037-2.326-1.556-3.488c-0.254-0.569-0.508-1.138-0.761-1.706 C339.109,359.403,338.955,359.135,338.917,358.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M348.239,367.299c-1.445,4.768-3.338,7.765-3.661,12.805 c-1.254,0.132-2.674,0.005-3.451-0.943c-0.361-0.439-0.51-1.023-0.514-1.592c-0.004-0.569,0.125-1.13,0.269-1.68 c0.405-1.547,1.081-3,1.49-4.543c0.49-1.849,0.599-2.174,0.101-4.074c-0.178-0.677-0.447-1.324-0.729-1.964 C343.512,366.768,345.839,367.395,348.239,367.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9ECF5"
    },
    d: "M338.971,358.305c0.523-1.717,2.449-2.585,3.858-3.44c-0.097,0.058,0.238,1.073,0.279,1.193 c0.129,0.38,0.3,0.746,0.526,1.079c0.957,1.412,2.574,1.83,4.118,1.165c1.988-0.857,0.961-2.345,1.711-3.705 c0.143-0.26,0.415-0.385,0.705-0.407c0.524-0.039,1.055,0.105,1.339,0.564c0.216,0.348,0.335,0.764,0.487,1.142 c0.245,0.61,0.518,1.207,0.809,1.795c0.415,0.836,0.871,1.654,1.2,2.527c0.327,0.867,0.628,1.911,0.595,2.848 c-0.039,1.109-1.005,3.698-1.011,6.406c-0.004,1.836,0.888,3.686,0.604,5.514c-0.025,0.164-0.062,0.327-0.112,0.486 c-0.243,0.773-0.792,1.422-1.441,1.904c-0.649,0.482-1.396,0.812-2.149,1.105c-1.53,0.593-3.11,1.048-4.708,1.42 c-0.359,0.084-0.771,0.16-1.202,0.205c0.323-5.041,2.216-8.038,3.661-12.805c-2.4,0.096-4.728-0.531-6.496-1.99 c-0.053-0.12-0.106-0.24-0.16-0.36c-0.518-1.163-1.037-2.326-1.556-3.488c-0.254-0.569-0.508-1.138-0.761-1.706 c-0.157-0.352-0.311-0.619-0.349-0.925C338.898,358.671,338.911,358.501,338.971,358.305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M343.252,355.226c-0.087,2.969,5.072,3.019,4.998,0.228c-0.103-3.892-0.323-4.338-2.021-4.941 c-0.465-0.165-0.952-0.293-1.444-0.302c-1.793-0.036-1.098,0.947-1.031,1.633 C343.954,353.876,343.284,354.158,343.252,355.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9C76"
    },
    d: "M343.752,353.173c-0.119,0.915-0.477,1.279-0.5,2.053c-0.081,2.754,4.348,2.995,4.933,0.789 C346.465,355.651,344.858,354.656,343.752,353.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9C76"
    },
    d: "M346.229,350.512c-0.465-0.165-0.952-0.293-1.444-0.302c-1.793-0.036-1.098,0.947-1.031,1.633 c0.055,0.559,0.043,0.983-0.002,1.33c1.106,1.483,2.713,2.479,4.432,2.842c0.046-0.173,0.071-0.358,0.065-0.561 C348.146,351.562,347.927,351.116,346.229,350.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M345.405,353.28c-0.149-0.125-0.295-0.255-0.437-0.388c-0.493-0.461-1.053-0.997-1.395-1.58 c-1.1-1.873-1.153-4.384,0.413-6.016c1.111-1.158,2.875-1.635,4.415-1.196c0.417,0.119,0.814,0.299,1.199,0.498 c0.333,0.172,0.664,0.364,0.917,0.641c0.167,0.181,0.295,0.395,0.412,0.612c0.132,0.244,0.253,0.497,0.32,0.767 c0.3,1.213-0.504,2.452-0.044,3.648c0.101,0.261,0.251,0.503,0.343,0.767c0.092,0.264,0.118,0.57-0.027,0.807 c-0.137,0.225-0.319,0.338-0.4,0.587c-0.11,0.338-0.185,0.697-0.28,1.041c-0.104,0.375-0.21,0.754-0.399,1.094 c-0.463,0.831-1.131,0.883-1.958,0.557C347.366,354.678,346.322,354.052,345.405,353.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6AF75"
    },
    d: "M341.695,347.586c0.083-2.361,0.775-2.761,1.669-3.513c0.865-0.729,2.032-1.058,3.156-1.024 c1.15,0.035,2.273,0.431,3.244,1.039c0.039,0.024,0.078,0.049,0.116,0.074c0.503,0.328,0.948,0.705,1.215,1.254 c0.141,0.29,0.249,0.606,0.302,0.925c0.1,0.603-0.421,0.855-0.947,1.02c-0.706,0.221-1.706-0.081-2.428-0.16 c-0.338-0.037-0.685-0.073-1.014,0.014c-0.329,0.086-0.641,0.323-0.716,0.656c-0.079,0.347,0.107,0.691,0.185,1.039 c0.154,0.687-0.193,1.435-0.769,1.818c-0.342,0.228-0.58,0.245-0.946,0.077c-0.328-0.15-0.665-0.406-1.027-0.181 c-0.334,0.208-0.208,0.645-0.129,0.961c0.016,0.059,0.144,0.507-0.039,0.509 C343.383,352.095,341.595,350.424,341.695,347.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B09061"
    },
    d: "M346.292,347.871c-0.079,0.347,0.107,0.691,0.185,1.039c0.154,0.687-0.193,1.435-0.769,1.818 c-0.342,0.228-0.58,0.245-0.946,0.077c-0.328-0.15-0.665-0.406-1.027-0.181c-0.334,0.208-0.208,0.645-0.129,0.961 c0.016,0.059,0.144,0.507-0.039,0.509c-0.184,0.002-1.972-1.67-1.872-4.508c0.049-1.384,0.306-2.094,0.691-2.596 c0,0,1.073,0.415,2.029,1.096C345.308,346.722,346.292,347.871,346.292,347.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M343.934,349.739c-0.802-0.054-1.005,0.946-0.455,1.718c0.16,0.225,0.445,0.425,0.655,0.605 c1.437,1.229,1.798-0.101,1.341-0.519C344.415,350.57,344.943,349.807,343.934,349.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A984"
    },
    d: "M344.446,351.57c-0.092-0.085-1.006-0.626-0.383-0.995c0.172-0.102,0.364,0.049,0.391,0.233 c0.013,0.095-0.016,0.192-0.002,0.287c0.008,0.056,0.032,0.109,0.061,0.158c0.081,0.133,0.358,0.26,0.304,0.454 C344.769,351.879,344.5,351.619,344.446,351.57z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9ECF5"
    },
    d: "M357.23,383.04c0.348-0.617,0.822-1.148,1.424-1.417c0.647-0.289,1.456-0.231,2.048,0.27 c0.296,0.251,0.523,0.593,0.793,0.881c0.736,0.782,1.6,0.813,2.506,1.024c0.967,0.225,1.981,0.048,2.915,0.528 c0.129,0.067,0.259,0.149,0.35,0.274c0.078,0.107,0.123,0.238,0.153,0.37c0.139,0.621-0.05,1.242-0.237,1.819 c-0.233,0.721-0.61,1.587-1.336,1.782c-0.674,0.182-1.693-0.399-2.367-0.596c-1.756-0.512-3.556-0.894-5.339-0.802 c-0.491,0.025-1.062,0.051-1.41-0.375c-0.736-0.9,0.009-2.822,0.425-3.618C357.179,383.134,357.204,383.086,357.23,383.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1499FC"
    },
    d: "M344.16,386.994c3.175-0.364,6.179-1.026,9.211-2.053c0.633-0.215,1.276-0.416,1.901-0.653 c0.503-0.19,1.157-0.503,1.707-0.464c0.555,0.039,0.992,0.477,1.295,0.933c0.224,0.337,0.409,0.705,0.486,1.1 c0.072,0.371,0.04,0.776-0.122,1.123c-0.156,0.331-0.535,0.513-0.858,0.68c-0.67,0.348-1.39,0.49-2.074,0.78 c-0.574,0.244-1.154,0.577-1.699,0.885c-1.245,0.705-2.421,1.532-3.73,2.122c-1.095,0.494-2.262,0.809-3.424,1.122 c-0.885,0.238-1.796,0.379-2.708,0.473c-0.818,0.083-3.328,0.125-4.082-0.251C339.767,392.643,342.915,387.137,344.16,386.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1C232A"
    },
    points: "367.707,378.404 367.704,379.608 353.723,387.772 353.727,386.568  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#251B29"
    },
    points: "353.727,386.568 353.723,387.772 345.123,382.786 345.127,381.581  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1C232A"
    },
    points: "367.587,378.479 353.727,386.568 345.127,381.581 358.987,373.493  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0F1317"
    },
    points: "356.767,377.708 353.001,379.891 350.947,378.7 354.713,376.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0F1317"
    },
    points: "348.9,382.922 361.559,375.534 366.08,378.161 353.422,385.548  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.418,370.665c-0.39-2.038-0.607-4.662-0.987-7.95c-0.102-0.886-0.071-1.801,0.108-2.68 c0.181-0.887,0.621-1.574,1.209-2.283c0.266-0.321,0.61-0.652,1.034-0.646c0.386,0.005,0.696,0.292,0.939,0.576 c1.462,1.717,1.945,4.145,1.89,6.335c-0.052,2.038,0.181,4.077,0.111,6.122c-0.013,0.389-0.002,0.807-0.095,1.189 c-0.442,1.818-1.876,2.673-2.98,1.849C339.108,372.775,338.63,371.774,338.418,370.665z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M357.822,375.484c0.108,0.224,0.51,0.816,0.686,0.992c0.176,0.176,0.053-0.561,0.302-0.551 c0.378,0.014,0.789,0.257,1.075,0.008c0.228-0.199,0.454-0.406,0.625-0.657c0.171-0.25,0.283-0.551,0.262-0.854 c-0.009-0.117-0.038-0.236-0.105-0.333c-0.045-0.066-0.105-0.12-0.165-0.173c-0.336-0.299-0.672-0.598-1.008-0.896 c-0.074-0.065-0.148-0.131-0.234-0.178c-0.115-0.064-0.248-0.092-0.38-0.099c-0.468-0.027-0.915,0.204-1.227,0.543 c-0.151,0.164-0.327,0.392-0.376,0.615c-0.042,0.188,0.089,0.395,0.147,0.57C357.538,374.815,357.664,375.157,357.822,375.484 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M357.381,374.576c-0.025,0.493-0.048,0.987-0.073,1.48c-0.009,0.19-0.018,0.383,0.026,0.569 c0.035,0.143,0.101,0.277,0.15,0.415c0.045,0.127,0.077,0.259,0.132,0.382c0.168,0.371,0.53,0.607,0.874,0.823 c0.14,0.089,0.286,0.178,0.448,0.207c0.104,0.018,0.235-0.004,0.273-0.103c0.018-0.047,0.009-0.1,0-0.15 c-0.027-0.143-0.057-0.291-0.144-0.408c-0.105-0.141-0.276-0.219-0.392-0.35c-0.201-0.226-0.202-0.573-0.109-0.861 s0.266-0.544,0.385-0.822c0.12-0.278,0.184-0.606,0.054-0.88c-0.046-0.097-0.114-0.181-0.184-0.262 c-0.164-0.187-0.35-0.36-0.575-0.462c-0.191-0.088-0.416-0.119-0.62-0.06C357.397,374.16,357.391,374.361,357.381,374.576z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B495"
    },
    d: "M359.656,375.188c-0.274-0.129-0.836,0.476-0.885,0.637c-0.119,0.389,0.278,0.063,0.782,0.844 c0.146,0.227,0.296,0.46,0.356,0.723c0.044,0.192,0.065,0.432,0.245,0.512c0.138,0.061,0.305-0.02,0.385-0.148 c0.042,0.273,0.455,0.053,0.536-0.224c0.157-0.533,0.562-0.047,0.623-0.982c0.051,0.022,0.102,0.044,0.153,0.066 c0.624-0.515-0.678-2.015-1.244-2.6C359.608,372.984,359.379,374.605,359.656,375.188z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4DBEF"
    },
    d: "M353.65,371.122c0.959-0.977,1.966-1.907,3.106-2.703c1.029,1.424,1.957,2.984,2.508,4.206 c0.511,1.134-1.671,2.194-2.196,1.61C356.636,373.755,354.816,372.542,353.65,371.122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M351.257,379.72c0.245,0.13,0.885,0.602,1.073,0.805c0.188,0.204-0.625,0.038-0.624,0.316 c0.001,0.423,0.254,0.892-0.033,1.202c-0.229,0.248-0.467,0.492-0.752,0.673c-0.284,0.181-0.622,0.295-0.957,0.259 c-0.129-0.014-0.259-0.052-0.365-0.13c-0.072-0.053-0.129-0.122-0.185-0.191c-0.318-0.387-0.636-0.775-0.954-1.162 c-0.07-0.085-0.139-0.17-0.188-0.268c-0.067-0.132-0.092-0.281-0.096-0.429c-0.012-0.525,0.262-1.015,0.651-1.351 c0.187-0.162,0.447-0.35,0.696-0.397c0.209-0.039,0.435,0.114,0.627,0.187C350.527,379.378,350.9,379.531,351.257,379.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M350.268,379.192c0.548-0.008,1.096-0.016,1.644-0.024c0.211-0.003,0.426-0.005,0.629,0.052 c0.157,0.044,0.303,0.123,0.455,0.184c0.139,0.055,0.284,0.096,0.418,0.163c0.404,0.202,0.652,0.616,0.878,1.009 c0.092,0.16,0.186,0.326,0.212,0.509c0.017,0.117-0.014,0.263-0.125,0.301c-0.053,0.018-0.111,0.007-0.166-0.006 c-0.158-0.035-0.32-0.076-0.447-0.177c-0.153-0.122-0.232-0.317-0.373-0.453c-0.243-0.233-0.628-0.248-0.951-0.155 c-0.323,0.093-0.613,0.275-0.926,0.398c-0.313,0.123-0.679,0.182-0.978,0.027c-0.105-0.055-0.197-0.135-0.283-0.217 c-0.2-0.19-0.385-0.405-0.49-0.661c-0.089-0.217-0.115-0.47-0.042-0.696C349.806,379.194,350.029,379.196,350.268,379.192z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M348.549,380.805c-0.685,0.145-1.384-0.313-1.914-0.708c-1.275-0.949-7.507-6.141-7.926-8.558 c-0.106-0.61,0.582-0.934,1.122-1.422c0.408-0.368,2.536,0.07,2.917,0.52c0.599,0.706,5.185,5.371,6.762,7.708 c0.208,0.309,0.41,0.65,0.405,1.018C349.908,379.953,349.08,380.693,348.549,380.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBFA2"
    },
    d: "M350.858,381.759c-0.132-0.311,0.56-0.916,0.741-0.965c0.436-0.117,0.059,0.314,0.905,0.908 c0.246,0.173,0.498,0.348,0.788,0.426c0.211,0.057,0.476,0.09,0.558,0.293c0.063,0.156-0.034,0.34-0.179,0.425 c0.302,0.057,0.041,0.51-0.269,0.59c-0.597,0.154-0.075,0.627-1.113,0.658c0.022,0.059,0.044,0.116,0.067,0.174 c-0.595,0.678-2.207-0.837-2.833-1.492C348.416,381.62,350.221,381.427,350.858,381.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099664102712754946800000002456207702696369848_",
    d: "M369.674,370.365l1.023,0.597 c-0.071-0.041-0.169-0.035-0.277,0.027l-1.023-0.597C369.505,370.33,369.603,370.324,369.674,370.365z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079445696126292860310000002888674780239162513_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099664102712754946800000002456207702696369848_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000077283004314319226460000013787911999463204797_",
    d: "M369.674,370.365l1.023,0.597 c-0.071-0.041-0.169-0.035-0.277,0.027l-1.023-0.597C369.505,370.33,369.603,370.324,369.674,370.365z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077283004314319226460000013787911999463204797_",
    style: {
      overflow: "visible",
      fill: "#251B29"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038394201265744013900000013527807663136996796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077283004314319226460000013787911999463204797_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038394201265744013900000013527807663136996796_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251B29"
    },
    d: "M370.42,370.99l-1.023-0.597c0.041-0.024,0.081-0.04,0.119-0.047l1.023,0.597 C370.501,370.95,370.461,370.965,370.42,370.99L370.42,370.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251B29"
    },
    d: "M370.539,370.942l-1.023-0.597c0.058-0.012,0.109-0.006,0.151,0.017l1.023,0.597 C370.647,370.936,370.596,370.93,370.539,370.942L370.539,370.942z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#251B29"
    },
    points: "370.69,370.958 369.667,370.362 369.674,370.365 370.697,370.962 370.69,370.958  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147185571295873462570000001607798272258484663_",
    d: "M369.674,370.365l1.023,0.597 c-0.071-0.041-0.169-0.035-0.277,0.027l-1.023-0.597C369.505,370.33,369.603,370.324,369.674,370.365z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139979114255459724190000008135384547820945555_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147185571295873462570000001607798272258484663_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#251B29"
    },
    points: "357.521,378.519 356.498,377.922 369.397,370.392 370.42,370.99  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044147070818818097950000011825435536955980675_",
    d: "M357.13,379.195l-1.023-0.597 c0-0.249,0.175-0.552,0.391-0.676l1.023,0.597C357.305,378.644,357.129,378.946,357.13,379.195z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111880321604323306060000018411746531207590541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044147070818818097950000011825435536955980675_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146501821402686026520000015719438380923355325_",
    d: "M357.13,379.195l-1.023-0.597 c0-0.249,0.175-0.552,0.391-0.676l1.023,0.597C357.305,378.644,357.129,378.946,357.13,379.195z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146501821402686026520000015719438380923355325_",
    style: {
      overflow: "visible",
      fill: "#251B29"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166676783375271232500000001571626431568136099_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146501821402686026520000015719438380923355325_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000166676783375271232500000001571626431568136099_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251B29"
    },
    d: "M357.33,378.686l-1.023-0.597c0.056-0.069,0.121-0.127,0.19-0.167l1.023,0.597 C357.451,378.559,357.386,378.617,357.33,378.686L357.33,378.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#251B29"
    },
    d: "M357.198,378.9l-1.023-0.597c0.034-0.077,0.079-0.15,0.132-0.214l1.023,0.597 C357.278,378.75,357.232,378.824,357.198,378.9L357.198,378.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089532924174403863790000012099166775883804091_",
    d: "M357.13,379.195l-1.023-0.597 c0-0.249,0.175-0.552,0.391-0.676l1.023,0.597C357.305,378.644,357.129,378.946,357.13,379.195z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014627202452690469520000014804205493291241874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089532924174403863790000012099166775883804091_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C232A"
    },
    d: "M370.42,370.99c0.215-0.125,0.39-0.025,0.39,0.223l-3.104,7.362l-13.68,7.981l3.055-7.373 c0,0,0.086-0.456,0.44-0.664L370.42,370.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#251B29"
    },
    points: "354.026,386.556 353.003,385.959 356.175,378.303 357.198,378.9  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "529.25,411.725 519.259,417.493 509.268,411.725 519.259,405.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9945,
      fill: "#FFFFFF"
    },
    points: "529.25,411.509 519.259,417.277 509.268,411.509 519.259,405.741  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.989,
      fill: "#FFFFFF"
    },
    points: "529.25,411.292 519.259,417.06 509.268,411.292 519.259,405.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9834,
      fill: "#FFFFFF"
    },
    points: "529.25,411.076 519.259,416.844 509.268,411.076 519.259,405.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9779,
      fill: "#FFFFFF"
    },
    points: "529.25,410.859 519.259,416.627 509.268,410.859 519.259,405.091  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9724,
      fill: "#FFFFFF"
    },
    points: "529.25,410.643 519.259,416.411 509.268,410.643 519.259,404.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9669,
      fill: "#FFFFFF"
    },
    points: "529.25,410.426 519.259,416.194 509.268,410.426 519.259,404.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9613,
      fill: "#FFFFFF"
    },
    points: "529.25,410.21 519.259,415.978 509.268,410.21 519.259,404.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9558,
      fill: "#FFFFFF"
    },
    points: "529.25,409.993 519.259,415.761 509.268,409.993 519.259,404.225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9503,
      fill: "#FFFFFF"
    },
    points: "529.25,409.776 519.259,415.545 509.268,409.776 519.259,404.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9448,
      fill: "#FFFFFF"
    },
    points: "529.25,409.56 519.259,415.328 509.268,409.56 519.259,403.792  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9392,
      fill: "#FFFFFF"
    },
    points: "529.25,409.343 519.259,415.112 509.268,409.343 519.259,403.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9337,
      fill: "#FFFFFF"
    },
    points: "529.25,409.127 519.259,414.895 509.268,409.127 519.259,403.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9282,
      fill: "#FFFFFF"
    },
    points: "529.25,408.91 519.259,414.678 509.268,408.91 519.259,403.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9227,
      fill: "#FFFFFF"
    },
    points: "529.25,408.694 519.259,414.462 509.268,408.694 519.259,402.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9171,
      fill: "#FFFFFF"
    },
    points: "529.25,408.477 519.259,414.245 509.268,408.477 519.259,402.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9116,
      fill: "#FFFFFF"
    },
    points: "529.25,408.261 519.259,414.029 509.268,408.261 519.259,402.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9061,
      fill: "#FFFFFF"
    },
    points: "529.25,408.044 519.259,413.812 509.268,408.044 519.259,402.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9006,
      fill: "#FFFFFF"
    },
    points: "529.25,407.828 519.259,413.596 509.268,407.828 519.259,402.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.895,
      fill: "#FFFFFF"
    },
    points: "529.25,407.611 519.259,413.379 509.268,407.611 519.259,401.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8895,
      fill: "#FFFFFF"
    },
    points: "529.25,407.395 519.259,413.163 509.268,407.395 519.259,401.626  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.884,
      fill: "#FFFFFF"
    },
    points: "529.25,407.178 519.259,412.946 509.268,407.178 519.259,401.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8785,
      fill: "#FFFFFF"
    },
    points: "529.25,406.961 519.259,412.73 509.268,406.961 519.259,401.193  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8729,
      fill: "#FFFFFF"
    },
    points: "529.25,406.745 519.259,412.513 509.268,406.745 519.259,400.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8674,
      fill: "#FFFFFF"
    },
    points: "529.25,406.528 519.259,412.297 509.268,406.528 519.259,400.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8619,
      fill: "#FFFFFF"
    },
    points: "529.25,406.312 519.259,412.08 509.268,406.312 519.259,400.544  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8564,
      fill: "#FFFFFF"
    },
    points: "529.25,406.095 519.259,411.863 509.268,406.095 519.259,400.327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8508,
      fill: "#FFFFFF"
    },
    points: "529.25,405.879 519.259,411.647 509.268,405.879 519.259,400.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8453,
      fill: "#FFFFFF"
    },
    points: "529.25,405.662 519.259,411.43 509.268,405.662 519.259,399.894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8398,
      fill: "#FFFFFF"
    },
    points: "529.25,405.446 519.259,411.214 509.268,405.446 519.259,399.678  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8343,
      fill: "#FFFFFF"
    },
    points: "529.25,405.229 519.259,410.997 509.268,405.229 519.259,399.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8287,
      fill: "#FFFFFF"
    },
    points: "529.25,405.013 519.259,410.781 509.268,405.013 519.259,399.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8232,
      fill: "#FFFFFF"
    },
    points: "529.25,404.796 519.259,410.564 509.268,404.796 519.259,399.028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8177,
      fill: "#FFFFFF"
    },
    points: "529.25,404.58 519.259,410.348 509.268,404.58 519.259,398.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8122,
      fill: "#FFFFFF"
    },
    points: "529.25,404.363 519.259,410.131 509.268,404.363 519.259,398.595  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8066,
      fill: "#FFFFFF"
    },
    points: "529.25,404.147 519.259,409.915 509.268,404.147 519.259,398.378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8011,
      fill: "#FFFFFF"
    },
    points: "529.25,403.93 519.259,409.698 509.268,403.93 519.259,398.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7956,
      fill: "#FFFFFF"
    },
    points: "529.25,403.713 519.259,409.482 509.268,403.713 519.259,397.945  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7901,
      fill: "#FFFFFF"
    },
    points: "529.25,403.497 519.259,409.265 509.268,403.497 519.259,397.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7845,
      fill: "#FFFFFF"
    },
    points: "529.25,403.28 519.259,409.048 509.268,403.28 519.259,397.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.779,
      fill: "#FFFFFF"
    },
    points: "529.25,403.064 519.259,408.832 509.268,403.064 519.259,397.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7735,
      fill: "#FFFFFF"
    },
    points: "529.25,402.847 519.259,408.615 509.268,402.847 519.259,397.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.768,
      fill: "#FFFFFF"
    },
    points: "529.25,402.631 519.259,408.399 509.268,402.631 519.259,396.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7624,
      fill: "#FFFFFF"
    },
    points: "529.25,402.414 519.259,408.182 509.268,402.414 519.259,396.646  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7569,
      fill: "#FFFFFF"
    },
    points: "529.25,402.198 519.259,407.966 509.268,402.198 519.259,396.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7514,
      fill: "#FFFFFF"
    },
    points: "529.25,401.981 519.259,407.749 509.268,401.981 519.259,396.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7459,
      fill: "#FFFFFF"
    },
    points: "529.25,401.765 519.259,407.533 509.268,401.765 519.259,395.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7403,
      fill: "#FFFFFF"
    },
    points: "529.25,401.548 519.259,407.316 509.268,401.548 519.259,395.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7348,
      fill: "#FFFFFF"
    },
    points: "529.25,401.332 519.259,407.1 509.268,401.332 519.259,395.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7293,
      fill: "#FFFFFF"
    },
    points: "529.25,401.115 519.259,406.883 509.268,401.115 519.259,395.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7238,
      fill: "#FFFFFF"
    },
    points: "529.25,400.898 519.259,406.667 509.268,400.898 519.259,395.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7182,
      fill: "#FFFFFF"
    },
    points: "529.25,400.682 519.259,406.45 509.268,400.682 519.259,394.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7127,
      fill: "#FFFFFF"
    },
    points: "529.25,400.465 519.259,406.233 509.268,400.465 519.259,394.697  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7072,
      fill: "#FFFFFF"
    },
    points: "529.25,400.249 519.259,406.017 509.268,400.249 519.259,394.481  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7017,
      fill: "#FFFFFF"
    },
    points: "529.25,400.032 519.259,405.8 509.268,400.032 519.259,394.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6961,
      fill: "#FFFFFF"
    },
    points: "529.25,399.816 519.259,405.584 509.268,399.816 519.259,394.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6906,
      fill: "#FFFFFF"
    },
    points: "529.25,399.599 519.259,405.367 509.268,399.599 519.259,393.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6851,
      fill: "#FFFFFF"
    },
    points: "529.25,399.383 519.259,405.151 509.268,399.383 519.259,393.615  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6796,
      fill: "#FFFFFF"
    },
    points: "529.25,399.166 519.259,404.934 509.268,399.166 519.259,393.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.674,
      fill: "#FFFFFF"
    },
    points: "529.25,398.949 519.259,404.718 509.268,398.949 519.259,393.181  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6685,
      fill: "#FFFFFF"
    },
    points: "529.25,398.733 519.259,404.501 509.268,398.733 519.259,392.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.663,
      fill: "#FFFFFF"
    },
    points: "529.25,398.517 519.259,404.285 509.268,398.517 519.259,392.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6575,
      fill: "#FFFFFF"
    },
    points: "529.25,398.3 519.259,404.068 509.268,398.3 519.259,392.532  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6519,
      fill: "#FFFFFF"
    },
    points: "529.25,398.083 519.259,403.852 509.268,398.083 519.259,392.315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6464,
      fill: "#FFFFFF"
    },
    points: "529.25,397.867 519.259,403.635 509.268,397.867 519.259,392.099  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6409,
      fill: "#FFFFFF"
    },
    points: "529.25,397.65 519.259,403.418 509.268,397.65 519.259,391.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6354,
      fill: "#FFFFFF"
    },
    points: "529.25,397.434 519.259,403.202 509.268,397.434 519.259,391.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6298,
      fill: "#FFFFFF"
    },
    points: "529.25,397.217 519.259,402.985 509.268,397.217 519.259,391.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6243,
      fill: "#FFFFFF"
    },
    points: "529.25,397.001 519.259,402.769 509.268,397.001 519.259,391.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6188,
      fill: "#FFFFFF"
    },
    points: "529.25,396.784 519.259,402.552 509.268,396.784 519.259,391.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6133,
      fill: "#FFFFFF"
    },
    points: "529.25,396.568 519.259,402.336 509.268,396.568 519.259,390.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6077,
      fill: "#FFFFFF"
    },
    points: "529.25,396.351 519.259,402.119 509.268,396.351 519.259,390.583  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6022,
      fill: "#FFFFFF"
    },
    points: "529.25,396.134 519.259,401.903 509.268,396.134 519.259,390.366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5967,
      fill: "#FFFFFF"
    },
    points: "529.25,395.918 519.259,401.686 509.268,395.918 519.259,390.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5912,
      fill: "#FFFFFF"
    },
    points: "529.25,395.702 519.259,401.47 509.268,395.702 519.259,389.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5856,
      fill: "#FFFFFF"
    },
    points: "529.25,395.485 519.259,401.253 509.268,395.485 519.259,389.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5801,
      fill: "#FFFFFF"
    },
    points: "529.25,395.268 519.259,401.036 509.268,395.268 519.259,389.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5746,
      fill: "#FFFFFF"
    },
    points: "529.25,395.052 519.259,400.82 509.268,395.052 519.259,389.284  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5691,
      fill: "#FFFFFF"
    },
    points: "529.25,394.835 519.259,400.603 509.268,394.835 519.259,389.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5635,
      fill: "#FFFFFF"
    },
    points: "529.25,394.619 519.259,400.387 509.268,394.619 519.259,388.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.558,
      fill: "#FFFFFF"
    },
    points: "529.25,394.402 519.259,400.17 509.268,394.402 519.259,388.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5525,
      fill: "#FFFFFF"
    },
    points: "529.25,394.186 519.259,399.954 509.268,394.186 519.259,388.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.547,
      fill: "#FFFFFF"
    },
    points: "529.25,393.969 519.259,399.737 509.268,393.969 519.259,388.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5414,
      fill: "#FFFFFF"
    },
    points: "529.25,393.753 519.259,399.521 509.268,393.753 519.259,387.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5359,
      fill: "#FFFFFF"
    },
    points: "529.25,393.536 519.259,399.304 509.268,393.536 519.259,387.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5304,
      fill: "#FFFFFF"
    },
    points: "529.25,393.319 519.259,399.088 509.268,393.319 519.259,387.551  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5249,
      fill: "#FFFFFF"
    },
    points: "529.25,393.103 519.259,398.871 509.268,393.103 519.259,387.335  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5193,
      fill: "#FFFFFF"
    },
    points: "529.25,392.886 519.259,398.655 509.268,392.886 519.259,387.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5138,
      fill: "#FFFFFF"
    },
    points: "529.25,392.67 519.259,398.438 509.268,392.67 519.259,386.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5083,
      fill: "#FFFFFF"
    },
    points: "529.25,392.453 519.259,398.221 509.268,392.453 519.259,386.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5028,
      fill: "#FFFFFF"
    },
    points: "529.25,392.237 519.259,398.005 509.268,392.237 519.259,386.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4972,
      fill: "#FFFFFF"
    },
    points: "529.25,392.02 519.259,397.788 509.268,392.02 519.259,386.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4917,
      fill: "#FFFFFF"
    },
    points: "529.25,391.804 519.259,397.572 509.268,391.804 519.259,386.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4862,
      fill: "#FFFFFF"
    },
    points: "529.25,391.587 519.259,397.355 509.268,391.587 519.259,385.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4807,
      fill: "#FFFFFF"
    },
    points: "529.25,391.371 519.259,397.139 509.268,391.371 519.259,385.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4751,
      fill: "#FFFFFF"
    },
    points: "529.25,391.154 519.259,396.922 509.268,391.154 519.259,385.386  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4696,
      fill: "#FFFFFF"
    },
    points: "529.25,390.938 519.259,396.706 509.268,390.938 519.259,385.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4641,
      fill: "#FFFFFF"
    },
    points: "529.25,390.721 519.259,396.489 509.268,390.721 519.259,384.953  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4586,
      fill: "#FFFFFF"
    },
    points: "529.25,390.504 519.259,396.273 509.268,390.504 519.259,384.736  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.453,
      fill: "#FFFFFF"
    },
    points: "529.25,390.288 519.259,396.056 509.268,390.288 519.259,384.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4475,
      fill: "#FFFFFF"
    },
    points: "529.25,390.071 519.259,395.84 509.268,390.071 519.259,384.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.442,
      fill: "#FFFFFF"
    },
    points: "529.25,389.855 519.259,395.623 509.268,389.855 519.259,384.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4365,
      fill: "#FFFFFF"
    },
    points: "529.25,389.638 519.259,395.406 509.268,389.638 519.259,383.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4309,
      fill: "#FFFFFF"
    },
    points: "529.25,389.422 519.259,395.19 509.268,389.422 519.259,383.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4254,
      fill: "#FFFFFF"
    },
    points: "529.25,389.205 519.259,394.973 509.268,389.205 519.259,383.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4199,
      fill: "#FFFFFF"
    },
    points: "529.25,388.989 519.259,394.757 509.268,388.989 519.259,383.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4144,
      fill: "#FFFFFF"
    },
    points: "529.25,388.772 519.259,394.54 509.268,388.772 519.259,383.004  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4088,
      fill: "#FFFFFF"
    },
    points: "529.25,388.556 519.259,394.324 509.268,388.556 519.259,382.788  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4033,
      fill: "#FFFFFF"
    },
    points: "529.25,388.339 519.259,394.107 509.268,388.339 519.259,382.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3978,
      fill: "#FFFFFF"
    },
    points: "529.25,388.123 519.259,393.891 509.268,388.123 519.259,382.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3923,
      fill: "#FFFFFF"
    },
    points: "529.25,387.906 519.259,393.674 509.268,387.906 519.259,382.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3867,
      fill: "#FFFFFF"
    },
    points: "529.25,387.69 519.259,393.458 509.268,387.69 519.259,381.921  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3812,
      fill: "#FFFFFF"
    },
    points: "529.25,387.473 519.259,393.241 509.268,387.473 519.259,381.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3757,
      fill: "#FFFFFF"
    },
    points: "529.25,387.256 519.259,393.025 509.268,387.256 519.259,381.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3702,
      fill: "#FFFFFF"
    },
    points: "529.25,387.04 519.259,392.808 509.268,387.04 519.259,381.272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3646,
      fill: "#FFFFFF"
    },
    points: "529.25,386.823 519.259,392.591 509.268,386.823 519.259,381.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3591,
      fill: "#FFFFFF"
    },
    points: "529.25,386.607 519.259,392.375 509.268,386.607 519.259,380.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3536,
      fill: "#FFFFFF"
    },
    points: "529.25,386.39 519.259,392.158 509.268,386.39 519.259,380.622  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3481,
      fill: "#FFFFFF"
    },
    points: "529.25,386.174 519.259,391.942 509.268,386.174 519.259,380.406  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3425,
      fill: "#FFFFFF"
    },
    points: "529.25,385.957 519.259,391.725 509.268,385.957 519.259,380.189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.337,
      fill: "#FFFFFF"
    },
    points: "529.25,385.741 519.259,391.509 509.268,385.741 519.259,379.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3315,
      fill: "#FFFFFF"
    },
    points: "529.25,385.524 519.259,391.292 509.268,385.524 519.259,379.756  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.326,
      fill: "#FFFFFF"
    },
    points: "529.25,385.308 519.259,391.076 509.268,385.308 519.259,379.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3204,
      fill: "#FFFFFF"
    },
    points: "529.25,385.091 519.259,390.859 509.268,385.091 519.259,379.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3149,
      fill: "#FFFFFF"
    },
    points: "529.25,384.875 519.259,390.643 509.268,384.875 519.259,379.106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3094,
      fill: "#FFFFFF"
    },
    points: "529.25,384.658 519.259,390.426 509.268,384.658 519.259,378.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3039,
      fill: "#FFFFFF"
    },
    points: "529.25,384.441 519.259,390.21 509.268,384.441 519.259,378.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2983,
      fill: "#FFFFFF"
    },
    points: "529.25,384.225 519.259,389.993 509.268,384.225 519.259,378.457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2928,
      fill: "#FFFFFF"
    },
    points: "529.25,384.008 519.259,389.776 509.268,384.008 519.259,378.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2873,
      fill: "#FFFFFF"
    },
    points: "529.25,383.792 519.259,389.56 509.268,383.792 519.259,378.024  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2818,
      fill: "#FFFFFF"
    },
    points: "529.25,383.575 519.259,389.343 509.268,383.575 519.259,377.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2762,
      fill: "#FFFFFF"
    },
    points: "529.25,383.359 519.259,389.127 509.268,383.359 519.259,377.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2707,
      fill: "#FFFFFF"
    },
    points: "529.25,383.142 519.259,388.91 509.268,383.142 519.259,377.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2652,
      fill: "#FFFFFF"
    },
    points: "529.25,382.926 519.259,388.694 509.268,382.926 519.259,377.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2597,
      fill: "#FFFFFF"
    },
    points: "529.25,382.709 519.259,388.477 509.268,382.709 519.259,376.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2541,
      fill: "#FFFFFF"
    },
    points: "529.25,382.493 519.259,388.261 509.268,382.493 519.259,376.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2486,
      fill: "#FFFFFF"
    },
    points: "529.25,382.276 519.259,388.044 509.268,382.276 519.259,376.508  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2431,
      fill: "#FFFFFF"
    },
    points: "529.25,382.06 519.259,387.828 509.268,382.06 519.259,376.291  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2376,
      fill: "#FFFFFF"
    },
    points: "529.25,381.843 519.259,387.611 509.268,381.843 519.259,376.075  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.232,
      fill: "#FFFFFF"
    },
    points: "529.25,381.626 519.259,387.395 509.268,381.626 519.259,375.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2265,
      fill: "#FFFFFF"
    },
    points: "529.25,381.41 519.259,387.178 509.268,381.41 519.259,375.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.221,
      fill: "#FFFFFF"
    },
    points: "529.25,381.193 519.259,386.961 509.268,381.193 519.259,375.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2155,
      fill: "#FFFFFF"
    },
    points: "529.25,380.977 519.259,386.745 509.268,380.977 519.259,375.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2099,
      fill: "#FFFFFF"
    },
    points: "529.25,380.76 519.259,386.528 509.268,380.76 519.259,374.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2044,
      fill: "#FFFFFF"
    },
    points: "529.25,380.544 519.259,386.312 509.268,380.544 519.259,374.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1989,
      fill: "#FFFFFF"
    },
    points: "529.25,380.327 519.259,386.095 509.268,380.327 519.259,374.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1934,
      fill: "#FFFFFF"
    },
    points: "529.25,380.111 519.259,385.879 509.268,380.111 519.259,374.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1878,
      fill: "#FFFFFF"
    },
    points: "529.25,379.894 519.259,385.662 509.268,379.894 519.259,374.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1823,
      fill: "#FFFFFF"
    },
    points: "529.25,379.678 519.259,385.446 509.268,379.678 519.259,373.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1768,
      fill: "#FFFFFF"
    },
    points: "529.25,379.461 519.259,385.229 509.268,379.461 519.259,373.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1713,
      fill: "#FFFFFF"
    },
    points: "529.25,379.245 519.259,385.013 509.268,379.245 519.259,373.476  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1657,
      fill: "#FFFFFF"
    },
    points: "529.25,379.028 519.259,384.796 509.268,379.028 519.259,373.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1602,
      fill: "#FFFFFF"
    },
    points: "529.25,378.811 519.259,384.58 509.268,378.811 519.259,373.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1547,
      fill: "#FFFFFF"
    },
    points: "529.25,378.595 519.259,384.363 509.268,378.595 519.259,372.827  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1492,
      fill: "#FFFFFF"
    },
    points: "529.25,378.378 519.259,384.147 509.268,378.378 519.259,372.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1436,
      fill: "#FFFFFF"
    },
    points: "529.25,378.162 519.259,383.93 509.268,378.162 519.259,372.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1381,
      fill: "#FFFFFF"
    },
    points: "529.25,377.945 519.259,383.713 509.268,377.945 519.259,372.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1326,
      fill: "#FFFFFF"
    },
    points: "529.25,377.729 519.259,383.497 509.268,377.729 519.259,371.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1271,
      fill: "#FFFFFF"
    },
    points: "529.25,377.512 519.259,383.28 509.268,377.512 519.259,371.744  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1215,
      fill: "#FFFFFF"
    },
    points: "529.25,377.296 519.259,383.064 509.268,377.296 519.259,371.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.116,
      fill: "#FFFFFF"
    },
    points: "529.25,377.079 519.259,382.847 509.268,377.079 519.259,371.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1105,
      fill: "#FFFFFF"
    },
    points: "529.25,376.862 519.259,382.631 509.268,376.862 519.259,371.094  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.105,
      fill: "#FFFFFF"
    },
    points: "529.25,376.646 519.259,382.414 509.268,376.646 519.259,370.878  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0994,
      fill: "#FFFFFF"
    },
    points: "529.25,376.43 519.259,382.198 509.268,376.43 519.259,370.661  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0939,
      fill: "#FFFFFF"
    },
    points: "529.25,376.213 519.259,381.981 509.268,376.213 519.259,370.445  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0884,
      fill: "#FFFFFF"
    },
    points: "529.25,375.996 519.259,381.765 509.268,375.996 519.259,370.228  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0829,
      fill: "#FFFFFF"
    },
    points: "529.25,375.78 519.259,381.548 509.268,375.78 519.259,370.012  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0773,
      fill: "#FFFFFF"
    },
    points: "529.25,375.563 519.259,381.332 509.268,375.563 519.259,369.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0718,
      fill: "#FFFFFF"
    },
    points: "529.25,375.347 519.259,381.115 509.268,375.347 519.259,369.579  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0663,
      fill: "#FFFFFF"
    },
    points: "529.25,375.13 519.259,380.898 509.268,375.13 519.259,369.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0608,
      fill: "#FFFFFF"
    },
    points: "529.25,374.914 519.259,380.682 509.268,374.914 519.259,369.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0552,
      fill: "#FFFFFF"
    },
    points: "529.25,374.697 519.259,380.465 509.268,374.697 519.259,368.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0497,
      fill: "#FFFFFF"
    },
    points: "529.25,374.481 519.259,380.249 509.268,374.481 519.259,368.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0442,
      fill: "#FFFFFF"
    },
    points: "529.25,374.264 519.259,380.032 509.268,374.264 519.259,368.496  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0387,
      fill: "#FFFFFF"
    },
    points: "529.25,374.047 519.259,379.816 509.268,374.047 519.259,368.279  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0331,
      fill: "#FFFFFF"
    },
    points: "529.25,373.831 519.259,379.599 509.268,373.831 519.259,368.063  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0276,
      fill: "#FFFFFF"
    },
    points: "529.25,373.615 519.259,379.383 509.268,373.615 519.259,367.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0221,
      fill: "#FFFFFF"
    },
    points: "529.25,373.398 519.259,379.166 509.268,373.398 519.259,367.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0166,
      fill: "#FFFFFF"
    },
    points: "529.25,373.181 519.259,378.95 509.268,373.181 519.259,367.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.011,
      fill: "#FFFFFF"
    },
    points: "529.25,372.965 519.259,378.733 509.268,372.965 519.259,367.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.0055,
      fill: "#FFFFFF"
    },
    points: "529.25,372.748 519.259,378.517 509.268,372.748 519.259,366.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0,
      fill: "#FFFFFF"
    },
    points: "529.25,372.532 519.259,378.3 509.268,372.532 519.259,366.764  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D855A9"
    },
    d: "M519.259,429.556c-0.086,0-0.173-0.022-0.25-0.067c-0.155-0.089-0.25-0.254-0.25-0.433v-11.484 c0-0.179,0.095-0.344,0.25-0.433l9.991-5.768c0.154-0.089,0.346-0.089,0.5,0c0.155,0.089,0.25,0.254,0.25,0.433v11.483 c0,0.179-0.095,0.344-0.25,0.433l-9.991,5.768C519.432,429.534,519.345,429.556,519.259,429.556z M519.759,417.861v10.329 l8.991-5.191V412.67L519.759,417.861z M529.25,423.288h0.01H529.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D855A9"
    },
    d: "M519.259,429.556c-0.086,0-0.173-0.022-0.25-0.067l-9.991-5.768 c-0.155-0.089-0.25-0.254-0.25-0.433v-11.483c0-0.179,0.095-0.344,0.25-0.433c0.154-0.089,0.346-0.089,0.5,0l9.991,5.768 c0.155,0.089,0.25,0.254,0.25,0.433v11.484c0,0.179-0.095,0.344-0.25,0.433C519.432,429.534,519.345,429.556,519.259,429.556z  M509.768,422.999l8.991,5.191v-10.329l-8.991-5.19V422.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D855A9"
    },
    d: "M519.259,418.072c-0.086,0-0.173-0.022-0.25-0.067l-9.991-5.768 c-0.155-0.089-0.25-0.254-0.25-0.433s0.095-0.344,0.25-0.433l9.991-5.768c0.154-0.089,0.346-0.089,0.5,0l9.991,5.768 c0.155,0.089,0.25,0.254,0.25,0.433s-0.095,0.344-0.25,0.433l-9.991,5.768C519.432,418.05,519.345,418.072,519.259,418.072z  M510.268,411.804l8.991,5.191l8.991-5.191l-8.991-5.191L510.268,411.804z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D855A9"
    },
    d: "M528.935,423.848c-0.173,0-0.341-0.089-0.434-0.25c-0.059-0.102-0.078-0.215-0.062-0.323 l-9.181-5.3l-9.741,5.624c-0.239,0.137-0.545,0.056-0.683-0.183c-0.138-0.239-0.056-0.545,0.183-0.683l9.991-5.768 c0.154-0.089,0.346-0.089,0.5,0l9.991,5.768c0.155,0.089,0.25,0.254,0.25,0.433c0,0.179-0.095,0.344-0.25,0.433l-0.315,0.182 C529.106,423.827,529.02,423.848,528.935,423.848z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D855A9"
    },
    d: "M519.259,417.898c-0.276,0-0.5-0.224-0.5-0.5v-11.362c0-0.276,0.224-0.5,0.5-0.5 c0.276,0,0.5,0.224,0.5,0.5v11.362C519.759,417.674,519.535,417.898,519.259,417.898z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.110ff69237b5ab2e021ebac72d79be54.svg";
export { ForwardRef as ReactComponent };